import { g as th } from "../_commonjsHelpers-C6fGbg64.js";
import { jsx as rh } from "react/jsx-runtime";
import nh, { useContext as ih, useState as oh } from "react";
class ui extends Error {
  constructor(r) {
    super(r), this.name = "LocalLogicTracking/RequestError";
  }
}
const sh = (e) => {
  const r = "https://analytics.locallogic.co/track-v2";
  async function n(t, i) {
    const o = await fetch(`${r}${t}`, {
      body: JSON.stringify(i),
      headers: {
        Accept: "application/json",
        Authorization: `${e.substring(0, 3) !== "V3 " ? "V3 " : ""}${e}`,
        "Content-type": "application/json"
      },
      method: "POST"
    });
    if (!o.ok) {
      let s;
      try {
        s = await o.json();
      } catch {
      }
      const a = s != null && s.message ? s.message : "";
      if (a.toLowerCase() !== "unauthorized")
        throw new ui(`Could not post tracking event: ${a}`);
    }
  }
  return {
    post: n
  };
};
var Zi, ma;
function ah() {
  if (ma) return Zi;
  ma = 1;
  function e(b) {
    this._maxSize = b, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(b) {
    return this._values[b];
  }, e.prototype.set = function(b, C) {
    return this._size >= this._maxSize && this.clear(), b in this._values || this._size++, this._values[b] = C;
  };
  var r = /[^.^\]^[]+|(?=\[\]|\.\.)/g, n = /^\d+$/, t = /^\d/, i = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, o = /^\s*(['"]?)(.*?)(\1)\s*$/, s = 512, a = new e(s), u = new e(s), l = new e(s);
  Zi = {
    Cache: e,
    split: h,
    normalizePath: c,
    setter: function(b) {
      var C = c(b);
      return u.get(b) || u.set(b, function(R, A) {
        for (var M = 0, L = C.length, N = R; M < L - 1; ) {
          var B = C[M];
          if (B === "__proto__" || B === "constructor" || B === "prototype")
            return R;
          N = N[C[M++]];
        }
        N[C[M]] = A;
      });
    },
    getter: function(b, C) {
      var E = c(b);
      return l.get(b) || l.set(b, function(A) {
        for (var M = 0, L = E.length; M < L; )
          if (A != null || !C) A = A[E[M++]];
          else return;
        return A;
      });
    },
    join: function(b) {
      return b.reduce(function(C, E) {
        return C + (v(E) || n.test(E) ? "[" + E + "]" : (C ? "." : "") + E);
      }, "");
    },
    forEach: function(b, C, E) {
      m(Array.isArray(b) ? b : h(b), C, E);
    }
  };
  function c(b) {
    return a.get(b) || a.set(
      b,
      h(b).map(function(C) {
        return C.replace(o, "$2");
      })
    );
  }
  function h(b) {
    return b.match(r) || [""];
  }
  function m(b, C, E) {
    var R = b.length, A, M, L, N;
    for (M = 0; M < R; M++)
      A = b[M], A && (_(A) && (A = '"' + A + '"'), N = v(A), L = !N && /^\d+$/.test(A), C.call(E, A, N, L, M, b));
  }
  function v(b) {
    return typeof b == "string" && b && ["'", '"'].indexOf(b.charAt(0)) !== -1;
  }
  function y(b) {
    return b.match(t) && !b.match(n);
  }
  function S(b) {
    return i.test(b);
  }
  function _(b) {
    return !v(b) && (y(b) || S(b));
  }
  return Zi;
}
var ar = ah(), Ki, ga;
function uh() {
  if (ga) return Ki;
  ga = 1;
  const e = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, r = (c) => c.match(e) || [], n = (c) => c[0].toUpperCase() + c.slice(1), t = (c, h) => r(c).join(h).toLowerCase(), i = (c) => r(c).reduce(
    (h, m) => `${h}${h ? m[0].toUpperCase() + m.slice(1).toLowerCase() : m.toLowerCase()}`,
    ""
  );
  return Ki = {
    words: r,
    upperFirst: n,
    camelCase: i,
    pascalCase: (c) => n(i(c)),
    snakeCase: (c) => t(c, "_"),
    kebabCase: (c) => t(c, "-"),
    sentenceCase: (c) => n(t(c, " ")),
    titleCase: (c) => r(c).map(n).join(" ")
  }, Ki;
}
var Ji = uh(), In = { exports: {} }, va;
function ch() {
  if (va) return In.exports;
  va = 1, In.exports = function(i) {
    return e(r(i), i);
  }, In.exports.array = e;
  function e(i, o) {
    var s = i.length, a = new Array(s), u = {}, l = s, c = n(o), h = t(i);
    for (o.forEach(function(v) {
      if (!h.has(v[0]) || !h.has(v[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); l--; )
      u[l] || m(i[l], l, /* @__PURE__ */ new Set());
    return a;
    function m(v, y, S) {
      if (S.has(v)) {
        var _;
        try {
          _ = ", node was:" + JSON.stringify(v);
        } catch {
          _ = "";
        }
        throw new Error("Cyclic dependency" + _);
      }
      if (!h.has(v))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(v));
      if (!u[y]) {
        u[y] = !0;
        var b = c.get(v) || /* @__PURE__ */ new Set();
        if (b = Array.from(b), y = b.length) {
          S.add(v);
          do {
            var C = b[--y];
            m(C, h.get(C), S);
          } while (y);
          S.delete(v);
        }
        a[--s] = v;
      }
    }
  }
  function r(i) {
    for (var o = /* @__PURE__ */ new Set(), s = 0, a = i.length; s < a; s++) {
      var u = i[s];
      o.add(u[0]), o.add(u[1]);
    }
    return Array.from(o);
  }
  function n(i) {
    for (var o = /* @__PURE__ */ new Map(), s = 0, a = i.length; s < a; s++) {
      var u = i[s];
      o.has(u[0]) || o.set(u[0], /* @__PURE__ */ new Set()), o.has(u[1]) || o.set(u[1], /* @__PURE__ */ new Set()), o.get(u[0]).add(u[1]);
    }
    return o;
  }
  function t(i) {
    for (var o = /* @__PURE__ */ new Map(), s = 0, a = i.length; s < a; s++)
      o.set(i[s], s);
    return o;
  }
  return In.exports;
}
var lh = ch();
const fh = /* @__PURE__ */ th(lh), hh = Object.prototype.toString, ph = Error.prototype.toString, dh = RegExp.prototype.toString, mh = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", gh = /^Symbol\((.*)\)(.*)$/;
function vh(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function ya(e, r = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const n = typeof e;
  if (n === "number") return vh(e);
  if (n === "string") return r ? `"${e}"` : e;
  if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (n === "symbol") return mh.call(e).replace(gh, "Symbol($1)");
  const t = hh.call(e).slice(8, -1);
  return t === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : t === "Error" || e instanceof Error ? "[" + ph.call(e) + "]" : t === "RegExp" ? dh.call(e) : null;
}
function Wt(e, r) {
  let n = ya(e, r);
  return n !== null ? n : JSON.stringify(e, function(t, i) {
    let o = ya(this[t], r);
    return o !== null ? o : i;
  }, 2);
}
function Ku(e) {
  return e == null ? [] : [].concat(e);
}
let Ju, Xu, Qu, yh = /\$\{\s*(\w+)\s*\}/g;
Ju = Symbol.toStringTag;
class _a {
  constructor(r, n, t, i) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[Ju] = "Error", this.name = "ValidationError", this.value = n, this.path = t, this.type = i, this.errors = [], this.inner = [], Ku(r).forEach((o) => {
      if (qe.isError(o)) {
        this.errors.push(...o.errors);
        const s = o.inner.length ? o.inner : [o];
        this.inner.push(...s);
      } else
        this.errors.push(o);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
Xu = Symbol.hasInstance;
Qu = Symbol.toStringTag;
let qe = class ec extends Error {
  static formatError(r, n) {
    const t = n.label || n.path || "this";
    return n = Object.assign({}, n, {
      path: t,
      originalPath: n.path
    }), typeof r == "string" ? r.replace(yh, (i, o) => Wt(n[o])) : typeof r == "function" ? r(n) : r;
  }
  static isError(r) {
    return r && r.name === "ValidationError";
  }
  constructor(r, n, t, i, o) {
    const s = new _a(r, n, t, i);
    if (o)
      return s;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[Qu] = "Error", this.name = s.name, this.message = s.message, this.type = s.type, this.value = s.value, this.path = s.path, this.errors = s.errors, this.inner = s.inner, Error.captureStackTrace && Error.captureStackTrace(this, ec);
  }
  static [Xu](r) {
    return _a[Symbol.hasInstance](r) || super[Symbol.hasInstance](r);
  }
}, dt = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: r,
    value: n,
    originalValue: t
  }) => {
    const i = t != null && t !== n ? ` (cast from the value \`${Wt(t, !0)}\`).` : ".";
    return r !== "mixed" ? `${e} must be a \`${r}\` type, but the final value was: \`${Wt(n, !0)}\`` + i : `${e} must match the configured type. The validated value was: \`${Wt(n, !0)}\`` + i;
  }
}, Ue = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, _h = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Co = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, xo = {
  isValue: "${path} field must be ${value}"
}, Jn = {
  noUnknown: "${path} field has unspecified keys: ${unknown}",
  exact: "${path} object contains unknown properties: ${properties}"
}, wh = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, bh = {
  notType: (e) => {
    const {
      path: r,
      value: n,
      spec: t
    } = e, i = t.types.length;
    if (Array.isArray(n)) {
      if (n.length < i) return `${r} tuple value has too few items, expected a length of ${i} but got ${n.length} for value: \`${Wt(n, !0)}\``;
      if (n.length > i) return `${r} tuple value has too many items, expected a length of ${i} but got ${n.length} for value: \`${Wt(n, !0)}\``;
    }
    return qe.formatError(dt.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: dt,
  string: Ue,
  number: _h,
  date: Co,
  object: Jn,
  array: wh,
  boolean: xo,
  tuple: bh
});
const bs = (e) => e && e.__isYupSchema__;
class ci {
  static fromOptions(r, n) {
    if (!n.then && !n.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: t,
      then: i,
      otherwise: o
    } = n, s = typeof t == "function" ? t : (...a) => a.every((u) => u === t);
    return new ci(r, (a, u) => {
      var l;
      let c = s(...a) ? i : o;
      return (l = c == null ? void 0 : c(u)) != null ? l : u;
    });
  }
  constructor(r, n) {
    this.fn = void 0, this.refs = r, this.refs = r, this.fn = n;
  }
  resolve(r, n) {
    let t = this.refs.map((o) => (
      // TODO: ? operator here?
      o.getValue(n == null ? void 0 : n.value, n == null ? void 0 : n.parent, n == null ? void 0 : n.context)
    )), i = this.fn(t, r, n);
    if (i === void 0 || // @ts-ignore this can be base
    i === r)
      return r;
    if (!bs(i)) throw new TypeError("conditions must return a schema object");
    return i.resolve(n);
  }
}
const En = {
  context: "$",
  value: "."
};
class fr {
  constructor(r, n = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof r != "string") throw new TypeError("ref must be a string, got: " + r);
    if (this.key = r.trim(), r === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === En.context, this.isValue = this.key[0] === En.value, this.isSibling = !this.isContext && !this.isValue;
    let t = this.isContext ? En.context : this.isValue ? En.value : "";
    this.path = this.key.slice(t.length), this.getter = this.path && ar.getter(this.path, !0), this.map = n.map;
  }
  getValue(r, n, t) {
    let i = this.isContext ? t : this.isValue ? r : n;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(r, n) {
    return this.getValue(r, n == null ? void 0 : n.parent, n == null ? void 0 : n.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(r) {
    return r && r.__isYupRef;
  }
}
fr.prototype.__isYupRef = !0;
const Rt = (e) => e == null;
function gr(e) {
  function r({
    value: n,
    path: t = "",
    options: i,
    originalValue: o,
    schema: s
  }, a, u) {
    const {
      name: l,
      test: c,
      params: h,
      message: m,
      skipAbsent: v
    } = e;
    let {
      parent: y,
      context: S,
      abortEarly: _ = s.spec.abortEarly,
      disableStackTrace: b = s.spec.disableStackTrace
    } = i;
    const C = {
      value: n,
      parent: y,
      context: S
    };
    function E(P = {}) {
      const z = tc(Object.assign({
        value: n,
        originalValue: o,
        label: s.spec.label,
        path: P.path || t,
        spec: s.spec,
        disableStackTrace: P.disableStackTrace || b
      }, h, P.params), C), Z = new qe(qe.formatError(P.message || m, z), n, z.path, P.type || l, z.disableStackTrace);
      return Z.params = z, Z;
    }
    const R = _ ? a : u;
    let A = {
      path: t,
      parent: y,
      type: l,
      from: i.from,
      createError: E,
      resolve(P) {
        return rc(P, C);
      },
      options: i,
      originalValue: o,
      schema: s
    };
    const M = (P) => {
      qe.isError(P) ? R(P) : P ? u(null) : R(E());
    }, L = (P) => {
      qe.isError(P) ? R(P) : a(P);
    };
    if (v && Rt(n))
      return M(!0);
    let B;
    try {
      var G;
      if (B = c.call(A, n, A), typeof ((G = B) == null ? void 0 : G.then) == "function") {
        if (i.sync)
          throw new Error(`Validation test of type: "${A.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(B).then(M, L);
      }
    } catch (P) {
      L(P);
      return;
    }
    M(B);
  }
  return r.OPTIONS = e, r;
}
function tc(e, r) {
  if (!e) return e;
  for (const n of Object.keys(e))
    e[n] = rc(e[n], r);
  return e;
}
function rc(e, r) {
  return fr.isRef(e) ? e.getValue(r.value, r.parent, r.context) : e;
}
function Sh(e, r, n, t = n) {
  let i, o, s;
  return r ? (ar.forEach(r, (a, u, l) => {
    let c = u ? a.slice(1, a.length - 1) : a;
    e = e.resolve({
      context: t,
      parent: i,
      value: n
    });
    let h = e.type === "tuple", m = l ? parseInt(c, 10) : 0;
    if (e.innerType || h) {
      if (h && !l) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${s}" must contain an index to the tuple element, e.g. "${s}[0]"`);
      if (n && m >= n.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${a}, in the path: ${r}. because there is no value at that index. `);
      i = n, n = n && n[m], e = h ? e.spec.types[m] : e.innerType;
    }
    if (!l) {
      if (!e.fields || !e.fields[c]) throw new Error(`The schema does not contain the path: ${r}. (failed at: ${s} which is a type: "${e.type}")`);
      i = n, n = n && n[c], e = e.fields[c];
    }
    o = c, s = u ? "[" + a + "]" : "." + a;
  }), {
    schema: e,
    parent: i,
    parentPath: o
  }) : {
    parent: i,
    parentPath: r,
    schema: e
  };
}
class li extends Set {
  describe() {
    const r = [];
    for (const n of this.values())
      r.push(fr.isRef(n) ? n.describe() : n);
    return r;
  }
  resolveAll(r) {
    let n = [];
    for (const t of this.values())
      n.push(r(t));
    return n;
  }
  clone() {
    return new li(this.values());
  }
  merge(r, n) {
    const t = this.clone();
    return r.forEach((i) => t.add(i)), n.forEach((i) => t.delete(i)), t;
  }
}
function Sr(e, r = /* @__PURE__ */ new Map()) {
  if (bs(e) || !e || typeof e != "object") return e;
  if (r.has(e)) return r.get(e);
  let n;
  if (e instanceof Date)
    n = new Date(e.getTime()), r.set(e, n);
  else if (e instanceof RegExp)
    n = new RegExp(e), r.set(e, n);
  else if (Array.isArray(e)) {
    n = new Array(e.length), r.set(e, n);
    for (let t = 0; t < e.length; t++) n[t] = Sr(e[t], r);
  } else if (e instanceof Map) {
    n = /* @__PURE__ */ new Map(), r.set(e, n);
    for (const [t, i] of e.entries()) n.set(t, Sr(i, r));
  } else if (e instanceof Set) {
    n = /* @__PURE__ */ new Set(), r.set(e, n);
    for (const t of e) n.add(Sr(t, r));
  } else if (e instanceof Object) {
    n = {}, r.set(e, n);
    for (const [t, i] of Object.entries(e)) n[t] = Sr(i, r);
  } else
    throw Error(`Unable to clone ${e}`);
  return n;
}
function Ch(e) {
  if (!(e != null && e.length))
    return;
  const r = [];
  let n = "", t = !1, i = !1;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    if (s === "[" && !i) {
      n && (r.push(...n.split(".").filter(Boolean)), n = ""), t = !0;
      continue;
    }
    if (s === "]" && !i) {
      n && (/^\d+$/.test(n) ? r.push(n) : r.push(n.replace(/^"|"$/g, "")), n = ""), t = !1;
      continue;
    }
    if (s === '"') {
      i = !i;
      continue;
    }
    if (s === "." && !t && !i) {
      n && (r.push(n), n = "");
      continue;
    }
    n += s;
  }
  return n && r.push(...n.split(".").filter(Boolean)), r;
}
function xh(e, r) {
  const n = r ? `${r}.${e.path}` : e.path;
  return e.errors.map((t) => ({
    message: t,
    path: Ch(n)
  }));
}
function nc(e, r) {
  var n;
  if (!((n = e.inner) != null && n.length) && e.errors.length)
    return xh(e, r);
  const t = r ? `${r}.${e.path}` : e.path;
  return e.inner.flatMap((i) => nc(i, t));
}
class at {
  constructor(r) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new li(), this._blacklist = new li(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(dt.notType);
    }), this.type = r.type, this._typeCheck = r.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, r == null ? void 0 : r.spec), this.withMutation((n) => {
      n.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(r) {
    if (this._mutate)
      return r && Object.assign(this.spec, r), this;
    const n = Object.create(Object.getPrototypeOf(this));
    return n.type = this.type, n._typeCheck = this._typeCheck, n._whitelist = this._whitelist.clone(), n._blacklist = this._blacklist.clone(), n.internalTests = Object.assign({}, this.internalTests), n.exclusiveTests = Object.assign({}, this.exclusiveTests), n.deps = [...this.deps], n.conditions = [...this.conditions], n.tests = [...this.tests], n.transforms = [...this.transforms], n.spec = Sr(Object.assign({}, this.spec, r)), n;
  }
  label(r) {
    let n = this.clone();
    return n.spec.label = r, n;
  }
  meta(...r) {
    if (r.length === 0) return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, r[0]), n;
  }
  withMutation(r) {
    let n = this._mutate;
    this._mutate = !0;
    let t = r(this);
    return this._mutate = n, t;
  }
  concat(r) {
    if (!r || r === this) return this;
    if (r.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${r.type}`);
    let n = this, t = r.clone();
    const i = Object.assign({}, n.spec, t.spec);
    return t.spec = i, t.internalTests = Object.assign({}, n.internalTests, t.internalTests), t._whitelist = n._whitelist.merge(r._whitelist, r._blacklist), t._blacklist = n._blacklist.merge(r._blacklist, r._whitelist), t.tests = n.tests, t.exclusiveTests = n.exclusiveTests, t.withMutation((o) => {
      r.tests.forEach((s) => {
        o.test(s.OPTIONS);
      });
    }), t.transforms = [...n.transforms, ...t.transforms], t;
  }
  isType(r) {
    return r == null ? !!(this.spec.nullable && r === null || this.spec.optional && r === void 0) : this._typeCheck(r);
  }
  resolve(r) {
    let n = this;
    if (n.conditions.length) {
      let t = n.conditions;
      n = n.clone(), n.conditions = [], n = t.reduce((i, o) => o.resolve(i, r), n), n = n.resolve(r);
    }
    return n;
  }
  resolveOptions(r) {
    var n, t, i, o;
    return Object.assign({}, r, {
      from: r.from || [],
      strict: (n = r.strict) != null ? n : this.spec.strict,
      abortEarly: (t = r.abortEarly) != null ? t : this.spec.abortEarly,
      recursive: (i = r.recursive) != null ? i : this.spec.recursive,
      disableStackTrace: (o = r.disableStackTrace) != null ? o : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(r, n = {}) {
    let t = this.resolve(Object.assign({
      value: r
    }, n)), i = n.assert === "ignore-optionality", o = t._cast(r, n);
    if (n.assert !== !1 && !t.isType(o)) {
      if (i && Rt(o))
        return o;
      let s = Wt(r), a = Wt(o);
      throw new TypeError(`The value of ${n.path || "field"} could not be cast to a value that satisfies the schema type: "${t.type}". 

attempted value: ${s} 
` + (a !== s ? `result of cast: ${a}` : ""));
    }
    return o;
  }
  _cast(r, n) {
    let t = r === void 0 ? r : this.transforms.reduce((i, o) => o.call(this, i, r, this), r);
    return t === void 0 && (t = this.getDefault(n)), t;
  }
  _validate(r, n = {}, t, i) {
    let {
      path: o,
      originalValue: s = r,
      strict: a = this.spec.strict
    } = n, u = r;
    a || (u = this._cast(u, Object.assign({
      assert: !1
    }, n)));
    let l = [];
    for (let c of Object.values(this.internalTests))
      c && l.push(c);
    this.runTests({
      path: o,
      value: u,
      originalValue: s,
      options: n,
      tests: l
    }, t, (c) => {
      if (c.length)
        return i(c, u);
      this.runTests({
        path: o,
        value: u,
        originalValue: s,
        options: n,
        tests: this.tests
      }, t, i);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(r, n, t) {
    let i = !1, {
      tests: o,
      value: s,
      originalValue: a,
      path: u,
      options: l
    } = r, c = (S) => {
      i || (i = !0, n(S, s));
    }, h = (S) => {
      i || (i = !0, t(S, s));
    }, m = o.length, v = [];
    if (!m) return h([]);
    let y = {
      value: s,
      originalValue: a,
      path: u,
      options: l,
      schema: this
    };
    for (let S = 0; S < o.length; S++) {
      const _ = o[S];
      _(y, c, function(C) {
        C && (Array.isArray(C) ? v.push(...C) : v.push(C)), --m <= 0 && h(v);
      });
    }
  }
  asNestedTest({
    key: r,
    index: n,
    parent: t,
    parentPath: i,
    originalParent: o,
    options: s
  }) {
    const a = r ?? n;
    if (a == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const u = typeof a == "number";
    let l = t[a];
    const c = Object.assign({}, s, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: t,
      value: l,
      originalValue: o[a],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [u ? "index" : "key"]: a,
      path: u || a.includes(".") ? `${i || ""}[${u ? a : `"${a}"`}]` : (i ? `${i}.` : "") + r
    });
    return (h, m, v) => this.resolve(c)._validate(l, c, m, v);
  }
  validate(r, n) {
    var t;
    let i = this.resolve(Object.assign({}, n, {
      value: r
    })), o = (t = n == null ? void 0 : n.disableStackTrace) != null ? t : i.spec.disableStackTrace;
    return new Promise((s, a) => i._validate(r, n, (u, l) => {
      qe.isError(u) && (u.value = l), a(u);
    }, (u, l) => {
      u.length ? a(new qe(u, l, void 0, void 0, o)) : s(l);
    }));
  }
  validateSync(r, n) {
    var t;
    let i = this.resolve(Object.assign({}, n, {
      value: r
    })), o, s = (t = n == null ? void 0 : n.disableStackTrace) != null ? t : i.spec.disableStackTrace;
    return i._validate(r, Object.assign({}, n, {
      sync: !0
    }), (a, u) => {
      throw qe.isError(a) && (a.value = u), a;
    }, (a, u) => {
      if (a.length) throw new qe(a, r, void 0, void 0, s);
      o = u;
    }), o;
  }
  isValid(r, n) {
    return this.validate(r, n).then(() => !0, (t) => {
      if (qe.isError(t)) return !1;
      throw t;
    });
  }
  isValidSync(r, n) {
    try {
      return this.validateSync(r, n), !0;
    } catch (t) {
      if (qe.isError(t)) return !1;
      throw t;
    }
  }
  _getDefault(r) {
    let n = this.spec.default;
    return n == null ? n : typeof n == "function" ? n.call(this, r) : Sr(n);
  }
  getDefault(r) {
    return this.resolve(r || {})._getDefault(r);
  }
  default(r) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: r
    });
  }
  strict(r = !0) {
    return this.clone({
      strict: r
    });
  }
  nullability(r, n) {
    const t = this.clone({
      nullable: r
    });
    return t.internalTests.nullable = gr({
      message: n,
      name: "nullable",
      test(i) {
        return i === null ? this.schema.spec.nullable : !0;
      }
    }), t;
  }
  optionality(r, n) {
    const t = this.clone({
      optional: r
    });
    return t.internalTests.optionality = gr({
      message: n,
      name: "optionality",
      test(i) {
        return i === void 0 ? this.schema.spec.optional : !0;
      }
    }), t;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(r = dt.defined) {
    return this.optionality(!1, r);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(r = dt.notNull) {
    return this.nullability(!1, r);
  }
  required(r = dt.required) {
    return this.clone().withMutation((n) => n.nonNullable(r).defined(r));
  }
  notRequired() {
    return this.clone().withMutation((r) => r.nullable().optional());
  }
  transform(r) {
    let n = this.clone();
    return n.transforms.push(r), n;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...r) {
    let n;
    if (r.length === 1 ? typeof r[0] == "function" ? n = {
      test: r[0]
    } : n = r[0] : r.length === 2 ? n = {
      name: r[0],
      test: r[1]
    } : n = {
      name: r[0],
      message: r[1],
      test: r[2]
    }, n.message === void 0 && (n.message = dt.default), typeof n.test != "function") throw new TypeError("`test` is a required parameters");
    let t = this.clone(), i = gr(n), o = n.exclusive || n.name && t.exclusiveTests[n.name] === !0;
    if (n.exclusive && !n.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n.name && (t.exclusiveTests[n.name] = !!n.exclusive), t.tests = t.tests.filter((s) => !(s.OPTIONS.name === n.name && (o || s.OPTIONS.test === i.OPTIONS.test))), t.tests.push(i), t;
  }
  when(r, n) {
    !Array.isArray(r) && typeof r != "string" && (n = r, r = ".");
    let t = this.clone(), i = Ku(r).map((o) => new fr(o));
    return i.forEach((o) => {
      o.isSibling && t.deps.push(o.key);
    }), t.conditions.push(typeof n == "function" ? new ci(i, n) : ci.fromOptions(i, n)), t;
  }
  typeError(r) {
    let n = this.clone();
    return n.internalTests.typeError = gr({
      message: r,
      name: "typeError",
      skipAbsent: !0,
      test(t) {
        return this.schema._typeCheck(t) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), n;
  }
  oneOf(r, n = dt.oneOf) {
    let t = this.clone();
    return r.forEach((i) => {
      t._whitelist.add(i), t._blacklist.delete(i);
    }), t.internalTests.whiteList = gr({
      message: n,
      name: "oneOf",
      skipAbsent: !0,
      test(i) {
        let o = this.schema._whitelist, s = o.resolveAll(this.resolve);
        return s.includes(i) ? !0 : this.createError({
          params: {
            values: Array.from(o).join(", "),
            resolved: s
          }
        });
      }
    }), t;
  }
  notOneOf(r, n = dt.notOneOf) {
    let t = this.clone();
    return r.forEach((i) => {
      t._blacklist.add(i), t._whitelist.delete(i);
    }), t.internalTests.blacklist = gr({
      message: n,
      name: "notOneOf",
      test(i) {
        let o = this.schema._blacklist, s = o.resolveAll(this.resolve);
        return s.includes(i) ? this.createError({
          params: {
            values: Array.from(o).join(", "),
            resolved: s
          }
        }) : !0;
      }
    }), t;
  }
  strip(r = !0) {
    let n = this.clone();
    return n.spec.strip = r, n;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(r) {
    const n = (r ? this.resolve(r) : this).clone(), {
      label: t,
      meta: i,
      optional: o,
      nullable: s
    } = n.spec;
    return {
      meta: i,
      label: t,
      optional: o,
      nullable: s,
      default: n.getDefault(r),
      type: n.type,
      oneOf: n._whitelist.describe(),
      notOneOf: n._blacklist.describe(),
      tests: n.tests.filter((u, l, c) => c.findIndex((h) => h.OPTIONS.name === u.OPTIONS.name) === l).map((u) => {
        const l = u.OPTIONS.params && r ? tc(Object.assign({}, u.OPTIONS.params), r) : u.OPTIONS.params;
        return {
          name: u.OPTIONS.name,
          params: l
        };
      })
    };
  }
  get "~standard"() {
    const r = this;
    return {
      version: 1,
      vendor: "yup",
      async validate(t) {
        try {
          return {
            value: await r.validate(t, {
              abortEarly: !1
            })
          };
        } catch (i) {
          if (i instanceof qe)
            return {
              issues: nc(i)
            };
          throw i;
        }
      }
    };
  }
}
at.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) at.prototype[`${e}At`] = function(r, n, t = {}) {
  const {
    parent: i,
    parentPath: o,
    schema: s
  } = Sh(this, r, n, t.context);
  return s[e](i && i[o], Object.assign({}, t, {
    parent: i,
    path: r
  }));
};
for (const e of ["equals", "is"]) at.prototype[e] = at.prototype.oneOf;
for (const e of ["not", "nope"]) at.prototype[e] = at.prototype.notOneOf;
function ic() {
  return new oc();
}
class oc extends at {
  constructor() {
    super({
      type: "boolean",
      check(r) {
        return r instanceof Boolean && (r = r.valueOf()), typeof r == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((r, n, t) => {
        if (t.spec.coerce && !t.isType(r)) {
          if (/^(true|1)$/i.test(String(r))) return !0;
          if (/^(false|0)$/i.test(String(r))) return !1;
        }
        return r;
      });
    });
  }
  isTrue(r = xo.isValue) {
    return this.test({
      message: r,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(n) {
        return Rt(n) || n === !0;
      }
    });
  }
  isFalse(r = xo.isValue) {
    return this.test({
      message: r,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(n) {
        return Rt(n) || n === !1;
      }
    });
  }
  default(r) {
    return super.default(r);
  }
  defined(r) {
    return super.defined(r);
  }
  optional() {
    return super.optional();
  }
  required(r) {
    return super.required(r);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(r) {
    return super.nonNullable(r);
  }
  strip(r) {
    return super.strip(r);
  }
}
ic.prototype = oc.prototype;
const Ih = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Eh(e) {
  const r = Io(e);
  if (!r) return Date.parse ? Date.parse(e) : Number.NaN;
  if (r.z === void 0 && r.plusMinus === void 0)
    return new Date(r.year, r.month, r.day, r.hour, r.minute, r.second, r.millisecond).valueOf();
  let n = 0;
  return r.z !== "Z" && r.plusMinus !== void 0 && (n = r.hourOffset * 60 + r.minuteOffset, r.plusMinus === "+" && (n = 0 - n)), Date.UTC(r.year, r.month, r.day, r.hour, r.minute + n, r.second, r.millisecond);
}
function Io(e) {
  var r, n;
  const t = Ih.exec(e);
  return t ? {
    year: Et(t[1]),
    month: Et(t[2], 1) - 1,
    day: Et(t[3], 1),
    hour: Et(t[4]),
    minute: Et(t[5]),
    second: Et(t[6]),
    millisecond: t[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      Et(t[7].substring(0, 3))
    ) : 0,
    precision: (r = (n = t[7]) == null ? void 0 : n.length) != null ? r : void 0,
    z: t[8] || void 0,
    plusMinus: t[9] || void 0,
    hourOffset: Et(t[10]),
    minuteOffset: Et(t[11])
  } : null;
}
function Et(e, r = 0) {
  return Number(e) || r;
}
let Oh = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), kh = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), Ah = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Rh = "^\\d{4}-\\d{2}-\\d{2}", Th = "\\d{2}:\\d{2}:\\d{2}", Mh = "(([+-]\\d{2}(:?\\d{2})?)|Z)", Fh = new RegExp(`${Rh}T${Th}(\\.\\d+)?${Mh}$`), $h = (e) => Rt(e) || e === e.trim(), Nh = {}.toString();
function Ot() {
  return new sc();
}
class sc extends at {
  constructor() {
    super({
      type: "string",
      check(r) {
        return r instanceof String && (r = r.valueOf()), typeof r == "string";
      }
    }), this.withMutation(() => {
      this.transform((r, n, t) => {
        if (!t.spec.coerce || t.isType(r) || Array.isArray(r)) return r;
        const i = r != null && r.toString ? r.toString() : r;
        return i === Nh ? r : i;
      });
    });
  }
  required(r) {
    return super.required(r).withMutation((n) => n.test({
      message: r || dt.required,
      name: "required",
      skipAbsent: !0,
      test: (t) => !!t.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((r) => (r.tests = r.tests.filter((n) => n.OPTIONS.name !== "required"), r));
  }
  length(r, n = Ue.length) {
    return this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: r
      },
      skipAbsent: !0,
      test(t) {
        return t.length === this.resolve(r);
      }
    });
  }
  min(r, n = Ue.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: r
      },
      skipAbsent: !0,
      test(t) {
        return t.length >= this.resolve(r);
      }
    });
  }
  max(r, n = Ue.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: n,
      params: {
        max: r
      },
      skipAbsent: !0,
      test(t) {
        return t.length <= this.resolve(r);
      }
    });
  }
  matches(r, n) {
    let t = !1, i, o;
    return n && (typeof n == "object" ? {
      excludeEmptyString: t = !1,
      message: i,
      name: o
    } = n : i = n), this.test({
      name: o || "matches",
      message: i || Ue.matches,
      params: {
        regex: r
      },
      skipAbsent: !0,
      test: (s) => s === "" && t || s.search(r) !== -1
    });
  }
  email(r = Ue.email) {
    return this.matches(Oh, {
      name: "email",
      message: r,
      excludeEmptyString: !0
    });
  }
  url(r = Ue.url) {
    return this.matches(kh, {
      name: "url",
      message: r,
      excludeEmptyString: !0
    });
  }
  uuid(r = Ue.uuid) {
    return this.matches(Ah, {
      name: "uuid",
      message: r,
      excludeEmptyString: !1
    });
  }
  datetime(r) {
    let n = "", t, i;
    return r && (typeof r == "object" ? {
      message: n = "",
      allowOffset: t = !1,
      precision: i = void 0
    } = r : n = r), this.matches(Fh, {
      name: "datetime",
      message: n || Ue.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: n || Ue.datetime_offset,
      params: {
        allowOffset: t
      },
      skipAbsent: !0,
      test: (o) => {
        if (!o || t) return !0;
        const s = Io(o);
        return s ? !!s.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: n || Ue.datetime_precision,
      params: {
        precision: i
      },
      skipAbsent: !0,
      test: (o) => {
        if (!o || i == null) return !0;
        const s = Io(o);
        return s ? s.precision === i : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((r) => r === null ? "" : r);
  }
  trim(r = Ue.trim) {
    return this.transform((n) => n != null ? n.trim() : n).test({
      message: r,
      name: "trim",
      test: $h
    });
  }
  lowercase(r = Ue.lowercase) {
    return this.transform((n) => Rt(n) ? n : n.toLowerCase()).test({
      message: r,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (n) => Rt(n) || n === n.toLowerCase()
    });
  }
  uppercase(r = Ue.uppercase) {
    return this.transform((n) => Rt(n) ? n : n.toUpperCase()).test({
      message: r,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (n) => Rt(n) || n === n.toUpperCase()
    });
  }
}
Ot.prototype = sc.prototype;
let Ph = /* @__PURE__ */ new Date(""), Dh = (e) => Object.prototype.toString.call(e) === "[object Date]";
class Ss extends at {
  constructor() {
    super({
      type: "date",
      check(r) {
        return Dh(r) && !isNaN(r.getTime());
      }
    }), this.withMutation(() => {
      this.transform((r, n, t) => !t.spec.coerce || t.isType(r) || r === null ? r : (r = Eh(r), isNaN(r) ? Ss.INVALID_DATE : new Date(r)));
    });
  }
  prepareParam(r, n) {
    let t;
    if (fr.isRef(r))
      t = r;
    else {
      let i = this.cast(r);
      if (!this._typeCheck(i)) throw new TypeError(`\`${n}\` must be a Date or a value that can be \`cast()\` to a Date`);
      t = i;
    }
    return t;
  }
  min(r, n = Co.min) {
    let t = this.prepareParam(r, "min");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: r
      },
      skipAbsent: !0,
      test(i) {
        return i >= this.resolve(t);
      }
    });
  }
  max(r, n = Co.max) {
    let t = this.prepareParam(r, "max");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: r
      },
      skipAbsent: !0,
      test(i) {
        return i <= this.resolve(t);
      }
    });
  }
}
Ss.INVALID_DATE = Ph;
function Lh(e, r = []) {
  let n = [], t = /* @__PURE__ */ new Set(), i = new Set(r.map(([s, a]) => `${s}-${a}`));
  function o(s, a) {
    let u = ar.split(s)[0];
    t.add(u), i.has(`${a}-${u}`) || n.push([a, u]);
  }
  for (const s of Object.keys(e)) {
    let a = e[s];
    t.add(s), fr.isRef(a) && a.isSibling ? o(a.path, s) : bs(a) && "deps" in a && a.deps.forEach((u) => o(u, s));
  }
  return fh.array(Array.from(t), n).reverse();
}
function wa(e, r) {
  let n = 1 / 0;
  return e.some((t, i) => {
    var o;
    if ((o = r.path) != null && o.includes(t))
      return n = i, !0;
  }), n;
}
function ac(e) {
  return (r, n) => wa(e, r) - wa(e, n);
}
const Bh = (e, r, n) => {
  if (typeof e != "string")
    return e;
  let t = e;
  try {
    t = JSON.parse(e);
  } catch {
  }
  return n.isType(t) ? t : e;
};
function Xn(e) {
  if ("fields" in e) {
    const r = {};
    for (const [n, t] of Object.entries(e.fields))
      r[n] = Xn(t);
    return e.setFields(r);
  }
  if (e.type === "array") {
    const r = e.optional();
    return r.innerType && (r.innerType = Xn(r.innerType)), r;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(Xn)
  }) : "optional" in e ? e.optional() : e;
}
const Uh = (e, r) => {
  const n = [...ar.normalizePath(r)];
  if (n.length === 1) return n[0] in e;
  let t = n.pop(), i = ar.getter(ar.join(n), !0)(e);
  return !!(i && t in i);
};
let ba = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Sa(e, r) {
  let n = Object.keys(e.fields);
  return Object.keys(r).filter((t) => n.indexOf(t) === -1);
}
const zh = ac([]);
function Qn(e) {
  return new uc(e);
}
class uc extends at {
  constructor(r) {
    super({
      type: "object",
      check(n) {
        return ba(n) || typeof n == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = zh, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      r && this.shape(r);
    });
  }
  _cast(r, n = {}) {
    var t;
    let i = super._cast(r, n);
    if (i === void 0) return this.getDefault(n);
    if (!this._typeCheck(i)) return i;
    let o = this.fields, s = (t = n.stripUnknown) != null ? t : this.spec.noUnknown, a = [].concat(this._nodes, Object.keys(i).filter((h) => !this._nodes.includes(h))), u = {}, l = Object.assign({}, n, {
      parent: u,
      __validating: n.__validating || !1
    }), c = !1;
    for (const h of a) {
      let m = o[h], v = h in i;
      if (m) {
        let y, S = i[h];
        l.path = (n.path ? `${n.path}.` : "") + h, m = m.resolve({
          value: S,
          context: n.context,
          parent: u
        });
        let _ = m instanceof at ? m.spec : void 0, b = _ == null ? void 0 : _.strict;
        if (_ != null && _.strip) {
          c = c || h in i;
          continue;
        }
        y = !n.__validating || !b ? (
          // TODO: use _cast, this is double resolving
          m.cast(i[h], l)
        ) : i[h], y !== void 0 && (u[h] = y);
      } else v && !s && (u[h] = i[h]);
      (v !== h in u || u[h] !== i[h]) && (c = !0);
    }
    return c ? u : i;
  }
  _validate(r, n = {}, t, i) {
    let {
      from: o = [],
      originalValue: s = r,
      recursive: a = this.spec.recursive
    } = n;
    n.from = [{
      schema: this,
      value: s
    }, ...o], n.__validating = !0, n.originalValue = s, super._validate(r, n, t, (u, l) => {
      if (!a || !ba(l)) {
        i(u, l);
        return;
      }
      s = s || l;
      let c = [];
      for (let h of this._nodes) {
        let m = this.fields[h];
        !m || fr.isRef(m) || c.push(m.asNestedTest({
          options: n,
          key: h,
          parent: l,
          parentPath: n.path,
          originalParent: s
        }));
      }
      this.runTests({
        tests: c,
        value: l,
        originalValue: s,
        options: n
      }, t, (h) => {
        i(h.sort(this._sortErrors).concat(u), l);
      });
    });
  }
  clone(r) {
    const n = super.clone(r);
    return n.fields = Object.assign({}, this.fields), n._nodes = this._nodes, n._excludedEdges = this._excludedEdges, n._sortErrors = this._sortErrors, n;
  }
  concat(r) {
    let n = super.concat(r), t = n.fields;
    for (let [i, o] of Object.entries(this.fields)) {
      const s = t[i];
      t[i] = s === void 0 ? o : s;
    }
    return n.withMutation((i) => (
      // XXX: excludes here is wrong
      i.setFields(t, [...this._excludedEdges, ...r._excludedEdges])
    ));
  }
  _getDefault(r) {
    if ("default" in this.spec)
      return super._getDefault(r);
    if (!this._nodes.length)
      return;
    let n = {};
    return this._nodes.forEach((t) => {
      var i;
      const o = this.fields[t];
      let s = r;
      (i = s) != null && i.value && (s = Object.assign({}, s, {
        parent: s.value,
        value: s.value[t]
      })), n[t] = o && "getDefault" in o ? o.getDefault(s) : void 0;
    }), n;
  }
  setFields(r, n) {
    let t = this.clone();
    return t.fields = r, t._nodes = Lh(r, n), t._sortErrors = ac(Object.keys(r)), n && (t._excludedEdges = n), t;
  }
  shape(r, n = []) {
    return this.clone().withMutation((t) => {
      let i = t._excludedEdges;
      return n.length && (Array.isArray(n[0]) || (n = [n]), i = [...t._excludedEdges, ...n]), t.setFields(Object.assign(t.fields, r), i);
    });
  }
  partial() {
    const r = {};
    for (const [n, t] of Object.entries(this.fields))
      r[n] = "optional" in t && t.optional instanceof Function ? t.optional() : t;
    return this.setFields(r);
  }
  deepPartial() {
    return Xn(this);
  }
  pick(r) {
    const n = {};
    for (const t of r)
      this.fields[t] && (n[t] = this.fields[t]);
    return this.setFields(n, this._excludedEdges.filter(([t, i]) => r.includes(t) && r.includes(i)));
  }
  omit(r) {
    const n = [];
    for (const t of Object.keys(this.fields))
      r.includes(t) || n.push(t);
    return this.pick(n);
  }
  from(r, n, t) {
    let i = ar.getter(r, !0);
    return this.transform((o) => {
      if (!o) return o;
      let s = o;
      return Uh(o, r) && (s = Object.assign({}, o), t || delete s[r], s[n] = i(o)), s;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Bh);
  }
  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(r) {
    return this.test({
      name: "exact",
      exclusive: !0,
      message: r || Jn.exact,
      test(n) {
        if (n == null) return !0;
        const t = Sa(this.schema, n);
        return t.length === 0 || this.createError({
          params: {
            properties: t.join(", ")
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: !0
    });
  }
  noUnknown(r = !0, n = Jn.noUnknown) {
    typeof r != "boolean" && (n = r, r = !0);
    let t = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test(i) {
        if (i == null) return !0;
        const o = Sa(this.schema, i);
        return !r || o.length === 0 || this.createError({
          params: {
            unknown: o.join(", ")
          }
        });
      }
    });
    return t.spec.noUnknown = r, t;
  }
  unknown(r = !0, n = Jn.noUnknown) {
    return this.noUnknown(!r, n);
  }
  transformKeys(r) {
    return this.transform((n) => {
      if (!n) return n;
      const t = {};
      for (const i of Object.keys(n)) t[r(i)] = n[i];
      return t;
    });
  }
  camelCase() {
    return this.transformKeys(Ji.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Ji.snakeCase);
  }
  constantCase() {
    return this.transformKeys((r) => Ji.snakeCase(r).toUpperCase());
  }
  describe(r) {
    const n = (r ? this.resolve(r) : this).clone(), t = super.describe(r);
    t.fields = {};
    for (const [o, s] of Object.entries(n.fields)) {
      var i;
      let a = r;
      (i = a) != null && i.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[o]
      })), t.fields[o] = s.describe(a);
    }
    return t;
  }
}
Qn.prototype = uc.prototype;
class cc extends Error {
  constructor(r) {
    super(r), this.name = "LocalLogicTracking/UnknownError";
  }
}
class lc extends Error {
  constructor(r) {
    super(r), this.name = "LocalLogicTracking/ValidationError";
  }
}
const Ca = (e) => {
  throw e instanceof qe ? new lc(e.message) : e instanceof ui ? new ui(e.message) : new cc(e.message);
}, qh = (e, r, n) => {
  const t = n.value;
  return n.value = function(...i) {
    try {
      const o = t.apply(this, i);
      return o && o instanceof Promise ? o.catch((s) => {
        Ca(s);
      }) : o;
    } catch (o) {
      Ca(o);
    }
  }, n;
}, jh = ["1.0.0"], Wh = Qn({
  event_type: Ot().required(),
  event_version: Ot().required().oneOf(jh),
  isTestEvent: ic(),
  meta: Qn({
    user_id: Ot(),
    session_id: Ot(),
    page_load_id: Ot(),
    product_version: Ot(),
    client_id: Ot(),
    product_name: Ot().required()
  }),
  attributes: Qn({})
}), Gh = (e) => async (r) => {
  const n = await Wh.validate(r), {
    event_type: t,
    isTestEvent: i,
    event_version: o,
    meta: s,
    attributes: a
  } = n;
  try {
    return await e.post("/record", {
      params: {
        event_type: t,
        event_version: o,
        isTestEvent: i,
        meta: s,
        attributes: a
      }
    });
  } catch (u) {
    if (u instanceof TypeError && (u.message.toLowerCase().includes("networkerror") || u.message.toLowerCase().includes("load failed") || u.message.toLowerCase().includes("failed to fetch")) || u instanceof DOMException && u.message.toLowerCase().includes("aborted") || u instanceof TypeError && u.message.toLowerCase().includes("cancelled") || u instanceof TypeError && u.message.toLowerCase().includes("annulé"))
      return;
    throw u;
  }
};
var Vh = Object.defineProperty, Yh = Object.getOwnPropertyDescriptor, Hh = (e, r, n, t) => {
  for (var i = Yh(r, n), o = e.length - 1, s; o >= 0; o--)
    (s = e[o]) && (i = s(r, n, i) || i);
  return i && Vh(r, n, i), i;
};
class fc {
  constructor(r) {
    this.requests = sh(r);
  }
  postEvent(r) {
    const n = {
      ...r,
      meta: {
        ...r.meta,
        event_time: /* @__PURE__ */ new Date()
      }
    };
    return Gh(this.requests)(n);
  }
}
Hh([
  qh
], fc.prototype, "postEvent");
const Zh = (e) => new fc(e);
var hc = {}, Fi = {};
Fi.byteLength = Xh;
Fi.toByteArray = ep;
Fi.fromByteArray = np;
var vt = [], Xe = [], Kh = typeof Uint8Array < "u" ? Uint8Array : Array, Xi = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var vr = 0, Jh = Xi.length; vr < Jh; ++vr)
  vt[vr] = Xi[vr], Xe[Xi.charCodeAt(vr)] = vr;
Xe[45] = 62;
Xe[95] = 63;
function pc(e) {
  var r = e.length;
  if (r % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = r);
  var t = n === r ? 0 : 4 - n % 4;
  return [n, t];
}
function Xh(e) {
  var r = pc(e), n = r[0], t = r[1];
  return (n + t) * 3 / 4 - t;
}
function Qh(e, r, n) {
  return (r + n) * 3 / 4 - n;
}
function ep(e) {
  var r, n = pc(e), t = n[0], i = n[1], o = new Kh(Qh(e, t, i)), s = 0, a = i > 0 ? t - 4 : t, u;
  for (u = 0; u < a; u += 4)
    r = Xe[e.charCodeAt(u)] << 18 | Xe[e.charCodeAt(u + 1)] << 12 | Xe[e.charCodeAt(u + 2)] << 6 | Xe[e.charCodeAt(u + 3)], o[s++] = r >> 16 & 255, o[s++] = r >> 8 & 255, o[s++] = r & 255;
  return i === 2 && (r = Xe[e.charCodeAt(u)] << 2 | Xe[e.charCodeAt(u + 1)] >> 4, o[s++] = r & 255), i === 1 && (r = Xe[e.charCodeAt(u)] << 10 | Xe[e.charCodeAt(u + 1)] << 4 | Xe[e.charCodeAt(u + 2)] >> 2, o[s++] = r >> 8 & 255, o[s++] = r & 255), o;
}
function tp(e) {
  return vt[e >> 18 & 63] + vt[e >> 12 & 63] + vt[e >> 6 & 63] + vt[e & 63];
}
function rp(e, r, n) {
  for (var t, i = [], o = r; o < n; o += 3)
    t = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (e[o + 2] & 255), i.push(tp(t));
  return i.join("");
}
function np(e) {
  for (var r, n = e.length, t = n % 3, i = [], o = 16383, s = 0, a = n - t; s < a; s += o)
    i.push(rp(e, s, s + o > a ? a : s + o));
  return t === 1 ? (r = e[n - 1], i.push(
    vt[r >> 2] + vt[r << 4 & 63] + "=="
  )) : t === 2 && (r = (e[n - 2] << 8) + e[n - 1], i.push(
    vt[r >> 10] + vt[r >> 4 & 63] + vt[r << 2 & 63] + "="
  )), i.join("");
}
var Cs = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Cs.read = function(e, r, n, t, i) {
  var o, s, a = i * 8 - t - 1, u = (1 << a) - 1, l = u >> 1, c = -7, h = n ? i - 1 : 0, m = n ? -1 : 1, v = e[r + h];
  for (h += m, o = v & (1 << -c) - 1, v >>= -c, c += a; c > 0; o = o * 256 + e[r + h], h += m, c -= 8)
    ;
  for (s = o & (1 << -c) - 1, o >>= -c, c += t; c > 0; s = s * 256 + e[r + h], h += m, c -= 8)
    ;
  if (o === 0)
    o = 1 - l;
  else {
    if (o === u)
      return s ? NaN : (v ? -1 : 1) * (1 / 0);
    s = s + Math.pow(2, t), o = o - l;
  }
  return (v ? -1 : 1) * s * Math.pow(2, o - t);
};
Cs.write = function(e, r, n, t, i, o) {
  var s, a, u, l = o * 8 - i - 1, c = (1 << l) - 1, h = c >> 1, m = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, v = t ? 0 : o - 1, y = t ? 1 : -1, S = r < 0 || r === 0 && 1 / r < 0 ? 1 : 0;
  for (r = Math.abs(r), isNaN(r) || r === 1 / 0 ? (a = isNaN(r) ? 1 : 0, s = c) : (s = Math.floor(Math.log(r) / Math.LN2), r * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), s + h >= 1 ? r += m / u : r += m * Math.pow(2, 1 - h), r * u >= 2 && (s++, u /= 2), s + h >= c ? (a = 0, s = c) : s + h >= 1 ? (a = (r * u - 1) * Math.pow(2, i), s = s + h) : (a = r * Math.pow(2, h - 1) * Math.pow(2, i), s = 0)); i >= 8; e[n + v] = a & 255, v += y, a /= 256, i -= 8)
    ;
  for (s = s << i | a, l += i; l > 0; e[n + v] = s & 255, v += y, s /= 256, l -= 8)
    ;
  e[n + v - y] |= S * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const r = Fi, n = Cs, t = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = c, e.SlowBuffer = A, e.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  e.kMaxLength = i;
  const { Uint8Array: o, ArrayBuffer: s, SharedArrayBuffer: a } = globalThis;
  c.TYPED_ARRAY_SUPPORT = u(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function u() {
    try {
      const g = new o(1), f = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(f, o.prototype), Object.setPrototypeOf(g, f), g.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(c.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(c.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.byteOffset;
    }
  });
  function l(g) {
    if (g > i)
      throw new RangeError('The value "' + g + '" is invalid for option "size"');
    const f = new o(g);
    return Object.setPrototypeOf(f, c.prototype), f;
  }
  function c(g, f, p) {
    if (typeof g == "number") {
      if (typeof f == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return y(g);
    }
    return h(g, f, p);
  }
  c.poolSize = 8192;
  function h(g, f, p) {
    if (typeof g == "string")
      return S(g, f);
    if (s.isView(g))
      return b(g);
    if (g == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof g
      );
    if (Oe(g, s) || g && Oe(g.buffer, s) || typeof a < "u" && (Oe(g, a) || g && Oe(g.buffer, a)))
      return C(g, f, p);
    if (typeof g == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const w = g.valueOf && g.valueOf();
    if (w != null && w !== g)
      return c.from(w, f, p);
    const x = E(g);
    if (x) return x;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof g[Symbol.toPrimitive] == "function")
      return c.from(g[Symbol.toPrimitive]("string"), f, p);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof g
    );
  }
  c.from = function(g, f, p) {
    return h(g, f, p);
  }, Object.setPrototypeOf(c.prototype, o.prototype), Object.setPrototypeOf(c, o);
  function m(g) {
    if (typeof g != "number")
      throw new TypeError('"size" argument must be of type number');
    if (g < 0)
      throw new RangeError('The value "' + g + '" is invalid for option "size"');
  }
  function v(g, f, p) {
    return m(g), g <= 0 ? l(g) : f !== void 0 ? typeof p == "string" ? l(g).fill(f, p) : l(g).fill(f) : l(g);
  }
  c.alloc = function(g, f, p) {
    return v(g, f, p);
  };
  function y(g) {
    return m(g), l(g < 0 ? 0 : R(g) | 0);
  }
  c.allocUnsafe = function(g) {
    return y(g);
  }, c.allocUnsafeSlow = function(g) {
    return y(g);
  };
  function S(g, f) {
    if ((typeof f != "string" || f === "") && (f = "utf8"), !c.isEncoding(f))
      throw new TypeError("Unknown encoding: " + f);
    const p = M(g, f) | 0;
    let w = l(p);
    const x = w.write(g, f);
    return x !== p && (w = w.slice(0, x)), w;
  }
  function _(g) {
    const f = g.length < 0 ? 0 : R(g.length) | 0, p = l(f);
    for (let w = 0; w < f; w += 1)
      p[w] = g[w] & 255;
    return p;
  }
  function b(g) {
    if (Oe(g, o)) {
      const f = new o(g);
      return C(f.buffer, f.byteOffset, f.byteLength);
    }
    return _(g);
  }
  function C(g, f, p) {
    if (f < 0 || g.byteLength < f)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (g.byteLength < f + (p || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let w;
    return f === void 0 && p === void 0 ? w = new o(g) : p === void 0 ? w = new o(g, f) : w = new o(g, f, p), Object.setPrototypeOf(w, c.prototype), w;
  }
  function E(g) {
    if (c.isBuffer(g)) {
      const f = R(g.length) | 0, p = l(f);
      return p.length === 0 || g.copy(p, 0, 0, f), p;
    }
    if (g.length !== void 0)
      return typeof g.length != "number" || rt(g.length) ? l(0) : _(g);
    if (g.type === "Buffer" && Array.isArray(g.data))
      return _(g.data);
  }
  function R(g) {
    if (g >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return g | 0;
  }
  function A(g) {
    return +g != g && (g = 0), c.alloc(+g);
  }
  c.isBuffer = function(f) {
    return f != null && f._isBuffer === !0 && f !== c.prototype;
  }, c.compare = function(f, p) {
    if (Oe(f, o) && (f = c.from(f, f.offset, f.byteLength)), Oe(p, o) && (p = c.from(p, p.offset, p.byteLength)), !c.isBuffer(f) || !c.isBuffer(p))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (f === p) return 0;
    let w = f.length, x = p.length;
    for (let I = 0, k = Math.min(w, x); I < k; ++I)
      if (f[I] !== p[I]) {
        w = f[I], x = p[I];
        break;
      }
    return w < x ? -1 : x < w ? 1 : 0;
  }, c.isEncoding = function(f) {
    switch (String(f).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, c.concat = function(f, p) {
    if (!Array.isArray(f))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (f.length === 0)
      return c.alloc(0);
    let w;
    if (p === void 0)
      for (p = 0, w = 0; w < f.length; ++w)
        p += f[w].length;
    const x = c.allocUnsafe(p);
    let I = 0;
    for (w = 0; w < f.length; ++w) {
      let k = f[w];
      if (Oe(k, o))
        I + k.length > x.length ? (c.isBuffer(k) || (k = c.from(k)), k.copy(x, I)) : o.prototype.set.call(
          x,
          k,
          I
        );
      else if (c.isBuffer(k))
        k.copy(x, I);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      I += k.length;
    }
    return x;
  };
  function M(g, f) {
    if (c.isBuffer(g))
      return g.length;
    if (s.isView(g) || Oe(g, s))
      return g.byteLength;
    if (typeof g != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof g
      );
    const p = g.length, w = arguments.length > 2 && arguments[2] === !0;
    if (!w && p === 0) return 0;
    let x = !1;
    for (; ; )
      switch (f) {
        case "ascii":
        case "latin1":
        case "binary":
          return p;
        case "utf8":
        case "utf-8":
          return Ye(g).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return p * 2;
        case "hex":
          return p >>> 1;
        case "base64":
          return jr(g).length;
        default:
          if (x)
            return w ? -1 : Ye(g).length;
          f = ("" + f).toLowerCase(), x = !0;
      }
  }
  c.byteLength = M;
  function L(g, f, p) {
    let w = !1;
    if ((f === void 0 || f < 0) && (f = 0), f > this.length || ((p === void 0 || p > this.length) && (p = this.length), p <= 0) || (p >>>= 0, f >>>= 0, p <= f))
      return "";
    for (g || (g = "utf8"); ; )
      switch (g) {
        case "hex":
          return Ze(this, f, p);
        case "utf8":
        case "utf-8":
          return Ee(this, f, p);
        case "ascii":
          return De(this, f, p);
        case "latin1":
        case "binary":
          return St(this, f, p);
        case "base64":
          return Pe(this, f, p);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Lt(this, f, p);
        default:
          if (w) throw new TypeError("Unknown encoding: " + g);
          g = (g + "").toLowerCase(), w = !0;
      }
  }
  c.prototype._isBuffer = !0;
  function N(g, f, p) {
    const w = g[f];
    g[f] = g[p], g[p] = w;
  }
  c.prototype.swap16 = function() {
    const f = this.length;
    if (f % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let p = 0; p < f; p += 2)
      N(this, p, p + 1);
    return this;
  }, c.prototype.swap32 = function() {
    const f = this.length;
    if (f % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let p = 0; p < f; p += 4)
      N(this, p, p + 3), N(this, p + 1, p + 2);
    return this;
  }, c.prototype.swap64 = function() {
    const f = this.length;
    if (f % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let p = 0; p < f; p += 8)
      N(this, p, p + 7), N(this, p + 1, p + 6), N(this, p + 2, p + 5), N(this, p + 3, p + 4);
    return this;
  }, c.prototype.toString = function() {
    const f = this.length;
    return f === 0 ? "" : arguments.length === 0 ? Ee(this, 0, f) : L.apply(this, arguments);
  }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(f) {
    if (!c.isBuffer(f)) throw new TypeError("Argument must be a Buffer");
    return this === f ? !0 : c.compare(this, f) === 0;
  }, c.prototype.inspect = function() {
    let f = "";
    const p = e.INSPECT_MAX_BYTES;
    return f = this.toString("hex", 0, p).replace(/(.{2})/g, "$1 ").trim(), this.length > p && (f += " ... "), "<Buffer " + f + ">";
  }, t && (c.prototype[t] = c.prototype.inspect), c.prototype.compare = function(f, p, w, x, I) {
    if (Oe(f, o) && (f = c.from(f, f.offset, f.byteLength)), !c.isBuffer(f))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof f
      );
    if (p === void 0 && (p = 0), w === void 0 && (w = f ? f.length : 0), x === void 0 && (x = 0), I === void 0 && (I = this.length), p < 0 || w > f.length || x < 0 || I > this.length)
      throw new RangeError("out of range index");
    if (x >= I && p >= w)
      return 0;
    if (x >= I)
      return -1;
    if (p >= w)
      return 1;
    if (p >>>= 0, w >>>= 0, x >>>= 0, I >>>= 0, this === f) return 0;
    let k = I - x, T = w - p;
    const U = Math.min(k, T), le = this.slice(x, I), me = f.slice(p, w);
    for (let se = 0; se < U; ++se)
      if (le[se] !== me[se]) {
        k = le[se], T = me[se];
        break;
      }
    return k < T ? -1 : T < k ? 1 : 0;
  };
  function B(g, f, p, w, x) {
    if (g.length === 0) return -1;
    if (typeof p == "string" ? (w = p, p = 0) : p > 2147483647 ? p = 2147483647 : p < -2147483648 && (p = -2147483648), p = +p, rt(p) && (p = x ? 0 : g.length - 1), p < 0 && (p = g.length + p), p >= g.length) {
      if (x) return -1;
      p = g.length - 1;
    } else if (p < 0)
      if (x) p = 0;
      else return -1;
    if (typeof f == "string" && (f = c.from(f, w)), c.isBuffer(f))
      return f.length === 0 ? -1 : G(g, f, p, w, x);
    if (typeof f == "number")
      return f = f & 255, typeof o.prototype.indexOf == "function" ? x ? o.prototype.indexOf.call(g, f, p) : o.prototype.lastIndexOf.call(g, f, p) : G(g, [f], p, w, x);
    throw new TypeError("val must be string, number or Buffer");
  }
  function G(g, f, p, w, x) {
    let I = 1, k = g.length, T = f.length;
    if (w !== void 0 && (w = String(w).toLowerCase(), w === "ucs2" || w === "ucs-2" || w === "utf16le" || w === "utf-16le")) {
      if (g.length < 2 || f.length < 2)
        return -1;
      I = 2, k /= 2, T /= 2, p /= 2;
    }
    function U(me, se) {
      return I === 1 ? me[se] : me.readUInt16BE(se * I);
    }
    let le;
    if (x) {
      let me = -1;
      for (le = p; le < k; le++)
        if (U(g, le) === U(f, me === -1 ? 0 : le - me)) {
          if (me === -1 && (me = le), le - me + 1 === T) return me * I;
        } else
          me !== -1 && (le -= le - me), me = -1;
    } else
      for (p + T > k && (p = k - T), le = p; le >= 0; le--) {
        let me = !0;
        for (let se = 0; se < T; se++)
          if (U(g, le + se) !== U(f, se)) {
            me = !1;
            break;
          }
        if (me) return le;
      }
    return -1;
  }
  c.prototype.includes = function(f, p, w) {
    return this.indexOf(f, p, w) !== -1;
  }, c.prototype.indexOf = function(f, p, w) {
    return B(this, f, p, w, !0);
  }, c.prototype.lastIndexOf = function(f, p, w) {
    return B(this, f, p, w, !1);
  };
  function P(g, f, p, w) {
    p = Number(p) || 0;
    const x = g.length - p;
    w ? (w = Number(w), w > x && (w = x)) : w = x;
    const I = f.length;
    w > I / 2 && (w = I / 2);
    let k;
    for (k = 0; k < w; ++k) {
      const T = parseInt(f.substr(k * 2, 2), 16);
      if (rt(T)) return k;
      g[p + k] = T;
    }
    return k;
  }
  function z(g, f, p, w) {
    return mr(Ye(f, g.length - p), g, p, w);
  }
  function Z(g, f, p, w) {
    return mr(It(f), g, p, w);
  }
  function Me(g, f, p, w) {
    return mr(jr(f), g, p, w);
  }
  function te(g, f, p, w) {
    return mr(Cn(f, g.length - p), g, p, w);
  }
  c.prototype.write = function(f, p, w, x) {
    if (p === void 0)
      x = "utf8", w = this.length, p = 0;
    else if (w === void 0 && typeof p == "string")
      x = p, w = this.length, p = 0;
    else if (isFinite(p))
      p = p >>> 0, isFinite(w) ? (w = w >>> 0, x === void 0 && (x = "utf8")) : (x = w, w = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const I = this.length - p;
    if ((w === void 0 || w > I) && (w = I), f.length > 0 && (w < 0 || p < 0) || p > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    x || (x = "utf8");
    let k = !1;
    for (; ; )
      switch (x) {
        case "hex":
          return P(this, f, p, w);
        case "utf8":
        case "utf-8":
          return z(this, f, p, w);
        case "ascii":
        case "latin1":
        case "binary":
          return Z(this, f, p, w);
        case "base64":
          return Me(this, f, p, w);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return te(this, f, p, w);
        default:
          if (k) throw new TypeError("Unknown encoding: " + x);
          x = ("" + x).toLowerCase(), k = !0;
      }
  }, c.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function Pe(g, f, p) {
    return f === 0 && p === g.length ? r.fromByteArray(g) : r.fromByteArray(g.slice(f, p));
  }
  function Ee(g, f, p) {
    p = Math.min(g.length, p);
    const w = [];
    let x = f;
    for (; x < p; ) {
      const I = g[x];
      let k = null, T = I > 239 ? 4 : I > 223 ? 3 : I > 191 ? 2 : 1;
      if (x + T <= p) {
        let U, le, me, se;
        switch (T) {
          case 1:
            I < 128 && (k = I);
            break;
          case 2:
            U = g[x + 1], (U & 192) === 128 && (se = (I & 31) << 6 | U & 63, se > 127 && (k = se));
            break;
          case 3:
            U = g[x + 1], le = g[x + 2], (U & 192) === 128 && (le & 192) === 128 && (se = (I & 15) << 12 | (U & 63) << 6 | le & 63, se > 2047 && (se < 55296 || se > 57343) && (k = se));
            break;
          case 4:
            U = g[x + 1], le = g[x + 2], me = g[x + 3], (U & 192) === 128 && (le & 192) === 128 && (me & 192) === 128 && (se = (I & 15) << 18 | (U & 63) << 12 | (le & 63) << 6 | me & 63, se > 65535 && se < 1114112 && (k = se));
        }
      }
      k === null ? (k = 65533, T = 1) : k > 65535 && (k -= 65536, w.push(k >>> 10 & 1023 | 55296), k = 56320 | k & 1023), w.push(k), x += T;
    }
    return xe(w);
  }
  const ce = 4096;
  function xe(g) {
    const f = g.length;
    if (f <= ce)
      return String.fromCharCode.apply(String, g);
    let p = "", w = 0;
    for (; w < f; )
      p += String.fromCharCode.apply(
        String,
        g.slice(w, w += ce)
      );
    return p;
  }
  function De(g, f, p) {
    let w = "";
    p = Math.min(g.length, p);
    for (let x = f; x < p; ++x)
      w += String.fromCharCode(g[x] & 127);
    return w;
  }
  function St(g, f, p) {
    let w = "";
    p = Math.min(g.length, p);
    for (let x = f; x < p; ++x)
      w += String.fromCharCode(g[x]);
    return w;
  }
  function Ze(g, f, p) {
    const w = g.length;
    (!f || f < 0) && (f = 0), (!p || p < 0 || p > w) && (p = w);
    let x = "";
    for (let I = f; I < p; ++I)
      x += Hi[g[I]];
    return x;
  }
  function Lt(g, f, p) {
    const w = g.slice(f, p);
    let x = "";
    for (let I = 0; I < w.length - 1; I += 2)
      x += String.fromCharCode(w[I] + w[I + 1] * 256);
    return x;
  }
  c.prototype.slice = function(f, p) {
    const w = this.length;
    f = ~~f, p = p === void 0 ? w : ~~p, f < 0 ? (f += w, f < 0 && (f = 0)) : f > w && (f = w), p < 0 ? (p += w, p < 0 && (p = 0)) : p > w && (p = w), p < f && (p = f);
    const x = this.subarray(f, p);
    return Object.setPrototypeOf(x, c.prototype), x;
  };
  function re(g, f, p) {
    if (g % 1 !== 0 || g < 0) throw new RangeError("offset is not uint");
    if (g + f > p) throw new RangeError("Trying to access beyond buffer length");
  }
  c.prototype.readUintLE = c.prototype.readUIntLE = function(f, p, w) {
    f = f >>> 0, p = p >>> 0, w || re(f, p, this.length);
    let x = this[f], I = 1, k = 0;
    for (; ++k < p && (I *= 256); )
      x += this[f + k] * I;
    return x;
  }, c.prototype.readUintBE = c.prototype.readUIntBE = function(f, p, w) {
    f = f >>> 0, p = p >>> 0, w || re(f, p, this.length);
    let x = this[f + --p], I = 1;
    for (; p > 0 && (I *= 256); )
      x += this[f + --p] * I;
    return x;
  }, c.prototype.readUint8 = c.prototype.readUInt8 = function(f, p) {
    return f = f >>> 0, p || re(f, 1, this.length), this[f];
  }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(f, p) {
    return f = f >>> 0, p || re(f, 2, this.length), this[f] | this[f + 1] << 8;
  }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(f, p) {
    return f = f >>> 0, p || re(f, 2, this.length), this[f] << 8 | this[f + 1];
  }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(f, p) {
    return f = f >>> 0, p || re(f, 4, this.length), (this[f] | this[f + 1] << 8 | this[f + 2] << 16) + this[f + 3] * 16777216;
  }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(f, p) {
    return f = f >>> 0, p || re(f, 4, this.length), this[f] * 16777216 + (this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3]);
  }, c.prototype.readBigUInt64LE = nt(function(f) {
    f = f >>> 0, Ve(f, "offset");
    const p = this[f], w = this[f + 7];
    (p === void 0 || w === void 0) && tt(f, this.length - 8);
    const x = p + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + this[++f] * 2 ** 24, I = this[++f] + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + w * 2 ** 24;
    return BigInt(x) + (BigInt(I) << BigInt(32));
  }), c.prototype.readBigUInt64BE = nt(function(f) {
    f = f >>> 0, Ve(f, "offset");
    const p = this[f], w = this[f + 7];
    (p === void 0 || w === void 0) && tt(f, this.length - 8);
    const x = p * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + this[++f], I = this[++f] * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + w;
    return (BigInt(x) << BigInt(32)) + BigInt(I);
  }), c.prototype.readIntLE = function(f, p, w) {
    f = f >>> 0, p = p >>> 0, w || re(f, p, this.length);
    let x = this[f], I = 1, k = 0;
    for (; ++k < p && (I *= 256); )
      x += this[f + k] * I;
    return I *= 128, x >= I && (x -= Math.pow(2, 8 * p)), x;
  }, c.prototype.readIntBE = function(f, p, w) {
    f = f >>> 0, p = p >>> 0, w || re(f, p, this.length);
    let x = p, I = 1, k = this[f + --x];
    for (; x > 0 && (I *= 256); )
      k += this[f + --x] * I;
    return I *= 128, k >= I && (k -= Math.pow(2, 8 * p)), k;
  }, c.prototype.readInt8 = function(f, p) {
    return f = f >>> 0, p || re(f, 1, this.length), this[f] & 128 ? (255 - this[f] + 1) * -1 : this[f];
  }, c.prototype.readInt16LE = function(f, p) {
    f = f >>> 0, p || re(f, 2, this.length);
    const w = this[f] | this[f + 1] << 8;
    return w & 32768 ? w | 4294901760 : w;
  }, c.prototype.readInt16BE = function(f, p) {
    f = f >>> 0, p || re(f, 2, this.length);
    const w = this[f + 1] | this[f] << 8;
    return w & 32768 ? w | 4294901760 : w;
  }, c.prototype.readInt32LE = function(f, p) {
    return f = f >>> 0, p || re(f, 4, this.length), this[f] | this[f + 1] << 8 | this[f + 2] << 16 | this[f + 3] << 24;
  }, c.prototype.readInt32BE = function(f, p) {
    return f = f >>> 0, p || re(f, 4, this.length), this[f] << 24 | this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3];
  }, c.prototype.readBigInt64LE = nt(function(f) {
    f = f >>> 0, Ve(f, "offset");
    const p = this[f], w = this[f + 7];
    (p === void 0 || w === void 0) && tt(f, this.length - 8);
    const x = this[f + 4] + this[f + 5] * 2 ** 8 + this[f + 6] * 2 ** 16 + (w << 24);
    return (BigInt(x) << BigInt(32)) + BigInt(p + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + this[++f] * 2 ** 24);
  }), c.prototype.readBigInt64BE = nt(function(f) {
    f = f >>> 0, Ve(f, "offset");
    const p = this[f], w = this[f + 7];
    (p === void 0 || w === void 0) && tt(f, this.length - 8);
    const x = (p << 24) + // Overflow
    this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + this[++f];
    return (BigInt(x) << BigInt(32)) + BigInt(this[++f] * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + w);
  }), c.prototype.readFloatLE = function(f, p) {
    return f = f >>> 0, p || re(f, 4, this.length), n.read(this, f, !0, 23, 4);
  }, c.prototype.readFloatBE = function(f, p) {
    return f = f >>> 0, p || re(f, 4, this.length), n.read(this, f, !1, 23, 4);
  }, c.prototype.readDoubleLE = function(f, p) {
    return f = f >>> 0, p || re(f, 8, this.length), n.read(this, f, !0, 52, 8);
  }, c.prototype.readDoubleBE = function(f, p) {
    return f = f >>> 0, p || re(f, 8, this.length), n.read(this, f, !1, 52, 8);
  };
  function ye(g, f, p, w, x, I) {
    if (!c.isBuffer(g)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (f > x || f < I) throw new RangeError('"value" argument is out of bounds');
    if (p + w > g.length) throw new RangeError("Index out of range");
  }
  c.prototype.writeUintLE = c.prototype.writeUIntLE = function(f, p, w, x) {
    if (f = +f, p = p >>> 0, w = w >>> 0, !x) {
      const T = Math.pow(2, 8 * w) - 1;
      ye(this, f, p, w, T, 0);
    }
    let I = 1, k = 0;
    for (this[p] = f & 255; ++k < w && (I *= 256); )
      this[p + k] = f / I & 255;
    return p + w;
  }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(f, p, w, x) {
    if (f = +f, p = p >>> 0, w = w >>> 0, !x) {
      const T = Math.pow(2, 8 * w) - 1;
      ye(this, f, p, w, T, 0);
    }
    let I = w - 1, k = 1;
    for (this[p + I] = f & 255; --I >= 0 && (k *= 256); )
      this[p + I] = f / k & 255;
    return p + w;
  }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 1, 255, 0), this[p] = f & 255, p + 1;
  }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 2, 65535, 0), this[p] = f & 255, this[p + 1] = f >>> 8, p + 2;
  }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 2, 65535, 0), this[p] = f >>> 8, this[p + 1] = f & 255, p + 2;
  }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 4, 4294967295, 0), this[p + 3] = f >>> 24, this[p + 2] = f >>> 16, this[p + 1] = f >>> 8, this[p] = f & 255, p + 4;
  }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 4, 4294967295, 0), this[p] = f >>> 24, this[p + 1] = f >>> 16, this[p + 2] = f >>> 8, this[p + 3] = f & 255, p + 4;
  };
  function J(g, f, p, w, x) {
    ft(f, w, x, g, p, 7);
    let I = Number(f & BigInt(4294967295));
    g[p++] = I, I = I >> 8, g[p++] = I, I = I >> 8, g[p++] = I, I = I >> 8, g[p++] = I;
    let k = Number(f >> BigInt(32) & BigInt(4294967295));
    return g[p++] = k, k = k >> 8, g[p++] = k, k = k >> 8, g[p++] = k, k = k >> 8, g[p++] = k, p;
  }
  function ut(g, f, p, w, x) {
    ft(f, w, x, g, p, 7);
    let I = Number(f & BigInt(4294967295));
    g[p + 7] = I, I = I >> 8, g[p + 6] = I, I = I >> 8, g[p + 5] = I, I = I >> 8, g[p + 4] = I;
    let k = Number(f >> BigInt(32) & BigInt(4294967295));
    return g[p + 3] = k, k = k >> 8, g[p + 2] = k, k = k >> 8, g[p + 1] = k, k = k >> 8, g[p] = k, p + 8;
  }
  c.prototype.writeBigUInt64LE = nt(function(f, p = 0) {
    return J(this, f, p, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeBigUInt64BE = nt(function(f, p = 0) {
    return ut(this, f, p, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeIntLE = function(f, p, w, x) {
    if (f = +f, p = p >>> 0, !x) {
      const U = Math.pow(2, 8 * w - 1);
      ye(this, f, p, w, U - 1, -U);
    }
    let I = 0, k = 1, T = 0;
    for (this[p] = f & 255; ++I < w && (k *= 256); )
      f < 0 && T === 0 && this[p + I - 1] !== 0 && (T = 1), this[p + I] = (f / k >> 0) - T & 255;
    return p + w;
  }, c.prototype.writeIntBE = function(f, p, w, x) {
    if (f = +f, p = p >>> 0, !x) {
      const U = Math.pow(2, 8 * w - 1);
      ye(this, f, p, w, U - 1, -U);
    }
    let I = w - 1, k = 1, T = 0;
    for (this[p + I] = f & 255; --I >= 0 && (k *= 256); )
      f < 0 && T === 0 && this[p + I + 1] !== 0 && (T = 1), this[p + I] = (f / k >> 0) - T & 255;
    return p + w;
  }, c.prototype.writeInt8 = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 1, 127, -128), f < 0 && (f = 255 + f + 1), this[p] = f & 255, p + 1;
  }, c.prototype.writeInt16LE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 2, 32767, -32768), this[p] = f & 255, this[p + 1] = f >>> 8, p + 2;
  }, c.prototype.writeInt16BE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 2, 32767, -32768), this[p] = f >>> 8, this[p + 1] = f & 255, p + 2;
  }, c.prototype.writeInt32LE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 4, 2147483647, -2147483648), this[p] = f & 255, this[p + 1] = f >>> 8, this[p + 2] = f >>> 16, this[p + 3] = f >>> 24, p + 4;
  }, c.prototype.writeInt32BE = function(f, p, w) {
    return f = +f, p = p >>> 0, w || ye(this, f, p, 4, 2147483647, -2147483648), f < 0 && (f = 4294967295 + f + 1), this[p] = f >>> 24, this[p + 1] = f >>> 16, this[p + 2] = f >>> 8, this[p + 3] = f & 255, p + 4;
  }, c.prototype.writeBigInt64LE = nt(function(f, p = 0) {
    return J(this, f, p, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), c.prototype.writeBigInt64BE = nt(function(f, p = 0) {
    return ut(this, f, p, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ct(g, f, p, w, x, I) {
    if (p + w > g.length) throw new RangeError("Index out of range");
    if (p < 0) throw new RangeError("Index out of range");
  }
  function Ct(g, f, p, w, x) {
    return f = +f, p = p >>> 0, x || ct(g, f, p, 4), n.write(g, f, p, w, 23, 4), p + 4;
  }
  c.prototype.writeFloatLE = function(f, p, w) {
    return Ct(this, f, p, !0, w);
  }, c.prototype.writeFloatBE = function(f, p, w) {
    return Ct(this, f, p, !1, w);
  };
  function Bt(g, f, p, w, x) {
    return f = +f, p = p >>> 0, x || ct(g, f, p, 8), n.write(g, f, p, w, 52, 8), p + 8;
  }
  c.prototype.writeDoubleLE = function(f, p, w) {
    return Bt(this, f, p, !0, w);
  }, c.prototype.writeDoubleBE = function(f, p, w) {
    return Bt(this, f, p, !1, w);
  }, c.prototype.copy = function(f, p, w, x) {
    if (!c.isBuffer(f)) throw new TypeError("argument should be a Buffer");
    if (w || (w = 0), !x && x !== 0 && (x = this.length), p >= f.length && (p = f.length), p || (p = 0), x > 0 && x < w && (x = w), x === w || f.length === 0 || this.length === 0) return 0;
    if (p < 0)
      throw new RangeError("targetStart out of bounds");
    if (w < 0 || w >= this.length) throw new RangeError("Index out of range");
    if (x < 0) throw new RangeError("sourceEnd out of bounds");
    x > this.length && (x = this.length), f.length - p < x - w && (x = f.length - p + w);
    const I = x - w;
    return this === f && typeof o.prototype.copyWithin == "function" ? this.copyWithin(p, w, x) : o.prototype.set.call(
      f,
      this.subarray(w, x),
      p
    ), I;
  }, c.prototype.fill = function(f, p, w, x) {
    if (typeof f == "string") {
      if (typeof p == "string" ? (x = p, p = 0, w = this.length) : typeof w == "string" && (x = w, w = this.length), x !== void 0 && typeof x != "string")
        throw new TypeError("encoding must be a string");
      if (typeof x == "string" && !c.isEncoding(x))
        throw new TypeError("Unknown encoding: " + x);
      if (f.length === 1) {
        const k = f.charCodeAt(0);
        (x === "utf8" && k < 128 || x === "latin1") && (f = k);
      }
    } else typeof f == "number" ? f = f & 255 : typeof f == "boolean" && (f = Number(f));
    if (p < 0 || this.length < p || this.length < w)
      throw new RangeError("Out of range index");
    if (w <= p)
      return this;
    p = p >>> 0, w = w === void 0 ? this.length : w >>> 0, f || (f = 0);
    let I;
    if (typeof f == "number")
      for (I = p; I < w; ++I)
        this[I] = f;
    else {
      const k = c.isBuffer(f) ? f : c.from(f, x), T = k.length;
      if (T === 0)
        throw new TypeError('The value "' + f + '" is invalid for argument "value"');
      for (I = 0; I < w - p; ++I)
        this[I + p] = k[I % T];
    }
    return this;
  };
  const Ke = {};
  function nr(g, f, p) {
    Ke[g] = class extends p {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: f.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${g}]`, this.stack, delete this.name;
      }
      get code() {
        return g;
      }
      set code(x) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: x,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${g}]: ${this.message}`;
      }
    };
  }
  nr(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(g) {
      return g ? `${g} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), nr(
    "ERR_INVALID_ARG_TYPE",
    function(g, f) {
      return `The "${g}" argument must be of type number. Received type ${typeof f}`;
    },
    TypeError
  ), nr(
    "ERR_OUT_OF_RANGE",
    function(g, f, p) {
      let w = `The value of "${g}" is out of range.`, x = p;
      return Number.isInteger(p) && Math.abs(p) > 2 ** 32 ? x = ir(String(p)) : typeof p == "bigint" && (x = String(p), (p > BigInt(2) ** BigInt(32) || p < -(BigInt(2) ** BigInt(32))) && (x = ir(x)), x += "n"), w += ` It must be ${f}. Received ${x}`, w;
    },
    RangeError
  );
  function ir(g) {
    let f = "", p = g.length;
    const w = g[0] === "-" ? 1 : 0;
    for (; p >= w + 4; p -= 3)
      f = `_${g.slice(p - 3, p)}${f}`;
    return `${g.slice(0, p)}${f}`;
  }
  function lt(g, f, p) {
    Ve(f, "offset"), (g[f] === void 0 || g[f + p] === void 0) && tt(f, g.length - (p + 1));
  }
  function ft(g, f, p, w, x, I) {
    if (g > p || g < f) {
      const k = typeof f == "bigint" ? "n" : "";
      let T;
      throw f === 0 || f === BigInt(0) ? T = `>= 0${k} and < 2${k} ** ${(I + 1) * 8}${k}` : T = `>= -(2${k} ** ${(I + 1) * 8 - 1}${k}) and < 2 ** ${(I + 1) * 8 - 1}${k}`, new Ke.ERR_OUT_OF_RANGE("value", T, g);
    }
    lt(w, x, I);
  }
  function Ve(g, f) {
    if (typeof g != "number")
      throw new Ke.ERR_INVALID_ARG_TYPE(f, "number", g);
  }
  function tt(g, f, p) {
    throw Math.floor(g) !== g ? (Ve(g, p), new Ke.ERR_OUT_OF_RANGE("offset", "an integer", g)) : f < 0 ? new Ke.ERR_BUFFER_OUT_OF_BOUNDS() : new Ke.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${f}`,
      g
    );
  }
  const Ut = /[^+/0-9A-Za-z-_]/g;
  function xt(g) {
    if (g = g.split("=")[0], g = g.trim().replace(Ut, ""), g.length < 2) return "";
    for (; g.length % 4 !== 0; )
      g = g + "=";
    return g;
  }
  function Ye(g, f) {
    f = f || 1 / 0;
    let p;
    const w = g.length;
    let x = null;
    const I = [];
    for (let k = 0; k < w; ++k) {
      if (p = g.charCodeAt(k), p > 55295 && p < 57344) {
        if (!x) {
          if (p > 56319) {
            (f -= 3) > -1 && I.push(239, 191, 189);
            continue;
          } else if (k + 1 === w) {
            (f -= 3) > -1 && I.push(239, 191, 189);
            continue;
          }
          x = p;
          continue;
        }
        if (p < 56320) {
          (f -= 3) > -1 && I.push(239, 191, 189), x = p;
          continue;
        }
        p = (x - 55296 << 10 | p - 56320) + 65536;
      } else x && (f -= 3) > -1 && I.push(239, 191, 189);
      if (x = null, p < 128) {
        if ((f -= 1) < 0) break;
        I.push(p);
      } else if (p < 2048) {
        if ((f -= 2) < 0) break;
        I.push(
          p >> 6 | 192,
          p & 63 | 128
        );
      } else if (p < 65536) {
        if ((f -= 3) < 0) break;
        I.push(
          p >> 12 | 224,
          p >> 6 & 63 | 128,
          p & 63 | 128
        );
      } else if (p < 1114112) {
        if ((f -= 4) < 0) break;
        I.push(
          p >> 18 | 240,
          p >> 12 & 63 | 128,
          p >> 6 & 63 | 128,
          p & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return I;
  }
  function It(g) {
    const f = [];
    for (let p = 0; p < g.length; ++p)
      f.push(g.charCodeAt(p) & 255);
    return f;
  }
  function Cn(g, f) {
    let p, w, x;
    const I = [];
    for (let k = 0; k < g.length && !((f -= 2) < 0); ++k)
      p = g.charCodeAt(k), w = p >> 8, x = p % 256, I.push(x), I.push(w);
    return I;
  }
  function jr(g) {
    return r.toByteArray(xt(g));
  }
  function mr(g, f, p, w) {
    let x;
    for (x = 0; x < w && !(x + p >= f.length || x >= g.length); ++x)
      f[x + p] = g[x];
    return x;
  }
  function Oe(g, f) {
    return g instanceof f || g != null && g.constructor != null && g.constructor.name != null && g.constructor.name === f.name;
  }
  function rt(g) {
    return g !== g;
  }
  const Hi = function() {
    const g = "0123456789abcdef", f = new Array(256);
    for (let p = 0; p < 16; ++p) {
      const w = p * 16;
      for (let x = 0; x < 16; ++x)
        f[w + x] = g[p] + g[x];
    }
    return f;
  }();
  function nt(g) {
    return typeof BigInt > "u" ? xn : g;
  }
  function xn() {
    throw new Error("BigInt not supported");
  }
})(hc);
const Vt = hc.Buffer;
function ip(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var dc = { exports: {} }, we = dc.exports = {}, mt, gt;
function Eo() {
  throw new Error("setTimeout has not been defined");
}
function Oo() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? mt = setTimeout : mt = Eo;
  } catch {
    mt = Eo;
  }
  try {
    typeof clearTimeout == "function" ? gt = clearTimeout : gt = Oo;
  } catch {
    gt = Oo;
  }
})();
function mc(e) {
  if (mt === setTimeout)
    return setTimeout(e, 0);
  if ((mt === Eo || !mt) && setTimeout)
    return mt = setTimeout, setTimeout(e, 0);
  try {
    return mt(e, 0);
  } catch {
    try {
      return mt.call(null, e, 0);
    } catch {
      return mt.call(this, e, 0);
    }
  }
}
function op(e) {
  if (gt === clearTimeout)
    return clearTimeout(e);
  if ((gt === Oo || !gt) && clearTimeout)
    return gt = clearTimeout, clearTimeout(e);
  try {
    return gt(e);
  } catch {
    try {
      return gt.call(null, e);
    } catch {
      return gt.call(this, e);
    }
  }
}
var Tt = [], Or = !1, or, ei = -1;
function sp() {
  !Or || !or || (Or = !1, or.length ? Tt = or.concat(Tt) : ei = -1, Tt.length && gc());
}
function gc() {
  if (!Or) {
    var e = mc(sp);
    Or = !0;
    for (var r = Tt.length; r; ) {
      for (or = Tt, Tt = []; ++ei < r; )
        or && or[ei].run();
      ei = -1, r = Tt.length;
    }
    or = null, Or = !1, op(e);
  }
}
we.nextTick = function(e) {
  var r = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      r[n - 1] = arguments[n];
  Tt.push(new vc(e, r)), Tt.length === 1 && !Or && mc(gc);
};
function vc(e, r) {
  this.fun = e, this.array = r;
}
vc.prototype.run = function() {
  this.fun.apply(null, this.array);
};
we.title = "browser";
we.browser = !0;
we.env = {};
we.argv = [];
we.version = "";
we.versions = {};
function Nt() {
}
we.on = Nt;
we.addListener = Nt;
we.once = Nt;
we.off = Nt;
we.removeListener = Nt;
we.removeAllListeners = Nt;
we.emit = Nt;
we.prependListener = Nt;
we.prependOnceListener = Nt;
we.listeners = function(e) {
  return [];
};
we.binding = function(e) {
  throw new Error("process.binding is not supported");
};
we.cwd = function() {
  return "/";
};
we.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
we.umask = function() {
  return 0;
};
var ap = dc.exports;
const We = /* @__PURE__ */ ip(ap);
var $;
if (typeof window > "u") {
  var xa = {
    hostname: ""
  };
  $ = {
    crypto: { randomUUID: function() {
      throw Error("unsupported");
    } },
    navigator: { userAgent: "", onLine: !0 },
    document: {
      createElement: function() {
        return {};
      },
      location: xa,
      referrer: ""
    },
    screen: { width: 0, height: 0 },
    location: xa,
    addEventListener: function() {
    },
    removeEventListener: function() {
    }
  };
} else
  $ = window;
function Ia(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var n = 0, t = new Array(r); n < r; n++) t[n] = e[n];
  return t;
}
function Ea(e, r, n, t, i, o, s) {
  try {
    var a = e[o](s), u = a.value;
  } catch (l) {
    n(l);
    return;
  }
  a.done ? r(u) : Promise.resolve(u).then(t, i);
}
function xs(e) {
  return function() {
    var r = this, n = arguments;
    return new Promise(function(t, i) {
      var o = e.apply(r, n);
      function s(u) {
        Ea(o, t, i, s, a, "next", u);
      }
      function a(u) {
        Ea(o, t, i, s, a, "throw", u);
      }
      s(void 0);
    });
  };
}
function ti(e, r, n) {
  return yc() ? ti = Reflect.construct : ti = function(i, o, s) {
    var a = [
      null
    ];
    a.push.apply(a, o);
    var u = Function.bind.apply(i, a), l = new u();
    return s && rn(l, s.prototype), l;
  }, ti.apply(null, arguments);
}
function up(e, r) {
  for (var n = 0; n < r.length; n++) {
    var t = r[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function Te(e, r, n) {
  return r && up(e.prototype, r), e;
}
function Q() {
  return Q = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, Q.apply(this, arguments);
}
function ko(e) {
  return ko = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ko(e);
}
function Ne(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && rn(e, r);
}
function W(e, r) {
  return r != null && typeof Symbol < "u" && r[Symbol.hasInstance] ? !!r[Symbol.hasInstance](e) : e instanceof r;
}
function cp(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function tn(e, r) {
  if (e == null) return {};
  var n = {}, t = Object.keys(e), i, o;
  for (o = 0; o < t.length; o++)
    i = t[o], !(r.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function rn(e, r) {
  return rn = Object.setPrototypeOf || function(t, i) {
    return t.__proto__ = i, t;
  }, rn(e, r);
}
function H(e) {
  "@swc/helpers - typeof";
  return e && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e;
}
function lp(e, r) {
  if (e) {
    if (typeof e == "string") return Ia(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ia(e, r);
  }
}
function fi(e) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return fi = function(t) {
    if (t === null || !cp(t)) return t;
    if (typeof t != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof r < "u") {
      if (r.has(t)) return r.get(t);
      r.set(t, i);
    }
    function i() {
      return ti(t, arguments, ko(this).constructor);
    }
    return i.prototype = Object.create(t.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), rn(i, t);
  }, fi(e);
}
function yc() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yc = function() {
    return !!e;
  })();
}
function D(e, r) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = lp(e)) || r) {
    n && (e = n);
    var t = 0;
    return function() {
      return t >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[t++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function nn(e, r) {
  var n, t, i, o, s = {
    label: 0,
    sent: function() {
      if (i[0] & 1) throw i[1];
      return i[1];
    },
    trys: [],
    ops: []
  };
  return o = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(l) {
    return function(c) {
      return u([
        l,
        c
      ]);
    };
  }
  function u(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; s; ) try {
      if (n = 1, t && (i = l[0] & 2 ? t.return : l[0] ? t.throw || ((i = t.return) && i.call(t), 0) : t.next) && !(i = i.call(t, l[1])).done) return i;
      switch (t = 0, i && (l = [
        l[0] & 2,
        i.value
      ]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return s.label++, {
            value: l[1],
            done: !1
          };
        case 5:
          s.label++, t = l[1], l = [
            0
          ];
          continue;
        case 7:
          l = s.ops.pop(), s.trys.pop();
          continue;
        default:
          if (i = s.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            s = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            s.label = l[1];
            break;
          }
          if (l[0] === 6 && s.label < i[1]) {
            s.label = i[1], i = l;
            break;
          }
          if (i && s.label < i[2]) {
            s.label = i[2], s.ops.push(l);
            break;
          }
          i[2] && s.ops.pop(), s.trys.pop();
          continue;
      }
      l = r.call(e, s);
    } catch (c) {
      l = [
        6,
        c
      ], t = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return {
      value: l[0] ? l[1] : void 0,
      done: !0
    };
  }
}
function _c(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, n = r && e[r], t = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && t >= e.length && (e = void 0), {
        value: e && e[t++],
        done: !e
      };
    }
  };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
var fp = Object.defineProperty, hp = function(e, r, n) {
  return r in e ? fp(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[r] = n;
}, F = function(e, r, n) {
  return hp(e, (typeof r > "u" ? "undefined" : H(r)) !== "symbol" ? r + "" : r, n);
}, Oa, pp = Object.defineProperty, dp = function(e, r, n) {
  return r in e ? pp(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[r] = n;
}, ka = function(e, r, n) {
  return dp(e, (typeof r > "u" ? "undefined" : H(r)) !== "symbol" ? r + "" : r, n);
}, Ie = /* @__PURE__ */ function(e) {
  return e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e;
}(Ie || {}), Aa = {
  Node: [
    "childNodes",
    "parentNode",
    "parentElement",
    "textContent"
  ],
  ShadowRoot: [
    "host",
    "styleSheets"
  ],
  Element: [
    "shadowRoot",
    "querySelector",
    "querySelectorAll"
  ],
  MutationObserver: []
}, Ra = {
  Node: [
    "contains",
    "getRootNode"
  ],
  ShadowRoot: [
    "getSelection"
  ],
  Element: [],
  MutationObserver: [
    "constructor"
  ]
}, On = {}, mp = function() {
  return !!globalThis.Zone;
};
function Is(e) {
  if (On[e]) return On[e];
  var r = globalThis[e], n = r.prototype, t = e in Aa ? Aa[e] : void 0, i = !!(t && // @ts-expect-error 2345
  t.every(function(c) {
    var h, m;
    return !!((m = (h = Object.getOwnPropertyDescriptor(n, c)) == null ? void 0 : h.get) != null && m.toString().includes("[native code]"));
  })), o = e in Ra ? Ra[e] : void 0, s = !!(o && o.every(
    // @ts-expect-error 2345
    function(c) {
      var h;
      return typeof n[c] == "function" && ((h = n[c]) == null ? void 0 : h.toString().includes("[native code]"));
    }
  ));
  if (i && s && !mp())
    return On[e] = r.prototype, r.prototype;
  try {
    var a = document.createElement("iframe");
    document.body.appendChild(a);
    var u = a.contentWindow;
    if (!u) return r.prototype;
    var l = u[e].prototype;
    return document.body.removeChild(a), l ? On[e] = l : n;
  } catch {
    return n;
  }
}
var Qi = {};
function Zt(e, r, n) {
  var t, i = e + "." + String(n);
  if (Qi[i]) return Qi[i].call(r);
  var o = Is(e), s = (t = Object.getOwnPropertyDescriptor(o, n)) == null ? void 0 : t.get;
  return s ? (Qi[i] = s, s.call(r)) : r[n];
}
var eo = {};
function wc(e, r, n) {
  var t = e + "." + String(n);
  if (eo[t]) return eo[t].bind(r);
  var i = Is(e), o = i[n];
  return typeof o != "function" ? r[n] : (eo[t] = o, o.bind(r));
}
function gp(e) {
  return Zt("Node", e, "childNodes");
}
function vp(e) {
  return Zt("Node", e, "parentNode");
}
function yp(e) {
  return Zt("Node", e, "parentElement");
}
function _p(e) {
  return Zt("Node", e, "textContent");
}
function wp(e, r) {
  return wc("Node", e, "contains")(r);
}
function bp(e) {
  return wc("Node", e, "getRootNode")();
}
function Sp(e) {
  return !e || !("host" in e) ? null : Zt("ShadowRoot", e, "host");
}
function Cp(e) {
  return e.styleSheets;
}
function xp(e) {
  return !e || !("shadowRoot" in e) ? null : Zt("Element", e, "shadowRoot");
}
function Ip(e, r) {
  return Zt("Element", e, "querySelector")(r);
}
function Ep(e, r) {
  return Zt("Element", e, "querySelectorAll")(r);
}
function Op() {
  return Is("MutationObserver").constructor;
}
var $e = {
  childNodes: gp,
  parentNode: vp,
  parentElement: yp,
  textContent: _p,
  contains: wp,
  getRootNode: bp,
  host: Sp,
  styleSheets: Cp,
  shadowRoot: xp,
  querySelector: Ip,
  querySelectorAll: Ep,
  mutationObserver: Op
};
function bc(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Hr(e) {
  var r = (
    // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    e && "host" in e && "mode" in e && $e.host(e) || null
  );
  return !!(r && "shadowRoot" in r && $e.shadowRoot(r) === e);
}
function Zr(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function kp(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(/\sbackground-clip:\s*text;/g, " -webkit-background-clip: text; background-clip: text;")), e;
}
function Ap(e) {
  var r = e.cssText;
  if (r.split('"').length < 3) return r;
  var n = [
    "@import",
    "url(" + JSON.stringify(e.href) + ")"
  ];
  return e.layerName === "" ? n.push("layer") : e.layerName && n.push("layer(" + e.layerName + ")"), e.supportsText && n.push("supports(" + e.supportsText + ")"), e.media.length && n.push(e.media.mediaText), n.join(" ") + ";";
}
function Ao(e) {
  try {
    var r = e.rules || e.cssRules;
    if (!r)
      return null;
    var n = e.href;
    !n && e.ownerNode && e.ownerNode.ownerDocument && (n = e.ownerNode.ownerDocument.location.href);
    var t = Array.from(r, function(i) {
      return Sc(i, n);
    }).join("");
    return kp(t);
  } catch {
    return null;
  }
}
function Sc(e, r) {
  if (Tp(e)) {
    var n;
    try {
      n = // we can access the imported stylesheet rules directly
      Ao(e.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      Ap(e);
    } catch {
      n = e.cssText;
    }
    return e.styleSheet.href ? hi(n, e.styleSheet.href) : n;
  } else {
    var t = e.cssText;
    return Mp(e) && e.selectorText.includes(":") && (t = Rp(t)), r ? hi(t, r) : t;
  }
}
function Rp(e) {
  var r = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(r, "$1\\$2");
}
function Tp(e) {
  return "styleSheet" in e;
}
function Mp(e) {
  return "selectorText" in e;
}
var Cc = /* @__PURE__ */ function() {
  function e() {
    ka(this, "idNodeMap", /* @__PURE__ */ new Map()), ka(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  var r = e.prototype;
  return r.getId = function(t) {
    var i;
    if (!t) return -1;
    var o = (i = this.getMeta(t)) == null ? void 0 : i.id;
    return o ?? -1;
  }, r.getNode = function(t) {
    return this.idNodeMap.get(t) || null;
  }, r.getIds = function() {
    return Array.from(this.idNodeMap.keys());
  }, r.getMeta = function(t) {
    return this.nodeMetaMap.get(t) || null;
  }, r.removeNodeFromMap = function(t) {
    var i = this, o = this.getId(t);
    this.idNodeMap.delete(o), t.childNodes && t.childNodes.forEach(function(s) {
      return i.removeNodeFromMap(s);
    });
  }, r.has = function(t) {
    return this.idNodeMap.has(t);
  }, r.hasNode = function(t) {
    return this.nodeMetaMap.has(t);
  }, r.add = function(t, i) {
    var o = i.id;
    this.idNodeMap.set(o, t), this.nodeMetaMap.set(t, i);
  }, r.replace = function(t, i) {
    var o = this.getNode(t);
    if (o) {
      var s = this.nodeMetaMap.get(o);
      s && this.nodeMetaMap.set(i, s);
    }
    this.idNodeMap.set(t, i);
  }, r.reset = function() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }, e;
}();
function Fp() {
  return new Cc();
}
function Es(e) {
  var r = e.element, n = e.maskInputOptions, t = e.tagName, i = e.type, o = e.value, s = e.maskInputFn, a = o || "", u = i && ur(i);
  return (n[t.toLowerCase()] || u && n[u]) && (s ? a = s(a, r) : a = "*".repeat(a.length)), a;
}
function ur(e) {
  return e.toLowerCase();
}
var Ta = "__rrweb_original__";
function $p(e) {
  var r = e.getContext("2d");
  if (!r) return !0;
  for (var n = 50, t = 0; t < e.width; t += n)
    for (var i = 0; i < e.height; i += n) {
      var o = r.getImageData, s = Ta in o ? o[Ta] : o, a = new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        s.call(r, t, i, Math.min(n, e.width - t), Math.min(n, e.height - i)).data.buffer
      );
      if (a.some(function(u) {
        return u !== 0;
      })) return !1;
    }
  return !0;
}
function Os(e) {
  var r = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : r ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    ur(r)
  ) : null;
}
function xc(e, r) {
  var n;
  try {
    n = new URL(e, r ?? window.location.href);
  } catch {
    return null;
  }
  var t = /\.([0-9a-z]+)(?:$)/i, i = n.pathname.match(t), o;
  return (o = i == null ? void 0 : i[1]) != null ? o : null;
}
function Np(e) {
  var r = "";
  return e.indexOf("//") > -1 ? r = e.split("/").slice(0, 3).join("/") : r = e.split("/")[0], r = r.split("?")[0], r;
}
var Pp = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Dp = /^(?:[a-z+]+:)?\/\//i, Lp = /^www\..*/i, Bp = /^(data:)([^,]*),(.*)/i;
function hi(e, r) {
  return (e || "").replace(Pp, function(n, t, i, o, s, a) {
    var u = i || s || a, l = t || o || "";
    if (!u)
      return n;
    if (Dp.test(u) || Lp.test(u) || Bp.test(u))
      return "url(" + l + u + l + ")";
    if (u[0] === "/")
      return "url(" + l + (Np(r) + u) + l + ")";
    var c = r.split("/"), h = u.split("/");
    c.pop();
    for (var m = D(h), v; !(v = m()).done; ) {
      var y = v.value;
      y !== "." && (y === ".." ? c.pop() : c.push(y));
    }
    return "url(" + l + c.join("/") + l + ")";
  });
}
function to(e) {
  return e.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "");
}
function Up(e, r) {
  var n = Array.from(r.childNodes), t = [];
  if (n.length > 1 && e && typeof e == "string") {
    for (var i = to(e), o = 1; o < n.length; o++)
      if (n[o].textContent && typeof n[o].textContent == "string")
        for (var s = to(n[o].textContent), a = 3; a < s.length; a++) {
          var u = s.substring(0, a);
          if (i.split(u).length === 2) {
            for (var l = i.indexOf(u), c = l; c < e.length; c++)
              if (to(e.substring(0, c)).length === l) {
                t.push(e.substring(0, c)), e = e.substring(c);
                break;
              }
            break;
          }
        }
  }
  return t.push(e), t;
}
function zp(e, r) {
  return Up(e, r).join("/* rr_split */");
}
var qp = 1, jp = new RegExp("[^a-z0-9-_:]"), on = -2;
function Ic() {
  return qp++;
}
function Wp(e) {
  if (W(e, HTMLFormElement))
    return "form";
  var r = ur(e.tagName);
  return jp.test(r) ? "div" : r;
}
var yr, Ma, Gp = /^[^ \t\n\r\u000c]+/, Vp = /^[, \t\n\r\u000c]+/;
function Yp(e, r) {
  if (r.trim() === "")
    return r;
  var n = 0;
  function t(l) {
    var c, h = l.exec(r.substring(n));
    return h ? (c = h[0], n += c.length, c) : "";
  }
  for (var i = []; t(Vp), !(n >= r.length); ) {
    var o = t(Gp);
    if (o.slice(-1) === ",")
      o = Cr(e, o.substring(0, o.length - 1)), i.push(o);
    else {
      var s = "";
      o = Cr(e, o);
      for (var a = !1; ; ) {
        var u = r.charAt(n);
        if (u === "") {
          i.push((o + s).trim());
          break;
        } else if (a)
          u === ")" && (a = !1);
        else if (u === ",") {
          n += 1, i.push((o + s).trim());
          break;
        } else u === "(" && (a = !0);
        s += u, n += 1;
      }
    }
  }
  return i.join(", ");
}
var Fa = /* @__PURE__ */ new WeakMap();
function Cr(e, r) {
  return !r || r.trim() === "" ? r : ks(e, r);
}
function Hp(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function ks(e, r) {
  var n = Fa.get(e);
  if (n || (n = e.createElement("a"), Fa.set(e, n)), !r)
    r = "";
  else if (r.startsWith("blob:") || r.startsWith("data:"))
    return r;
  return n.setAttribute("href", r), n.href;
}
function Ec(e, r, n, t) {
  return t && (n === "src" || n === "href" && !(r === "use" && t[0] === "#") || n === "xlink:href" && t[0] !== "#" || n === "background" && (r === "table" || r === "td" || r === "th") ? Cr(e, t) : n === "srcset" ? Yp(e, t) : n === "style" ? hi(t, ks(e)) : r === "object" && n === "data" ? Cr(e, t) : t);
}
function Oc(e, r, n) {
  return (e === "video" || e === "audio") && r === "autoplay";
}
function Zp(e, r, n) {
  try {
    if (typeof r == "string") {
      if (e.classList.contains(r))
        return !0;
    } else
      for (var t = e.classList.length; t--; ) {
        var i = e.classList[t];
        if (r.test(i))
          return !0;
      }
    if (n)
      return e.matches(n);
  } catch {
  }
  return !1;
}
function pi(e, r, n) {
  if (!e) return !1;
  if (e.nodeType !== e.ELEMENT_NODE)
    return n ? pi($e.parentNode(e), r, n) : !1;
  for (var t = e.classList.length; t--; ) {
    var i = e.classList[t];
    if (r.test(i))
      return !0;
  }
  return n ? pi($e.parentNode(e), r, n) : !1;
}
function kc(e, r, n, t) {
  var i;
  if (bc(e)) {
    if (i = e, !$e.childNodes(i).length)
      return !1;
  } else {
    if ($e.parentElement(e) === null)
      return !1;
    i = $e.parentElement(e);
  }
  try {
    if (typeof r == "string") {
      if (t) {
        if (i.closest("." + r)) return !0;
      } else if (i.classList.contains(r)) return !0;
    } else if (pi(i, r, t)) return !0;
    if (n) {
      if (t) {
        if (i.closest(n)) return !0;
      } else if (i.matches(n)) return !0;
    }
  } catch {
  }
  return !1;
}
function Kp(e, r, n) {
  var t = e.contentWindow;
  if (t) {
    var i = !1, o;
    try {
      o = t.document.readyState;
    } catch {
      return;
    }
    if (o !== "complete") {
      var s = setTimeout(function() {
        i || (r(), i = !0);
      }, n);
      e.addEventListener("load", function() {
        clearTimeout(s), i = !0, r();
      });
      return;
    }
    var a = "about:blank";
    if (t.location.href !== a || e.src === a || e.src === "")
      return setTimeout(r, 0), e.addEventListener("load", r);
    e.addEventListener("load", r);
  }
}
function Jp(e, r, n) {
  var t = !1, i;
  try {
    i = e.sheet;
  } catch {
    return;
  }
  if (!i) {
    var o = setTimeout(function() {
      t || (r(), t = !0);
    }, n);
    e.addEventListener("load", function() {
      clearTimeout(o), t = !0, r();
    });
  }
}
function Xp(e, r) {
  var n = r.doc, t = r.mirror, i = r.blockClass, o = r.blockSelector, s = r.needsMask, a = r.inlineStylesheet, u = r.maskInputOptions, l = u === void 0 ? {} : u, c = r.maskTextFn, h = r.maskInputFn, m = r.dataURLOptions, v = m === void 0 ? {} : m, y = r.inlineImages, S = r.recordCanvas, _ = r.keepIframeSrcFn, b = r.newlyAddedElement, C = b === void 0 ? !1 : b, E = r.cssCaptured, R = E === void 0 ? !1 : E, A = Qp(n, t);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: Ie.Document,
        childNodes: [],
        compatMode: e.compatMode
      } : {
        type: Ie.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: Ie.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: A
      };
    case e.ELEMENT_NODE:
      return td(e, {
        doc: n,
        blockClass: i,
        blockSelector: o,
        inlineStylesheet: a,
        maskInputOptions: l,
        maskInputFn: h,
        dataURLOptions: v,
        inlineImages: y,
        recordCanvas: S,
        keepIframeSrcFn: _,
        newlyAddedElement: C,
        rootId: A
      });
    case e.TEXT_NODE:
      return ed(e, {
        doc: n,
        needsMask: s,
        maskTextFn: c,
        rootId: A,
        cssCaptured: R
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: Ie.CDATA,
        textContent: "",
        rootId: A
      };
    case e.COMMENT_NODE:
      return {
        type: Ie.Comment,
        textContent: $e.textContent(e) || "",
        rootId: A
      };
    default:
      return !1;
  }
}
function Qp(e, r) {
  if (r.hasNode(e)) {
    var n = r.getId(e);
    return n === 1 ? void 0 : n;
  }
}
function ed(e, r) {
  var n = r.needsMask, t = r.maskTextFn, i = r.rootId, o = r.cssCaptured, s = $e.parentNode(e), a = s && s.tagName, u = "", l = a === "STYLE" ? !0 : void 0, c = a === "SCRIPT" ? !0 : void 0;
  return c ? u = "SCRIPT_PLACEHOLDER" : o || (u = $e.textContent(e), l && u && (u = hi(u, ks(r.doc)))), !l && !c && u && n && (u = t ? t(u, $e.parentElement(e)) : u.replace(/[\S]/g, "*")), {
    type: Ie.Text,
    textContent: u || "",
    rootId: i
  };
}
function td(e, r) {
  for (var n = r.doc, t = r.blockClass, i = r.blockSelector, o = r.inlineStylesheet, s = r.maskInputOptions, a = s === void 0 ? {} : s, u = r.maskInputFn, l = r.dataURLOptions, c = l === void 0 ? {} : l, h = r.inlineImages, m = r.recordCanvas, v = r.keepIframeSrcFn, y = r.newlyAddedElement, S = y === void 0 ? !1 : y, _ = r.rootId, b = Zp(e, t, i), C = Wp(e), E = {}, R = e.attributes.length, A = 0; A < R; A++) {
    var M = e.attributes[A];
    Oc(C, M.name, M.value) || (E[M.name] = Ec(n, C, ur(M.name), M.value));
  }
  if (C === "link" && o) {
    var L = Array.from(n.styleSheets).find(function(re) {
      return re.href === e.href;
    }), N = null;
    L && (N = Ao(L)), N && (delete E.rel, delete E.href, E._cssText = N);
  }
  if (C === "style" && e.sheet) {
    var B = Ao(e.sheet);
    B && (e.childNodes.length > 1 && (B = zp(B, e)), E._cssText = B);
  }
  if (C === "input" || C === "textarea" || C === "select") {
    var G = e.value, P = e.checked;
    E.type !== "radio" && E.type !== "checkbox" && E.type !== "submit" && E.type !== "button" && G ? E.value = Es({
      element: e,
      type: Os(e),
      tagName: C,
      value: G,
      maskInputOptions: a,
      maskInputFn: u
    }) : P && (E.checked = P);
  }
  if (C === "option" && (e.selected && !a.select ? E.selected = !0 : delete E.selected), C === "dialog" && e.open && (E.rr_open_mode = e.matches("dialog:modal") ? "modal" : "non-modal"), C === "canvas" && m) {
    if (e.__context === "2d")
      $p(e) || (E.rr_dataURL = e.toDataURL(c.type, c.quality));
    else if (!("__context" in e)) {
      var z = e.toDataURL(c.type, c.quality), Z = n.createElement("canvas");
      Z.width = e.width, Z.height = e.height;
      var Me = Z.toDataURL(c.type, c.quality);
      z !== Me && (E.rr_dataURL = z);
    }
  }
  if (C === "img" && h) {
    yr || (yr = n.createElement("canvas"), Ma = yr.getContext("2d"));
    var te = e, Pe = te.currentSrc || te.getAttribute("src") || "<unknown-src>", Ee = te.crossOrigin, ce = function() {
      te.removeEventListener("load", ce);
      try {
        yr.width = te.naturalWidth, yr.height = te.naturalHeight, Ma.drawImage(te, 0, 0), E.rr_dataURL = yr.toDataURL(c.type, c.quality);
      } catch (re) {
        if (te.crossOrigin !== "anonymous") {
          te.crossOrigin = "anonymous", te.complete && te.naturalWidth !== 0 ? ce() : te.addEventListener("load", ce);
          return;
        } else
          console.warn("Cannot inline img src=" + Pe + "! Error: " + re);
      }
      te.crossOrigin === "anonymous" && (Ee ? E.crossOrigin = Ee : te.removeAttribute("crossorigin"));
    };
    te.complete && te.naturalWidth !== 0 ? ce() : te.addEventListener("load", ce);
  }
  if (C === "audio" || C === "video") {
    var xe = E;
    xe.rr_mediaState = e.paused ? "paused" : "played", xe.rr_mediaCurrentTime = e.currentTime, xe.rr_mediaPlaybackRate = e.playbackRate, xe.rr_mediaMuted = e.muted, xe.rr_mediaLoop = e.loop, xe.rr_mediaVolume = e.volume;
  }
  if (S || (e.scrollLeft && (E.rr_scrollLeft = e.scrollLeft), e.scrollTop && (E.rr_scrollTop = e.scrollTop)), b) {
    var De = e.getBoundingClientRect(), St = De.width, Ze = De.height;
    E = {
      class: E.class,
      rr_width: "" + St + "px",
      rr_height: "" + Ze + "px"
    };
  }
  C === "iframe" && !v(E.src) && (e.contentDocument || (E.rr_src = E.src), delete E.src);
  var Lt;
  try {
    customElements.get(C) && (Lt = !0);
  } catch {
  }
  return {
    type: Ie.Element,
    tagName: C,
    attributes: E,
    childNodes: [],
    isSVG: Hp(e) || void 0,
    needBlock: b,
    rootId: _,
    isCustom: Lt
  };
}
function fe(e) {
  return e == null ? "" : e.toLowerCase();
}
function rd(e, r) {
  if (r.comment && e.type === Ie.Comment)
    return !0;
  if (e.type === Ie.Element) {
    if (r.script && // script tag
    (e.tagName === "script" || // (module)preload link
    e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || // prefetch link
    e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && xc(e.attributes.href) === "js"))
      return !0;
    if (r.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (fe(e.attributes.name).match(/^msapplication-tile(image|color)$/) || fe(e.attributes.name) === "application-name" || fe(e.attributes.rel) === "icon" || fe(e.attributes.rel) === "apple-touch-icon" || fe(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (r.headMetaDescKeywords && fe(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (r.headMetaSocial && (fe(e.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      fe(e.attributes.name).match(/^(og|twitter):/) || fe(e.attributes.name) === "pinterest"))
        return !0;
      if (r.headMetaRobots && (fe(e.attributes.name) === "robots" || fe(e.attributes.name) === "googlebot" || fe(e.attributes.name) === "bingbot"))
        return !0;
      if (r.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (r.headMetaAuthorship && (fe(e.attributes.name) === "author" || fe(e.attributes.name) === "generator" || fe(e.attributes.name) === "framework" || fe(e.attributes.name) === "publisher" || fe(e.attributes.name) === "progid" || fe(e.attributes.property).match(/^article:/) || fe(e.attributes.property).match(/^product:/)))
        return !0;
      if (r.headMetaVerification && (fe(e.attributes.name) === "google-site-verification" || fe(e.attributes.name) === "yandex-verification" || fe(e.attributes.name) === "csrf-token" || fe(e.attributes.name) === "p:domain_verify" || fe(e.attributes.name) === "verify-v1" || fe(e.attributes.name) === "verification" || fe(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function xr(e, r) {
  var n = r.doc, t = r.mirror, i = r.blockClass, o = r.blockSelector, s = r.maskTextClass, a = r.maskTextSelector, u = r.skipChild, l = u === void 0 ? !1 : u, c = r.inlineStylesheet, h = c === void 0 ? !0 : c, m = r.maskInputOptions, v = m === void 0 ? {} : m, y = r.maskTextFn, S = r.maskInputFn, _ = r.slimDOMOptions, b = r.dataURLOptions, C = b === void 0 ? {} : b, E = r.inlineImages, R = E === void 0 ? !1 : E, A = r.recordCanvas, M = A === void 0 ? !1 : A, L = r.onSerialize, N = r.onIframeLoad, B = r.iframeLoadTimeout, G = B === void 0 ? 5e3 : B, P = r.onStylesheetLoad, z = r.stylesheetLoadTimeout, Z = z === void 0 ? 5e3 : z, Me = r.keepIframeSrcFn, te = Me === void 0 ? function() {
    return !1;
  } : Me, Pe = r.newlyAddedElement, Ee = Pe === void 0 ? !1 : Pe, ce = r.cssCaptured, xe = ce === void 0 ? !1 : ce, De = r.needsMask, St = r.preserveWhiteSpace, Ze = St === void 0 ? !0 : St;
  if (!De) {
    var Lt = De === void 0;
    De = kc(e, s, a, Lt);
  }
  var re = Xp(e, {
    doc: n,
    mirror: t,
    blockClass: i,
    blockSelector: o,
    needsMask: De,
    inlineStylesheet: h,
    maskInputOptions: v,
    maskTextFn: y,
    maskInputFn: S,
    dataURLOptions: C,
    inlineImages: R,
    recordCanvas: M,
    keepIframeSrcFn: te,
    newlyAddedElement: Ee,
    cssCaptured: xe
  });
  if (!re)
    return console.warn(e, "not serialized"), null;
  var ye;
  t.hasNode(e) ? ye = t.getId(e) : rd(re, _) || !Ze && re.type === Ie.Text && !re.textContent.replace(/^\s+|\s+$/gm, "").length ? ye = on : ye = Ic();
  var J = Object.assign(re, {
    id: ye
  });
  if (t.add(e, J), ye === on)
    return null;
  L && L(e);
  var ut = !l;
  if (J.type === Ie.Element) {
    ut = ut && !J.needBlock, delete J.needBlock;
    var ct = $e.shadowRoot(e);
    ct && Zr(ct) && (J.isShadowHost = !0);
  }
  if ((J.type === Ie.Document || J.type === Ie.Element) && ut) {
    _.headWhitespace && J.type === Ie.Element && J.tagName === "head" && (Ze = !1);
    var Ct = {
      doc: n,
      mirror: t,
      blockClass: i,
      blockSelector: o,
      needsMask: De,
      maskTextClass: s,
      maskTextSelector: a,
      skipChild: l,
      inlineStylesheet: h,
      maskInputOptions: v,
      maskTextFn: y,
      maskInputFn: S,
      slimDOMOptions: _,
      dataURLOptions: C,
      inlineImages: R,
      recordCanvas: M,
      preserveWhiteSpace: Ze,
      onSerialize: L,
      onIframeLoad: N,
      iframeLoadTimeout: G,
      onStylesheetLoad: P,
      stylesheetLoadTimeout: Z,
      keepIframeSrcFn: te,
      cssCaptured: !1
    };
    if (!(J.type === Ie.Element && J.tagName === "textarea" && J.attributes.value !== void 0)) {
      J.type === Ie.Element && J.attributes._cssText !== void 0 && typeof J.attributes._cssText == "string" && (Ct.cssCaptured = !0);
      for (var Bt = D(Array.from($e.childNodes(e))), Ke; !(Ke = Bt()).done; ) {
        var nr = Ke.value, ir = xr(nr, Ct);
        ir && J.childNodes.push(ir);
      }
    }
    var lt = null;
    if (bc(e) && (lt = $e.shadowRoot(e)))
      for (var ft = D(Array.from($e.childNodes(lt))), Ve; !(Ve = ft()).done; ) {
        var tt = Ve.value, Ut = xr(tt, Ct);
        Ut && (Zr(lt) && (Ut.isShadow = !0), J.childNodes.push(Ut));
      }
  }
  var xt = $e.parentNode(e);
  return xt && Hr(xt) && Zr(xt) && (J.isShadow = !0), J.type === Ie.Element && J.tagName === "iframe" && Kp(e, function() {
    var Ye = e.contentDocument;
    if (Ye && N) {
      var It = xr(Ye, {
        doc: Ye,
        mirror: t,
        blockClass: i,
        blockSelector: o,
        needsMask: De,
        maskTextClass: s,
        maskTextSelector: a,
        skipChild: !1,
        inlineStylesheet: h,
        maskInputOptions: v,
        maskTextFn: y,
        maskInputFn: S,
        slimDOMOptions: _,
        dataURLOptions: C,
        inlineImages: R,
        recordCanvas: M,
        preserveWhiteSpace: Ze,
        onSerialize: L,
        onIframeLoad: N,
        iframeLoadTimeout: G,
        onStylesheetLoad: P,
        stylesheetLoadTimeout: Z,
        keepIframeSrcFn: te
      });
      It && N(e, It);
    }
  }, G), J.type === Ie.Element && J.tagName === "link" && typeof J.attributes.rel == "string" && (J.attributes.rel === "stylesheet" || J.attributes.rel === "preload" && typeof J.attributes.href == "string" && xc(J.attributes.href) === "css") && Jp(e, function() {
    if (P) {
      var Ye = xr(e, {
        doc: n,
        mirror: t,
        blockClass: i,
        blockSelector: o,
        needsMask: De,
        maskTextClass: s,
        maskTextSelector: a,
        skipChild: !1,
        inlineStylesheet: h,
        maskInputOptions: v,
        maskTextFn: y,
        maskInputFn: S,
        slimDOMOptions: _,
        dataURLOptions: C,
        inlineImages: R,
        recordCanvas: M,
        preserveWhiteSpace: Ze,
        onSerialize: L,
        onIframeLoad: N,
        iframeLoadTimeout: G,
        onStylesheetLoad: P,
        stylesheetLoadTimeout: Z,
        keepIframeSrcFn: te
      });
      Ye && P(e, Ye);
    }
  }, Z), J;
}
function nd(e, r) {
  var n = r || {}, t = n.mirror, i = t === void 0 ? new Cc() : t, o = n.blockClass, s = o === void 0 ? "rr-block" : o, a = n.blockSelector, u = a === void 0 ? null : a, l = n.maskTextClass, c = l === void 0 ? "rr-mask" : l, h = n.maskTextSelector, m = h === void 0 ? null : h, v = n.inlineStylesheet, y = v === void 0 ? !0 : v, S = n.inlineImages, _ = S === void 0 ? !1 : S, b = n.recordCanvas, C = b === void 0 ? !1 : b, E = n.maskAllInputs, R = E === void 0 ? !1 : E, A = n.maskTextFn, M = n.maskInputFn, L = n.slimDOM, N = L === void 0 ? !1 : L, B = n.dataURLOptions, G = n.preserveWhiteSpace, P = n.onSerialize, z = n.onIframeLoad, Z = n.iframeLoadTimeout, Me = n.onStylesheetLoad, te = n.stylesheetLoadTimeout, Pe = n.keepIframeSrcFn, Ee = Pe === void 0 ? function() {
    return !1;
  } : Pe, ce = R === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : R === !1 ? {
    password: !0
  } : R, xe = N === !0 || N === "all" ? (
    // if true: set of sensible options that should not throw away any information
    {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: N === "all",
      // destructive
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    }
  ) : N === !1 ? {} : N;
  return xr(e, {
    doc: e,
    mirror: i,
    blockClass: s,
    blockSelector: u,
    maskTextClass: c,
    maskTextSelector: m,
    skipChild: !1,
    inlineStylesheet: y,
    maskInputOptions: ce,
    maskTextFn: A,
    maskInputFn: M,
    slimDOMOptions: xe,
    dataURLOptions: B,
    inlineImages: _,
    recordCanvas: C,
    preserveWhiteSpace: G,
    onSerialize: P,
    onIframeLoad: z,
    iframeLoadTimeout: Z,
    onStylesheetLoad: Me,
    stylesheetLoadTimeout: te,
    keepIframeSrcFn: Ee,
    newlyAddedElement: !1
  });
}
function id(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function od(e) {
  if (e.__esModule) return e;
  var r = e.default;
  if (typeof r == "function") {
    var n = function t() {
      return W(this, t) ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    n.prototype = r.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function(t) {
    var i = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(n, t, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), n;
}
var As = {
  exports: {}
}, he = String, Ac = function() {
  return {
    isColorSupported: !1,
    reset: he,
    bold: he,
    dim: he,
    italic: he,
    underline: he,
    inverse: he,
    hidden: he,
    strikethrough: he,
    black: he,
    red: he,
    green: he,
    yellow: he,
    blue: he,
    magenta: he,
    cyan: he,
    white: he,
    gray: he,
    bgBlack: he,
    bgRed: he,
    bgGreen: he,
    bgYellow: he,
    bgBlue: he,
    bgMagenta: he,
    bgCyan: he,
    bgWhite: he
  };
};
As.exports = Ac();
As.exports.createColors = Ac;
var sd = As.exports, ad = {}, ud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ad
}, Symbol.toStringTag, {
  value: "Module"
})), be = /* @__PURE__ */ od(ud), $a = sd, Na = be, Ro = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t, i, o, s, a, u) {
    var l;
    return l = e.call(this, t) || this, l.name = "CssSyntaxError", l.reason = t, a && (l.file = a), s && (l.source = s), u && (l.plugin = u), typeof i < "u" && typeof o < "u" && (typeof i == "number" ? (l.line = i, l.column = o) : (l.line = i.line, l.column = i.column, l.endLine = o.line, l.endColumn = o.column)), l.setMessage(), Error.captureStackTrace && Error.captureStackTrace(l, r), l;
  }
  var n = r.prototype;
  return n.setMessage = function() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }, n.showSourceCode = function(i) {
    var o = this;
    if (!this.source) return "";
    var s = this.source;
    i == null && (i = $a.isColorSupported), Na && i && (s = Na(s));
    var a = s.split(/\r?\n/), u = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, a.length), c = String(l).length, h, m;
    if (i) {
      var v = $a.createColors(!0), y = v.bold, S = v.gray, _ = v.red;
      h = function(b) {
        return y(_(b));
      }, m = function(b) {
        return S(b);
      };
    } else
      h = m = function(b) {
        return b;
      };
    return a.slice(u, l).map(function(b, C) {
      var E = u + 1 + C, R = " " + (" " + E).slice(-c) + " | ";
      if (E === o.line) {
        var A = m(R.replace(/\d/g, " ")) + b.slice(0, o.column - 1).replace(/[^\t]/g, " ");
        return h(">") + m(R) + b + `
 ` + A + h("^");
      }
      return " " + m(R) + b;
    }).join(`
`);
  }, n.toString = function() {
    var i = this.showSourceCode();
    return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
  }, r;
}(fi(Error)), Rs = Ro;
Ro.default = Ro;
var Kt = {};
Kt.isClean = Symbol("isClean");
Kt.my = Symbol("my");
var Pa = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function cd(e) {
  return e[0].toUpperCase() + e.slice(1);
}
var To = /* @__PURE__ */ function() {
  function e(n) {
    this.builder = n;
  }
  var r = e.prototype;
  return r.atrule = function(t, i) {
    var o = "@" + t.name, s = t.params ? this.rawValue(t, "params") : "";
    if (typeof t.raws.afterName < "u" ? o += t.raws.afterName : s && (o += " "), t.nodes)
      this.block(t, o + s);
    else {
      var a = (t.raws.between || "") + (i ? ";" : "");
      this.builder(o + s + a, t);
    }
  }, r.beforeAfter = function(t, i) {
    var o;
    t.type === "decl" ? o = this.raw(t, null, "beforeDecl") : t.type === "comment" ? o = this.raw(t, null, "beforeComment") : i === "before" ? o = this.raw(t, null, "beforeRule") : o = this.raw(t, null, "beforeClose");
    for (var s = t.parent, a = 0; s && s.type !== "root"; )
      a += 1, s = s.parent;
    if (o.includes(`
`)) {
      var u = this.raw(t, null, "indent");
      if (u.length)
        for (var l = 0; l < a; l++) o += u;
    }
    return o;
  }, r.block = function(t, i) {
    var o = this.raw(t, "between", "beforeOpen");
    this.builder(i + o + "{", t, "start");
    var s;
    t.nodes && t.nodes.length ? (this.body(t), s = this.raw(t, "after")) : s = this.raw(t, "after", "emptyBody"), s && this.builder(s), this.builder("}", t, "end");
  }, r.body = function(t) {
    for (var i = t.nodes.length - 1; i > 0 && t.nodes[i].type === "comment"; )
      i -= 1;
    for (var o = this.raw(t, "semicolon"), s = 0; s < t.nodes.length; s++) {
      var a = t.nodes[s], u = this.raw(a, "before");
      u && this.builder(u), this.stringify(a, i !== s || o);
    }
  }, r.comment = function(t) {
    var i = this.raw(t, "left", "commentLeft"), o = this.raw(t, "right", "commentRight");
    this.builder("/*" + i + t.text + o + "*/", t);
  }, r.decl = function(t, i) {
    var o = this.raw(t, "between", "colon"), s = t.prop + o + this.rawValue(t, "value");
    t.important && (s += t.raws.important || " !important"), i && (s += ";"), this.builder(s, t);
  }, r.document = function(t) {
    this.body(t);
  }, r.raw = function(t, i, o) {
    var s;
    if (o || (o = i), i && (s = t.raws[i], typeof s < "u"))
      return s;
    var a = t.parent;
    if (o === "before" && (!a || a.type === "root" && a.first === t || a && a.type === "document"))
      return "";
    if (!a) return Pa[o];
    var u = t.root();
    if (u.rawCache || (u.rawCache = {}), typeof u.rawCache[o] < "u")
      return u.rawCache[o];
    if (o === "before" || o === "after")
      return this.beforeAfter(t, o);
    var l = "raw" + cd(o);
    return this[l] ? s = this[l](u, t) : u.walk(function(c) {
      if (s = c.raws[i], typeof s < "u") return !1;
    }), typeof s > "u" && (s = Pa[o]), u.rawCache[o] = s, s;
  }, r.rawBeforeClose = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && o.nodes.length > 0 && typeof o.raws.after < "u")
        return i = o.raws.after, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), i && (i = i.replace(/\S/g, "")), i;
  }, r.rawBeforeComment = function(t, i) {
    var o;
    return t.walkComments(function(s) {
      if (typeof s.raws.before < "u")
        return o = s.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
    }), typeof o > "u" ? o = this.raw(i, null, "beforeDecl") : o && (o = o.replace(/\S/g, "")), o;
  }, r.rawBeforeDecl = function(t, i) {
    var o;
    return t.walkDecls(function(s) {
      if (typeof s.raws.before < "u")
        return o = s.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
    }), typeof o > "u" ? o = this.raw(i, null, "beforeRule") : o && (o = o.replace(/\S/g, "")), o;
  }, r.rawBeforeOpen = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.type !== "decl" && (i = o.raws.between, typeof i < "u"))
        return !1;
    }), i;
  }, r.rawBeforeRule = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && (o.parent !== t || t.first !== o) && typeof o.raws.before < "u")
        return i = o.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), i && (i = i.replace(/\S/g, "")), i;
  }, r.rawColon = function(t) {
    var i;
    return t.walkDecls(function(o) {
      if (typeof o.raws.between < "u")
        return i = o.raws.between.replace(/[^\s:]/g, ""), !1;
    }), i;
  }, r.rawEmptyBody = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && o.nodes.length === 0 && (i = o.raws.after, typeof i < "u"))
        return !1;
    }), i;
  }, r.rawIndent = function(t) {
    if (t.raws.indent) return t.raws.indent;
    var i;
    return t.walk(function(o) {
      var s = o.parent;
      if (s && s !== t && s.parent && s.parent === t && typeof o.raws.before < "u") {
        var a = o.raws.before.split(`
`);
        return i = a[a.length - 1], i = i.replace(/\S/g, ""), !1;
      }
    }), i;
  }, r.rawSemicolon = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && o.nodes.length && o.last.type === "decl" && (i = o.raws.semicolon, typeof i < "u"))
        return !1;
    }), i;
  }, r.rawValue = function(t, i) {
    var o = t[i], s = t.raws[i];
    return s && s.value === o ? s.raw : o;
  }, r.root = function(t) {
    this.body(t), t.raws.after && this.builder(t.raws.after);
  }, r.rule = function(t) {
    this.block(t, this.rawValue(t, "selector")), t.raws.ownSemicolon && this.builder(t.raws.ownSemicolon, t, "end");
  }, r.stringify = function(t, i) {
    if (!this[t.type])
      throw new Error("Unknown AST node type " + t.type + ". Maybe you need to change PostCSS stringifier.");
    this[t.type](t, i);
  }, e;
}(), Rc = To;
To.default = To;
var ld = Rc;
function Mo(e, r) {
  var n = new ld(r);
  n.stringify(e);
}
var $i = Mo;
Mo.default = Mo;
var kn = Kt.isClean, fd = Kt.my, hd = Rs, pd = Rc, dd = $i;
function Fo(e, r) {
  var n = new e.constructor();
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && t !== "proxyCache") {
      var i = e[t], o = typeof i > "u" ? "undefined" : H(i);
      t === "parent" && o === "object" ? r && (n[t] = r) : t === "source" ? n[t] = i : Array.isArray(i) ? n[t] = i.map(function(s) {
        return Fo(s, n);
      }) : (o === "object" && i !== null && (i = Fo(i)), n[t] = i);
    }
  return n;
}
var $o = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = {}), this.raws = {}, this[kn] = !1, this[fd] = !0;
    for (var t in n)
      if (t === "nodes") {
        this.nodes = [];
        for (var i = D(n[t]), o; !(o = i()).done; ) {
          var s = o.value;
          typeof s.clone == "function" ? this.append(s.clone()) : this.append(s);
        }
      } else
        this[t] = n[t];
  }
  var r = e.prototype;
  return r.addToError = function(t) {
    if (t.postcssNode = this, t.stack && this.source && /\n\s{4}at /.test(t.stack)) {
      var i = this.source;
      t.stack = t.stack.replace(/\n\s{4}at /, "$&" + i.input.from + ":" + i.start.line + ":" + i.start.column + "$&");
    }
    return t;
  }, r.after = function(t) {
    return this.parent.insertAfter(this, t), this;
  }, r.assign = function(t) {
    t === void 0 && (t = {});
    for (var i in t)
      this[i] = t[i];
    return this;
  }, r.before = function(t) {
    return this.parent.insertBefore(this, t), this;
  }, r.cleanRaws = function(t) {
    delete this.raws.before, delete this.raws.after, t || delete this.raws.between;
  }, r.clone = function(t) {
    t === void 0 && (t = {});
    var i = Fo(this);
    for (var o in t)
      i[o] = t[o];
    return i;
  }, r.cloneAfter = function(t) {
    t === void 0 && (t = {});
    var i = this.clone(t);
    return this.parent.insertAfter(this, i), i;
  }, r.cloneBefore = function(t) {
    t === void 0 && (t = {});
    var i = this.clone(t);
    return this.parent.insertBefore(this, i), i;
  }, r.error = function(t, i) {
    if (i === void 0 && (i = {}), this.source) {
      var o = this.rangeBy(i), s = o.end, a = o.start;
      return this.source.input.error(t, {
        column: a.column,
        line: a.line
      }, {
        column: s.column,
        line: s.line
      }, i);
    }
    return new hd(t);
  }, r.getProxyProcessor = function() {
    return {
      get: function(i, o) {
        return o === "proxyOf" ? i : o === "root" ? function() {
          return i.root().toProxy();
        } : i[o];
      },
      set: function(i, o, s) {
        return i[o] === s || (i[o] = s, (o === "prop" || o === "value" || o === "name" || o === "params" || o === "important" || /* c8 ignore next */
        o === "text") && i.markDirty()), !0;
      }
    };
  }, r.markDirty = function() {
    if (this[kn]) {
      this[kn] = !1;
      for (var t = this; t = t.parent; )
        t[kn] = !1;
    }
  }, r.next = function() {
    if (this.parent) {
      var t = this.parent.index(this);
      return this.parent.nodes[t + 1];
    }
  }, r.positionBy = function(t, i) {
    var o = this.source.start;
    if (t.index)
      o = this.positionInside(t.index, i);
    else if (t.word) {
      i = this.toString();
      var s = i.indexOf(t.word);
      s !== -1 && (o = this.positionInside(s, i));
    }
    return o;
  }, r.positionInside = function(t, i) {
    for (var o = i || this.toString(), s = this.source.start.column, a = this.source.start.line, u = 0; u < t; u++)
      o[u] === `
` ? (s = 1, a += 1) : s += 1;
    return {
      column: s,
      line: a
    };
  }, r.prev = function() {
    if (this.parent) {
      var t = this.parent.index(this);
      return this.parent.nodes[t - 1];
    }
  }, r.rangeBy = function(t) {
    var i = {
      column: this.source.start.column,
      line: this.source.start.line
    }, o = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: i.column + 1,
      line: i.line
    };
    if (t.word) {
      var s = this.toString(), a = s.indexOf(t.word);
      a !== -1 && (i = this.positionInside(a, s), o = this.positionInside(a + t.word.length, s));
    } else
      t.start ? i = {
        column: t.start.column,
        line: t.start.line
      } : t.index && (i = this.positionInside(t.index)), t.end ? o = {
        column: t.end.column,
        line: t.end.line
      } : typeof t.endIndex == "number" ? o = this.positionInside(t.endIndex) : t.index && (o = this.positionInside(t.index + 1));
    return (o.line < i.line || o.line === i.line && o.column <= i.column) && (o = {
      column: i.column + 1,
      line: i.line
    }), {
      end: o,
      start: i
    };
  }, r.raw = function(t, i) {
    var o = new pd();
    return o.raw(this, t, i);
  }, r.remove = function() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }, r.replaceWith = function() {
    for (var t = arguments.length, i = new Array(t), o = 0; o < t; o++)
      i[o] = arguments[o];
    if (this.parent) {
      for (var s = this, a = !1, u = D(i), l; !(l = u()).done; ) {
        var c = l.value;
        c === this ? a = !0 : a ? (this.parent.insertAfter(s, c), s = c) : this.parent.insertBefore(s, c);
      }
      a || this.remove();
    }
    return this;
  }, r.root = function() {
    for (var t = this; t.parent && t.parent.type !== "document"; )
      t = t.parent;
    return t;
  }, r.toJSON = function(t, i) {
    var o = {}, s = i == null;
    i = i || /* @__PURE__ */ new Map();
    var a = 0;
    for (var u in this)
      if (Object.prototype.hasOwnProperty.call(this, u) && !(u === "parent" || u === "proxyCache")) {
        var l = this[u];
        if (Array.isArray(l))
          o[u] = l.map(function(h) {
            return (typeof h > "u" ? "undefined" : H(h)) === "object" && h.toJSON ? h.toJSON(null, i) : h;
          });
        else if ((typeof l > "u" ? "undefined" : H(l)) === "object" && l.toJSON)
          o[u] = l.toJSON(null, i);
        else if (u === "source") {
          var c = i.get(l.input);
          c == null && (c = a, i.set(l.input, a), a++), o[u] = {
            end: l.end,
            inputId: c,
            start: l.start
          };
        } else
          o[u] = l;
      }
    return s && (o.inputs = [].concat(i.keys()).map(function(h) {
      return h.toJSON();
    })), o;
  }, r.toProxy = function() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }, r.toString = function(t) {
    t === void 0 && (t = dd), t.stringify && (t = t.stringify);
    var i = "";
    return t(this, function(o) {
      i += o;
    }), i;
  }, r.warn = function(t, i, o) {
    var s = {
      node: this
    };
    for (var a in o) s[a] = o[a];
    return t.warn(i, s);
  }, Te(e, [
    {
      key: "proxyOf",
      get: function() {
        return this;
      }
    }
  ]), e;
}(), Ni = $o;
$o.default = $o;
var md = Ni, No = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(n) {
    var t;
    return n && typeof n.value < "u" && typeof n.value != "string" && (n = Q({}, n, {
      value: String(n.value)
    })), t = e.call(this, n) || this, t.type = "decl", t;
  }
  return Te(r, [
    {
      key: "variable",
      get: function() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
      }
    }
  ]), r;
}(md), Pi = No;
No.default = No;
var gd = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", vd = function(e) {
  e === void 0 && (e = 21);
  for (var r = "", n = e; n--; )
    r += gd[Math.random() * 64 | 0];
  return r;
}, yd = {
  nanoid: vd
}, Da = be.SourceMapConsumer, La = be.SourceMapGenerator, _d = be.existsSync, wd = be.readFileSync, ro = be.dirname, bd = be.join;
function Sd(e) {
  return Vt ? Vt.from(e, "base64").toString() : window.atob(e);
}
var Po = /* @__PURE__ */ function() {
  function e(n, t) {
    if (t.map !== !1) {
      this.loadAnnotation(n), this.inline = this.startWith(this.annotation, "data:");
      var i = t.map ? t.map.prev : void 0, o = this.loadMap(t.from, i);
      !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = ro(this.mapFile)), o && (this.text = o);
    }
  }
  var r = e.prototype;
  return r.consumer = function() {
    return this.consumerCache || (this.consumerCache = new Da(this.text)), this.consumerCache;
  }, r.decodeInline = function(t) {
    var i = /^data:application\/json;charset=utf-?8;base64,/, o = /^data:application\/json;base64,/, s = /^data:application\/json;charset=utf-?8,/, a = /^data:application\/json,/;
    if (s.test(t) || a.test(t))
      return decodeURIComponent(t.substr(RegExp.lastMatch.length));
    if (i.test(t) || o.test(t))
      return Sd(t.substr(RegExp.lastMatch.length));
    var u = t.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + u);
  }, r.getAnnotationURL = function(t) {
    return t.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }, r.isMap = function(t) {
    return (typeof t > "u" ? "undefined" : H(t)) !== "object" ? !1 : typeof t.mappings == "string" || typeof t._mappings == "string" || Array.isArray(t.sections);
  }, r.loadAnnotation = function(t) {
    var i = t.match(/\/\*\s*# sourceMappingURL=/gm);
    if (i) {
      var o = t.lastIndexOf(i.pop()), s = t.indexOf("*/", o);
      o > -1 && s > -1 && (this.annotation = this.getAnnotationURL(t.substring(o, s)));
    }
  }, r.loadFile = function(t) {
    if (this.root = ro(t), _d(t))
      return this.mapFile = t, wd(t, "utf-8").toString().trim();
  }, r.loadMap = function(t, i) {
    if (i === !1) return !1;
    if (i) {
      if (typeof i == "string")
        return i;
      if (typeof i == "function") {
        var o = i(t);
        if (o) {
          var s = this.loadFile(o);
          if (!s)
            throw new Error("Unable to load previous source map: " + o.toString());
          return s;
        }
      } else {
        if (W(i, Da))
          return La.fromSourceMap(i).toString();
        if (W(i, La))
          return i.toString();
        if (this.isMap(i))
          return JSON.stringify(i);
        throw new Error("Unsupported previous source map format: " + i.toString());
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        var a = this.annotation;
        return t && (a = bd(ro(t), a)), this.loadFile(a);
      }
    }
  }, r.startWith = function(t, i) {
    return t ? t.substr(0, i.length) === i : !1;
  }, r.withContent = function() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }, e;
}(), Tc = Po;
Po.default = Po;
var Cd = be.SourceMapConsumer, xd = be.SourceMapGenerator, Ba = be.fileURLToPath, An = be.pathToFileURL, Do = be.isAbsolute, Lo = be.resolve, Id = yd.nanoid, no = be, Ua = Rs, Ed = Tc, io = Symbol("fromOffsetCache"), Od = !!(Cd && xd), za = !!(Lo && Do), di = /* @__PURE__ */ function() {
  function e(n, t) {
    if (t === void 0 && (t = {}), n === null || typeof n > "u" || (typeof n > "u" ? "undefined" : H(n)) === "object" && !n.toString)
      throw new Error("PostCSS received " + n + " instead of CSS string");
    if (this.css = n.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, t.from && (!za || /^\w+:\/\//.test(t.from) || Do(t.from) ? this.file = t.from : this.file = Lo(t.from)), za && Od) {
      var i = new Ed(this.css, t);
      if (i.text) {
        this.map = i;
        var o = i.consumer().file;
        !this.file && o && (this.file = this.mapResolve(o));
      }
    }
    this.file || (this.id = "<input css " + Id(6) + ">"), this.map && (this.map.file = this.from);
  }
  var r = e.prototype;
  return r.error = function(t, i, o, s) {
    s === void 0 && (s = {});
    var a, u, l;
    if (i && (typeof i > "u" ? "undefined" : H(i)) === "object") {
      var c = i, h = o;
      if (typeof c.offset == "number") {
        var m = this.fromOffset(c.offset);
        i = m.line, o = m.col;
      } else
        i = c.line, o = c.column;
      if (typeof h.offset == "number") {
        var v = this.fromOffset(h.offset);
        u = v.line, l = v.col;
      } else
        u = h.line, l = h.column;
    } else if (!o) {
      var y = this.fromOffset(i);
      i = y.line, o = y.col;
    }
    var S = this.origin(i, o, u, l);
    return S ? a = new Ua(t, S.endLine === void 0 ? S.line : {
      column: S.column,
      line: S.line
    }, S.endLine === void 0 ? S.column : {
      column: S.endColumn,
      line: S.endLine
    }, S.source, S.file, s.plugin) : a = new Ua(t, u === void 0 ? i : {
      column: o,
      line: i
    }, u === void 0 ? o : {
      column: l,
      line: u
    }, this.css, this.file, s.plugin), a.input = {
      column: o,
      endColumn: l,
      endLine: u,
      line: i,
      source: this.css
    }, this.file && (An && (a.input.url = An(this.file).toString()), a.input.file = this.file), a;
  }, r.fromOffset = function(t) {
    var i, o;
    if (this[io])
      o = this[io];
    else {
      var s = this.css.split(`
`);
      o = new Array(s.length);
      for (var a = 0, u = 0, l = s.length; u < l; u++)
        o[u] = a, a += s[u].length + 1;
      this[io] = o;
    }
    i = o[o.length - 1];
    var c = 0;
    if (t >= i)
      c = o.length - 1;
    else
      for (var h = o.length - 2, m; c < h; )
        if (m = c + (h - c >> 1), t < o[m])
          h = m - 1;
        else if (t >= o[m + 1])
          c = m + 1;
        else {
          c = m;
          break;
        }
    return {
      col: t - o[c] + 1,
      line: c + 1
    };
  }, r.mapResolve = function(t) {
    return /^\w+:\/\//.test(t) ? t : Lo(this.map.consumer().sourceRoot || this.map.root || ".", t);
  }, r.origin = function(t, i, o, s) {
    if (!this.map) return !1;
    var a = this.map.consumer(), u = a.originalPositionFor({
      column: i,
      line: t
    });
    if (!u.source) return !1;
    var l;
    typeof o == "number" && (l = a.originalPositionFor({
      column: s,
      line: o
    }));
    var c;
    Do(u.source) ? c = An(u.source) : c = new URL(u.source, this.map.consumer().sourceRoot || An(this.map.mapFile));
    var h = {
      column: u.column,
      endColumn: l && l.column,
      endLine: l && l.line,
      line: u.line,
      url: c.toString()
    };
    if (c.protocol === "file:")
      if (Ba)
        h.file = Ba(c);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    var m = a.sourceContentFor(u.source);
    return m && (h.source = m), h;
  }, r.toJSON = function() {
    for (var t = {}, i = 0, o = [
      "hasBOM",
      "css",
      "file",
      "id"
    ]; i < o.length; i++) {
      var s = o[i];
      this[s] != null && (t[s] = this[s]);
    }
    return this.map && (t.map = Q({}, this.map), t.map.consumerCache && (t.map.consumerCache = void 0)), t;
  }, Te(e, [
    {
      key: "from",
      get: function() {
        return this.file || this.id;
      }
    }
  ]), e;
}(), Di = di;
di.default = di;
no && no.registerInput && no.registerInput(di);
var Mc = be.SourceMapConsumer, ri = be.SourceMapGenerator, ni = be.dirname, Fc = be.relative, $c = be.resolve, Nc = be.sep, qa = be.pathToFileURL, kd = Di, Ad = !!(Mc && ri), Rd = !!(ni && $c && Fc && Nc), Td = /* @__PURE__ */ function() {
  function e(n, t, i, o) {
    this.stringify = n, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = o, this.originalCSS = o, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  var r = e.prototype;
  return r.addAnnotation = function() {
    var t;
    this.isInline() ? t = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? t = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? t = this.mapOpts.annotation(this.opts.to, this.root) : t = this.outputFile() + ".map";
    var i = `
`;
    this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + t + " */";
  }, r.applyPrevMaps = function() {
    for (var t = D(this.previous()), i; !(i = t()).done; ) {
      var o = i.value, s = this.toUrl(this.path(o.file)), a = o.root || ni(o.file), u = void 0;
      this.mapOpts.sourcesContent === !1 ? (u = new Mc(o.text), u.sourcesContent && (u.sourcesContent = null)) : u = o.consumer(), this.map.applySourceMap(u, s, this.toUrl(this.path(a)));
    }
  }, r.clearAnnotation = function() {
    if (this.mapOpts.annotation !== !1)
      if (this.root)
        for (var t, i = this.root.nodes.length - 1; i >= 0; i--)
          t = this.root.nodes[i], t.type === "comment" && t.text.indexOf("# sourceMappingURL=") === 0 && this.root.removeChild(i);
      else this.css && (this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, ""));
  }, r.generate = function() {
    if (this.clearAnnotation(), Rd && Ad && this.isMap())
      return this.generateMap();
    var t = "";
    return this.stringify(this.root, function(i) {
      t += i;
    }), [
      t
    ];
  }, r.generateMap = function() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      var t = this.previous()[0].consumer();
      t.file = this.outputFile(), this.map = ri.fromSourceMap(t, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new ri({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: {
          column: 0,
          line: 1
        },
        original: {
          column: 0,
          line: 1
        },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [
      this.css
    ] : [
      this.css,
      this.map
    ];
  }, r.generateString = function() {
    var t = this;
    this.css = "", this.map = new ri({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    var i = 1, o = 1, s = "<no source>", a = {
      generated: {
        column: 0,
        line: 0
      },
      original: {
        column: 0,
        line: 0
      },
      source: ""
    }, u, l;
    this.stringify(this.root, function(c, h, m) {
      if (t.css += c, h && m !== "end" && (a.generated.line = i, a.generated.column = o - 1, h.source && h.source.start ? (a.source = t.sourcePath(h), a.original.line = h.source.start.line, a.original.column = h.source.start.column - 1, t.map.addMapping(a)) : (a.source = s, a.original.line = 1, a.original.column = 0, t.map.addMapping(a))), u = c.match(/\n/g), u ? (i += u.length, l = c.lastIndexOf(`
`), o = c.length - l) : o += c.length, h && m !== "start") {
        var v = h.parent || {
          raws: {}
        }, y = h.type === "decl" || h.type === "atrule" && !h.nodes;
        (!y || h !== v.last || v.raws.semicolon) && (h.source && h.source.end ? (a.source = t.sourcePath(h), a.original.line = h.source.end.line, a.original.column = h.source.end.column - 1, a.generated.line = i, a.generated.column = o - 2, t.map.addMapping(a)) : (a.source = s, a.original.line = 1, a.original.column = 0, a.generated.line = i, a.generated.column = o - 1, t.map.addMapping(a)));
      }
    });
  }, r.isAnnotation = function() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some(function(t) {
      return t.annotation;
    }) : !0;
  }, r.isInline = function() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    var t = this.mapOpts.annotation;
    return typeof t < "u" && t !== !0 ? !1 : this.previous().length ? this.previous().some(function(i) {
      return i.inline;
    }) : !0;
  }, r.isMap = function() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }, r.isSourcesContent = function() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some(function(t) {
      return t.withContent();
    }) : !0;
  }, r.outputFile = function() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }, r.path = function(t) {
    if (this.mapOpts.absolute || t.charCodeAt(0) === 60 || /^\w+:\/\//.test(t)) return t;
    var i = this.memoizedPaths.get(t);
    if (i) return i;
    var o = this.opts.to ? ni(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (o = ni($c(o, this.mapOpts.annotation)));
    var s = Fc(o, t);
    return this.memoizedPaths.set(t, s), s;
  }, r.previous = function() {
    var t = this;
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk(function(o) {
          if (o.source && o.source.input.map) {
            var s = o.source.input.map;
            t.previousMaps.includes(s) || t.previousMaps.push(s);
          }
        });
      else {
        var i = new kd(this.originalCSS, this.opts);
        i.map && this.previousMaps.push(i.map);
      }
    return this.previousMaps;
  }, r.setSourcesContent = function() {
    var t = this, i = {};
    if (this.root)
      this.root.walk(function(s) {
        if (s.source) {
          var a = s.source.input.from;
          if (a && !i[a]) {
            i[a] = !0;
            var u = t.usesFileUrls ? t.toFileUrl(a) : t.toUrl(t.path(a));
            t.map.setSourceContent(u, s.source.input.css);
          }
        }
      });
    else if (this.css) {
      var o = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(o, this.css);
    }
  }, r.sourcePath = function(t) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(t.source.input.from) : this.toUrl(this.path(t.source.input.from));
  }, r.toBase64 = function(t) {
    return Vt ? Vt.from(t).toString("base64") : window.btoa(unescape(encodeURIComponent(t)));
  }, r.toFileUrl = function(t) {
    var i = this.memoizedFileURLs.get(t);
    if (i) return i;
    if (qa) {
      var o = qa(t).toString();
      return this.memoizedFileURLs.set(t, o), o;
    } else
      throw new Error("`map.absolute` option is not available in this PostCSS build");
  }, r.toUrl = function(t) {
    var i = this.memoizedURLs.get(t);
    if (i) return i;
    Nc === "\\" && (t = t.replace(/\\/g, "/"));
    var o = encodeURI(t).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(t, o), o;
  }, e;
}(), Pc = Td, Md = Ni, Bo = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(n) {
    var t;
    return t = e.call(this, n) || this, t.type = "comment", t;
  }
  return r;
}(Md), Li = Bo;
Bo.default = Bo;
var Dc = Kt.isClean, Lc = Kt.my, Bc = Pi, Uc = Li, Fd = Ni, zc, Ts, Ms, qc;
function jc(e) {
  return e.map(function(r) {
    return r.nodes && (r.nodes = jc(r.nodes)), delete r.source, r;
  });
}
function Wc(e) {
  if (e[Dc] = !1, e.proxyOf.nodes)
    for (var r = D(e.proxyOf.nodes), n; !(n = r()).done; ) {
      var t = n.value;
      Wc(t);
    }
}
var Ft = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var n = r.prototype;
  return n.append = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    for (var a = D(o), u; !(u = a()).done; )
      for (var l = u.value, c = this.normalize(l, this.last), h = D(c), m; !(m = h()).done; ) {
        var v = m.value;
        this.proxyOf.nodes.push(v);
      }
    return this.markDirty(), this;
  }, n.cleanRaws = function(i) {
    if (e.prototype.cleanRaws.call(this, i), this.nodes)
      for (var o = D(this.nodes), s; !(s = o()).done; ) {
        var a = s.value;
        a.cleanRaws(i);
      }
  }, n.each = function(i) {
    if (this.proxyOf.nodes) {
      for (var o = this.getIterator(), s, a; this.indexes[o] < this.proxyOf.nodes.length && (s = this.indexes[o], a = i(this.proxyOf.nodes[s], s), a !== !1); )
        this.indexes[o] += 1;
      return delete this.indexes[o], a;
    }
  }, n.every = function(i) {
    return this.nodes.every(i);
  }, n.getIterator = function() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    var i = this.lastEach;
    return this.indexes[i] = 0, i;
  }, n.getProxyProcessor = function() {
    return {
      get: function(o, s) {
        return s === "proxyOf" ? o : o[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? function() {
          for (var a = arguments.length, u = new Array(a), l = 0; l < a; l++)
            u[l] = arguments[l];
          var c;
          return (c = o)[s].apply(c, [].concat(u.map(function(h) {
            return typeof h == "function" ? function(m, v) {
              return h(m.toProxy(), v);
            } : h;
          })));
        } : s === "every" || s === "some" ? function(a) {
          return o[s](function(u) {
            for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
              c[h - 1] = arguments[h];
            return a.apply(void 0, [].concat([
              u.toProxy()
            ], c));
          });
        } : s === "root" ? function() {
          return o.root().toProxy();
        } : s === "nodes" ? o.nodes.map(function(a) {
          return a.toProxy();
        }) : s === "first" || s === "last" ? o[s].toProxy() : o[s] : o[s];
      },
      set: function(o, s, a) {
        return o[s] === a || (o[s] = a, (s === "name" || s === "params" || s === "selector") && o.markDirty()), !0;
      }
    };
  }, n.index = function(i) {
    return typeof i == "number" ? i : (i.proxyOf && (i = i.proxyOf), this.proxyOf.nodes.indexOf(i));
  }, n.insertAfter = function(i, o) {
    var s = this.index(i), a = this.normalize(o, this.proxyOf.nodes[s]).reverse();
    s = this.index(i);
    for (var u = D(a), l; !(l = u()).done; ) {
      var c = l.value;
      this.proxyOf.nodes.splice(s + 1, 0, c);
    }
    var h;
    for (var m in this.indexes)
      h = this.indexes[m], s < h && (this.indexes[m] = h + a.length);
    return this.markDirty(), this;
  }, n.insertBefore = function(i, o) {
    var s = this.index(i), a = s === 0 ? "prepend" : !1, u = this.normalize(o, this.proxyOf.nodes[s], a).reverse();
    s = this.index(i);
    for (var l = D(u), c; !(c = l()).done; ) {
      var h = c.value;
      this.proxyOf.nodes.splice(s, 0, h);
    }
    var m;
    for (var v in this.indexes)
      m = this.indexes[v], s <= m && (this.indexes[v] = m + u.length);
    return this.markDirty(), this;
  }, n.normalize = function(i, o) {
    var s = this;
    if (typeof i == "string")
      i = jc(zc(i).nodes);
    else if (typeof i > "u")
      i = [];
    else if (Array.isArray(i)) {
      i = i.slice(0);
      for (var a = D(i), u; !(u = a()).done; ) {
        var l = u.value;
        l.parent && l.parent.removeChild(l, "ignore");
      }
    } else if (i.type === "root" && this.type !== "document") {
      i = i.nodes.slice(0);
      for (var c = D(i), h; !(h = c()).done; ) {
        var m = h.value;
        m.parent && m.parent.removeChild(m, "ignore");
      }
    } else if (i.type)
      i = [
        i
      ];
    else if (i.prop) {
      if (typeof i.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof i.value != "string" && (i.value = String(i.value)), i = [
        new Bc(i)
      ];
    } else if (i.selector)
      i = [
        new Ts(i)
      ];
    else if (i.name)
      i = [
        new Ms(i)
      ];
    else if (i.text)
      i = [
        new Uc(i)
      ];
    else
      throw new Error("Unknown node type in node creation");
    var v = i.map(function(y) {
      return y[Lc] || r.rebuild(y), y = y.proxyOf, y.parent && y.parent.removeChild(y), y[Dc] && Wc(y), typeof y.raws.before > "u" && o && typeof o.raws.before < "u" && (y.raws.before = o.raws.before.replace(/\S/g, "")), y.parent = s.proxyOf, y;
    });
    return v;
  }, n.prepend = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    o = o.reverse();
    for (var a = D(o), u; !(u = a()).done; ) {
      for (var l = u.value, c = this.normalize(l, this.first, "prepend").reverse(), h = D(c), m; !(m = h()).done; ) {
        var v = m.value;
        this.proxyOf.nodes.unshift(v);
      }
      for (var y in this.indexes)
        this.indexes[y] = this.indexes[y] + c.length;
    }
    return this.markDirty(), this;
  }, n.push = function(i) {
    return i.parent = this, this.proxyOf.nodes.push(i), this;
  }, n.removeAll = function() {
    for (var i = D(this.proxyOf.nodes), o; !(o = i()).done; ) {
      var s = o.value;
      s.parent = void 0;
    }
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }, n.removeChild = function(i) {
    i = this.index(i), this.proxyOf.nodes[i].parent = void 0, this.proxyOf.nodes.splice(i, 1);
    var o;
    for (var s in this.indexes)
      o = this.indexes[s], o >= i && (this.indexes[s] = o - 1);
    return this.markDirty(), this;
  }, n.replaceValues = function(i, o, s) {
    return s || (s = o, o = {}), this.walkDecls(function(a) {
      o.props && !o.props.includes(a.prop) || o.fast && !a.value.includes(o.fast) || (a.value = a.value.replace(i, s));
    }), this.markDirty(), this;
  }, n.some = function(i) {
    return this.nodes.some(i);
  }, n.walk = function(i) {
    return this.each(function(o, s) {
      var a;
      try {
        a = i(o, s);
      } catch (u) {
        throw o.addToError(u);
      }
      return a !== !1 && o.walk && (a = o.walk(i)), a;
    });
  }, n.walkAtRules = function(i, o) {
    return o ? W(i, RegExp) ? this.walk(function(s, a) {
      if (s.type === "atrule" && i.test(s.name))
        return o(s, a);
    }) : this.walk(function(s, a) {
      if (s.type === "atrule" && s.name === i)
        return o(s, a);
    }) : (o = i, this.walk(function(s, a) {
      if (s.type === "atrule")
        return o(s, a);
    }));
  }, n.walkComments = function(i) {
    return this.walk(function(o, s) {
      if (o.type === "comment")
        return i(o, s);
    });
  }, n.walkDecls = function(i, o) {
    return o ? W(i, RegExp) ? this.walk(function(s, a) {
      if (s.type === "decl" && i.test(s.prop))
        return o(s, a);
    }) : this.walk(function(s, a) {
      if (s.type === "decl" && s.prop === i)
        return o(s, a);
    }) : (o = i, this.walk(function(s, a) {
      if (s.type === "decl")
        return o(s, a);
    }));
  }, n.walkRules = function(i, o) {
    return o ? W(i, RegExp) ? this.walk(function(s, a) {
      if (s.type === "rule" && i.test(s.selector))
        return o(s, a);
    }) : this.walk(function(s, a) {
      if (s.type === "rule" && s.selector === i)
        return o(s, a);
    }) : (o = i, this.walk(function(s, a) {
      if (s.type === "rule")
        return o(s, a);
    }));
  }, Te(r, [
    {
      key: "first",
      get: function() {
        if (this.proxyOf.nodes)
          return this.proxyOf.nodes[0];
      }
    },
    {
      key: "last",
      get: function() {
        if (this.proxyOf.nodes)
          return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
      }
    }
  ]), r;
}(Fd);
Ft.registerParse = function(e) {
  zc = e;
};
Ft.registerRule = function(e) {
  Ts = e;
};
Ft.registerAtRule = function(e) {
  Ms = e;
};
Ft.registerRoot = function(e) {
  qc = e;
};
var hr = Ft;
Ft.default = Ft;
Ft.rebuild = function(e) {
  e.type === "atrule" ? Object.setPrototypeOf(e, Ms.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, Ts.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, Bc.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, Uc.prototype) : e.type === "root" && Object.setPrototypeOf(e, qc.prototype), e[Lc] = !0, e.nodes && e.nodes.forEach(function(r) {
    Ft.rebuild(r);
  });
};
var $d = hr, Gc, Vc, sn = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t) {
    var i;
    return i = e.call(this, Q({
      type: "document"
    }, t)) || this, i.nodes || (i.nodes = []), i;
  }
  var n = r.prototype;
  return n.toResult = function(i) {
    i === void 0 && (i = {});
    var o = new Gc(new Vc(), this, i);
    return o.stringify();
  }, r;
}($d);
sn.registerLazyResult = function(e) {
  Gc = e;
};
sn.registerProcessor = function(e) {
  Vc = e;
};
var Fs = sn;
sn.default = sn;
var ja = {}, Yc = function(r) {
  ja[r] || (ja[r] = !0, typeof console < "u" && console.warn && console.warn(r));
}, Uo = /* @__PURE__ */ function() {
  function e(n, t) {
    if (t === void 0 && (t = {}), this.type = "warning", this.text = n, t.node && t.node.source) {
      var i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (var o in t) this[o] = t[o];
  }
  var r = e.prototype;
  return r.toString = function() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }, e;
}(), Hc = Uo;
Uo.default = Uo;
var Nd = Hc, zo = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.processor = n, this.messages = [], this.root = t, this.opts = i, this.css = void 0, this.map = void 0;
  }
  var r = e.prototype;
  return r.toString = function() {
    return this.css;
  }, r.warn = function(t, i) {
    i === void 0 && (i = {}), i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
    var o = new Nd(t, i);
    return this.messages.push(o), o;
  }, r.warnings = function() {
    return this.messages.filter(function(t) {
      return t.type === "warning";
    });
  }, Te(e, [
    {
      key: "content",
      get: function() {
        return this.css;
      }
    }
  ]), e;
}(), $s = zo;
zo.default = zo;
var oo = 39, Wa = 34, Rn = 92, Ga = 47, Tn = 10, Wr = 32, Mn = 12, Fn = 9, $n = 13, Pd = 91, Dd = 93, Ld = 40, Bd = 41, Ud = 123, zd = 125, qd = 59, jd = 42, Wd = 58, Gd = 64, Nn = /[\t\n\f\r "#'()/;[\\\]{}]/g, Pn = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Vd = /.[\r\n"'(/\\]/, Va = /[\da-f]/i, Yd = function(r, n) {
  n === void 0 && (n = {});
  var t = r.css.valueOf(), i = n.ignoreErrors, o, s, a, u, l, c, h, m, v, y, S = t.length, _ = 0, b = [], C = [];
  function E() {
    return _;
  }
  function R(N) {
    throw r.error("Unclosed " + N, _);
  }
  function A() {
    return C.length === 0 && _ >= S;
  }
  function M(N) {
    if (C.length) return C.pop();
    if (!(_ >= S)) {
      var B = N ? N.ignoreUnclosed : !1;
      switch (o = t.charCodeAt(_), o) {
        case Tn:
        case Wr:
        case Fn:
        case $n:
        case Mn: {
          s = _;
          do
            s += 1, o = t.charCodeAt(s);
          while (o === Wr || o === Tn || o === Fn || o === $n || o === Mn);
          y = [
            "space",
            t.slice(_, s)
          ], _ = s - 1;
          break;
        }
        case Pd:
        case Dd:
        case Ud:
        case zd:
        case Wd:
        case qd:
        case Bd: {
          var G = String.fromCharCode(o);
          y = [
            G,
            G,
            _
          ];
          break;
        }
        case Ld: {
          if (m = b.length ? b.pop()[1] : "", v = t.charCodeAt(_ + 1), m === "url" && v !== oo && v !== Wa && v !== Wr && v !== Tn && v !== Fn && v !== Mn && v !== $n) {
            s = _;
            do {
              if (c = !1, s = t.indexOf(")", s + 1), s === -1)
                if (i || B) {
                  s = _;
                  break;
                } else
                  R("bracket");
              for (h = s; t.charCodeAt(h - 1) === Rn; )
                h -= 1, c = !c;
            } while (c);
            y = [
              "brackets",
              t.slice(_, s + 1),
              _,
              s
            ], _ = s;
          } else
            s = t.indexOf(")", _ + 1), u = t.slice(_, s + 1), s === -1 || Vd.test(u) ? y = [
              "(",
              "(",
              _
            ] : (y = [
              "brackets",
              u,
              _,
              s
            ], _ = s);
          break;
        }
        case oo:
        case Wa: {
          a = o === oo ? "'" : '"', s = _;
          do {
            if (c = !1, s = t.indexOf(a, s + 1), s === -1)
              if (i || B) {
                s = _ + 1;
                break;
              } else
                R("string");
            for (h = s; t.charCodeAt(h - 1) === Rn; )
              h -= 1, c = !c;
          } while (c);
          y = [
            "string",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s;
          break;
        }
        case Gd: {
          Nn.lastIndex = _ + 1, Nn.test(t), Nn.lastIndex === 0 ? s = t.length - 1 : s = Nn.lastIndex - 2, y = [
            "at-word",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s;
          break;
        }
        case Rn: {
          for (s = _, l = !0; t.charCodeAt(s + 1) === Rn; )
            s += 1, l = !l;
          if (o = t.charCodeAt(s + 1), l && o !== Ga && o !== Wr && o !== Tn && o !== Fn && o !== $n && o !== Mn && (s += 1, Va.test(t.charAt(s)))) {
            for (; Va.test(t.charAt(s + 1)); )
              s += 1;
            t.charCodeAt(s + 1) === Wr && (s += 1);
          }
          y = [
            "word",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s;
          break;
        }
        default: {
          o === Ga && t.charCodeAt(_ + 1) === jd ? (s = t.indexOf("*/", _ + 2) + 1, s === 0 && (i || B ? s = t.length : R("comment")), y = [
            "comment",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s) : (Pn.lastIndex = _ + 1, Pn.test(t), Pn.lastIndex === 0 ? s = t.length - 1 : s = Pn.lastIndex - 2, y = [
            "word",
            t.slice(_, s + 1),
            _,
            s
          ], b.push(y), _ = s);
          break;
        }
      }
      return _++, y;
    }
  }
  function L(N) {
    C.push(N);
  }
  return {
    back: L,
    endOfFile: A,
    nextToken: M,
    position: E
  };
}, Zc = hr, mi = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t) {
    var i;
    return i = e.call(this, t) || this, i.type = "atrule", i;
  }
  var n = r.prototype;
  return n.append = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    var a;
    return this.proxyOf.nodes || (this.nodes = []), (a = e.prototype.append).call.apply(a, [].concat([
      this
    ], o));
  }, n.prepend = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    var a;
    return this.proxyOf.nodes || (this.nodes = []), (a = e.prototype.prepend).call.apply(a, [].concat([
      this
    ], o));
  }, r;
}(Zc), Ns = mi;
mi.default = mi;
Zc.registerAtRule(mi);
var Kc = hr, Jc, Xc, Rr = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t) {
    var i;
    return i = e.call(this, t) || this, i.type = "root", i.nodes || (i.nodes = []), i;
  }
  var n = r.prototype;
  return n.normalize = function(i, o, s) {
    var a = e.prototype.normalize.call(this, i);
    if (o) {
      if (s === "prepend")
        this.nodes.length > 1 ? o.raws.before = this.nodes[1].raws.before : delete o.raws.before;
      else if (this.first !== o)
        for (var u = D(a), l; !(l = u()).done; ) {
          var c = l.value;
          c.raws.before = o.raws.before;
        }
    }
    return a;
  }, n.removeChild = function(i, o) {
    var s = this.index(i);
    return !o && s === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[s].raws.before), e.prototype.removeChild.call(this, i);
  }, n.toResult = function(i) {
    i === void 0 && (i = {});
    var o = new Jc(new Xc(), this, i);
    return o.stringify();
  }, r;
}(Kc);
Rr.registerLazyResult = function(e) {
  Jc = e;
};
Rr.registerProcessor = function(e) {
  Xc = e;
};
var yn = Rr;
Rr.default = Rr;
Kc.registerRoot(Rr);
var an = {
  comma: function(r) {
    return an.split(r, [
      ","
    ], !0);
  },
  space: function(r) {
    var n = [
      " ",
      `
`,
      "	"
    ];
    return an.split(r, n);
  },
  split: function(r, n, t) {
    for (var i = [], o = "", s = !1, a = 0, u = !1, l = "", c = !1, h = D(r), m; !(m = h()).done; ) {
      var v = m.value;
      c ? c = !1 : v === "\\" ? c = !0 : u ? v === l && (u = !1) : v === '"' || v === "'" ? (u = !0, l = v) : v === "(" ? a += 1 : v === ")" ? a > 0 && (a -= 1) : a === 0 && n.includes(v) && (s = !0), s ? (o !== "" && i.push(o.trim()), o = "", s = !1) : o += v;
    }
    return (t || o !== "") && i.push(o.trim()), i;
  }
}, Qc = an;
an.default = an;
var el = hr, Hd = Qc, gi = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(n) {
    var t;
    return t = e.call(this, n) || this, t.type = "rule", t.nodes || (t.nodes = []), t;
  }
  return Te(r, [
    {
      key: "selectors",
      get: function() {
        return Hd.comma(this.selector);
      },
      set: function(t) {
        var i = this.selector ? this.selector.match(/,\s*/) : null, o = i ? i[0] : "," + this.raw("between", "beforeOpen");
        this.selector = t.join(o);
      }
    }
  ]), r;
}(el), Ps = gi;
gi.default = gi;
el.registerRule(gi);
var Zd = Pi, Kd = Yd, Jd = Li, Xd = Ns, Qd = yn, Ya = Ps, Ha = {
  empty: !0,
  space: !0
};
function em(e) {
  for (var r = e.length - 1; r >= 0; r--) {
    var n = e[r], t = n[3] || n[2];
    if (t) return t;
  }
}
var tm = /* @__PURE__ */ function() {
  function e(n) {
    this.input = n, this.root = new Qd(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = {
      input: n,
      start: {
        column: 1,
        line: 1,
        offset: 0
      }
    };
  }
  var r = e.prototype;
  return r.atrule = function(t) {
    var i = new Xd();
    i.name = t[1].slice(1), i.name === "" && this.unnamedAtrule(i, t), this.init(i, t[2]);
    for (var o, s, a, u = !1, l = !1, c = [], h = []; !this.tokenizer.endOfFile(); ) {
      if (t = this.tokenizer.nextToken(), o = t[0], o === "(" || o === "[" ? h.push(o === "(" ? ")" : "]") : o === "{" && h.length > 0 ? h.push("}") : o === h[h.length - 1] && h.pop(), h.length === 0)
        if (o === ";") {
          i.source.end = this.getPosition(t[2]), i.source.end.offset++, this.semicolon = !0;
          break;
        } else if (o === "{") {
          l = !0;
          break;
        } else if (o === "}") {
          if (c.length > 0) {
            for (a = c.length - 1, s = c[a]; s && s[0] === "space"; )
              s = c[--a];
            s && (i.source.end = this.getPosition(s[3] || s[2]), i.source.end.offset++);
          }
          this.end(t);
          break;
        } else
          c.push(t);
      else
        c.push(t);
      if (this.tokenizer.endOfFile()) {
        u = !0;
        break;
      }
    }
    i.raws.between = this.spacesAndCommentsFromEnd(c), c.length ? (i.raws.afterName = this.spacesAndCommentsFromStart(c), this.raw(i, "params", c), u && (t = c[c.length - 1], i.source.end = this.getPosition(t[3] || t[2]), i.source.end.offset++, this.spaces = i.raws.between, i.raws.between = "")) : (i.raws.afterName = "", i.params = ""), l && (i.nodes = [], this.current = i);
  }, r.checkMissedSemicolon = function(t) {
    var i = this.colon(t);
    if (i !== !1) {
      for (var o = 0, s, a = i - 1; a >= 0 && (s = t[a], !(s[0] !== "space" && (o += 1, o === 2))); a--)
        ;
      throw this.input.error("Missed semicolon", s[0] === "word" ? s[3] + 1 : s[2]);
    }
  }, r.colon = function(t) {
    for (var i = 0, o, s, a, u = D(t.entries()), l; !(l = u()).done; ) {
      var c = l.value, h = c[0], m = c[1];
      if (o = m, s = o[0], s === "(" && (i += 1), s === ")" && (i -= 1), i === 0 && s === ":")
        if (!a)
          this.doubleColon(o);
        else {
          if (a[0] === "word" && a[1] === "progid")
            continue;
          return h;
        }
      a = o;
    }
    return !1;
  }, r.comment = function(t) {
    var i = new Jd();
    this.init(i, t[2]), i.source.end = this.getPosition(t[3] || t[2]), i.source.end.offset++;
    var o = t[1].slice(2, -2);
    if (/^\s*$/.test(o))
      i.text = "", i.raws.left = o, i.raws.right = "";
    else {
      var s = o.match(/^(\s*)([^]*\S)(\s*)$/);
      i.text = s[2], i.raws.left = s[1], i.raws.right = s[3];
    }
  }, r.createTokenizer = function() {
    this.tokenizer = Kd(this.input);
  }, r.decl = function(t, i) {
    var o = new Zd();
    this.init(o, t[0][2]);
    var s = t[t.length - 1];
    for (s[0] === ";" && (this.semicolon = !0, t.pop()), o.source.end = this.getPosition(s[3] || s[2] || em(t)), o.source.end.offset++; t[0][0] !== "word"; )
      t.length === 1 && this.unknownWord(t), o.raws.before += t.shift()[1];
    for (o.source.start = this.getPosition(t[0][2]), o.prop = ""; t.length; ) {
      var a = t[0][0];
      if (a === ":" || a === "space" || a === "comment")
        break;
      o.prop += t.shift()[1];
    }
    o.raws.between = "";
    for (var u; t.length; )
      if (u = t.shift(), u[0] === ":") {
        o.raws.between += u[1];
        break;
      } else
        u[0] === "word" && /\w/.test(u[1]) && this.unknownWord([
          u
        ]), o.raws.between += u[1];
    (o.prop[0] === "_" || o.prop[0] === "*") && (o.raws.before += o.prop[0], o.prop = o.prop.slice(1));
    for (var l = [], c; t.length && (c = t[0][0], !(c !== "space" && c !== "comment")); )
      l.push(t.shift());
    this.precheckMissedSemicolon(t);
    for (var h = t.length - 1; h >= 0; h--) {
      if (u = t[h], u[1].toLowerCase() === "!important") {
        o.important = !0;
        var m = this.stringFrom(t, h);
        m = this.spacesFromEnd(t) + m, m !== " !important" && (o.raws.important = m);
        break;
      } else if (u[1].toLowerCase() === "important") {
        for (var v = t.slice(0), y = "", S = h; S > 0; S--) {
          var _ = v[S][0];
          if (y.trim().indexOf("!") === 0 && _ !== "space")
            break;
          y = v.pop()[1] + y;
        }
        y.trim().indexOf("!") === 0 && (o.important = !0, o.raws.important = y, t = v);
      }
      if (u[0] !== "space" && u[0] !== "comment")
        break;
    }
    var b = t.some(function(C) {
      return C[0] !== "space" && C[0] !== "comment";
    });
    b && (o.raws.between += l.map(function(C) {
      return C[1];
    }).join(""), l = []), this.raw(o, "value", l.concat(t), i), o.value.includes(":") && !i && this.checkMissedSemicolon(t);
  }, r.doubleColon = function(t) {
    throw this.input.error("Double colon", {
      offset: t[2]
    }, {
      offset: t[2] + t[1].length
    });
  }, r.emptyRule = function(t) {
    var i = new Ya();
    this.init(i, t[2]), i.selector = "", i.raws.between = "", this.current = i;
  }, r.end = function(t) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(t[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(t);
  }, r.endFile = function() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }, r.freeSemicolon = function(t) {
    if (this.spaces += t[1], this.current.nodes) {
      var i = this.current.nodes[this.current.nodes.length - 1];
      i && i.type === "rule" && !i.raws.ownSemicolon && (i.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }, r.getPosition = function(t) {
    var i = this.input.fromOffset(t);
    return {
      column: i.col,
      line: i.line,
      offset: t
    };
  }, r.init = function(t, i) {
    this.current.push(t), t.source = {
      input: this.input,
      start: this.getPosition(i)
    }, t.raws.before = this.spaces, this.spaces = "", t.type !== "comment" && (this.semicolon = !1);
  }, r.other = function(t) {
    for (var i = !1, o = null, s = !1, a = null, u = [], l = t[1].startsWith("--"), c = [], h = t; h; ) {
      if (o = h[0], c.push(h), o === "(" || o === "[")
        a || (a = h), u.push(o === "(" ? ")" : "]");
      else if (l && s && o === "{")
        a || (a = h), u.push("}");
      else if (u.length === 0)
        if (o === ";")
          if (s) {
            this.decl(c, l);
            return;
          } else
            break;
        else if (o === "{") {
          this.rule(c);
          return;
        } else if (o === "}") {
          this.tokenizer.back(c.pop()), i = !0;
          break;
        } else o === ":" && (s = !0);
      else o === u[u.length - 1] && (u.pop(), u.length === 0 && (a = null));
      h = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (i = !0), u.length > 0 && this.unclosedBracket(a), i && s) {
      if (!l)
        for (; c.length && (h = c[c.length - 1][0], !(h !== "space" && h !== "comment")); )
          this.tokenizer.back(c.pop());
      this.decl(c, l);
    } else
      this.unknownWord(c);
  }, r.parse = function() {
    for (var t; !this.tokenizer.endOfFile(); )
      switch (t = this.tokenizer.nextToken(), t[0]) {
        case "space":
          this.spaces += t[1];
          break;
        case ";":
          this.freeSemicolon(t);
          break;
        case "}":
          this.end(t);
          break;
        case "comment":
          this.comment(t);
          break;
        case "at-word":
          this.atrule(t);
          break;
        case "{":
          this.emptyRule(t);
          break;
        default:
          this.other(t);
          break;
      }
    this.endFile();
  }, r.precheckMissedSemicolon = function() {
  }, r.raw = function(t, i, o, s) {
    for (var a, u, l = o.length, c = "", h = !0, m, v, y = 0; y < l; y += 1)
      a = o[y], u = a[0], u === "space" && y === l - 1 && !s ? h = !1 : u === "comment" ? (v = o[y - 1] ? o[y - 1][0] : "empty", m = o[y + 1] ? o[y + 1][0] : "empty", !Ha[v] && !Ha[m] ? c.slice(-1) === "," ? h = !1 : c += a[1] : h = !1) : c += a[1];
    if (!h) {
      var S = o.reduce(function(_, b) {
        return _ + b[1];
      }, "");
      t.raws[i] = {
        raw: S,
        value: c
      };
    }
    t[i] = c;
  }, r.rule = function(t) {
    t.pop();
    var i = new Ya();
    this.init(i, t[0][2]), i.raws.between = this.spacesAndCommentsFromEnd(t), this.raw(i, "selector", t), this.current = i;
  }, r.spacesAndCommentsFromEnd = function(t) {
    for (var i, o = ""; t.length && (i = t[t.length - 1][0], !(i !== "space" && i !== "comment")); )
      o = t.pop()[1] + o;
    return o;
  }, r.spacesAndCommentsFromStart = function(t) {
    for (var i, o = ""; t.length && (i = t[0][0], !(i !== "space" && i !== "comment")); )
      o += t.shift()[1];
    return o;
  }, r.spacesFromEnd = function(t) {
    for (var i, o = ""; t.length && (i = t[t.length - 1][0], i === "space"); )
      o = t.pop()[1] + o;
    return o;
  }, r.stringFrom = function(t, i) {
    for (var o = "", s = i; s < t.length; s++)
      o += t[s][1];
    return t.splice(i, t.length - i), o;
  }, r.unclosedBlock = function() {
    var t = this.current.source.start;
    throw this.input.error("Unclosed block", t.line, t.column);
  }, r.unclosedBracket = function(t) {
    throw this.input.error("Unclosed bracket", {
      offset: t[2]
    }, {
      offset: t[2] + 1
    });
  }, r.unexpectedClose = function(t) {
    throw this.input.error("Unexpected }", {
      offset: t[2]
    }, {
      offset: t[2] + 1
    });
  }, r.unknownWord = function(t) {
    throw this.input.error("Unknown word", {
      offset: t[0][2]
    }, {
      offset: t[0][2] + t[0][1].length
    });
  }, r.unnamedAtrule = function(t, i) {
    throw this.input.error("At-rule without name", {
      offset: i[2]
    }, {
      offset: i[2] + i[1].length
    });
  }, e;
}(), rm = tm, nm = hr, im = rm, om = Di;
function vi(e, r) {
  var n = new om(e, r), t = new im(n);
  try {
    t.parse();
  } catch (i) {
    throw We.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && r && r.from && (/\.scss$/i.test(r.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(r.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(r.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return t.root;
}
var Ds = vi;
vi.default = vi;
nm.registerParse(vi);
var ht = Kt.isClean, sm = Kt.my, am = Pc, um = $i, cm = hr, lm = Fs, fm = Yc, Za = $s, hm = Ds, pm = yn, dm = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, mm = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, gm = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, Tr = 0;
function Gr(e) {
  return (typeof e > "u" ? "undefined" : H(e)) === "object" && typeof e.then == "function";
}
function tl(e) {
  var r = !1, n = dm[e.type];
  return e.type === "decl" ? r = e.prop.toLowerCase() : e.type === "atrule" && (r = e.name.toLowerCase()), r && e.append ? [
    n,
    n + "-" + r,
    Tr,
    n + "Exit",
    n + "Exit-" + r
  ] : r ? [
    n,
    n + "-" + r,
    n + "Exit",
    n + "Exit-" + r
  ] : e.append ? [
    n,
    Tr,
    n + "Exit"
  ] : [
    n,
    n + "Exit"
  ];
}
function Ka(e) {
  var r;
  return e.type === "document" ? r = [
    "Document",
    Tr,
    "DocumentExit"
  ] : e.type === "root" ? r = [
    "Root",
    Tr,
    "RootExit"
  ] : r = tl(e), {
    eventIndex: 0,
    events: r,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function qo(e) {
  return e[ht] = !1, e.nodes && e.nodes.forEach(function(r) {
    return qo(r);
  }), e;
}
var jo = {}, Mr = /* @__PURE__ */ function() {
  function e(n, t, i) {
    var o = this;
    this.stringified = !1, this.processed = !1;
    var s;
    if ((typeof t > "u" ? "undefined" : H(t)) === "object" && t !== null && (t.type === "root" || t.type === "document"))
      s = qo(t);
    else if (W(t, e) || W(t, Za))
      s = qo(t.root), t.map && (typeof i.map > "u" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      var a = hm;
      i.syntax && (a = i.syntax.parse), i.parser && (a = i.parser), a.parse && (a = a.parse);
      try {
        s = a(t, i);
      } catch (u) {
        this.processed = !0, this.error = u;
      }
      s && !s[sm] && cm.rebuild(s);
    }
    this.result = new Za(n, s, i), this.helpers = Q({}, jo, {
      postcss: jo,
      result: this.result
    }), this.plugins = this.processor.plugins.map(function(u) {
      return (typeof u > "u" ? "undefined" : H(u)) === "object" && u.prepare ? Q({}, u, u.prepare(o.result)) : u;
    });
  }
  var r = e.prototype;
  return r.async = function() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }, r.catch = function(t) {
    return this.async().catch(t);
  }, r.finally = function(t) {
    return this.async().then(t, t);
  }, r.getAsyncError = function() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }, r.handleError = function(t, i) {
    var o = this.result.lastPlugin;
    try {
      if (i && i.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = o.postcssPlugin, t.setMessage();
      else if (o.postcssVersion && We.env.NODE_ENV !== "production") {
        var s = o.postcssPlugin, a = o.postcssVersion, u = this.result.processor.version, l = a.split("."), c = u.split(".");
        (l[0] !== c[0] || parseInt(l[1]) > parseInt(c[1])) && console.error("Unknown error from PostCSS plugin. Your current PostCSS version is " + u + ", but " + s + " uses " + a + ". Perhaps this is the source of the error below.");
      }
    } catch (h) {
      console && console.error && console.error(h);
    }
    return t;
  }, r.prepareVisitors = function() {
    var t = this;
    this.listeners = {};
    for (var i = function(c, h, m) {
      t.listeners[h] || (t.listeners[h] = []), t.listeners[h].push([
        c,
        m
      ]);
    }, o = D(this.plugins), s; !(s = o()).done; ) {
      var a = s.value;
      if ((typeof a > "u" ? "undefined" : H(a)) === "object")
        for (var u in a) {
          if (!mm[u] && /^[A-Z]/.test(u))
            throw new Error("Unknown event " + u + " in " + a.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
          if (!gm[u])
            if (H(a[u]) === "object")
              for (var l in a[u])
                l === "*" ? i(a, u, a[u][l]) : i(a, u + "-" + l.toLowerCase(), a[u][l]);
            else typeof a[u] == "function" && i(a, u, a[u]);
        }
    }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }, r.runAsync = function() {
    var t = this;
    return xs(function() {
      var i, o, s, a, u, l, c, h, m, v, y, S;
      return nn(this, function(_) {
        switch (_.label) {
          case 0:
            t.plugin = 0, i = 0, _.label = 1;
          case 1:
            if (!(i < t.plugins.length)) return [
              3,
              6
            ];
            if (o = t.plugins[i], s = t.runOnRoot(o), !Gr(s)) return [
              3,
              5
            ];
            _.label = 2;
          case 2:
            return _.trys.push([
              2,
              4,
              ,
              5
            ]), [
              4,
              s
            ];
          case 3:
            return _.sent(), [
              3,
              5
            ];
          case 4:
            throw a = _.sent(), t.handleError(a);
          case 5:
            return i++, [
              3,
              1
            ];
          case 6:
            if (t.prepareVisitors(), !t.hasListener) return [
              3,
              18
            ];
            u = t.result.root, _.label = 7;
          case 7:
            if (u[ht]) return [
              3,
              14
            ];
            u[ht] = !0, l = [
              Ka(u)
            ], _.label = 8;
          case 8:
            if (!(l.length > 0)) return [
              3,
              13
            ];
            if (c = t.visitTick(l), !Gr(c)) return [
              3,
              12
            ];
            _.label = 9;
          case 9:
            return _.trys.push([
              9,
              11,
              ,
              12
            ]), [
              4,
              c
            ];
          case 10:
            return _.sent(), [
              3,
              12
            ];
          case 11:
            throw h = _.sent(), m = l[l.length - 1].node, t.handleError(h, m);
          case 12:
            return [
              3,
              8
            ];
          case 13:
            return [
              3,
              7
            ];
          case 14:
            if (!t.listeners.OnceExit) return [
              3,
              18
            ];
            v = function() {
              var b, C, E, R, A;
              return nn(this, function(M) {
                switch (M.label) {
                  case 0:
                    b = S.value, C = b[0], E = b[1], t.result.lastPlugin = C, M.label = 1;
                  case 1:
                    return M.trys.push([
                      1,
                      6,
                      ,
                      7
                    ]), u.type !== "document" ? [
                      3,
                      3
                    ] : (R = u.nodes.map(function(L) {
                      return E(L, t.helpers);
                    }), [
                      4,
                      Promise.all(R)
                    ]);
                  case 2:
                    return M.sent(), [
                      3,
                      5
                    ];
                  case 3:
                    return [
                      4,
                      E(u, t.helpers)
                    ];
                  case 4:
                    M.sent(), M.label = 5;
                  case 5:
                    return [
                      3,
                      7
                    ];
                  case 6:
                    throw A = M.sent(), t.handleError(A);
                  case 7:
                    return [
                      2
                    ];
                }
              });
            }, y = D(t.listeners.OnceExit), _.label = 15;
          case 15:
            return (S = y()).done ? [
              3,
              18
            ] : [
              5,
              _c(v())
            ];
          case 16:
            _.sent(), _.label = 17;
          case 17:
            return [
              3,
              15
            ];
          case 18:
            return t.processed = !0, [
              2,
              t.stringify()
            ];
        }
      });
    })();
  }, r.runOnRoot = function(t) {
    var i = this;
    this.result.lastPlugin = t;
    try {
      if ((typeof t > "u" ? "undefined" : H(t)) === "object" && t.Once) {
        if (this.result.root.type === "document") {
          var o = this.result.root.nodes.map(function(s) {
            return t.Once(s, i.helpers);
          });
          return Gr(o[0]) ? Promise.all(o) : o;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (s) {
      throw this.handleError(s);
    }
  }, r.stringify = function() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    var t = this.result.opts, i = um;
    t.syntax && (i = t.syntax.stringify), t.stringifier && (i = t.stringifier), i.stringify && (i = i.stringify);
    var o = new am(i, this.result.root, this.result.opts), s = o.generate();
    return this.result.css = s[0], this.result.map = s[1], this.result;
  }, r.sync = function() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (var t = D(this.plugins), i; !(i = t()).done; ) {
      var o = i.value, s = this.runOnRoot(o);
      if (Gr(s))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      for (var a = this.result.root; !a[ht]; )
        a[ht] = !0, this.walkSync(a);
      if (this.listeners.OnceExit)
        if (a.type === "document")
          for (var u = D(a.nodes), l; !(l = u()).done; ) {
            var c = l.value;
            this.visitSync(this.listeners.OnceExit, c);
          }
        else
          this.visitSync(this.listeners.OnceExit, a);
    }
    return this.result;
  }, r.then = function(t, i) {
    return We.env.NODE_ENV !== "production" && ("from" in this.opts || fm("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.")), this.async().then(t, i);
  }, r.toString = function() {
    return this.css;
  }, r.visitSync = function(t, i) {
    for (var o = D(t), s; !(s = o()).done; ) {
      var a = s.value, u = a[0], l = a[1];
      this.result.lastPlugin = u;
      var c = void 0;
      try {
        c = l(i, this.helpers);
      } catch (h) {
        throw this.handleError(h, i.proxyOf);
      }
      if (i.type !== "root" && i.type !== "document" && !i.parent)
        return !0;
      if (Gr(c))
        throw this.getAsyncError();
    }
  }, r.visitTick = function(t) {
    var i = t[t.length - 1], o = i.node, s = i.visitors;
    if (o.type !== "root" && o.type !== "document" && !o.parent) {
      t.pop();
      return;
    }
    if (s.length > 0 && i.visitorIndex < s.length) {
      var a = s[i.visitorIndex], u = a[0], l = a[1];
      i.visitorIndex += 1, i.visitorIndex === s.length && (i.visitors = [], i.visitorIndex = 0), this.result.lastPlugin = u;
      try {
        return l(o.toProxy(), this.helpers);
      } catch (y) {
        throw this.handleError(y, o);
      }
    }
    if (i.iterator !== 0) {
      for (var c = i.iterator, h; h = o.nodes[o.indexes[c]]; )
        if (o.indexes[c] += 1, !h[ht]) {
          h[ht] = !0, t.push(Ka(h));
          return;
        }
      i.iterator = 0, delete o.indexes[c];
    }
    for (var m = i.events; i.eventIndex < m.length; ) {
      var v = m[i.eventIndex];
      if (i.eventIndex += 1, v === Tr) {
        o.nodes && o.nodes.length && (o[ht] = !0, i.iterator = o.getIterator());
        return;
      } else if (this.listeners[v]) {
        i.visitors = this.listeners[v];
        return;
      }
    }
    t.pop();
  }, r.walkSync = function(t) {
    var i = this;
    t[ht] = !0;
    for (var o = tl(t), s = D(o), a; !(a = s()).done; ) {
      var u = a.value;
      if (u === Tr)
        t.nodes && t.each(function(c) {
          c[ht] || i.walkSync(c);
        });
      else {
        var l = this.listeners[u];
        if (l && this.visitSync(l, t.toProxy()))
          return;
      }
    }
  }, r.warnings = function() {
    return this.sync().warnings();
  }, Te(e, [
    {
      key: "content",
      get: function() {
        return this.stringify().content;
      }
    },
    {
      key: "css",
      get: function() {
        return this.stringify().css;
      }
    },
    {
      key: "map",
      get: function() {
        return this.stringify().map;
      }
    },
    {
      key: "messages",
      get: function() {
        return this.sync().messages;
      }
    },
    {
      key: "opts",
      get: function() {
        return this.result.opts;
      }
    },
    {
      key: "processor",
      get: function() {
        return this.result.processor;
      }
    },
    {
      key: "root",
      get: function() {
        return this.sync().root;
      }
    },
    {
      key: Symbol.toStringTag,
      get: function() {
        return "LazyResult";
      }
    }
  ]), e;
}();
Mr.registerPostcss = function(e) {
  jo = e;
};
var rl = Mr;
Mr.default = Mr;
pm.registerLazyResult(Mr);
lm.registerLazyResult(Mr);
var vm = Pc, ym = $i, _m = Yc, wm = Ds, bm = $s, Wo = /* @__PURE__ */ function() {
  function e(n, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = n, this._css = t, this._opts = i, this._map = void 0;
    var o, s = ym;
    this.result = new bm(this._processor, o, this._opts), this.result.css = t;
    var a = this;
    Object.defineProperty(this.result, "root", {
      get: function() {
        return a.root;
      }
    });
    var u = new vm(s, o, this._opts, t);
    if (u.isMap()) {
      var l = u.generate(), c = l[0], h = l[1];
      c && (this.result.css = c), h && (this.result.map = h);
    } else
      u.clearAnnotation(), this.result.css = u.css;
  }
  var r = e.prototype;
  return r.async = function() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }, r.catch = function(t) {
    return this.async().catch(t);
  }, r.finally = function(t) {
    return this.async().then(t, t);
  }, r.sync = function() {
    if (this.error) throw this.error;
    return this.result;
  }, r.then = function(t, i) {
    return We.env.NODE_ENV !== "production" && ("from" in this._opts || _m("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.")), this.async().then(t, i);
  }, r.toString = function() {
    return this._css;
  }, r.warnings = function() {
    return [];
  }, Te(e, [
    {
      key: "content",
      get: function() {
        return this.result.css;
      }
    },
    {
      key: "css",
      get: function() {
        return this.result.css;
      }
    },
    {
      key: "map",
      get: function() {
        return this.result.map;
      }
    },
    {
      key: "messages",
      get: function() {
        return [];
      }
    },
    {
      key: "opts",
      get: function() {
        return this.result.opts;
      }
    },
    {
      key: "processor",
      get: function() {
        return this.result.processor;
      }
    },
    {
      key: "root",
      get: function() {
        if (this._root)
          return this._root;
        var t, i = wm;
        try {
          t = i(this._css, this._opts);
        } catch (o) {
          this.error = o;
        }
        if (this.error)
          throw this.error;
        return this._root = t, t;
      }
    },
    {
      key: Symbol.toStringTag,
      get: function() {
        return "NoWorkResult";
      }
    }
  ]), e;
}(), Sm = Wo;
Wo.default = Wo;
var Cm = Sm, xm = rl, Im = Fs, Em = yn, un = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = []), this.version = "8.4.38", this.plugins = this.normalize(n);
  }
  var r = e.prototype;
  return r.normalize = function(t) {
    for (var i = [], o = D(t), s; !(s = o()).done; ) {
      var a = s.value;
      if (a.postcss === !0 ? a = a() : a.postcss && (a = a.postcss), (typeof a > "u" ? "undefined" : H(a)) === "object" && Array.isArray(a.plugins))
        i = i.concat(a.plugins);
      else if ((typeof a > "u" ? "undefined" : H(a)) === "object" && a.postcssPlugin)
        i.push(a);
      else if (typeof a == "function")
        i.push(a);
      else if ((typeof a > "u" ? "undefined" : H(a)) === "object" && (a.parse || a.stringify)) {
        if (We.env.NODE_ENV !== "production")
          throw new Error("PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation.");
      } else
        throw new Error(a + " is not a PostCSS plugin");
    }
    return i;
  }, r.process = function(t, i) {
    return i === void 0 && (i = {}), !this.plugins.length && !i.parser && !i.stringifier && !i.syntax ? new Cm(this, t, i) : new xm(this, t, i);
  }, r.use = function(t) {
    return this.plugins = this.plugins.concat(this.normalize([
      t
    ])), this;
  }, e;
}(), Om = un;
un.default = un;
Em.registerProcessor(un);
Im.registerProcessor(un);
var km = Pi, Am = Tc, Rm = Li, Tm = Ns, Mm = Di, Fm = yn, $m = Ps;
function cn(e, r) {
  if (Array.isArray(e)) return e.map(function(h) {
    return cn(h);
  });
  var n = e.inputs, t = tn(e, [
    "inputs"
  ]);
  if (n) {
    r = [];
    for (var i = D(n), o; !(o = i()).done; ) {
      var s = o.value, a = Q({}, s, {
        __proto__: Mm.prototype
      });
      a.map && (a.map = Q({}, a.map, {
        __proto__: Am.prototype
      })), r.push(a);
    }
  }
  if (t.nodes && (t.nodes = e.nodes.map(function(h) {
    return cn(h, r);
  })), t.source) {
    var u = t.source, l = u.inputId, c = tn(u, [
      "inputId"
    ]);
    t.source = c, l != null && (t.source.input = r[l]);
  }
  if (t.type === "root")
    return new Fm(t);
  if (t.type === "decl")
    return new km(t);
  if (t.type === "rule")
    return new $m(t);
  if (t.type === "comment")
    return new Rm(t);
  if (t.type === "atrule")
    return new Tm(t);
  throw new Error("Unknown node type: " + e.type);
}
var Nm = cn;
cn.default = cn;
var Pm = Rs, nl = Pi, Dm = rl, Lm = hr, Ls = Om, Bm = $i, Um = Nm, il = Fs, zm = Hc, ol = Li, sl = Ns, qm = $s, jm = Di, Wm = Ds, Gm = Qc, al = Ps, ul = yn, Vm = Ni;
function ae() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new Ls(r);
}
ae.plugin = function(r, n) {
  var t = !1;
  function i() {
    for (var s = arguments.length, a = new Array(s), u = 0; u < s; u++)
      a[u] = arguments[u];
    console && console.warn && !t && (t = !0, console.warn(r + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`), We.env.LANG && We.env.LANG.startsWith("cn") && console.warn(r + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`));
    var l = n.apply(void 0, [].concat(a));
    return l.postcssPlugin = r, l.postcssVersion = new Ls().version, l;
  }
  var o;
  return Object.defineProperty(i, "postcss", {
    get: function() {
      return o || (o = i()), o;
    }
  }), i.process = function(s, a, u) {
    return ae([
      i(u)
    ]).process(s, a);
  }, i;
};
ae.stringify = Bm;
ae.parse = Wm;
ae.fromJSON = Um;
ae.list = Gm;
ae.comment = function(e) {
  return new ol(e);
};
ae.atRule = function(e) {
  return new sl(e);
};
ae.decl = function(e) {
  return new nl(e);
};
ae.rule = function(e) {
  return new al(e);
};
ae.root = function(e) {
  return new ul(e);
};
ae.document = function(e) {
  return new il(e);
};
ae.CssSyntaxError = Pm;
ae.Declaration = nl;
ae.Container = Lm;
ae.Processor = Ls;
ae.Document = il;
ae.Comment = ol;
ae.Warning = zm;
ae.AtRule = sl;
ae.Result = qm;
ae.Input = jm;
ae.Rule = al;
ae.Root = ul;
ae.Node = Vm;
Dm.registerPostcss(ae);
var Ym = ae;
ae.default = ae;
var ge = /* @__PURE__ */ id(Ym);
ge.stringify;
ge.fromJSON;
ge.plugin;
ge.parse;
ge.list;
ge.document;
ge.comment;
ge.atRule;
ge.rule;
ge.decl;
ge.root;
ge.CssSyntaxError;
ge.Declaration;
ge.Container;
ge.Processor;
ge.Document;
ge.Comment;
ge.Warning;
ge.AtRule;
ge.Result;
ge.Input;
ge.Rule;
ge.Root;
ge.Node;
var Hm = Object.defineProperty, Zm = function(e, r, n) {
  return r in e ? Hm(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[r] = n;
}, Je = function(e, r, n) {
  return Zm(e, (typeof r > "u" ? "undefined" : H(r)) !== "symbol" ? r + "" : r, n);
};
function Km(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Jm(e) {
  if (e.__esModule) return e;
  var r = e.default;
  if (typeof r == "function") {
    var n = function t() {
      return W(this, t) ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    n.prototype = r.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function(t) {
    var i = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(n, t, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), n;
}
var Bs = {
  exports: {}
}, pe = String, cl = function() {
  return {
    isColorSupported: !1,
    reset: pe,
    bold: pe,
    dim: pe,
    italic: pe,
    underline: pe,
    inverse: pe,
    hidden: pe,
    strikethrough: pe,
    black: pe,
    red: pe,
    green: pe,
    yellow: pe,
    blue: pe,
    magenta: pe,
    cyan: pe,
    white: pe,
    gray: pe,
    bgBlack: pe,
    bgRed: pe,
    bgGreen: pe,
    bgYellow: pe,
    bgBlue: pe,
    bgMagenta: pe,
    bgCyan: pe,
    bgWhite: pe
  };
};
Bs.exports = cl();
Bs.exports.createColors = cl;
var Xm = Bs.exports, Qm = {}, eg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qm
}, Symbol.toStringTag, {
  value: "Module"
})), Se = /* @__PURE__ */ Jm(eg), Ja = Xm, Xa = Se, Go = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t, i, o, s, a, u) {
    var l;
    return l = e.call(this, t) || this, l.name = "CssSyntaxError", l.reason = t, a && (l.file = a), s && (l.source = s), u && (l.plugin = u), typeof i < "u" && typeof o < "u" && (typeof i == "number" ? (l.line = i, l.column = o) : (l.line = i.line, l.column = i.column, l.endLine = o.line, l.endColumn = o.column)), l.setMessage(), Error.captureStackTrace && Error.captureStackTrace(l, r), l;
  }
  var n = r.prototype;
  return n.setMessage = function() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line < "u" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }, n.showSourceCode = function(i) {
    var o = this;
    if (!this.source) return "";
    var s = this.source;
    i == null && (i = Ja.isColorSupported), Xa && i && (s = Xa(s));
    var a = s.split(/\r?\n/), u = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, a.length), c = String(l).length, h, m;
    if (i) {
      var v = Ja.createColors(!0), y = v.bold, S = v.gray, _ = v.red;
      h = function(b) {
        return y(_(b));
      }, m = function(b) {
        return S(b);
      };
    } else
      h = m = function(b) {
        return b;
      };
    return a.slice(u, l).map(function(b, C) {
      var E = u + 1 + C, R = " " + (" " + E).slice(-c) + " | ";
      if (E === o.line) {
        var A = m(R.replace(/\d/g, " ")) + b.slice(0, o.column - 1).replace(/[^\t]/g, " ");
        return h(">") + m(R) + b + `
 ` + A + h("^");
      }
      return " " + m(R) + b;
    }).join(`
`);
  }, n.toString = function() {
    var i = this.showSourceCode();
    return i && (i = `

` + i + `
`), this.name + ": " + this.message + i;
  }, r;
}(fi(Error)), Us = Go;
Go.default = Go;
var Jt = {};
Jt.isClean = Symbol("isClean");
Jt.my = Symbol("my");
var Qa = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function tg(e) {
  return e[0].toUpperCase() + e.slice(1);
}
var Vo = /* @__PURE__ */ function() {
  function e(n) {
    this.builder = n;
  }
  var r = e.prototype;
  return r.atrule = function(t, i) {
    var o = "@" + t.name, s = t.params ? this.rawValue(t, "params") : "";
    if (typeof t.raws.afterName < "u" ? o += t.raws.afterName : s && (o += " "), t.nodes)
      this.block(t, o + s);
    else {
      var a = (t.raws.between || "") + (i ? ";" : "");
      this.builder(o + s + a, t);
    }
  }, r.beforeAfter = function(t, i) {
    var o;
    t.type === "decl" ? o = this.raw(t, null, "beforeDecl") : t.type === "comment" ? o = this.raw(t, null, "beforeComment") : i === "before" ? o = this.raw(t, null, "beforeRule") : o = this.raw(t, null, "beforeClose");
    for (var s = t.parent, a = 0; s && s.type !== "root"; )
      a += 1, s = s.parent;
    if (o.includes(`
`)) {
      var u = this.raw(t, null, "indent");
      if (u.length)
        for (var l = 0; l < a; l++) o += u;
    }
    return o;
  }, r.block = function(t, i) {
    var o = this.raw(t, "between", "beforeOpen");
    this.builder(i + o + "{", t, "start");
    var s;
    t.nodes && t.nodes.length ? (this.body(t), s = this.raw(t, "after")) : s = this.raw(t, "after", "emptyBody"), s && this.builder(s), this.builder("}", t, "end");
  }, r.body = function(t) {
    for (var i = t.nodes.length - 1; i > 0 && t.nodes[i].type === "comment"; )
      i -= 1;
    for (var o = this.raw(t, "semicolon"), s = 0; s < t.nodes.length; s++) {
      var a = t.nodes[s], u = this.raw(a, "before");
      u && this.builder(u), this.stringify(a, i !== s || o);
    }
  }, r.comment = function(t) {
    var i = this.raw(t, "left", "commentLeft"), o = this.raw(t, "right", "commentRight");
    this.builder("/*" + i + t.text + o + "*/", t);
  }, r.decl = function(t, i) {
    var o = this.raw(t, "between", "colon"), s = t.prop + o + this.rawValue(t, "value");
    t.important && (s += t.raws.important || " !important"), i && (s += ";"), this.builder(s, t);
  }, r.document = function(t) {
    this.body(t);
  }, r.raw = function(t, i, o) {
    var s;
    if (o || (o = i), i && (s = t.raws[i], typeof s < "u"))
      return s;
    var a = t.parent;
    if (o === "before" && (!a || a.type === "root" && a.first === t || a && a.type === "document"))
      return "";
    if (!a) return Qa[o];
    var u = t.root();
    if (u.rawCache || (u.rawCache = {}), typeof u.rawCache[o] < "u")
      return u.rawCache[o];
    if (o === "before" || o === "after")
      return this.beforeAfter(t, o);
    var l = "raw" + tg(o);
    return this[l] ? s = this[l](u, t) : u.walk(function(c) {
      if (s = c.raws[i], typeof s < "u") return !1;
    }), typeof s > "u" && (s = Qa[o]), u.rawCache[o] = s, s;
  }, r.rawBeforeClose = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && o.nodes.length > 0 && typeof o.raws.after < "u")
        return i = o.raws.after, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), i && (i = i.replace(/\S/g, "")), i;
  }, r.rawBeforeComment = function(t, i) {
    var o;
    return t.walkComments(function(s) {
      if (typeof s.raws.before < "u")
        return o = s.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
    }), typeof o > "u" ? o = this.raw(i, null, "beforeDecl") : o && (o = o.replace(/\S/g, "")), o;
  }, r.rawBeforeDecl = function(t, i) {
    var o;
    return t.walkDecls(function(s) {
      if (typeof s.raws.before < "u")
        return o = s.raws.before, o.includes(`
`) && (o = o.replace(/[^\n]+$/, "")), !1;
    }), typeof o > "u" ? o = this.raw(i, null, "beforeRule") : o && (o = o.replace(/\S/g, "")), o;
  }, r.rawBeforeOpen = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.type !== "decl" && (i = o.raws.between, typeof i < "u"))
        return !1;
    }), i;
  }, r.rawBeforeRule = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && (o.parent !== t || t.first !== o) && typeof o.raws.before < "u")
        return i = o.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), i && (i = i.replace(/\S/g, "")), i;
  }, r.rawColon = function(t) {
    var i;
    return t.walkDecls(function(o) {
      if (typeof o.raws.between < "u")
        return i = o.raws.between.replace(/[^\s:]/g, ""), !1;
    }), i;
  }, r.rawEmptyBody = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && o.nodes.length === 0 && (i = o.raws.after, typeof i < "u"))
        return !1;
    }), i;
  }, r.rawIndent = function(t) {
    if (t.raws.indent) return t.raws.indent;
    var i;
    return t.walk(function(o) {
      var s = o.parent;
      if (s && s !== t && s.parent && s.parent === t && typeof o.raws.before < "u") {
        var a = o.raws.before.split(`
`);
        return i = a[a.length - 1], i = i.replace(/\S/g, ""), !1;
      }
    }), i;
  }, r.rawSemicolon = function(t) {
    var i;
    return t.walk(function(o) {
      if (o.nodes && o.nodes.length && o.last.type === "decl" && (i = o.raws.semicolon, typeof i < "u"))
        return !1;
    }), i;
  }, r.rawValue = function(t, i) {
    var o = t[i], s = t.raws[i];
    return s && s.value === o ? s.raw : o;
  }, r.root = function(t) {
    this.body(t), t.raws.after && this.builder(t.raws.after);
  }, r.rule = function(t) {
    this.block(t, this.rawValue(t, "selector")), t.raws.ownSemicolon && this.builder(t.raws.ownSemicolon, t, "end");
  }, r.stringify = function(t, i) {
    if (!this[t.type])
      throw new Error("Unknown AST node type " + t.type + ". Maybe you need to change PostCSS stringifier.");
    this[t.type](t, i);
  }, e;
}(), ll = Vo;
Vo.default = Vo;
var rg = ll;
function Yo(e, r) {
  var n = new rg(r);
  n.stringify(e);
}
var Bi = Yo;
Yo.default = Yo;
var Dn = Jt.isClean, ng = Jt.my, ig = Us, og = ll, sg = Bi;
function Ho(e, r) {
  var n = new e.constructor();
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && t !== "proxyCache") {
      var i = e[t], o = typeof i > "u" ? "undefined" : H(i);
      t === "parent" && o === "object" ? r && (n[t] = r) : t === "source" ? n[t] = i : Array.isArray(i) ? n[t] = i.map(function(s) {
        return Ho(s, n);
      }) : (o === "object" && i !== null && (i = Ho(i)), n[t] = i);
    }
  return n;
}
var Zo = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = {}), this.raws = {}, this[Dn] = !1, this[ng] = !0;
    for (var t in n)
      if (t === "nodes") {
        this.nodes = [];
        for (var i = D(n[t]), o; !(o = i()).done; ) {
          var s = o.value;
          typeof s.clone == "function" ? this.append(s.clone()) : this.append(s);
        }
      } else
        this[t] = n[t];
  }
  var r = e.prototype;
  return r.addToError = function(t) {
    if (t.postcssNode = this, t.stack && this.source && /\n\s{4}at /.test(t.stack)) {
      var i = this.source;
      t.stack = t.stack.replace(/\n\s{4}at /, "$&" + i.input.from + ":" + i.start.line + ":" + i.start.column + "$&");
    }
    return t;
  }, r.after = function(t) {
    return this.parent.insertAfter(this, t), this;
  }, r.assign = function(t) {
    t === void 0 && (t = {});
    for (var i in t)
      this[i] = t[i];
    return this;
  }, r.before = function(t) {
    return this.parent.insertBefore(this, t), this;
  }, r.cleanRaws = function(t) {
    delete this.raws.before, delete this.raws.after, t || delete this.raws.between;
  }, r.clone = function(t) {
    t === void 0 && (t = {});
    var i = Ho(this);
    for (var o in t)
      i[o] = t[o];
    return i;
  }, r.cloneAfter = function(t) {
    t === void 0 && (t = {});
    var i = this.clone(t);
    return this.parent.insertAfter(this, i), i;
  }, r.cloneBefore = function(t) {
    t === void 0 && (t = {});
    var i = this.clone(t);
    return this.parent.insertBefore(this, i), i;
  }, r.error = function(t, i) {
    if (i === void 0 && (i = {}), this.source) {
      var o = this.rangeBy(i), s = o.end, a = o.start;
      return this.source.input.error(t, {
        column: a.column,
        line: a.line
      }, {
        column: s.column,
        line: s.line
      }, i);
    }
    return new ig(t);
  }, r.getProxyProcessor = function() {
    return {
      get: function(i, o) {
        return o === "proxyOf" ? i : o === "root" ? function() {
          return i.root().toProxy();
        } : i[o];
      },
      set: function(i, o, s) {
        return i[o] === s || (i[o] = s, (o === "prop" || o === "value" || o === "name" || o === "params" || o === "important" || /* c8 ignore next */
        o === "text") && i.markDirty()), !0;
      }
    };
  }, r.markDirty = function() {
    if (this[Dn]) {
      this[Dn] = !1;
      for (var t = this; t = t.parent; )
        t[Dn] = !1;
    }
  }, r.next = function() {
    if (this.parent) {
      var t = this.parent.index(this);
      return this.parent.nodes[t + 1];
    }
  }, r.positionBy = function(t, i) {
    var o = this.source.start;
    if (t.index)
      o = this.positionInside(t.index, i);
    else if (t.word) {
      i = this.toString();
      var s = i.indexOf(t.word);
      s !== -1 && (o = this.positionInside(s, i));
    }
    return o;
  }, r.positionInside = function(t, i) {
    for (var o = i || this.toString(), s = this.source.start.column, a = this.source.start.line, u = 0; u < t; u++)
      o[u] === `
` ? (s = 1, a += 1) : s += 1;
    return {
      column: s,
      line: a
    };
  }, r.prev = function() {
    if (this.parent) {
      var t = this.parent.index(this);
      return this.parent.nodes[t - 1];
    }
  }, r.rangeBy = function(t) {
    var i = {
      column: this.source.start.column,
      line: this.source.start.line
    }, o = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line
    } : {
      column: i.column + 1,
      line: i.line
    };
    if (t.word) {
      var s = this.toString(), a = s.indexOf(t.word);
      a !== -1 && (i = this.positionInside(a, s), o = this.positionInside(a + t.word.length, s));
    } else
      t.start ? i = {
        column: t.start.column,
        line: t.start.line
      } : t.index && (i = this.positionInside(t.index)), t.end ? o = {
        column: t.end.column,
        line: t.end.line
      } : typeof t.endIndex == "number" ? o = this.positionInside(t.endIndex) : t.index && (o = this.positionInside(t.index + 1));
    return (o.line < i.line || o.line === i.line && o.column <= i.column) && (o = {
      column: i.column + 1,
      line: i.line
    }), {
      end: o,
      start: i
    };
  }, r.raw = function(t, i) {
    var o = new og();
    return o.raw(this, t, i);
  }, r.remove = function() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }, r.replaceWith = function() {
    for (var t = arguments.length, i = new Array(t), o = 0; o < t; o++)
      i[o] = arguments[o];
    if (this.parent) {
      for (var s = this, a = !1, u = D(i), l; !(l = u()).done; ) {
        var c = l.value;
        c === this ? a = !0 : a ? (this.parent.insertAfter(s, c), s = c) : this.parent.insertBefore(s, c);
      }
      a || this.remove();
    }
    return this;
  }, r.root = function() {
    for (var t = this; t.parent && t.parent.type !== "document"; )
      t = t.parent;
    return t;
  }, r.toJSON = function(t, i) {
    var o = {}, s = i == null;
    i = i || /* @__PURE__ */ new Map();
    var a = 0;
    for (var u in this)
      if (Object.prototype.hasOwnProperty.call(this, u) && !(u === "parent" || u === "proxyCache")) {
        var l = this[u];
        if (Array.isArray(l))
          o[u] = l.map(function(h) {
            return (typeof h > "u" ? "undefined" : H(h)) === "object" && h.toJSON ? h.toJSON(null, i) : h;
          });
        else if ((typeof l > "u" ? "undefined" : H(l)) === "object" && l.toJSON)
          o[u] = l.toJSON(null, i);
        else if (u === "source") {
          var c = i.get(l.input);
          c == null && (c = a, i.set(l.input, a), a++), o[u] = {
            end: l.end,
            inputId: c,
            start: l.start
          };
        } else
          o[u] = l;
      }
    return s && (o.inputs = [].concat(i.keys()).map(function(h) {
      return h.toJSON();
    })), o;
  }, r.toProxy = function() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }, r.toString = function(t) {
    t === void 0 && (t = sg), t.stringify && (t = t.stringify);
    var i = "";
    return t(this, function(o) {
      i += o;
    }), i;
  }, r.warn = function(t, i, o) {
    var s = {
      node: this
    };
    for (var a in o) s[a] = o[a];
    return t.warn(i, s);
  }, Te(e, [
    {
      key: "proxyOf",
      get: function() {
        return this;
      }
    }
  ]), e;
}(), Ui = Zo;
Zo.default = Zo;
var ag = Ui, Ko = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(n) {
    var t;
    return n && typeof n.value < "u" && typeof n.value != "string" && (n = Q({}, n, {
      value: String(n.value)
    })), t = e.call(this, n) || this, t.type = "decl", t;
  }
  return Te(r, [
    {
      key: "variable",
      get: function() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
      }
    }
  ]), r;
}(ag), zi = Ko;
Ko.default = Ko;
var ug = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", cg = function(e) {
  e === void 0 && (e = 21);
  for (var r = "", n = e; n--; )
    r += ug[Math.random() * 64 | 0];
  return r;
}, lg = {
  nanoid: cg
}, eu = Se.SourceMapConsumer, tu = Se.SourceMapGenerator, fg = Se.existsSync, hg = Se.readFileSync, so = Se.dirname, pg = Se.join;
function dg(e) {
  return Vt ? Vt.from(e, "base64").toString() : window.atob(e);
}
var Jo = /* @__PURE__ */ function() {
  function e(n, t) {
    if (t.map !== !1) {
      this.loadAnnotation(n), this.inline = this.startWith(this.annotation, "data:");
      var i = t.map ? t.map.prev : void 0, o = this.loadMap(t.from, i);
      !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = so(this.mapFile)), o && (this.text = o);
    }
  }
  var r = e.prototype;
  return r.consumer = function() {
    return this.consumerCache || (this.consumerCache = new eu(this.text)), this.consumerCache;
  }, r.decodeInline = function(t) {
    var i = /^data:application\/json;charset=utf-?8;base64,/, o = /^data:application\/json;base64,/, s = /^data:application\/json;charset=utf-?8,/, a = /^data:application\/json,/;
    if (s.test(t) || a.test(t))
      return decodeURIComponent(t.substr(RegExp.lastMatch.length));
    if (i.test(t) || o.test(t))
      return dg(t.substr(RegExp.lastMatch.length));
    var u = t.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + u);
  }, r.getAnnotationURL = function(t) {
    return t.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }, r.isMap = function(t) {
    return (typeof t > "u" ? "undefined" : H(t)) !== "object" ? !1 : typeof t.mappings == "string" || typeof t._mappings == "string" || Array.isArray(t.sections);
  }, r.loadAnnotation = function(t) {
    var i = t.match(/\/\*\s*# sourceMappingURL=/gm);
    if (i) {
      var o = t.lastIndexOf(i.pop()), s = t.indexOf("*/", o);
      o > -1 && s > -1 && (this.annotation = this.getAnnotationURL(t.substring(o, s)));
    }
  }, r.loadFile = function(t) {
    if (this.root = so(t), fg(t))
      return this.mapFile = t, hg(t, "utf-8").toString().trim();
  }, r.loadMap = function(t, i) {
    if (i === !1) return !1;
    if (i) {
      if (typeof i == "string")
        return i;
      if (typeof i == "function") {
        var o = i(t);
        if (o) {
          var s = this.loadFile(o);
          if (!s)
            throw new Error("Unable to load previous source map: " + o.toString());
          return s;
        }
      } else {
        if (W(i, eu))
          return tu.fromSourceMap(i).toString();
        if (W(i, tu))
          return i.toString();
        if (this.isMap(i))
          return JSON.stringify(i);
        throw new Error("Unsupported previous source map format: " + i.toString());
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        var a = this.annotation;
        return t && (a = pg(so(t), a)), this.loadFile(a);
      }
    }
  }, r.startWith = function(t, i) {
    return t ? t.substr(0, i.length) === i : !1;
  }, r.withContent = function() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }, e;
}(), fl = Jo;
Jo.default = Jo;
var mg = Se.SourceMapConsumer, gg = Se.SourceMapGenerator, ru = Se.fileURLToPath, Ln = Se.pathToFileURL, Xo = Se.isAbsolute, Qo = Se.resolve, vg = lg.nanoid, ao = Se, nu = Us, yg = fl, uo = Symbol("fromOffsetCache"), _g = !!(mg && gg), iu = !!(Qo && Xo), yi = /* @__PURE__ */ function() {
  function e(n, t) {
    if (t === void 0 && (t = {}), n === null || typeof n > "u" || (typeof n > "u" ? "undefined" : H(n)) === "object" && !n.toString)
      throw new Error("PostCSS received " + n + " instead of CSS string");
    if (this.css = n.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, t.from && (!iu || /^\w+:\/\//.test(t.from) || Xo(t.from) ? this.file = t.from : this.file = Qo(t.from)), iu && _g) {
      var i = new yg(this.css, t);
      if (i.text) {
        this.map = i;
        var o = i.consumer().file;
        !this.file && o && (this.file = this.mapResolve(o));
      }
    }
    this.file || (this.id = "<input css " + vg(6) + ">"), this.map && (this.map.file = this.from);
  }
  var r = e.prototype;
  return r.error = function(t, i, o, s) {
    s === void 0 && (s = {});
    var a, u, l;
    if (i && (typeof i > "u" ? "undefined" : H(i)) === "object") {
      var c = i, h = o;
      if (typeof c.offset == "number") {
        var m = this.fromOffset(c.offset);
        i = m.line, o = m.col;
      } else
        i = c.line, o = c.column;
      if (typeof h.offset == "number") {
        var v = this.fromOffset(h.offset);
        u = v.line, l = v.col;
      } else
        u = h.line, l = h.column;
    } else if (!o) {
      var y = this.fromOffset(i);
      i = y.line, o = y.col;
    }
    var S = this.origin(i, o, u, l);
    return S ? a = new nu(t, S.endLine === void 0 ? S.line : {
      column: S.column,
      line: S.line
    }, S.endLine === void 0 ? S.column : {
      column: S.endColumn,
      line: S.endLine
    }, S.source, S.file, s.plugin) : a = new nu(t, u === void 0 ? i : {
      column: o,
      line: i
    }, u === void 0 ? o : {
      column: l,
      line: u
    }, this.css, this.file, s.plugin), a.input = {
      column: o,
      endColumn: l,
      endLine: u,
      line: i,
      source: this.css
    }, this.file && (Ln && (a.input.url = Ln(this.file).toString()), a.input.file = this.file), a;
  }, r.fromOffset = function(t) {
    var i, o;
    if (this[uo])
      o = this[uo];
    else {
      var s = this.css.split(`
`);
      o = new Array(s.length);
      for (var a = 0, u = 0, l = s.length; u < l; u++)
        o[u] = a, a += s[u].length + 1;
      this[uo] = o;
    }
    i = o[o.length - 1];
    var c = 0;
    if (t >= i)
      c = o.length - 1;
    else
      for (var h = o.length - 2, m; c < h; )
        if (m = c + (h - c >> 1), t < o[m])
          h = m - 1;
        else if (t >= o[m + 1])
          c = m + 1;
        else {
          c = m;
          break;
        }
    return {
      col: t - o[c] + 1,
      line: c + 1
    };
  }, r.mapResolve = function(t) {
    return /^\w+:\/\//.test(t) ? t : Qo(this.map.consumer().sourceRoot || this.map.root || ".", t);
  }, r.origin = function(t, i, o, s) {
    if (!this.map) return !1;
    var a = this.map.consumer(), u = a.originalPositionFor({
      column: i,
      line: t
    });
    if (!u.source) return !1;
    var l;
    typeof o == "number" && (l = a.originalPositionFor({
      column: s,
      line: o
    }));
    var c;
    Xo(u.source) ? c = Ln(u.source) : c = new URL(u.source, this.map.consumer().sourceRoot || Ln(this.map.mapFile));
    var h = {
      column: u.column,
      endColumn: l && l.column,
      endLine: l && l.line,
      line: u.line,
      url: c.toString()
    };
    if (c.protocol === "file:")
      if (ru)
        h.file = ru(c);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    var m = a.sourceContentFor(u.source);
    return m && (h.source = m), h;
  }, r.toJSON = function() {
    for (var t = {}, i = 0, o = [
      "hasBOM",
      "css",
      "file",
      "id"
    ]; i < o.length; i++) {
      var s = o[i];
      this[s] != null && (t[s] = this[s]);
    }
    return this.map && (t.map = Q({}, this.map), t.map.consumerCache && (t.map.consumerCache = void 0)), t;
  }, Te(e, [
    {
      key: "from",
      get: function() {
        return this.file || this.id;
      }
    }
  ]), e;
}(), qi = yi;
yi.default = yi;
ao && ao.registerInput && ao.registerInput(yi);
var hl = Se.SourceMapConsumer, ii = Se.SourceMapGenerator, oi = Se.dirname, pl = Se.relative, dl = Se.resolve, ml = Se.sep, ou = Se.pathToFileURL, wg = qi, bg = !!(hl && ii), Sg = !!(oi && dl && pl && ml), Cg = /* @__PURE__ */ function() {
  function e(n, t, i, o) {
    this.stringify = n, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = o, this.originalCSS = o, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  var r = e.prototype;
  return r.addAnnotation = function() {
    var t;
    this.isInline() ? t = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? t = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? t = this.mapOpts.annotation(this.opts.to, this.root) : t = this.outputFile() + ".map";
    var i = `
`;
    this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + t + " */";
  }, r.applyPrevMaps = function() {
    for (var t = D(this.previous()), i; !(i = t()).done; ) {
      var o = i.value, s = this.toUrl(this.path(o.file)), a = o.root || oi(o.file), u = void 0;
      this.mapOpts.sourcesContent === !1 ? (u = new hl(o.text), u.sourcesContent && (u.sourcesContent = null)) : u = o.consumer(), this.map.applySourceMap(u, s, this.toUrl(this.path(a)));
    }
  }, r.clearAnnotation = function() {
    if (this.mapOpts.annotation !== !1)
      if (this.root)
        for (var t, i = this.root.nodes.length - 1; i >= 0; i--)
          t = this.root.nodes[i], t.type === "comment" && t.text.indexOf("# sourceMappingURL=") === 0 && this.root.removeChild(i);
      else this.css && (this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, ""));
  }, r.generate = function() {
    if (this.clearAnnotation(), Sg && bg && this.isMap())
      return this.generateMap();
    var t = "";
    return this.stringify(this.root, function(i) {
      t += i;
    }), [
      t
    ];
  }, r.generateMap = function() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      var t = this.previous()[0].consumer();
      t.file = this.outputFile(), this.map = ii.fromSourceMap(t, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new ii({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: {
          column: 0,
          line: 1
        },
        original: {
          column: 0,
          line: 1
        },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [
      this.css
    ] : [
      this.css,
      this.map
    ];
  }, r.generateString = function() {
    var t = this;
    this.css = "", this.map = new ii({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    var i = 1, o = 1, s = "<no source>", a = {
      generated: {
        column: 0,
        line: 0
      },
      original: {
        column: 0,
        line: 0
      },
      source: ""
    }, u, l;
    this.stringify(this.root, function(c, h, m) {
      if (t.css += c, h && m !== "end" && (a.generated.line = i, a.generated.column = o - 1, h.source && h.source.start ? (a.source = t.sourcePath(h), a.original.line = h.source.start.line, a.original.column = h.source.start.column - 1, t.map.addMapping(a)) : (a.source = s, a.original.line = 1, a.original.column = 0, t.map.addMapping(a))), u = c.match(/\n/g), u ? (i += u.length, l = c.lastIndexOf(`
`), o = c.length - l) : o += c.length, h && m !== "start") {
        var v = h.parent || {
          raws: {}
        }, y = h.type === "decl" || h.type === "atrule" && !h.nodes;
        (!y || h !== v.last || v.raws.semicolon) && (h.source && h.source.end ? (a.source = t.sourcePath(h), a.original.line = h.source.end.line, a.original.column = h.source.end.column - 1, a.generated.line = i, a.generated.column = o - 2, t.map.addMapping(a)) : (a.source = s, a.original.line = 1, a.original.column = 0, a.generated.line = i, a.generated.column = o - 1, t.map.addMapping(a)));
      }
    });
  }, r.isAnnotation = function() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation < "u" ? this.mapOpts.annotation : this.previous().length ? this.previous().some(function(t) {
      return t.annotation;
    }) : !0;
  }, r.isInline = function() {
    if (typeof this.mapOpts.inline < "u")
      return this.mapOpts.inline;
    var t = this.mapOpts.annotation;
    return typeof t < "u" && t !== !0 ? !1 : this.previous().length ? this.previous().some(function(i) {
      return i.inline;
    }) : !0;
  }, r.isMap = function() {
    return typeof this.opts.map < "u" ? !!this.opts.map : this.previous().length > 0;
  }, r.isSourcesContent = function() {
    return typeof this.mapOpts.sourcesContent < "u" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some(function(t) {
      return t.withContent();
    }) : !0;
  }, r.outputFile = function() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }, r.path = function(t) {
    if (this.mapOpts.absolute || t.charCodeAt(0) === 60 || /^\w+:\/\//.test(t)) return t;
    var i = this.memoizedPaths.get(t);
    if (i) return i;
    var o = this.opts.to ? oi(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (o = oi(dl(o, this.mapOpts.annotation)));
    var s = pl(o, t);
    return this.memoizedPaths.set(t, s), s;
  }, r.previous = function() {
    var t = this;
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk(function(o) {
          if (o.source && o.source.input.map) {
            var s = o.source.input.map;
            t.previousMaps.includes(s) || t.previousMaps.push(s);
          }
        });
      else {
        var i = new wg(this.originalCSS, this.opts);
        i.map && this.previousMaps.push(i.map);
      }
    return this.previousMaps;
  }, r.setSourcesContent = function() {
    var t = this, i = {};
    if (this.root)
      this.root.walk(function(s) {
        if (s.source) {
          var a = s.source.input.from;
          if (a && !i[a]) {
            i[a] = !0;
            var u = t.usesFileUrls ? t.toFileUrl(a) : t.toUrl(t.path(a));
            t.map.setSourceContent(u, s.source.input.css);
          }
        }
      });
    else if (this.css) {
      var o = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(o, this.css);
    }
  }, r.sourcePath = function(t) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(t.source.input.from) : this.toUrl(this.path(t.source.input.from));
  }, r.toBase64 = function(t) {
    return Vt ? Vt.from(t).toString("base64") : window.btoa(unescape(encodeURIComponent(t)));
  }, r.toFileUrl = function(t) {
    var i = this.memoizedFileURLs.get(t);
    if (i) return i;
    if (ou) {
      var o = ou(t).toString();
      return this.memoizedFileURLs.set(t, o), o;
    } else
      throw new Error("`map.absolute` option is not available in this PostCSS build");
  }, r.toUrl = function(t) {
    var i = this.memoizedURLs.get(t);
    if (i) return i;
    ml === "\\" && (t = t.replace(/\\/g, "/"));
    var o = encodeURI(t).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(t, o), o;
  }, e;
}(), gl = Cg, xg = Ui, es = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(n) {
    var t;
    return t = e.call(this, n) || this, t.type = "comment", t;
  }
  return r;
}(xg), ji = es;
es.default = es;
var vl = Jt.isClean, yl = Jt.my, _l = zi, wl = ji, Ig = Ui, bl, zs, qs, Sl;
function Cl(e) {
  return e.map(function(r) {
    return r.nodes && (r.nodes = Cl(r.nodes)), delete r.source, r;
  });
}
function xl(e) {
  if (e[vl] = !1, e.proxyOf.nodes)
    for (var r = D(e.proxyOf.nodes), n; !(n = r()).done; ) {
      var t = n.value;
      xl(t);
    }
}
var $t = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var n = r.prototype;
  return n.append = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    for (var a = D(o), u; !(u = a()).done; )
      for (var l = u.value, c = this.normalize(l, this.last), h = D(c), m; !(m = h()).done; ) {
        var v = m.value;
        this.proxyOf.nodes.push(v);
      }
    return this.markDirty(), this;
  }, n.cleanRaws = function(i) {
    if (e.prototype.cleanRaws.call(this, i), this.nodes)
      for (var o = D(this.nodes), s; !(s = o()).done; ) {
        var a = s.value;
        a.cleanRaws(i);
      }
  }, n.each = function(i) {
    if (this.proxyOf.nodes) {
      for (var o = this.getIterator(), s, a; this.indexes[o] < this.proxyOf.nodes.length && (s = this.indexes[o], a = i(this.proxyOf.nodes[s], s), a !== !1); )
        this.indexes[o] += 1;
      return delete this.indexes[o], a;
    }
  }, n.every = function(i) {
    return this.nodes.every(i);
  }, n.getIterator = function() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    var i = this.lastEach;
    return this.indexes[i] = 0, i;
  }, n.getProxyProcessor = function() {
    return {
      get: function(o, s) {
        return s === "proxyOf" ? o : o[s] ? s === "each" || typeof s == "string" && s.startsWith("walk") ? function() {
          for (var a = arguments.length, u = new Array(a), l = 0; l < a; l++)
            u[l] = arguments[l];
          var c;
          return (c = o)[s].apply(c, [].concat(u.map(function(h) {
            return typeof h == "function" ? function(m, v) {
              return h(m.toProxy(), v);
            } : h;
          })));
        } : s === "every" || s === "some" ? function(a) {
          return o[s](function(u) {
            for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
              c[h - 1] = arguments[h];
            return a.apply(void 0, [].concat([
              u.toProxy()
            ], c));
          });
        } : s === "root" ? function() {
          return o.root().toProxy();
        } : s === "nodes" ? o.nodes.map(function(a) {
          return a.toProxy();
        }) : s === "first" || s === "last" ? o[s].toProxy() : o[s] : o[s];
      },
      set: function(o, s, a) {
        return o[s] === a || (o[s] = a, (s === "name" || s === "params" || s === "selector") && o.markDirty()), !0;
      }
    };
  }, n.index = function(i) {
    return typeof i == "number" ? i : (i.proxyOf && (i = i.proxyOf), this.proxyOf.nodes.indexOf(i));
  }, n.insertAfter = function(i, o) {
    var s = this.index(i), a = this.normalize(o, this.proxyOf.nodes[s]).reverse();
    s = this.index(i);
    for (var u = D(a), l; !(l = u()).done; ) {
      var c = l.value;
      this.proxyOf.nodes.splice(s + 1, 0, c);
    }
    var h;
    for (var m in this.indexes)
      h = this.indexes[m], s < h && (this.indexes[m] = h + a.length);
    return this.markDirty(), this;
  }, n.insertBefore = function(i, o) {
    var s = this.index(i), a = s === 0 ? "prepend" : !1, u = this.normalize(o, this.proxyOf.nodes[s], a).reverse();
    s = this.index(i);
    for (var l = D(u), c; !(c = l()).done; ) {
      var h = c.value;
      this.proxyOf.nodes.splice(s, 0, h);
    }
    var m;
    for (var v in this.indexes)
      m = this.indexes[v], s <= m && (this.indexes[v] = m + u.length);
    return this.markDirty(), this;
  }, n.normalize = function(i, o) {
    var s = this;
    if (typeof i == "string")
      i = Cl(bl(i).nodes);
    else if (typeof i > "u")
      i = [];
    else if (Array.isArray(i)) {
      i = i.slice(0);
      for (var a = D(i), u; !(u = a()).done; ) {
        var l = u.value;
        l.parent && l.parent.removeChild(l, "ignore");
      }
    } else if (i.type === "root" && this.type !== "document") {
      i = i.nodes.slice(0);
      for (var c = D(i), h; !(h = c()).done; ) {
        var m = h.value;
        m.parent && m.parent.removeChild(m, "ignore");
      }
    } else if (i.type)
      i = [
        i
      ];
    else if (i.prop) {
      if (typeof i.value > "u")
        throw new Error("Value field is missed in node creation");
      typeof i.value != "string" && (i.value = String(i.value)), i = [
        new _l(i)
      ];
    } else if (i.selector)
      i = [
        new zs(i)
      ];
    else if (i.name)
      i = [
        new qs(i)
      ];
    else if (i.text)
      i = [
        new wl(i)
      ];
    else
      throw new Error("Unknown node type in node creation");
    var v = i.map(function(y) {
      return y[yl] || r.rebuild(y), y = y.proxyOf, y.parent && y.parent.removeChild(y), y[vl] && xl(y), typeof y.raws.before > "u" && o && typeof o.raws.before < "u" && (y.raws.before = o.raws.before.replace(/\S/g, "")), y.parent = s.proxyOf, y;
    });
    return v;
  }, n.prepend = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    o = o.reverse();
    for (var a = D(o), u; !(u = a()).done; ) {
      for (var l = u.value, c = this.normalize(l, this.first, "prepend").reverse(), h = D(c), m; !(m = h()).done; ) {
        var v = m.value;
        this.proxyOf.nodes.unshift(v);
      }
      for (var y in this.indexes)
        this.indexes[y] = this.indexes[y] + c.length;
    }
    return this.markDirty(), this;
  }, n.push = function(i) {
    return i.parent = this, this.proxyOf.nodes.push(i), this;
  }, n.removeAll = function() {
    for (var i = D(this.proxyOf.nodes), o; !(o = i()).done; ) {
      var s = o.value;
      s.parent = void 0;
    }
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }, n.removeChild = function(i) {
    i = this.index(i), this.proxyOf.nodes[i].parent = void 0, this.proxyOf.nodes.splice(i, 1);
    var o;
    for (var s in this.indexes)
      o = this.indexes[s], o >= i && (this.indexes[s] = o - 1);
    return this.markDirty(), this;
  }, n.replaceValues = function(i, o, s) {
    return s || (s = o, o = {}), this.walkDecls(function(a) {
      o.props && !o.props.includes(a.prop) || o.fast && !a.value.includes(o.fast) || (a.value = a.value.replace(i, s));
    }), this.markDirty(), this;
  }, n.some = function(i) {
    return this.nodes.some(i);
  }, n.walk = function(i) {
    return this.each(function(o, s) {
      var a;
      try {
        a = i(o, s);
      } catch (u) {
        throw o.addToError(u);
      }
      return a !== !1 && o.walk && (a = o.walk(i)), a;
    });
  }, n.walkAtRules = function(i, o) {
    return o ? W(i, RegExp) ? this.walk(function(s, a) {
      if (s.type === "atrule" && i.test(s.name))
        return o(s, a);
    }) : this.walk(function(s, a) {
      if (s.type === "atrule" && s.name === i)
        return o(s, a);
    }) : (o = i, this.walk(function(s, a) {
      if (s.type === "atrule")
        return o(s, a);
    }));
  }, n.walkComments = function(i) {
    return this.walk(function(o, s) {
      if (o.type === "comment")
        return i(o, s);
    });
  }, n.walkDecls = function(i, o) {
    return o ? W(i, RegExp) ? this.walk(function(s, a) {
      if (s.type === "decl" && i.test(s.prop))
        return o(s, a);
    }) : this.walk(function(s, a) {
      if (s.type === "decl" && s.prop === i)
        return o(s, a);
    }) : (o = i, this.walk(function(s, a) {
      if (s.type === "decl")
        return o(s, a);
    }));
  }, n.walkRules = function(i, o) {
    return o ? W(i, RegExp) ? this.walk(function(s, a) {
      if (s.type === "rule" && i.test(s.selector))
        return o(s, a);
    }) : this.walk(function(s, a) {
      if (s.type === "rule" && s.selector === i)
        return o(s, a);
    }) : (o = i, this.walk(function(s, a) {
      if (s.type === "rule")
        return o(s, a);
    }));
  }, Te(r, [
    {
      key: "first",
      get: function() {
        if (this.proxyOf.nodes)
          return this.proxyOf.nodes[0];
      }
    },
    {
      key: "last",
      get: function() {
        if (this.proxyOf.nodes)
          return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
      }
    }
  ]), r;
}(Ig);
$t.registerParse = function(e) {
  bl = e;
};
$t.registerRule = function(e) {
  zs = e;
};
$t.registerAtRule = function(e) {
  qs = e;
};
$t.registerRoot = function(e) {
  Sl = e;
};
var pr = $t;
$t.default = $t;
$t.rebuild = function(e) {
  e.type === "atrule" ? Object.setPrototypeOf(e, qs.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, zs.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, _l.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, wl.prototype) : e.type === "root" && Object.setPrototypeOf(e, Sl.prototype), e[yl] = !0, e.nodes && e.nodes.forEach(function(r) {
    $t.rebuild(r);
  });
};
var Eg = pr, Il, El, ln = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t) {
    var i;
    return i = e.call(this, Q({
      type: "document"
    }, t)) || this, i.nodes || (i.nodes = []), i;
  }
  var n = r.prototype;
  return n.toResult = function(i) {
    i === void 0 && (i = {});
    var o = new Il(new El(), this, i);
    return o.stringify();
  }, r;
}(Eg);
ln.registerLazyResult = function(e) {
  Il = e;
};
ln.registerProcessor = function(e) {
  El = e;
};
var js = ln;
ln.default = ln;
var su = {}, Ol = function(r) {
  su[r] || (su[r] = !0, typeof console < "u" && console.warn && console.warn(r));
}, ts = /* @__PURE__ */ function() {
  function e(n, t) {
    if (t === void 0 && (t = {}), this.type = "warning", this.text = n, t.node && t.node.source) {
      var i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (var o in t) this[o] = t[o];
  }
  var r = e.prototype;
  return r.toString = function() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }, e;
}(), kl = ts;
ts.default = ts;
var Og = kl, rs = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.processor = n, this.messages = [], this.root = t, this.opts = i, this.css = void 0, this.map = void 0;
  }
  var r = e.prototype;
  return r.toString = function() {
    return this.css;
  }, r.warn = function(t, i) {
    i === void 0 && (i = {}), i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
    var o = new Og(t, i);
    return this.messages.push(o), o;
  }, r.warnings = function() {
    return this.messages.filter(function(t) {
      return t.type === "warning";
    });
  }, Te(e, [
    {
      key: "content",
      get: function() {
        return this.css;
      }
    }
  ]), e;
}(), Ws = rs;
rs.default = rs;
var co = 39, au = 34, Bn = 92, uu = 47, Un = 10, Vr = 32, zn = 12, qn = 9, jn = 13, kg = 91, Ag = 93, Rg = 40, Tg = 41, Mg = 123, Fg = 125, $g = 59, Ng = 42, Pg = 58, Dg = 64, Wn = /[\t\n\f\r "#'()/;[\\\]{}]/g, Gn = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Lg = /.[\r\n"'(/\\]/, cu = /[\da-f]/i, Bg = function(r, n) {
  n === void 0 && (n = {});
  var t = r.css.valueOf(), i = n.ignoreErrors, o, s, a, u, l, c, h, m, v, y, S = t.length, _ = 0, b = [], C = [];
  function E() {
    return _;
  }
  function R(N) {
    throw r.error("Unclosed " + N, _);
  }
  function A() {
    return C.length === 0 && _ >= S;
  }
  function M(N) {
    if (C.length) return C.pop();
    if (!(_ >= S)) {
      var B = N ? N.ignoreUnclosed : !1;
      switch (o = t.charCodeAt(_), o) {
        case Un:
        case Vr:
        case qn:
        case jn:
        case zn: {
          s = _;
          do
            s += 1, o = t.charCodeAt(s);
          while (o === Vr || o === Un || o === qn || o === jn || o === zn);
          y = [
            "space",
            t.slice(_, s)
          ], _ = s - 1;
          break;
        }
        case kg:
        case Ag:
        case Mg:
        case Fg:
        case Pg:
        case $g:
        case Tg: {
          var G = String.fromCharCode(o);
          y = [
            G,
            G,
            _
          ];
          break;
        }
        case Rg: {
          if (m = b.length ? b.pop()[1] : "", v = t.charCodeAt(_ + 1), m === "url" && v !== co && v !== au && v !== Vr && v !== Un && v !== qn && v !== zn && v !== jn) {
            s = _;
            do {
              if (c = !1, s = t.indexOf(")", s + 1), s === -1)
                if (i || B) {
                  s = _;
                  break;
                } else
                  R("bracket");
              for (h = s; t.charCodeAt(h - 1) === Bn; )
                h -= 1, c = !c;
            } while (c);
            y = [
              "brackets",
              t.slice(_, s + 1),
              _,
              s
            ], _ = s;
          } else
            s = t.indexOf(")", _ + 1), u = t.slice(_, s + 1), s === -1 || Lg.test(u) ? y = [
              "(",
              "(",
              _
            ] : (y = [
              "brackets",
              u,
              _,
              s
            ], _ = s);
          break;
        }
        case co:
        case au: {
          a = o === co ? "'" : '"', s = _;
          do {
            if (c = !1, s = t.indexOf(a, s + 1), s === -1)
              if (i || B) {
                s = _ + 1;
                break;
              } else
                R("string");
            for (h = s; t.charCodeAt(h - 1) === Bn; )
              h -= 1, c = !c;
          } while (c);
          y = [
            "string",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s;
          break;
        }
        case Dg: {
          Wn.lastIndex = _ + 1, Wn.test(t), Wn.lastIndex === 0 ? s = t.length - 1 : s = Wn.lastIndex - 2, y = [
            "at-word",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s;
          break;
        }
        case Bn: {
          for (s = _, l = !0; t.charCodeAt(s + 1) === Bn; )
            s += 1, l = !l;
          if (o = t.charCodeAt(s + 1), l && o !== uu && o !== Vr && o !== Un && o !== qn && o !== jn && o !== zn && (s += 1, cu.test(t.charAt(s)))) {
            for (; cu.test(t.charAt(s + 1)); )
              s += 1;
            t.charCodeAt(s + 1) === Vr && (s += 1);
          }
          y = [
            "word",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s;
          break;
        }
        default: {
          o === uu && t.charCodeAt(_ + 1) === Ng ? (s = t.indexOf("*/", _ + 2) + 1, s === 0 && (i || B ? s = t.length : R("comment")), y = [
            "comment",
            t.slice(_, s + 1),
            _,
            s
          ], _ = s) : (Gn.lastIndex = _ + 1, Gn.test(t), Gn.lastIndex === 0 ? s = t.length - 1 : s = Gn.lastIndex - 2, y = [
            "word",
            t.slice(_, s + 1),
            _,
            s
          ], b.push(y), _ = s);
          break;
        }
      }
      return _++, y;
    }
  }
  function L(N) {
    C.push(N);
  }
  return {
    back: L,
    endOfFile: A,
    nextToken: M,
    position: E
  };
}, Al = pr, _i = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t) {
    var i;
    return i = e.call(this, t) || this, i.type = "atrule", i;
  }
  var n = r.prototype;
  return n.append = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    var a;
    return this.proxyOf.nodes || (this.nodes = []), (a = e.prototype.append).call.apply(a, [].concat([
      this
    ], o));
  }, n.prepend = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    var a;
    return this.proxyOf.nodes || (this.nodes = []), (a = e.prototype.prepend).call.apply(a, [].concat([
      this
    ], o));
  }, r;
}(Al), Gs = _i;
_i.default = _i;
Al.registerAtRule(_i);
var Rl = pr, Tl, Ml, Fr = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(t) {
    var i;
    return i = e.call(this, t) || this, i.type = "root", i.nodes || (i.nodes = []), i;
  }
  var n = r.prototype;
  return n.normalize = function(i, o, s) {
    var a = e.prototype.normalize.call(this, i);
    if (o) {
      if (s === "prepend")
        this.nodes.length > 1 ? o.raws.before = this.nodes[1].raws.before : delete o.raws.before;
      else if (this.first !== o)
        for (var u = D(a), l; !(l = u()).done; ) {
          var c = l.value;
          c.raws.before = o.raws.before;
        }
    }
    return a;
  }, n.removeChild = function(i, o) {
    var s = this.index(i);
    return !o && s === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[s].raws.before), e.prototype.removeChild.call(this, i);
  }, n.toResult = function(i) {
    i === void 0 && (i = {});
    var o = new Tl(new Ml(), this, i);
    return o.stringify();
  }, r;
}(Rl);
Fr.registerLazyResult = function(e) {
  Tl = e;
};
Fr.registerProcessor = function(e) {
  Ml = e;
};
var _n = Fr;
Fr.default = Fr;
Rl.registerRoot(Fr);
var fn = {
  comma: function(r) {
    return fn.split(r, [
      ","
    ], !0);
  },
  space: function(r) {
    var n = [
      " ",
      `
`,
      "	"
    ];
    return fn.split(r, n);
  },
  split: function(r, n, t) {
    for (var i = [], o = "", s = !1, a = 0, u = !1, l = "", c = !1, h = D(r), m; !(m = h()).done; ) {
      var v = m.value;
      c ? c = !1 : v === "\\" ? c = !0 : u ? v === l && (u = !1) : v === '"' || v === "'" ? (u = !0, l = v) : v === "(" ? a += 1 : v === ")" ? a > 0 && (a -= 1) : a === 0 && n.includes(v) && (s = !0), s ? (o !== "" && i.push(o.trim()), o = "", s = !1) : o += v;
    }
    return (t || o !== "") && i.push(o.trim()), i;
  }
}, Fl = fn;
fn.default = fn;
var $l = pr, Ug = Fl, wi = /* @__PURE__ */ function(e) {
  Ne(r, e);
  function r(n) {
    var t;
    return t = e.call(this, n) || this, t.type = "rule", t.nodes || (t.nodes = []), t;
  }
  return Te(r, [
    {
      key: "selectors",
      get: function() {
        return Ug.comma(this.selector);
      },
      set: function(t) {
        var i = this.selector ? this.selector.match(/,\s*/) : null, o = i ? i[0] : "," + this.raw("between", "beforeOpen");
        this.selector = t.join(o);
      }
    }
  ]), r;
}($l), Vs = wi;
wi.default = wi;
$l.registerRule(wi);
var zg = zi, qg = Bg, jg = ji, Wg = Gs, Gg = _n, lu = Vs, fu = {
  empty: !0,
  space: !0
};
function Vg(e) {
  for (var r = e.length - 1; r >= 0; r--) {
    var n = e[r], t = n[3] || n[2];
    if (t) return t;
  }
}
var Yg = /* @__PURE__ */ function() {
  function e(n) {
    this.input = n, this.root = new Gg(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = {
      input: n,
      start: {
        column: 1,
        line: 1,
        offset: 0
      }
    };
  }
  var r = e.prototype;
  return r.atrule = function(t) {
    var i = new Wg();
    i.name = t[1].slice(1), i.name === "" && this.unnamedAtrule(i, t), this.init(i, t[2]);
    for (var o, s, a, u = !1, l = !1, c = [], h = []; !this.tokenizer.endOfFile(); ) {
      if (t = this.tokenizer.nextToken(), o = t[0], o === "(" || o === "[" ? h.push(o === "(" ? ")" : "]") : o === "{" && h.length > 0 ? h.push("}") : o === h[h.length - 1] && h.pop(), h.length === 0)
        if (o === ";") {
          i.source.end = this.getPosition(t[2]), i.source.end.offset++, this.semicolon = !0;
          break;
        } else if (o === "{") {
          l = !0;
          break;
        } else if (o === "}") {
          if (c.length > 0) {
            for (a = c.length - 1, s = c[a]; s && s[0] === "space"; )
              s = c[--a];
            s && (i.source.end = this.getPosition(s[3] || s[2]), i.source.end.offset++);
          }
          this.end(t);
          break;
        } else
          c.push(t);
      else
        c.push(t);
      if (this.tokenizer.endOfFile()) {
        u = !0;
        break;
      }
    }
    i.raws.between = this.spacesAndCommentsFromEnd(c), c.length ? (i.raws.afterName = this.spacesAndCommentsFromStart(c), this.raw(i, "params", c), u && (t = c[c.length - 1], i.source.end = this.getPosition(t[3] || t[2]), i.source.end.offset++, this.spaces = i.raws.between, i.raws.between = "")) : (i.raws.afterName = "", i.params = ""), l && (i.nodes = [], this.current = i);
  }, r.checkMissedSemicolon = function(t) {
    var i = this.colon(t);
    if (i !== !1) {
      for (var o = 0, s, a = i - 1; a >= 0 && (s = t[a], !(s[0] !== "space" && (o += 1, o === 2))); a--)
        ;
      throw this.input.error("Missed semicolon", s[0] === "word" ? s[3] + 1 : s[2]);
    }
  }, r.colon = function(t) {
    for (var i = 0, o, s, a, u = D(t.entries()), l; !(l = u()).done; ) {
      var c = l.value, h = c[0], m = c[1];
      if (o = m, s = o[0], s === "(" && (i += 1), s === ")" && (i -= 1), i === 0 && s === ":")
        if (!a)
          this.doubleColon(o);
        else {
          if (a[0] === "word" && a[1] === "progid")
            continue;
          return h;
        }
      a = o;
    }
    return !1;
  }, r.comment = function(t) {
    var i = new jg();
    this.init(i, t[2]), i.source.end = this.getPosition(t[3] || t[2]), i.source.end.offset++;
    var o = t[1].slice(2, -2);
    if (/^\s*$/.test(o))
      i.text = "", i.raws.left = o, i.raws.right = "";
    else {
      var s = o.match(/^(\s*)([^]*\S)(\s*)$/);
      i.text = s[2], i.raws.left = s[1], i.raws.right = s[3];
    }
  }, r.createTokenizer = function() {
    this.tokenizer = qg(this.input);
  }, r.decl = function(t, i) {
    var o = new zg();
    this.init(o, t[0][2]);
    var s = t[t.length - 1];
    for (s[0] === ";" && (this.semicolon = !0, t.pop()), o.source.end = this.getPosition(s[3] || s[2] || Vg(t)), o.source.end.offset++; t[0][0] !== "word"; )
      t.length === 1 && this.unknownWord(t), o.raws.before += t.shift()[1];
    for (o.source.start = this.getPosition(t[0][2]), o.prop = ""; t.length; ) {
      var a = t[0][0];
      if (a === ":" || a === "space" || a === "comment")
        break;
      o.prop += t.shift()[1];
    }
    o.raws.between = "";
    for (var u; t.length; )
      if (u = t.shift(), u[0] === ":") {
        o.raws.between += u[1];
        break;
      } else
        u[0] === "word" && /\w/.test(u[1]) && this.unknownWord([
          u
        ]), o.raws.between += u[1];
    (o.prop[0] === "_" || o.prop[0] === "*") && (o.raws.before += o.prop[0], o.prop = o.prop.slice(1));
    for (var l = [], c; t.length && (c = t[0][0], !(c !== "space" && c !== "comment")); )
      l.push(t.shift());
    this.precheckMissedSemicolon(t);
    for (var h = t.length - 1; h >= 0; h--) {
      if (u = t[h], u[1].toLowerCase() === "!important") {
        o.important = !0;
        var m = this.stringFrom(t, h);
        m = this.spacesFromEnd(t) + m, m !== " !important" && (o.raws.important = m);
        break;
      } else if (u[1].toLowerCase() === "important") {
        for (var v = t.slice(0), y = "", S = h; S > 0; S--) {
          var _ = v[S][0];
          if (y.trim().indexOf("!") === 0 && _ !== "space")
            break;
          y = v.pop()[1] + y;
        }
        y.trim().indexOf("!") === 0 && (o.important = !0, o.raws.important = y, t = v);
      }
      if (u[0] !== "space" && u[0] !== "comment")
        break;
    }
    var b = t.some(function(C) {
      return C[0] !== "space" && C[0] !== "comment";
    });
    b && (o.raws.between += l.map(function(C) {
      return C[1];
    }).join(""), l = []), this.raw(o, "value", l.concat(t), i), o.value.includes(":") && !i && this.checkMissedSemicolon(t);
  }, r.doubleColon = function(t) {
    throw this.input.error("Double colon", {
      offset: t[2]
    }, {
      offset: t[2] + t[1].length
    });
  }, r.emptyRule = function(t) {
    var i = new lu();
    this.init(i, t[2]), i.selector = "", i.raws.between = "", this.current = i;
  }, r.end = function(t) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(t[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(t);
  }, r.endFile = function() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }, r.freeSemicolon = function(t) {
    if (this.spaces += t[1], this.current.nodes) {
      var i = this.current.nodes[this.current.nodes.length - 1];
      i && i.type === "rule" && !i.raws.ownSemicolon && (i.raws.ownSemicolon = this.spaces, this.spaces = "");
    }
  }, r.getPosition = function(t) {
    var i = this.input.fromOffset(t);
    return {
      column: i.col,
      line: i.line,
      offset: t
    };
  }, r.init = function(t, i) {
    this.current.push(t), t.source = {
      input: this.input,
      start: this.getPosition(i)
    }, t.raws.before = this.spaces, this.spaces = "", t.type !== "comment" && (this.semicolon = !1);
  }, r.other = function(t) {
    for (var i = !1, o = null, s = !1, a = null, u = [], l = t[1].startsWith("--"), c = [], h = t; h; ) {
      if (o = h[0], c.push(h), o === "(" || o === "[")
        a || (a = h), u.push(o === "(" ? ")" : "]");
      else if (l && s && o === "{")
        a || (a = h), u.push("}");
      else if (u.length === 0)
        if (o === ";")
          if (s) {
            this.decl(c, l);
            return;
          } else
            break;
        else if (o === "{") {
          this.rule(c);
          return;
        } else if (o === "}") {
          this.tokenizer.back(c.pop()), i = !0;
          break;
        } else o === ":" && (s = !0);
      else o === u[u.length - 1] && (u.pop(), u.length === 0 && (a = null));
      h = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (i = !0), u.length > 0 && this.unclosedBracket(a), i && s) {
      if (!l)
        for (; c.length && (h = c[c.length - 1][0], !(h !== "space" && h !== "comment")); )
          this.tokenizer.back(c.pop());
      this.decl(c, l);
    } else
      this.unknownWord(c);
  }, r.parse = function() {
    for (var t; !this.tokenizer.endOfFile(); )
      switch (t = this.tokenizer.nextToken(), t[0]) {
        case "space":
          this.spaces += t[1];
          break;
        case ";":
          this.freeSemicolon(t);
          break;
        case "}":
          this.end(t);
          break;
        case "comment":
          this.comment(t);
          break;
        case "at-word":
          this.atrule(t);
          break;
        case "{":
          this.emptyRule(t);
          break;
        default:
          this.other(t);
          break;
      }
    this.endFile();
  }, r.precheckMissedSemicolon = function() {
  }, r.raw = function(t, i, o, s) {
    for (var a, u, l = o.length, c = "", h = !0, m, v, y = 0; y < l; y += 1)
      a = o[y], u = a[0], u === "space" && y === l - 1 && !s ? h = !1 : u === "comment" ? (v = o[y - 1] ? o[y - 1][0] : "empty", m = o[y + 1] ? o[y + 1][0] : "empty", !fu[v] && !fu[m] ? c.slice(-1) === "," ? h = !1 : c += a[1] : h = !1) : c += a[1];
    if (!h) {
      var S = o.reduce(function(_, b) {
        return _ + b[1];
      }, "");
      t.raws[i] = {
        raw: S,
        value: c
      };
    }
    t[i] = c;
  }, r.rule = function(t) {
    t.pop();
    var i = new lu();
    this.init(i, t[0][2]), i.raws.between = this.spacesAndCommentsFromEnd(t), this.raw(i, "selector", t), this.current = i;
  }, r.spacesAndCommentsFromEnd = function(t) {
    for (var i, o = ""; t.length && (i = t[t.length - 1][0], !(i !== "space" && i !== "comment")); )
      o = t.pop()[1] + o;
    return o;
  }, r.spacesAndCommentsFromStart = function(t) {
    for (var i, o = ""; t.length && (i = t[0][0], !(i !== "space" && i !== "comment")); )
      o += t.shift()[1];
    return o;
  }, r.spacesFromEnd = function(t) {
    for (var i, o = ""; t.length && (i = t[t.length - 1][0], i === "space"); )
      o = t.pop()[1] + o;
    return o;
  }, r.stringFrom = function(t, i) {
    for (var o = "", s = i; s < t.length; s++)
      o += t[s][1];
    return t.splice(i, t.length - i), o;
  }, r.unclosedBlock = function() {
    var t = this.current.source.start;
    throw this.input.error("Unclosed block", t.line, t.column);
  }, r.unclosedBracket = function(t) {
    throw this.input.error("Unclosed bracket", {
      offset: t[2]
    }, {
      offset: t[2] + 1
    });
  }, r.unexpectedClose = function(t) {
    throw this.input.error("Unexpected }", {
      offset: t[2]
    }, {
      offset: t[2] + 1
    });
  }, r.unknownWord = function(t) {
    throw this.input.error("Unknown word", {
      offset: t[0][2]
    }, {
      offset: t[0][2] + t[0][1].length
    });
  }, r.unnamedAtrule = function(t, i) {
    throw this.input.error("At-rule without name", {
      offset: i[2]
    }, {
      offset: i[2] + i[1].length
    });
  }, e;
}(), Hg = Yg, Zg = pr, Kg = Hg, Jg = qi;
function bi(e, r) {
  var n = new Jg(e, r), t = new Kg(n);
  try {
    t.parse();
  } catch (i) {
    throw We.env.NODE_ENV !== "production" && i.name === "CssSyntaxError" && r && r.from && (/\.scss$/i.test(r.from) ? i.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(r.from) ? i.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(r.from) && (i.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), i;
  }
  return t.root;
}
var Ys = bi;
bi.default = bi;
Zg.registerParse(bi);
var pt = Jt.isClean, Xg = Jt.my, Qg = gl, ev = Bi, tv = pr, rv = js, nv = Ol, hu = Ws, iv = Ys, ov = _n, sv = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, av = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, uv = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, $r = 0;
function Yr(e) {
  return (typeof e > "u" ? "undefined" : H(e)) === "object" && typeof e.then == "function";
}
function Nl(e) {
  var r = !1, n = sv[e.type];
  return e.type === "decl" ? r = e.prop.toLowerCase() : e.type === "atrule" && (r = e.name.toLowerCase()), r && e.append ? [
    n,
    n + "-" + r,
    $r,
    n + "Exit",
    n + "Exit-" + r
  ] : r ? [
    n,
    n + "-" + r,
    n + "Exit",
    n + "Exit-" + r
  ] : e.append ? [
    n,
    $r,
    n + "Exit"
  ] : [
    n,
    n + "Exit"
  ];
}
function pu(e) {
  var r;
  return e.type === "document" ? r = [
    "Document",
    $r,
    "DocumentExit"
  ] : e.type === "root" ? r = [
    "Root",
    $r,
    "RootExit"
  ] : r = Nl(e), {
    eventIndex: 0,
    events: r,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function ns(e) {
  return e[pt] = !1, e.nodes && e.nodes.forEach(function(r) {
    return ns(r);
  }), e;
}
var is = {}, Nr = /* @__PURE__ */ function() {
  function e(n, t, i) {
    var o = this;
    this.stringified = !1, this.processed = !1;
    var s;
    if ((typeof t > "u" ? "undefined" : H(t)) === "object" && t !== null && (t.type === "root" || t.type === "document"))
      s = ns(t);
    else if (W(t, e) || W(t, hu))
      s = ns(t.root), t.map && (typeof i.map > "u" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      var a = iv;
      i.syntax && (a = i.syntax.parse), i.parser && (a = i.parser), a.parse && (a = a.parse);
      try {
        s = a(t, i);
      } catch (u) {
        this.processed = !0, this.error = u;
      }
      s && !s[Xg] && tv.rebuild(s);
    }
    this.result = new hu(n, s, i), this.helpers = Q({}, is, {
      postcss: is,
      result: this.result
    }), this.plugins = this.processor.plugins.map(function(u) {
      return (typeof u > "u" ? "undefined" : H(u)) === "object" && u.prepare ? Q({}, u, u.prepare(o.result)) : u;
    });
  }
  var r = e.prototype;
  return r.async = function() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }, r.catch = function(t) {
    return this.async().catch(t);
  }, r.finally = function(t) {
    return this.async().then(t, t);
  }, r.getAsyncError = function() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }, r.handleError = function(t, i) {
    var o = this.result.lastPlugin;
    try {
      if (i && i.addToError(t), this.error = t, t.name === "CssSyntaxError" && !t.plugin)
        t.plugin = o.postcssPlugin, t.setMessage();
      else if (o.postcssVersion && We.env.NODE_ENV !== "production") {
        var s = o.postcssPlugin, a = o.postcssVersion, u = this.result.processor.version, l = a.split("."), c = u.split(".");
        (l[0] !== c[0] || parseInt(l[1]) > parseInt(c[1])) && console.error("Unknown error from PostCSS plugin. Your current PostCSS version is " + u + ", but " + s + " uses " + a + ". Perhaps this is the source of the error below.");
      }
    } catch (h) {
      console && console.error && console.error(h);
    }
    return t;
  }, r.prepareVisitors = function() {
    var t = this;
    this.listeners = {};
    for (var i = function(c, h, m) {
      t.listeners[h] || (t.listeners[h] = []), t.listeners[h].push([
        c,
        m
      ]);
    }, o = D(this.plugins), s; !(s = o()).done; ) {
      var a = s.value;
      if ((typeof a > "u" ? "undefined" : H(a)) === "object")
        for (var u in a) {
          if (!av[u] && /^[A-Z]/.test(u))
            throw new Error("Unknown event " + u + " in " + a.postcssPlugin + ". Try to update PostCSS (" + this.processor.version + " now).");
          if (!uv[u])
            if (H(a[u]) === "object")
              for (var l in a[u])
                l === "*" ? i(a, u, a[u][l]) : i(a, u + "-" + l.toLowerCase(), a[u][l]);
            else typeof a[u] == "function" && i(a, u, a[u]);
        }
    }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }, r.runAsync = function() {
    var t = this;
    return xs(function() {
      var i, o, s, a, u, l, c, h, m, v, y, S;
      return nn(this, function(_) {
        switch (_.label) {
          case 0:
            t.plugin = 0, i = 0, _.label = 1;
          case 1:
            if (!(i < t.plugins.length)) return [
              3,
              6
            ];
            if (o = t.plugins[i], s = t.runOnRoot(o), !Yr(s)) return [
              3,
              5
            ];
            _.label = 2;
          case 2:
            return _.trys.push([
              2,
              4,
              ,
              5
            ]), [
              4,
              s
            ];
          case 3:
            return _.sent(), [
              3,
              5
            ];
          case 4:
            throw a = _.sent(), t.handleError(a);
          case 5:
            return i++, [
              3,
              1
            ];
          case 6:
            if (t.prepareVisitors(), !t.hasListener) return [
              3,
              18
            ];
            u = t.result.root, _.label = 7;
          case 7:
            if (u[pt]) return [
              3,
              14
            ];
            u[pt] = !0, l = [
              pu(u)
            ], _.label = 8;
          case 8:
            if (!(l.length > 0)) return [
              3,
              13
            ];
            if (c = t.visitTick(l), !Yr(c)) return [
              3,
              12
            ];
            _.label = 9;
          case 9:
            return _.trys.push([
              9,
              11,
              ,
              12
            ]), [
              4,
              c
            ];
          case 10:
            return _.sent(), [
              3,
              12
            ];
          case 11:
            throw h = _.sent(), m = l[l.length - 1].node, t.handleError(h, m);
          case 12:
            return [
              3,
              8
            ];
          case 13:
            return [
              3,
              7
            ];
          case 14:
            if (!t.listeners.OnceExit) return [
              3,
              18
            ];
            v = function() {
              var b, C, E, R, A;
              return nn(this, function(M) {
                switch (M.label) {
                  case 0:
                    b = S.value, C = b[0], E = b[1], t.result.lastPlugin = C, M.label = 1;
                  case 1:
                    return M.trys.push([
                      1,
                      6,
                      ,
                      7
                    ]), u.type !== "document" ? [
                      3,
                      3
                    ] : (R = u.nodes.map(function(L) {
                      return E(L, t.helpers);
                    }), [
                      4,
                      Promise.all(R)
                    ]);
                  case 2:
                    return M.sent(), [
                      3,
                      5
                    ];
                  case 3:
                    return [
                      4,
                      E(u, t.helpers)
                    ];
                  case 4:
                    M.sent(), M.label = 5;
                  case 5:
                    return [
                      3,
                      7
                    ];
                  case 6:
                    throw A = M.sent(), t.handleError(A);
                  case 7:
                    return [
                      2
                    ];
                }
              });
            }, y = D(t.listeners.OnceExit), _.label = 15;
          case 15:
            return (S = y()).done ? [
              3,
              18
            ] : [
              5,
              _c(v())
            ];
          case 16:
            _.sent(), _.label = 17;
          case 17:
            return [
              3,
              15
            ];
          case 18:
            return t.processed = !0, [
              2,
              t.stringify()
            ];
        }
      });
    })();
  }, r.runOnRoot = function(t) {
    var i = this;
    this.result.lastPlugin = t;
    try {
      if ((typeof t > "u" ? "undefined" : H(t)) === "object" && t.Once) {
        if (this.result.root.type === "document") {
          var o = this.result.root.nodes.map(function(s) {
            return t.Once(s, i.helpers);
          });
          return Yr(o[0]) ? Promise.all(o) : o;
        }
        return t.Once(this.result.root, this.helpers);
      } else if (typeof t == "function")
        return t(this.result.root, this.result);
    } catch (s) {
      throw this.handleError(s);
    }
  }, r.stringify = function() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    var t = this.result.opts, i = ev;
    t.syntax && (i = t.syntax.stringify), t.stringifier && (i = t.stringifier), i.stringify && (i = i.stringify);
    var o = new Qg(i, this.result.root, this.result.opts), s = o.generate();
    return this.result.css = s[0], this.result.map = s[1], this.result;
  }, r.sync = function() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (var t = D(this.plugins), i; !(i = t()).done; ) {
      var o = i.value, s = this.runOnRoot(o);
      if (Yr(s))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      for (var a = this.result.root; !a[pt]; )
        a[pt] = !0, this.walkSync(a);
      if (this.listeners.OnceExit)
        if (a.type === "document")
          for (var u = D(a.nodes), l; !(l = u()).done; ) {
            var c = l.value;
            this.visitSync(this.listeners.OnceExit, c);
          }
        else
          this.visitSync(this.listeners.OnceExit, a);
    }
    return this.result;
  }, r.then = function(t, i) {
    return We.env.NODE_ENV !== "production" && ("from" in this.opts || nv("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.")), this.async().then(t, i);
  }, r.toString = function() {
    return this.css;
  }, r.visitSync = function(t, i) {
    for (var o = D(t), s; !(s = o()).done; ) {
      var a = s.value, u = a[0], l = a[1];
      this.result.lastPlugin = u;
      var c = void 0;
      try {
        c = l(i, this.helpers);
      } catch (h) {
        throw this.handleError(h, i.proxyOf);
      }
      if (i.type !== "root" && i.type !== "document" && !i.parent)
        return !0;
      if (Yr(c))
        throw this.getAsyncError();
    }
  }, r.visitTick = function(t) {
    var i = t[t.length - 1], o = i.node, s = i.visitors;
    if (o.type !== "root" && o.type !== "document" && !o.parent) {
      t.pop();
      return;
    }
    if (s.length > 0 && i.visitorIndex < s.length) {
      var a = s[i.visitorIndex], u = a[0], l = a[1];
      i.visitorIndex += 1, i.visitorIndex === s.length && (i.visitors = [], i.visitorIndex = 0), this.result.lastPlugin = u;
      try {
        return l(o.toProxy(), this.helpers);
      } catch (y) {
        throw this.handleError(y, o);
      }
    }
    if (i.iterator !== 0) {
      for (var c = i.iterator, h; h = o.nodes[o.indexes[c]]; )
        if (o.indexes[c] += 1, !h[pt]) {
          h[pt] = !0, t.push(pu(h));
          return;
        }
      i.iterator = 0, delete o.indexes[c];
    }
    for (var m = i.events; i.eventIndex < m.length; ) {
      var v = m[i.eventIndex];
      if (i.eventIndex += 1, v === $r) {
        o.nodes && o.nodes.length && (o[pt] = !0, i.iterator = o.getIterator());
        return;
      } else if (this.listeners[v]) {
        i.visitors = this.listeners[v];
        return;
      }
    }
    t.pop();
  }, r.walkSync = function(t) {
    var i = this;
    t[pt] = !0;
    for (var o = Nl(t), s = D(o), a; !(a = s()).done; ) {
      var u = a.value;
      if (u === $r)
        t.nodes && t.each(function(c) {
          c[pt] || i.walkSync(c);
        });
      else {
        var l = this.listeners[u];
        if (l && this.visitSync(l, t.toProxy()))
          return;
      }
    }
  }, r.warnings = function() {
    return this.sync().warnings();
  }, Te(e, [
    {
      key: "content",
      get: function() {
        return this.stringify().content;
      }
    },
    {
      key: "css",
      get: function() {
        return this.stringify().css;
      }
    },
    {
      key: "map",
      get: function() {
        return this.stringify().map;
      }
    },
    {
      key: "messages",
      get: function() {
        return this.sync().messages;
      }
    },
    {
      key: "opts",
      get: function() {
        return this.result.opts;
      }
    },
    {
      key: "processor",
      get: function() {
        return this.result.processor;
      }
    },
    {
      key: "root",
      get: function() {
        return this.sync().root;
      }
    },
    {
      key: Symbol.toStringTag,
      get: function() {
        return "LazyResult";
      }
    }
  ]), e;
}();
Nr.registerPostcss = function(e) {
  is = e;
};
var Pl = Nr;
Nr.default = Nr;
ov.registerLazyResult(Nr);
rv.registerLazyResult(Nr);
var cv = gl, lv = Bi, fv = Ol, hv = Ys, pv = Ws, os = /* @__PURE__ */ function() {
  function e(n, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = n, this._css = t, this._opts = i, this._map = void 0;
    var o, s = lv;
    this.result = new pv(this._processor, o, this._opts), this.result.css = t;
    var a = this;
    Object.defineProperty(this.result, "root", {
      get: function() {
        return a.root;
      }
    });
    var u = new cv(s, o, this._opts, t);
    if (u.isMap()) {
      var l = u.generate(), c = l[0], h = l[1];
      c && (this.result.css = c), h && (this.result.map = h);
    } else
      u.clearAnnotation(), this.result.css = u.css;
  }
  var r = e.prototype;
  return r.async = function() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }, r.catch = function(t) {
    return this.async().catch(t);
  }, r.finally = function(t) {
    return this.async().then(t, t);
  }, r.sync = function() {
    if (this.error) throw this.error;
    return this.result;
  }, r.then = function(t, i) {
    return We.env.NODE_ENV !== "production" && ("from" in this._opts || fv("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning.")), this.async().then(t, i);
  }, r.toString = function() {
    return this._css;
  }, r.warnings = function() {
    return [];
  }, Te(e, [
    {
      key: "content",
      get: function() {
        return this.result.css;
      }
    },
    {
      key: "css",
      get: function() {
        return this.result.css;
      }
    },
    {
      key: "map",
      get: function() {
        return this.result.map;
      }
    },
    {
      key: "messages",
      get: function() {
        return [];
      }
    },
    {
      key: "opts",
      get: function() {
        return this.result.opts;
      }
    },
    {
      key: "processor",
      get: function() {
        return this.result.processor;
      }
    },
    {
      key: "root",
      get: function() {
        if (this._root)
          return this._root;
        var t, i = hv;
        try {
          t = i(this._css, this._opts);
        } catch (o) {
          this.error = o;
        }
        if (this.error)
          throw this.error;
        return this._root = t, t;
      }
    },
    {
      key: Symbol.toStringTag,
      get: function() {
        return "NoWorkResult";
      }
    }
  ]), e;
}(), dv = os;
os.default = os;
var mv = dv, gv = Pl, vv = js, yv = _n, hn = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = []), this.version = "8.4.38", this.plugins = this.normalize(n);
  }
  var r = e.prototype;
  return r.normalize = function(t) {
    for (var i = [], o = D(t), s; !(s = o()).done; ) {
      var a = s.value;
      if (a.postcss === !0 ? a = a() : a.postcss && (a = a.postcss), (typeof a > "u" ? "undefined" : H(a)) === "object" && Array.isArray(a.plugins))
        i = i.concat(a.plugins);
      else if ((typeof a > "u" ? "undefined" : H(a)) === "object" && a.postcssPlugin)
        i.push(a);
      else if (typeof a == "function")
        i.push(a);
      else if ((typeof a > "u" ? "undefined" : H(a)) === "object" && (a.parse || a.stringify)) {
        if (We.env.NODE_ENV !== "production")
          throw new Error("PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation.");
      } else
        throw new Error(a + " is not a PostCSS plugin");
    }
    return i;
  }, r.process = function(t, i) {
    return i === void 0 && (i = {}), !this.plugins.length && !i.parser && !i.stringifier && !i.syntax ? new mv(this, t, i) : new gv(this, t, i);
  }, r.use = function(t) {
    return this.plugins = this.plugins.concat(this.normalize([
      t
    ])), this;
  }, e;
}(), _v = hn;
hn.default = hn;
yv.registerProcessor(hn);
vv.registerProcessor(hn);
var wv = zi, bv = fl, Sv = ji, Cv = Gs, xv = qi, Iv = _n, Ev = Vs;
function pn(e, r) {
  if (Array.isArray(e)) return e.map(function(h) {
    return pn(h);
  });
  var n = e.inputs, t = tn(e, [
    "inputs"
  ]);
  if (n) {
    r = [];
    for (var i = D(n), o; !(o = i()).done; ) {
      var s = o.value, a = Q({}, s, {
        __proto__: xv.prototype
      });
      a.map && (a.map = Q({}, a.map, {
        __proto__: bv.prototype
      })), r.push(a);
    }
  }
  if (t.nodes && (t.nodes = e.nodes.map(function(h) {
    return pn(h, r);
  })), t.source) {
    var u = t.source, l = u.inputId, c = tn(u, [
      "inputId"
    ]);
    t.source = c, l != null && (t.source.input = r[l]);
  }
  if (t.type === "root")
    return new Iv(t);
  if (t.type === "decl")
    return new wv(t);
  if (t.type === "rule")
    return new Ev(t);
  if (t.type === "comment")
    return new Sv(t);
  if (t.type === "atrule")
    return new Cv(t);
  throw new Error("Unknown node type: " + e.type);
}
var Ov = pn;
pn.default = pn;
var kv = Us, Dl = zi, Av = Pl, Rv = pr, Hs = _v, Tv = Bi, Mv = Ov, Ll = js, Fv = kl, Bl = ji, Ul = Gs, $v = Ws, Nv = qi, Pv = Ys, Dv = Fl, zl = Vs, ql = _n, Lv = Ui;
function ue() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return r.length === 1 && Array.isArray(r[0]) && (r = r[0]), new Hs(r);
}
ue.plugin = function(r, n) {
  var t = !1;
  function i() {
    for (var s = arguments.length, a = new Array(s), u = 0; u < s; u++)
      a[u] = arguments[u];
    console && console.warn && !t && (t = !0, console.warn(r + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`), We.env.LANG && We.env.LANG.startsWith("cn") && console.warn(r + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`));
    var l = n.apply(void 0, [].concat(a));
    return l.postcssPlugin = r, l.postcssVersion = new Hs().version, l;
  }
  var o;
  return Object.defineProperty(i, "postcss", {
    get: function() {
      return o || (o = i()), o;
    }
  }), i.process = function(s, a, u) {
    return ue([
      i(u)
    ]).process(s, a);
  }, i;
};
ue.stringify = Tv;
ue.parse = Pv;
ue.fromJSON = Mv;
ue.list = Dv;
ue.comment = function(e) {
  return new Bl(e);
};
ue.atRule = function(e) {
  return new Ul(e);
};
ue.decl = function(e) {
  return new Dl(e);
};
ue.rule = function(e) {
  return new zl(e);
};
ue.root = function(e) {
  return new ql(e);
};
ue.document = function(e) {
  return new Ll(e);
};
ue.CssSyntaxError = kv;
ue.Declaration = Dl;
ue.Container = Rv;
ue.Processor = Hs;
ue.Document = Ll;
ue.Comment = Bl;
ue.Warning = Fv;
ue.AtRule = Ul;
ue.Result = $v;
ue.Input = Nv;
ue.Rule = zl;
ue.Root = ql;
ue.Node = Lv;
Av.registerPostcss(ue);
var Bv = ue;
ue.default = ue;
var ve = /* @__PURE__ */ Km(Bv);
ve.stringify;
ve.fromJSON;
ve.plugin;
ve.parse;
ve.list;
ve.document;
ve.comment;
ve.atRule;
ve.rule;
ve.decl;
ve.root;
ve.CssSyntaxError;
ve.Declaration;
ve.Container;
ve.Processor;
ve.Document;
ve.Comment;
ve.Warning;
ve.AtRule;
ve.Result;
ve.Input;
ve.Rule;
ve.Root;
ve.Node;
var Uv = /* @__PURE__ */ function() {
  function e() {
    for (var n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    Je(this, "parentElement", null), Je(this, "parentNode", null), Je(this, "ownerDocument"), Je(this, "firstChild", null), Je(this, "lastChild", null), Je(this, "previousSibling", null), Je(this, "nextSibling", null), Je(this, "ELEMENT_NODE", 1), Je(this, "TEXT_NODE", 3), Je(this, "nodeType"), Je(this, "nodeName"), Je(this, "RRNodeType");
  }
  var r = e.prototype;
  return r.contains = function(t) {
    if (W(t, e)) {
      if (t.ownerDocument !== this.ownerDocument) return !1;
      if (t === this) return !0;
    } else return !1;
    for (; t.parentNode; ) {
      if (t.parentNode === this) return !0;
      t = t.parentNode;
    }
    return !1;
  }, r.appendChild = function(t) {
    throw new Error("RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method.");
  }, r.insertBefore = function(t, i) {
    throw new Error("RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method.");
  }, r.removeChild = function(t) {
    throw new Error("RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method.");
  }, r.toString = function() {
    return "RRNode";
  }, Te(e, [
    {
      key: "childNodes",
      get: function() {
        for (var t = [], i = this.firstChild; i; )
          t.push(i), i = i.nextSibling;
        return t;
      }
    }
  ]), e;
}(), du = {
  Node: [
    "childNodes",
    "parentNode",
    "parentElement",
    "textContent"
  ],
  ShadowRoot: [
    "host",
    "styleSheets"
  ],
  Element: [
    "shadowRoot",
    "querySelector",
    "querySelectorAll"
  ],
  MutationObserver: []
}, mu = {
  Node: [
    "contains",
    "getRootNode"
  ],
  ShadowRoot: [
    "getSelection"
  ],
  Element: [],
  MutationObserver: [
    "constructor"
  ]
}, Vn = {}, zv = function() {
  return !!globalThis.Zone;
};
function Zs(e) {
  if (Vn[e]) return Vn[e];
  var r = globalThis[e], n = r.prototype, t = e in du ? du[e] : void 0, i = !!(t && // @ts-expect-error 2345
  t.every(function(c) {
    var h, m;
    return !!((m = (h = Object.getOwnPropertyDescriptor(n, c)) == null ? void 0 : h.get) != null && m.toString().includes("[native code]"));
  })), o = e in mu ? mu[e] : void 0, s = !!(o && o.every(
    // @ts-expect-error 2345
    function(c) {
      var h;
      return typeof n[c] == "function" && ((h = n[c]) == null ? void 0 : h.toString().includes("[native code]"));
    }
  ));
  if (i && s && !zv())
    return Vn[e] = r.prototype, r.prototype;
  try {
    var a = document.createElement("iframe");
    document.body.appendChild(a);
    var u = a.contentWindow;
    if (!u) return r.prototype;
    var l = u[e].prototype;
    return document.body.removeChild(a), l ? Vn[e] = l : n;
  } catch {
    return n;
  }
}
var lo = {};
function Xt(e, r, n) {
  var t, i = e + "." + String(n);
  if (lo[i]) return lo[i].call(r);
  var o = Zs(e), s = (t = Object.getOwnPropertyDescriptor(o, n)) == null ? void 0 : t.get;
  return s ? (lo[i] = s, s.call(r)) : r[n];
}
var fo = {};
function jl(e, r, n) {
  var t = e + "." + String(n);
  if (fo[t]) return fo[t].bind(r);
  var i = Zs(e), o = i[n];
  return typeof o != "function" ? r[n] : (fo[t] = o, o.bind(r));
}
function qv(e) {
  return Xt("Node", e, "childNodes");
}
function jv(e) {
  return Xt("Node", e, "parentNode");
}
function Wv(e) {
  return Xt("Node", e, "parentElement");
}
function Gv(e) {
  return Xt("Node", e, "textContent");
}
function Vv(e, r) {
  return jl("Node", e, "contains")(r);
}
function Yv(e) {
  return jl("Node", e, "getRootNode")();
}
function Hv(e) {
  return !e || !("host" in e) ? null : Xt("ShadowRoot", e, "host");
}
function Zv(e) {
  return e.styleSheets;
}
function Kv(e) {
  return !e || !("shadowRoot" in e) ? null : Xt("Element", e, "shadowRoot");
}
function Jv(e, r) {
  return Xt("Element", e, "querySelector")(r);
}
function Xv(e, r) {
  return Xt("Element", e, "querySelectorAll")(r);
}
function Wl() {
  return Zs("MutationObserver").constructor;
}
var Y = {
  childNodes: qv,
  parentNode: jv,
  parentElement: Wv,
  textContent: Gv,
  contains: Vv,
  getRootNode: Yv,
  host: Hv,
  styleSheets: Zv,
  shadowRoot: Kv,
  querySelector: Jv,
  querySelectorAll: Xv,
  mutationObserver: Wl
};
function Le(e, r, n) {
  n === void 0 && (n = document);
  var t = {
    capture: !0,
    passive: !0
  };
  return n.addEventListener(e, r, t), function() {
    return n.removeEventListener(e, r, t);
  };
}
var wr = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`, gu = {
  map: {},
  getId: function() {
    return console.error(wr), -1;
  },
  getNode: function() {
    return console.error(wr), null;
  },
  removeNodeFromMap: function() {
    console.error(wr);
  },
  has: function() {
    return console.error(wr), !1;
  },
  reset: function() {
    console.error(wr);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (gu = new Proxy(gu, {
  get: function(r, n, t) {
    return n === "map" && console.error(wr), Reflect.get(r, n, t);
  }
}));
function dn(e, r, n) {
  n === void 0 && (n = {});
  var t = null, i = 0;
  return function() {
    for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++)
      s[a] = arguments[a];
    var u = Date.now();
    !i && n.leading === !1 && (i = u);
    var l = r - (u - i), c = this;
    l <= 0 || l > r ? (t && (clearTimeout(t), t = null), i = u, e.apply(c, s)) : !t && n.trailing !== !1 && (t = setTimeout(function() {
      i = n.leading === !1 ? 0 : Date.now(), t = null, e.apply(c, s);
    }, l));
  };
}
function Wi(e, r, n, t, i) {
  i === void 0 && (i = window);
  var o = i.Object.getOwnPropertyDescriptor(e, r);
  return i.Object.defineProperty(e, r, t ? n : {
    set: function(a) {
      var u = this;
      setTimeout(function() {
        n.set.call(u, a);
      }, 0), o && o.set && o.set.call(this, a);
    }
  }), function() {
    return Wi(e, r, o || {}, !0);
  };
}
function Ur(e, r, n) {
  try {
    if (!(r in e))
      return function() {
      };
    var t = e[r], i = n(t);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: t
      }
    })), e[r] = i, function() {
      e[r] = t;
    };
  } catch {
    return function() {
    };
  }
}
var Si = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (Si = function() {
  return /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTime();
});
function Gl(e) {
  var r, n, t, i, o = e.document;
  return {
    left: o.scrollingElement ? o.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : o.documentElement.scrollLeft || (o == null ? void 0 : o.body) && ((r = Y.parentElement(o.body)) == null ? void 0 : r.scrollLeft) || ((n = o == null ? void 0 : o.body) == null ? void 0 : n.scrollLeft) || 0,
    top: o.scrollingElement ? o.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : (o == null ? void 0 : o.documentElement.scrollTop) || (o == null ? void 0 : o.body) && ((t = Y.parentElement(o.body)) == null ? void 0 : t.scrollTop) || ((i = o == null ? void 0 : o.body) == null ? void 0 : i.scrollTop) || 0
  };
}
function Vl() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Yl() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function Hl(e) {
  if (!e)
    return null;
  var r = e.nodeType === e.ELEMENT_NODE ? e : Y.parentElement(e);
  return r;
}
function Be(e, r, n, t) {
  if (!e)
    return !1;
  var i = Hl(e);
  if (!i)
    return !1;
  try {
    if (typeof r == "string") {
      if (i.classList.contains(r) || t && i.closest("." + r) !== null) return !0;
    } else if (pi(i, r, t)) return !0;
  } catch {
  }
  return !!(n && (i.matches(n) || t && i.closest(n) !== null));
}
function Qv(e, r) {
  return r.getId(e) !== -1;
}
function ho(e, r, n) {
  return e.tagName === "TITLE" && n.headTitleMutations ? !0 : r.getId(e) === on;
}
function Zl(e, r) {
  if (Hr(e))
    return !1;
  var n = r.getId(e);
  if (!r.has(n))
    return !0;
  var t = Y.parentNode(e);
  return t && t.nodeType === e.DOCUMENT_NODE ? !1 : t ? Zl(t, r) : !0;
}
function ss(e) {
  return !!e.changedTouches;
}
function ey(e) {
  e === void 0 && (e = window), "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach);
}
function Kl(e, r) {
  return !!(e.nodeName === "IFRAME" && r.getMeta(e));
}
function Jl(e, r) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && r.getMeta(e));
}
function as(e) {
  return e ? W(e, Uv) && "shadowRoot" in e ? !!e.shadowRoot : !!Y.shadowRoot(e) : !1;
}
var ty = /* @__PURE__ */ function() {
  function e() {
    F(this, "id", 1), F(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), F(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  var r = e.prototype;
  return r.getId = function(t) {
    var i;
    return (i = this.styleIDMap.get(t)) != null ? i : -1;
  }, r.has = function(t) {
    return this.styleIDMap.has(t);
  }, r.add = function(t, i) {
    if (this.has(t)) return this.getId(t);
    var o;
    return i === void 0 ? o = this.id++ : o = i, this.styleIDMap.set(t, o), this.idStyleMap.set(o, t), o;
  }, r.getStyle = function(t) {
    return this.idStyleMap.get(t) || null;
  }, r.reset = function() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }, r.generateId = function() {
    return this.id++;
  }, e;
}();
function Xl(e) {
  var r, n = null;
  return "getRootNode" in e && ((r = Y.getRootNode(e)) == null ? void 0 : r.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && Y.host(Y.getRootNode(e)) && (n = Y.host(Y.getRootNode(e))), n;
}
function ry(e) {
  for (var r = e, n; n = Xl(r); ) r = n;
  return r;
}
function ny(e) {
  var r = e.ownerDocument;
  if (!r) return !1;
  var n = ry(e);
  return Y.contains(r, n);
}
function Ql(e) {
  var r = e.ownerDocument;
  return r ? Y.contains(r, e) || ny(e) : !1;
}
var K = /* @__PURE__ */ function(e) {
  return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
}(K || {}), q = /* @__PURE__ */ function(e) {
  return e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e;
}(q || {}), ze = /* @__PURE__ */ function(e) {
  return e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e;
}(ze || {}), kt = /* @__PURE__ */ function(e) {
  return e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e;
}(kt || {}), Pr = /* @__PURE__ */ function(e) {
  return e[e["2D"] = 0] = "2D", e[e.WebGL = 1] = "WebGL", e[e.WebGL2 = 2] = "WebGL2", e;
}(Pr || {}), br = /* @__PURE__ */ function(e) {
  return e[e.Play = 0] = "Play", e[e.Pause = 1] = "Pause", e[e.Seeked = 2] = "Seeked", e[e.VolumeChange = 3] = "VolumeChange", e[e.RateChange = 4] = "RateChange", e;
}(br || {}), ef = /* @__PURE__ */ function(e) {
  return e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment", e;
}(ef || {});
function vu(e) {
  return "__ln" in e;
}
var iy = /* @__PURE__ */ function() {
  function e() {
    F(this, "length", 0), F(this, "head", null), F(this, "tail", null);
  }
  var r = e.prototype;
  return r.get = function(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    for (var i = this.head, o = 0; o < t; o++)
      i = (i == null ? void 0 : i.next) || null;
    return i;
  }, r.addNode = function(t) {
    var i = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = i, t.previousSibling && vu(t.previousSibling)) {
      var o = t.previousSibling.__ln.next;
      i.next = o, i.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = i, o && (o.previous = i);
    } else if (t.nextSibling && vu(t.nextSibling) && t.nextSibling.__ln.previous) {
      var s = t.nextSibling.__ln.previous;
      i.previous = s, i.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = i, s && (s.next = i);
    } else
      this.head && (this.head.previous = i), i.next = this.head, this.head = i;
    i.next === null && (this.tail = i), this.length++;
  }, r.removeNode = function(t) {
    var i = t.__ln;
    this.head && (i.previous ? (i.previous.next = i.next, i.next ? i.next.previous = i.previous : this.tail = i.previous) : (this.head = i.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }, e;
}(), yu = function(e, r) {
  return e + "@" + r;
}, oy = /* @__PURE__ */ function() {
  function e() {
    var n = this;
    F(this, "frozen", !1), F(this, "locked", !1), F(this, "texts", []), F(this, "attributes", []), F(this, "attributeMap", /* @__PURE__ */ new WeakMap()), F(this, "removes", []), F(this, "mapRemoves", []), F(this, "movedMap", {}), F(this, "addedSet", /* @__PURE__ */ new Set()), F(this, "movedSet", /* @__PURE__ */ new Set()), F(this, "droppedSet", /* @__PURE__ */ new Set()), F(this, "removesSubTreeCache", /* @__PURE__ */ new Set()), F(this, "mutationCb"), F(this, "blockClass"), F(this, "blockSelector"), F(this, "maskTextClass"), F(this, "maskTextSelector"), F(this, "inlineStylesheet"), F(this, "maskInputOptions"), F(this, "maskTextFn"), F(this, "maskInputFn"), F(this, "keepIframeSrcFn"), F(this, "recordCanvas"), F(this, "inlineImages"), F(this, "slimDOMOptions"), F(this, "dataURLOptions"), F(this, "doc"), F(this, "mirror"), F(this, "iframeManager"), F(this, "stylesheetManager"), F(this, "shadowDomManager"), F(this, "canvasManager"), F(this, "processedNodeManager"), F(this, "unattachedDoc"), F(this, "processMutations", function(t) {
      t.forEach(n.processMutation), n.emit();
    }), F(this, "emit", function() {
      if (!(n.frozen || n.locked)) {
        for (var t = [], i = /* @__PURE__ */ new Set(), o = new iy(), s = function(P) {
          for (var z = P, Z = on; Z === on; )
            z = z && z.nextSibling, Z = z && n.mirror.getId(z);
          return Z;
        }, a = function(P) {
          var z = Y.parentNode(P);
          if (!(!z || !Ql(P))) {
            var Z = !1;
            if (P.nodeType === Node.TEXT_NODE) {
              var Me = z.tagName;
              if (Me === "TEXTAREA")
                return;
              Me === "STYLE" && n.addedSet.has(z) && (Z = !0);
            }
            var te = Hr(z) ? n.mirror.getId(Xl(P)) : n.mirror.getId(z), Pe = s(P);
            if (te === -1 || Pe === -1)
              return o.addNode(P);
            var Ee = xr(P, {
              doc: n.doc,
              mirror: n.mirror,
              blockClass: n.blockClass,
              blockSelector: n.blockSelector,
              maskTextClass: n.maskTextClass,
              maskTextSelector: n.maskTextSelector,
              skipChild: !0,
              newlyAddedElement: !0,
              inlineStylesheet: n.inlineStylesheet,
              maskInputOptions: n.maskInputOptions,
              maskTextFn: n.maskTextFn,
              maskInputFn: n.maskInputFn,
              slimDOMOptions: n.slimDOMOptions,
              dataURLOptions: n.dataURLOptions,
              recordCanvas: n.recordCanvas,
              inlineImages: n.inlineImages,
              onSerialize: function(ce) {
                Kl(ce, n.mirror) && n.iframeManager.addIframe(ce), Jl(ce, n.mirror) && n.stylesheetManager.trackLinkElement(ce), as(P) && n.shadowDomManager.addShadowRoot(Y.shadowRoot(P), n.doc);
              },
              onIframeLoad: function(ce, xe) {
                n.iframeManager.attachIframe(ce, xe), n.shadowDomManager.observeAttachShadow(ce);
              },
              onStylesheetLoad: function(ce, xe) {
                n.stylesheetManager.attachLinkElement(ce, xe);
              },
              cssCaptured: Z
            });
            Ee && (t.push({
              parentId: te,
              nextId: Pe,
              node: Ee
            }), i.add(Ee.id));
          }
        }; n.mapRemoves.length; )
          n.mirror.removeNodeFromMap(n.mapRemoves.shift());
        for (var u = D(n.movedSet), l; !(l = u()).done; ) {
          var c = l.value;
          _u(n.removesSubTreeCache, c, n.mirror) && !n.movedSet.has(Y.parentNode(c)) || a(c);
        }
        for (var h = D(n.addedSet), m; !(m = h()).done; ) {
          var v = m.value;
          !wu(n.droppedSet, v) && !_u(n.removesSubTreeCache, v, n.mirror) || wu(n.movedSet, v) ? a(v) : n.droppedSet.add(v);
        }
        for (var y = null; o.length; ) {
          var S = null;
          if (y) {
            var _ = n.mirror.getId(Y.parentNode(y.value)), b = s(y.value);
            _ !== -1 && b !== -1 && (S = y);
          }
          if (!S)
            for (var C = o.tail; C; ) {
              var E = C;
              if (C = C.previous, E) {
                var R = n.mirror.getId(Y.parentNode(E.value)), A = s(E.value);
                if (A === -1) continue;
                if (R !== -1) {
                  S = E;
                  break;
                } else {
                  var M = E.value, L = Y.parentNode(M);
                  if (L && L.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                    var N = Y.host(L), B = n.mirror.getId(N);
                    if (B !== -1) {
                      S = E;
                      break;
                    }
                  }
                }
              }
            }
          if (!S) {
            for (; o.head; )
              o.removeNode(o.head.value);
            break;
          }
          y = S.previous, o.removeNode(S.value), a(S.value);
        }
        var G = {
          texts: n.texts.map(function(P) {
            var z = P.node, Z = Y.parentNode(z);
            return Z && Z.tagName === "TEXTAREA" && n.genTextAreaValueMutation(Z), {
              id: n.mirror.getId(z),
              value: P.value
            };
          }).filter(function(P) {
            return !i.has(P.id);
          }).filter(function(P) {
            return n.mirror.has(P.id);
          }),
          attributes: n.attributes.map(function(P) {
            var z = P.attributes;
            if (typeof z.style == "string") {
              var Z = JSON.stringify(P.styleDiff), Me = JSON.stringify(P._unchangedStyles);
              Z.length < z.style.length && (Z + Me).split("var(").length === z.style.split("var(").length && (z.style = P.styleDiff);
            }
            return {
              id: n.mirror.getId(P.node),
              attributes: z
            };
          }).filter(function(P) {
            return !i.has(P.id);
          }).filter(function(P) {
            return n.mirror.has(P.id);
          }),
          removes: n.removes,
          adds: t
        };
        !G.texts.length && !G.attributes.length && !G.removes.length && !G.adds.length || (n.texts = [], n.attributes = [], n.attributeMap = /* @__PURE__ */ new WeakMap(), n.removes = [], n.addedSet = /* @__PURE__ */ new Set(), n.movedSet = /* @__PURE__ */ new Set(), n.droppedSet = /* @__PURE__ */ new Set(), n.removesSubTreeCache = /* @__PURE__ */ new Set(), n.movedMap = {}, n.mutationCb(G));
      }
    }), F(this, "genTextAreaValueMutation", function(t) {
      var i = n.attributeMap.get(t);
      i || (i = {
        node: t,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, n.attributes.push(i), n.attributeMap.set(t, i)), i.attributes.value = Array.from(Y.childNodes(t), function(o) {
        return Y.textContent(o) || "";
      }).join("");
    }), F(this, "processMutation", function(t) {
      if (!ho(t.target, n.mirror, n.slimDOMOptions))
        switch (t.type) {
          case "characterData": {
            var i = Y.textContent(t.target);
            !Be(t.target, n.blockClass, n.blockSelector, !1) && i !== t.oldValue && n.texts.push({
              value: kc(t.target, n.maskTextClass, n.maskTextSelector, !0) && i ? n.maskTextFn ? n.maskTextFn(i, Hl(t.target)) : i.replace(/[\S]/g, "*") : i,
              node: t.target
            });
            break;
          }
          case "attributes": {
            var o = t.target, s = t.attributeName, a = t.target.getAttribute(s);
            if (s === "value") {
              var u = Os(o);
              a = Es({
                element: o,
                maskInputOptions: n.maskInputOptions,
                tagName: o.tagName,
                type: u,
                value: a,
                maskInputFn: n.maskInputFn
              });
            }
            if (Be(t.target, n.blockClass, n.blockSelector, !1) || a === t.oldValue)
              return;
            var l = n.attributeMap.get(t.target);
            if (o.tagName === "IFRAME" && s === "src" && !n.keepIframeSrcFn(a))
              if (!o.contentDocument)
                s = "rr_src";
              else
                return;
            if (l || (l = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, n.attributes.push(l), n.attributeMap.set(t.target, l)), s === "type" && o.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && o.setAttribute("data-rr-is-password", "true"), !Oc(o.tagName, s))
              if (l.attributes[s] = Ec(n.doc, ur(o.tagName), ur(s), a), s === "style") {
                if (!n.unattachedDoc)
                  try {
                    n.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch {
                    n.unattachedDoc = n.doc;
                  }
                var c = n.unattachedDoc.createElement("span");
                t.oldValue && c.setAttribute("style", t.oldValue);
                for (var h = D(Array.from(o.style)), m; !(m = h()).done; ) {
                  var v = m.value, y = o.style.getPropertyValue(v), S = o.style.getPropertyPriority(v);
                  y !== c.style.getPropertyValue(v) || S !== c.style.getPropertyPriority(v) ? S === "" ? l.styleDiff[v] = y : l.styleDiff[v] = [
                    y,
                    S
                  ] : l._unchangedStyles[v] = [
                    y,
                    S
                  ];
                }
                for (var _ = D(Array.from(c.style)), b; !(b = _()).done; ) {
                  var C = b.value;
                  o.style.getPropertyValue(C) === "" && (l.styleDiff[C] = !1);
                }
              } else s === "open" && o.tagName === "DIALOG" && (o.matches("dialog:modal") ? l.attributes.rr_open_mode = "modal" : l.attributes.rr_open_mode = "non-modal");
            break;
          }
          case "childList": {
            if (Be(t.target, n.blockClass, n.blockSelector, !0)) return;
            if (t.target.tagName === "TEXTAREA") {
              n.genTextAreaValueMutation(t.target);
              return;
            }
            t.addedNodes.forEach(function(E) {
              return n.genAdds(E, t.target);
            }), t.removedNodes.forEach(function(E) {
              var R = n.mirror.getId(E), A = Hr(t.target) ? n.mirror.getId(Y.host(t.target)) : n.mirror.getId(t.target);
              Be(t.target, n.blockClass, n.blockSelector, !1) || ho(E, n.mirror, n.slimDOMOptions) || !Qv(E, n.mirror) || (n.addedSet.has(E) ? (us(n.addedSet, E), n.droppedSet.add(E)) : n.addedSet.has(t.target) && R === -1 || Zl(t.target, n.mirror) || (n.movedSet.has(E) && n.movedMap[yu(R, A)] ? us(n.movedSet, E) : (n.removes.push({
                parentId: A,
                id: R,
                isShadow: Hr(t.target) && Zr(t.target) ? !0 : void 0
              }), sy(E, n.removesSubTreeCache))), n.mapRemoves.push(E));
            });
            break;
          }
        }
    }), F(this, "genAdds", function(t, i) {
      if (!n.processedNodeManager.inOtherBuffer(t, n) && !(n.addedSet.has(t) || n.movedSet.has(t))) {
        if (n.mirror.hasNode(t)) {
          if (ho(t, n.mirror, n.slimDOMOptions))
            return;
          n.movedSet.add(t);
          var o = null;
          i && n.mirror.hasNode(i) && (o = n.mirror.getId(i)), o && o !== -1 && (n.movedMap[yu(n.mirror.getId(t), o)] = !0);
        } else
          n.addedSet.add(t), n.droppedSet.delete(t);
        Be(t, n.blockClass, n.blockSelector, !1) || (Y.childNodes(t).forEach(function(s) {
          return n.genAdds(s);
        }), as(t) && Y.childNodes(Y.shadowRoot(t)).forEach(function(s) {
          n.processedNodeManager.add(s, n), n.genAdds(s, t);
        }));
      }
    });
  }
  var r = e.prototype;
  return r.init = function(t) {
    var i = this;
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach(function(o) {
      i[o] = t[o];
    });
  }, r.freeze = function() {
    this.frozen = !0, this.canvasManager.freeze();
  }, r.unfreeze = function() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }, r.isFrozen = function() {
    return this.frozen;
  }, r.lock = function() {
    this.locked = !0, this.canvasManager.lock();
  }, r.unlock = function() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }, r.reset = function() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }, e;
}();
function us(e, r) {
  e.delete(r), Y.childNodes(r).forEach(function(n) {
    return us(e, n);
  });
}
function sy(e, r) {
  for (var n = [
    e
  ]; n.length; ) {
    var t = n.pop();
    r.has(t) || (r.add(t), Y.childNodes(t).forEach(function(i) {
      return n.push(i);
    }));
  }
}
function _u(e, r, n) {
  return e.size === 0 ? !1 : ay(e, r);
}
function ay(e, r, n) {
  var t = Y.parentNode(r);
  return t ? e.has(t) : !1;
}
function wu(e, r) {
  return e.size === 0 ? !1 : tf(e, r);
}
function tf(e, r) {
  var n = Y.parentNode(r);
  return n ? e.has(n) ? !0 : tf(e, n) : !1;
}
var Kr;
function uy(e) {
  Kr = e;
}
function cy() {
  Kr = void 0;
}
var X = function(e) {
  if (!Kr)
    return e;
  var r = function() {
    for (var n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    try {
      return e.apply(void 0, [].concat(t));
    } catch (o) {
      if (Kr && Kr(o) === !0)
        return;
      throw o;
    }
  };
  return r;
}, sr = [];
function wn(e) {
  try {
    if ("composedPath" in e) {
      var r = e.composedPath();
      if (r.length)
        return r[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function rf(e, r) {
  var n = new oy();
  sr.push(n), n.init(e);
  var t = new (Wl())(X(n.processMutations.bind(n)));
  return t.observe(r, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), t;
}
function ly(e) {
  var r = e.mousemoveCb, n = e.sampling, t = e.doc, i = e.mirror;
  if (n.mousemove === !1)
    return function() {
    };
  var o = typeof n.mousemove == "number" ? n.mousemove : 50, s = typeof n.mousemoveCallback == "number" ? n.mousemoveCallback : 500, a = [], u, l = dn(X(function(m) {
    var v = Date.now() - u;
    r(a.map(function(y) {
      return y.timeOffset -= v, y;
    }), m), a = [], u = null;
  }), s), c = X(dn(X(function(m) {
    var v = wn(m), y = ss(m) ? m.changedTouches[0] : m, S = y.clientX, _ = y.clientY;
    u || (u = Si()), a.push({
      x: S,
      y: _,
      id: i.getId(v),
      timeOffset: Si() - u
    }), l(typeof DragEvent < "u" && W(m, DragEvent) ? q.Drag : W(m, MouseEvent) ? q.MouseMove : q.TouchMove);
  }), o, {
    trailing: !1
  })), h = [
    Le("mousemove", c, t),
    Le("touchmove", c, t),
    Le("drag", c, t)
  ];
  return X(function() {
    h.forEach(function(m) {
      return m();
    });
  });
}
function fy(e) {
  var r = e.mouseInteractionCb, n = e.doc, t = e.mirror, i = e.blockClass, o = e.blockSelector, s = e.sampling;
  if (s.mouseInteraction === !1)
    return function() {
    };
  var a = s.mouseInteraction === !0 || s.mouseInteraction === void 0 ? {} : s.mouseInteraction, u = [], l = null, c = function(h) {
    return function(m) {
      var v = wn(m);
      if (!Be(v, i, o, !0)) {
        var y = null, S = h;
        if ("pointerType" in m) {
          switch (m.pointerType) {
            case "mouse":
              y = kt.Mouse;
              break;
            case "touch":
              y = kt.Touch;
              break;
            case "pen":
              y = kt.Pen;
              break;
          }
          y === kt.Touch ? ze[h] === ze.MouseDown ? S = "TouchStart" : ze[h] === ze.MouseUp && (S = "TouchEnd") : kt.Pen;
        } else ss(m) && (y = kt.Touch);
        y !== null ? (l = y, (S.startsWith("Touch") && y === kt.Touch || S.startsWith("Mouse") && y === kt.Mouse) && (y = null)) : ze[h] === ze.Click && (y = l, l = null);
        var _ = ss(m) ? m.changedTouches[0] : m;
        if (_) {
          var b = t.getId(v), C = _.clientX, E = _.clientY;
          X(r)(Q({
            type: ze[S],
            id: b,
            x: C,
            y: E
          }, y !== null && {
            pointerType: y
          }));
        }
      }
    };
  };
  return Object.keys(ze).filter(function(h) {
    return Number.isNaN(Number(h)) && !h.endsWith("_Departed") && a[h] !== !1;
  }).forEach(function(h) {
    var m = ur(h), v = c(h);
    if (window.PointerEvent)
      switch (ze[h]) {
        case ze.MouseDown:
        case ze.MouseUp:
          m = m.replace("mouse", "pointer");
          break;
        case ze.TouchStart:
        case ze.TouchEnd:
          return;
      }
    u.push(Le(m, v, n));
  }), X(function() {
    u.forEach(function(h) {
      return h();
    });
  });
}
function nf(e) {
  var r = e.scrollCb, n = e.doc, t = e.mirror, i = e.blockClass, o = e.blockSelector, s = e.sampling, a = X(dn(X(function(u) {
    var l = wn(u);
    if (!(!l || Be(l, i, o, !0))) {
      var c = t.getId(l);
      if (l === n && n.defaultView) {
        var h = Gl(n.defaultView);
        r({
          id: c,
          x: h.left,
          y: h.top
        });
      } else
        r({
          id: c,
          x: l.scrollLeft,
          y: l.scrollTop
        });
    }
  }), s.scroll || 100));
  return Le("scroll", a, n);
}
function hy(e, r) {
  var n = e.viewportResizeCb, t = r.win, i = -1, o = -1, s = X(dn(X(function() {
    var a = Vl(), u = Yl();
    (i !== a || o !== u) && (n({
      width: Number(u),
      height: Number(a)
    }), i = a, o = u);
  }), 200));
  return Le("resize", s, t);
}
var py = [
  "INPUT",
  "TEXTAREA",
  "SELECT"
], bu = /* @__PURE__ */ new WeakMap();
function dy(e) {
  var r = e.inputCb, n = e.doc, t = e.mirror, i = e.blockClass, o = e.blockSelector, s = e.ignoreClass, a = e.ignoreSelector, u = e.maskInputOptions, l = e.maskInputFn, c = e.sampling, h = e.userTriggeredOnInput;
  function m(R) {
    var A = wn(R), M = R.isTrusted, L = A && A.tagName;
    if (A && L === "OPTION" && (A = Y.parentElement(A)), !(!A || !L || py.indexOf(L) < 0 || Be(A, i, o, !0)) && !(A.classList.contains(s) || a && A.matches(a))) {
      var N = A.value, B = !1, G = Os(A) || "";
      G === "radio" || G === "checkbox" ? B = A.checked : (u[L.toLowerCase()] || u[G]) && (N = Es({
        element: A,
        maskInputOptions: u,
        tagName: L,
        type: G,
        value: N,
        maskInputFn: l
      })), v(A, h ? {
        text: N,
        isChecked: B,
        userTriggered: M
      } : {
        text: N,
        isChecked: B
      });
      var P = A.name;
      G === "radio" && P && B && n.querySelectorAll('input[type="radio"][name="' + P + '"]').forEach(function(z) {
        if (z !== A) {
          var Z = z.value;
          v(z, h ? {
            text: Z,
            isChecked: !B,
            userTriggered: !1
          } : {
            text: Z,
            isChecked: !B
          });
        }
      });
    }
  }
  function v(R, A) {
    var M = bu.get(R);
    if (!M || M.text !== A.text || M.isChecked !== A.isChecked) {
      bu.set(R, A);
      var L = t.getId(R);
      X(r)(Q({}, A, {
        id: L
      }));
    }
  }
  var y = c.input === "last" ? [
    "change"
  ] : [
    "input",
    "change"
  ], S = y.map(function(R) {
    return Le(R, X(m), n);
  }), _ = n.defaultView;
  if (!_)
    return function() {
      S.forEach(function(R) {
        return R();
      });
    };
  var b = _.Object.getOwnPropertyDescriptor(_.HTMLInputElement.prototype, "value"), C = [
    [
      _.HTMLInputElement.prototype,
      "value"
    ],
    [
      _.HTMLInputElement.prototype,
      "checked"
    ],
    [
      _.HTMLSelectElement.prototype,
      "value"
    ],
    [
      _.HTMLTextAreaElement.prototype,
      "value"
    ],
    // Some UI library use selectedIndex to set select value
    [
      _.HTMLSelectElement.prototype,
      "selectedIndex"
    ],
    [
      _.HTMLOptionElement.prototype,
      "selected"
    ]
  ];
  if (b && b.set) {
    var E;
    (E = S).push.apply(E, [].concat(C.map(function(R) {
      return Wi(R[0], R[1], {
        set: function() {
          X(m)({
            target: this,
            isTrusted: !1
          });
        }
      }, !1, _);
    })));
  }
  return X(function() {
    S.forEach(function(R) {
      return R();
    });
  });
}
function Ci(e) {
  var r = [];
  function n(t, i) {
    if (Yn("CSSGroupingRule") && W(t.parentRule, CSSGroupingRule) || Yn("CSSMediaRule") && W(t.parentRule, CSSMediaRule) || Yn("CSSSupportsRule") && W(t.parentRule, CSSSupportsRule) || Yn("CSSConditionRule") && W(t.parentRule, CSSConditionRule)) {
      var o = Array.from(t.parentRule.cssRules), s = o.indexOf(t);
      i.unshift(s);
    } else if (t.parentStyleSheet) {
      var a = Array.from(t.parentStyleSheet.cssRules), u = a.indexOf(t);
      i.unshift(u);
    }
    return i;
  }
  return n(e, r);
}
function zt(e, r, n) {
  var t, i;
  return e ? (e.ownerNode ? t = r.getId(e.ownerNode) : i = n.getId(e), {
    styleId: i,
    id: t
  }) : {};
}
function my(e, r) {
  var n = e.styleSheetRuleCb, t = e.mirror, i = e.stylesheetManager, o = r.win;
  if (!o.CSSStyleSheet || !o.CSSStyleSheet.prototype)
    return function() {
    };
  var s = o.CSSStyleSheet.prototype.insertRule;
  o.CSSStyleSheet.prototype.insertRule = new Proxy(s, {
    apply: X(function(m, v, y) {
      var S = y[0], _ = y[1], b = zt(v, t, i.styleMirror), C = b.id, E = b.styleId;
      return (C && C !== -1 || E && E !== -1) && n({
        id: C,
        styleId: E,
        adds: [
          {
            rule: S,
            index: _
          }
        ]
      }), m.apply(v, y);
    })
  }), o.CSSStyleSheet.prototype.addRule = function(m, v, y) {
    y === void 0 && (y = this.cssRules.length);
    var S = m + " { " + v + " }";
    return o.CSSStyleSheet.prototype.insertRule.apply(this, [
      S,
      y
    ]);
  };
  var a = o.CSSStyleSheet.prototype.deleteRule;
  o.CSSStyleSheet.prototype.deleteRule = new Proxy(a, {
    apply: X(function(m, v, y) {
      var S = y[0], _ = zt(v, t, i.styleMirror), b = _.id, C = _.styleId;
      return (b && b !== -1 || C && C !== -1) && n({
        id: b,
        styleId: C,
        removes: [
          {
            index: S
          }
        ]
      }), m.apply(v, y);
    })
  }), o.CSSStyleSheet.prototype.removeRule = function(m) {
    return o.CSSStyleSheet.prototype.deleteRule.apply(this, [
      m
    ]);
  };
  var u;
  o.CSSStyleSheet.prototype.replace && (u = o.CSSStyleSheet.prototype.replace, o.CSSStyleSheet.prototype.replace = new Proxy(u, {
    apply: X(function(m, v, y) {
      var S = y[0], _ = zt(v, t, i.styleMirror), b = _.id, C = _.styleId;
      return (b && b !== -1 || C && C !== -1) && n({
        id: b,
        styleId: C,
        replace: S
      }), m.apply(v, y);
    })
  }));
  var l;
  o.CSSStyleSheet.prototype.replaceSync && (l = o.CSSStyleSheet.prototype.replaceSync, o.CSSStyleSheet.prototype.replaceSync = new Proxy(l, {
    apply: X(function(m, v, y) {
      var S = y[0], _ = zt(v, t, i.styleMirror), b = _.id, C = _.styleId;
      return (b && b !== -1 || C && C !== -1) && n({
        id: b,
        styleId: C,
        replaceSync: S
      }), m.apply(v, y);
    })
  }));
  var c = {};
  Hn("CSSGroupingRule") ? c.CSSGroupingRule = o.CSSGroupingRule : (Hn("CSSMediaRule") && (c.CSSMediaRule = o.CSSMediaRule), Hn("CSSConditionRule") && (c.CSSConditionRule = o.CSSConditionRule), Hn("CSSSupportsRule") && (c.CSSSupportsRule = o.CSSSupportsRule));
  var h = {};
  return Object.entries(c).forEach(function(m) {
    var v = m[0], y = m[1];
    h[v] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: y.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: y.prototype.deleteRule
    }, y.prototype.insertRule = new Proxy(h[v].insertRule, {
      apply: X(function(S, _, b) {
        var C = b[0], E = b[1], R = zt(_.parentStyleSheet, t, i.styleMirror), A = R.id, M = R.styleId;
        return (A && A !== -1 || M && M !== -1) && n({
          id: A,
          styleId: M,
          adds: [
            {
              rule: C,
              index: [].concat(Ci(_), [
                E || 0
              ])
            }
          ]
        }), S.apply(_, b);
      })
    }), y.prototype.deleteRule = new Proxy(h[v].deleteRule, {
      apply: X(function(S, _, b) {
        var C = b[0], E = zt(_.parentStyleSheet, t, i.styleMirror), R = E.id, A = E.styleId;
        return (R && R !== -1 || A && A !== -1) && n({
          id: R,
          styleId: A,
          removes: [
            {
              index: [].concat(Ci(_), [
                C
              ])
            }
          ]
        }), S.apply(_, b);
      })
    });
  }), X(function() {
    o.CSSStyleSheet.prototype.insertRule = s, o.CSSStyleSheet.prototype.deleteRule = a, u && (o.CSSStyleSheet.prototype.replace = u), l && (o.CSSStyleSheet.prototype.replaceSync = l), Object.entries(c).forEach(function(m) {
      var v = m[0], y = m[1];
      y.prototype.insertRule = h[v].insertRule, y.prototype.deleteRule = h[v].deleteRule;
    });
  });
}
function of(e, r) {
  var n = e.mirror, t = e.stylesheetManager, i, o, s, a = null;
  r.nodeName === "#document" ? a = n.getId(r) : a = n.getId(Y.host(r));
  var u = r.nodeName === "#document" ? (i = r.defaultView) == null ? void 0 : i.Document : (s = (o = r.ownerDocument) == null ? void 0 : o.defaultView) == null ? void 0 : s.ShadowRoot, l = u != null && u.prototype ? Object.getOwnPropertyDescriptor(u == null ? void 0 : u.prototype, "adoptedStyleSheets") : void 0;
  return a === null || a === -1 || !u || !l ? function() {
  } : (Object.defineProperty(r, "adoptedStyleSheets", {
    configurable: l.configurable,
    enumerable: l.enumerable,
    get: function() {
      var h;
      return (h = l.get) == null ? void 0 : h.call(this);
    },
    set: function(h) {
      var m, v = (m = l.set) == null ? void 0 : m.call(this, h);
      if (a !== null && a !== -1)
        try {
          t.adoptStyleSheets(h, a);
        } catch {
        }
      return v;
    }
  }), X(function() {
    Object.defineProperty(r, "adoptedStyleSheets", {
      configurable: l.configurable,
      enumerable: l.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: l.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: l.set
    });
  }));
}
function gy(e, r) {
  var n = e.styleDeclarationCb, t = e.mirror, i = e.ignoreCSSAttributes, o = e.stylesheetManager, s = r.win, a = s.CSSStyleDeclaration.prototype.setProperty;
  s.CSSStyleDeclaration.prototype.setProperty = new Proxy(a, {
    apply: X(function(l, c, h) {
      var m, v = h[0], y = h[1], S = h[2];
      if (i.has(v))
        return a.apply(c, [
          v,
          y,
          S
        ]);
      var _ = zt((m = c.parentRule) == null ? void 0 : m.parentStyleSheet, t, o.styleMirror), b = _.id, C = _.styleId;
      return (b && b !== -1 || C && C !== -1) && n({
        id: b,
        styleId: C,
        set: {
          property: v,
          value: y,
          priority: S
        },
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        index: Ci(c.parentRule)
      }), l.apply(c, h);
    })
  });
  var u = s.CSSStyleDeclaration.prototype.removeProperty;
  return s.CSSStyleDeclaration.prototype.removeProperty = new Proxy(u, {
    apply: X(function(l, c, h) {
      var m, v = h[0];
      if (i.has(v))
        return u.apply(c, [
          v
        ]);
      var y = zt((m = c.parentRule) == null ? void 0 : m.parentStyleSheet, t, o.styleMirror), S = y.id, _ = y.styleId;
      return (S && S !== -1 || _ && _ !== -1) && n({
        id: S,
        styleId: _,
        remove: {
          property: v
        },
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        index: Ci(c.parentRule)
      }), l.apply(c, h);
    })
  }), X(function() {
    s.CSSStyleDeclaration.prototype.setProperty = a, s.CSSStyleDeclaration.prototype.removeProperty = u;
  });
}
function vy(e) {
  var r = e.mediaInteractionCb, n = e.blockClass, t = e.blockSelector, i = e.mirror, o = e.sampling, s = e.doc, a = X(function(l) {
    return dn(X(function(c) {
      var h = wn(c);
      if (!(!h || Be(h, n, t, !0))) {
        var m = h.currentTime, v = h.volume, y = h.muted, S = h.playbackRate, _ = h.loop;
        r({
          type: l,
          id: i.getId(h),
          currentTime: m,
          volume: v,
          muted: y,
          playbackRate: S,
          loop: _
        });
      }
    }), o.media || 500);
  }), u = [
    Le("play", a(br.Play), s),
    Le("pause", a(br.Pause), s),
    Le("seeked", a(br.Seeked), s),
    Le("volumechange", a(br.VolumeChange), s),
    Le("ratechange", a(br.RateChange), s)
  ];
  return X(function() {
    u.forEach(function(l) {
      return l();
    });
  });
}
function yy(e) {
  var r = e.fontCb, n = e.doc, t = n.defaultView;
  if (!t)
    return function() {
    };
  var i = [], o = /* @__PURE__ */ new WeakMap(), s = t.FontFace;
  t.FontFace = function(l, c, h) {
    var m = new s(l, c, h);
    return o.set(m, {
      family: l,
      buffer: typeof c != "string",
      descriptors: h,
      fontSource: typeof c == "string" ? c : JSON.stringify(Array.from(new Uint8Array(c)))
    }), m;
  };
  var a = Ur(n.fonts, "add", function(u) {
    return function(l) {
      return setTimeout(X(function() {
        var c = o.get(l);
        c && (r(c), o.delete(l));
      }), 0), u.apply(this, [
        l
      ]);
    };
  });
  return i.push(function() {
    t.FontFace = s;
  }), i.push(a), X(function() {
    i.forEach(function(u) {
      return u();
    });
  });
}
function _y(e) {
  var r = e.doc, n = e.mirror, t = e.blockClass, i = e.blockSelector, o = e.selectionCb, s = !0, a = X(function() {
    var u = r.getSelection();
    if (!(!u || s && (u != null && u.isCollapsed))) {
      s = u.isCollapsed || !1;
      for (var l = [], c = u.rangeCount || 0, h = 0; h < c; h++) {
        var m = u.getRangeAt(h), v = m.startContainer, y = m.startOffset, S = m.endContainer, _ = m.endOffset, b = Be(v, t, i, !0) || Be(S, t, i, !0);
        b || l.push({
          start: n.getId(v),
          startOffset: y,
          end: n.getId(S),
          endOffset: _
        });
      }
      o({
        ranges: l
      });
    }
  });
  return a(), Le("selectionchange", a);
}
function wy(e) {
  var r = e.doc, n = e.customElementCb, t = r.defaultView;
  if (!t || !t.customElements) return function() {
  };
  var i = Ur(t.customElements, "define", function(o) {
    return function(s, a, u) {
      try {
        n({
          define: {
            name: s
          }
        });
      } catch {
        console.warn("Custom element callback failed for " + s);
      }
      return o.apply(this, [
        s,
        a,
        u
      ]);
    };
  });
  return i;
}
function by(e, r) {
  var n = e.mutationCb, t = e.mousemoveCb, i = e.mouseInteractionCb, o = e.scrollCb, s = e.viewportResizeCb, a = e.inputCb, u = e.mediaInteractionCb, l = e.styleSheetRuleCb, c = e.styleDeclarationCb, h = e.canvasMutationCb, m = e.fontCb, v = e.selectionCb, y = e.customElementCb;
  e.mutationCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.mutation) {
      var C;
      (C = r).mutation.apply(C, [].concat(_));
    }
    n.apply(void 0, [].concat(_));
  }, e.mousemoveCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.mousemove) {
      var C;
      (C = r).mousemove.apply(C, [].concat(_));
    }
    t.apply(void 0, [].concat(_));
  }, e.mouseInteractionCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.mouseInteraction) {
      var C;
      (C = r).mouseInteraction.apply(C, [].concat(_));
    }
    i.apply(void 0, [].concat(_));
  }, e.scrollCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.scroll) {
      var C;
      (C = r).scroll.apply(C, [].concat(_));
    }
    o.apply(void 0, [].concat(_));
  }, e.viewportResizeCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.viewportResize) {
      var C;
      (C = r).viewportResize.apply(C, [].concat(_));
    }
    s.apply(void 0, [].concat(_));
  }, e.inputCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.input) {
      var C;
      (C = r).input.apply(C, [].concat(_));
    }
    a.apply(void 0, [].concat(_));
  }, e.mediaInteractionCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.mediaInteaction) {
      var C;
      (C = r).mediaInteaction.apply(C, [].concat(_));
    }
    u.apply(void 0, [].concat(_));
  }, e.styleSheetRuleCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.styleSheetRule) {
      var C;
      (C = r).styleSheetRule.apply(C, [].concat(_));
    }
    l.apply(void 0, [].concat(_));
  }, e.styleDeclarationCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.styleDeclaration) {
      var C;
      (C = r).styleDeclaration.apply(C, [].concat(_));
    }
    c.apply(void 0, [].concat(_));
  }, e.canvasMutationCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.canvasMutation) {
      var C;
      (C = r).canvasMutation.apply(C, [].concat(_));
    }
    h.apply(void 0, [].concat(_));
  }, e.fontCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.font) {
      var C;
      (C = r).font.apply(C, [].concat(_));
    }
    m.apply(void 0, [].concat(_));
  }, e.selectionCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.selection) {
      var C;
      (C = r).selection.apply(C, [].concat(_));
    }
    v.apply(void 0, [].concat(_));
  }, e.customElementCb = function() {
    for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
      _[b] = arguments[b];
    if (r.customElement) {
      var C;
      (C = r).customElement.apply(C, [].concat(_));
    }
    y.apply(void 0, [].concat(_));
  };
}
function Sy(e, r) {
  r === void 0 && (r = {});
  var n = e.doc.defaultView;
  if (!n)
    return function() {
    };
  by(e, r);
  var t;
  e.recordDOM && (t = rf(e, e.doc));
  var i = ly(e), o = fy(e), s = nf(e), a = hy(e, {
    win: n
  }), u = dy(e), l = vy(e), c = function() {
  }, h = function() {
  }, m = function() {
  }, v = function() {
  };
  e.recordDOM && (c = my(e, {
    win: n
  }), h = of(e, e.doc), m = gy(e, {
    win: n
  }), e.collectFonts && (v = yy(e)));
  for (var y = _y(e), S = wy(e), _ = [], b = D(e.plugins), C; !(C = b()).done; ) {
    var E = C.value;
    _.push(E.observer(E.callback, n, E.options));
  }
  return X(function() {
    sr.forEach(function(R) {
      return R.reset();
    }), t == null || t.disconnect(), i(), o(), s(), a(), u(), l(), c(), h(), m(), v(), y(), S(), _.forEach(function(R) {
      return R();
    });
  });
}
function Yn(e) {
  return typeof window[e] < "u";
}
function Hn(e) {
  return !!(typeof window[e] < "u" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
var Su = /* @__PURE__ */ function() {
  function e(n) {
    F(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap()), F(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap()), this.generateIdFn = n;
  }
  var r = e.prototype;
  return r.getId = function(t, i, o, s) {
    var a = o || this.getIdToRemoteIdMap(t), u = s || this.getRemoteIdToIdMap(t), l = a.get(i);
    return l || (l = this.generateIdFn(), a.set(i, l), u.set(l, i)), l;
  }, r.getIds = function(t, i) {
    var o = this, s = this.getIdToRemoteIdMap(t), a = this.getRemoteIdToIdMap(t);
    return i.map(function(u) {
      return o.getId(t, u, s, a);
    });
  }, r.getRemoteId = function(t, i, o) {
    var s = o || this.getRemoteIdToIdMap(t);
    if (typeof i != "number") return i;
    var a = s.get(i);
    return a || -1;
  }, r.getRemoteIds = function(t, i) {
    var o = this, s = this.getRemoteIdToIdMap(t);
    return i.map(function(a) {
      return o.getRemoteId(t, a, s);
    });
  }, r.reset = function(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }, r.getIdToRemoteIdMap = function(t) {
    var i = this.iframeIdToRemoteIdMap.get(t);
    return i || (i = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, i)), i;
  }, r.getRemoteIdToIdMap = function(t) {
    var i = this.iframeRemoteIdToIdMap.get(t);
    return i || (i = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, i)), i;
  }, e;
}(), Cy = /* @__PURE__ */ function() {
  function e(n) {
    F(this, "iframes", /* @__PURE__ */ new WeakMap()), F(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap()), F(this, "crossOriginIframeMirror", new Su(Ic)), F(this, "crossOriginIframeStyleMirror"), F(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap()), F(this, "mirror"), F(this, "mutationCb"), F(this, "wrappedEmit"), F(this, "loadListener"), F(this, "stylesheetManager"), F(this, "recordCrossOriginIframes"), this.mutationCb = n.mutationCb, this.wrappedEmit = n.wrappedEmit, this.stylesheetManager = n.stylesheetManager, this.recordCrossOriginIframes = n.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Su(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = n.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  var r = e.prototype;
  return r.addIframe = function(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }, r.addLoadListener = function(t) {
    this.loadListener = t;
  }, r.attachIframe = function(t, i) {
    var o, s;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: i
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((o = t.contentWindow) == null || o.addEventListener("message", this.handleMessage.bind(this))), (s = this.loadListener) == null || s.call(this, t), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(t.contentDocument.adoptedStyleSheets, this.mirror.getId(t.contentDocument));
  }, r.handleMessage = function(t) {
    var i = t;
    if (!(i.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    i.origin !== i.data.origin)) {
      var o = t.source;
      if (o) {
        var s = this.crossOriginIframeMap.get(t.source);
        if (s) {
          var a = this.transformCrossOriginEvent(s, i.data.event);
          a && this.wrappedEmit(a, i.data.isCheckout);
        }
      }
    }
  }, r.transformCrossOriginEvent = function(t, i) {
    var o = this, s;
    switch (i.type) {
      case K.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(i.data.node, t);
        var a = i.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, a), this.patchRootIdOnNode(i.data.node, a), {
          timestamp: i.timestamp,
          type: K.IncrementalSnapshot,
          data: {
            source: q.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: i.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case K.Meta:
      case K.Load:
      case K.DomContentLoaded:
        return !1;
      case K.Plugin:
        return i;
      case K.Custom:
        return this.replaceIds(i.data.payload, t, [
          "id",
          "parentId",
          "previousId",
          "nextId"
        ]), i;
      case K.IncrementalSnapshot:
        switch (i.data.source) {
          case q.Mutation:
            return i.data.adds.forEach(function(u) {
              o.replaceIds(u, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), o.replaceIdOnNode(u.node, t);
              var l = o.crossOriginIframeRootIdMap.get(t);
              l && o.patchRootIdOnNode(u.node, l);
            }), i.data.removes.forEach(function(u) {
              o.replaceIds(u, t, [
                "parentId",
                "id"
              ]);
            }), i.data.attributes.forEach(function(u) {
              o.replaceIds(u, t, [
                "id"
              ]);
            }), i.data.texts.forEach(function(u) {
              o.replaceIds(u, t, [
                "id"
              ]);
            }), i;
          case q.Drag:
          case q.TouchMove:
          case q.MouseMove:
            return i.data.positions.forEach(function(u) {
              o.replaceIds(u, t, [
                "id"
              ]);
            }), i;
          case q.ViewportResize:
            return !1;
          case q.MediaInteraction:
          case q.MouseInteraction:
          case q.Scroll:
          case q.CanvasMutation:
          case q.Input:
            return this.replaceIds(i.data, t, [
              "id"
            ]), i;
          case q.StyleSheetRule:
          case q.StyleDeclaration:
            return this.replaceIds(i.data, t, [
              "id"
            ]), this.replaceStyleIds(i.data, t, [
              "styleId"
            ]), i;
          case q.Font:
            return i;
          case q.Selection:
            return i.data.ranges.forEach(function(u) {
              o.replaceIds(u, t, [
                "start",
                "end"
              ]);
            }), i;
          case q.AdoptedStyleSheet:
            return this.replaceIds(i.data, t, [
              "id"
            ]), this.replaceStyleIds(i.data, t, [
              "styleIds"
            ]), (s = i.data.styles) == null || s.forEach(function(u) {
              o.replaceStyleIds(u, t, [
                "styleId"
              ]);
            }), i;
        }
    }
    return !1;
  }, r.replace = function(t, i, o, s) {
    for (var a = D(s), u; !(u = a()).done; ) {
      var l = u.value;
      !Array.isArray(i[l]) && typeof i[l] != "number" || (Array.isArray(i[l]) ? i[l] = t.getIds(o, i[l]) : i[l] = t.getId(o, i[l]));
    }
    return i;
  }, r.replaceIds = function(t, i, o) {
    return this.replace(this.crossOriginIframeMirror, t, i, o);
  }, r.replaceStyleIds = function(t, i, o) {
    return this.replace(this.crossOriginIframeStyleMirror, t, i, o);
  }, r.replaceIdOnNode = function(t, i) {
    var o = this;
    this.replaceIds(t, i, [
      "id",
      "rootId"
    ]), "childNodes" in t && t.childNodes.forEach(function(s) {
      o.replaceIdOnNode(s, i);
    });
  }, r.patchRootIdOnNode = function(t, i) {
    var o = this;
    t.type !== ef.Document && !t.rootId && (t.rootId = i), "childNodes" in t && t.childNodes.forEach(function(s) {
      o.patchRootIdOnNode(s, i);
    });
  }, e;
}(), xy = /* @__PURE__ */ function() {
  function e(n) {
    F(this, "shadowDoms", /* @__PURE__ */ new WeakSet()), F(this, "mutationCb"), F(this, "scrollCb"), F(this, "bypassOptions"), F(this, "mirror"), F(this, "restoreHandlers", []), this.mutationCb = n.mutationCb, this.scrollCb = n.scrollCb, this.bypassOptions = n.bypassOptions, this.mirror = n.mirror, this.init();
  }
  var r = e.prototype;
  return r.init = function() {
    this.reset(), this.patchAttachShadow(Element, document);
  }, r.addShadowRoot = function(t, i) {
    var o = this;
    if (Zr(t) && !this.shadowDoms.has(t)) {
      this.shadowDoms.add(t);
      var s = rf(Q({}, this.bypassOptions, {
        doc: i,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }), t);
      this.restoreHandlers.push(function() {
        return s.disconnect();
      }), this.restoreHandlers.push(nf(Q({}, this.bypassOptions, {
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: t,
        mirror: this.mirror
      }))), setTimeout(function() {
        t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && o.bypassOptions.stylesheetManager.adoptStyleSheets(t.adoptedStyleSheets, o.mirror.getId(Y.host(t))), o.restoreHandlers.push(of({
          mirror: o.mirror,
          stylesheetManager: o.bypassOptions.stylesheetManager
        }, t));
      }, 0);
    }
  }, r.observeAttachShadow = function(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(t.contentWindow.Element, t.contentDocument);
  }, r.patchAttachShadow = function(t, i) {
    var o = this;
    this.restoreHandlers.push(Ur(t.prototype, "attachShadow", function(s) {
      return function(a) {
        var u = s.call(this, a), l = Y.shadowRoot(this);
        return l && Ql(this) && o.addShadowRoot(l, i), u;
      };
    }));
  }, r.reset = function() {
    this.restoreHandlers.forEach(function(t) {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }, e;
}(), Ir = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Iy = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Zn = 0; Zn < Ir.length; Zn++)
  Iy[Ir.charCodeAt(Zn)] = Zn;
var Ey = function(r) {
  var n = new Uint8Array(r), t, i = n.length, o = "";
  for (t = 0; t < i; t += 3)
    o += Ir[n[t] >> 2], o += Ir[(n[t] & 3) << 4 | n[t + 1] >> 4], o += Ir[(n[t + 1] & 15) << 2 | n[t + 2] >> 6], o += Ir[n[t + 2] & 63];
  return i % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : i % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
}, Cu = /* @__PURE__ */ new Map();
function Oy(e, r) {
  var n = Cu.get(e);
  return n || (n = /* @__PURE__ */ new Map(), Cu.set(e, n)), n.has(r) || n.set(r, []), n.get(r);
}
var sf = function(e, r, n) {
  if (!(!e || !(uf(e, r) || (typeof e > "u" ? "undefined" : H(e)) === "object"))) {
    var t = e.constructor.name, i = Oy(n, t), o = i.indexOf(e);
    return o === -1 && (o = i.length, i.push(e)), o;
  }
};
function si(e, r, n) {
  if (W(e, Array))
    return e.map(function(y) {
      return si(y, r, n);
    });
  if (e === null)
    return e;
  if (W(e, Float32Array) || W(e, Float64Array) || W(e, Int32Array) || W(e, Uint32Array) || W(e, Uint8Array) || W(e, Uint16Array) || W(e, Int16Array) || W(e, Int8Array) || W(e, Uint8ClampedArray)) {
    var t = e.constructor.name;
    return {
      rr_type: t,
      args: [
        Object.values(e)
      ]
    };
  } else if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    W(e, ArrayBuffer)
  ) {
    var i = e.constructor.name, o = Ey(e);
    return {
      rr_type: i,
      base64: o
    };
  } else if (W(e, DataView)) {
    var s = e.constructor.name;
    return {
      rr_type: s,
      args: [
        si(e.buffer, r, n),
        e.byteOffset,
        e.byteLength
      ]
    };
  } else if (W(e, HTMLImageElement)) {
    var a = e.constructor.name, u = e.src;
    return {
      rr_type: a,
      src: u
    };
  } else if (W(e, HTMLCanvasElement)) {
    var l = "HTMLImageElement", c = e.toDataURL();
    return {
      rr_type: l,
      src: c
    };
  } else if (W(e, ImageData)) {
    var h = e.constructor.name;
    return {
      rr_type: h,
      args: [
        si(e.data, r, n),
        e.width,
        e.height
      ]
    };
  } else if (uf(e, r) || (typeof e > "u" ? "undefined" : H(e)) === "object") {
    var m = e.constructor.name, v = sf(e, r, n);
    return {
      rr_type: m,
      index: v
    };
  }
  return e;
}
var af = function(e, r, n) {
  return e.map(function(t) {
    return si(t, r, n);
  });
}, uf = function(e, r) {
  var n = [
    "WebGLActiveInfo",
    "WebGLBuffer",
    "WebGLFramebuffer",
    "WebGLProgram",
    "WebGLRenderbuffer",
    "WebGLShader",
    "WebGLShaderPrecisionFormat",
    "WebGLTexture",
    "WebGLUniformLocation",
    "WebGLVertexArrayObject",
    // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
    "WebGLVertexArrayObjectOES"
  ], t = n.filter(function(i) {
    return typeof r[i] == "function";
  });
  return !!t.find(function(i) {
    return W(e, r[i]);
  });
};
function ky(e, r, n, t) {
  for (var i = function() {
    var l = u.value;
    try {
      if (typeof r.CanvasRenderingContext2D.prototype[l] != "function")
        return "continue";
      var c = Ur(r.CanvasRenderingContext2D.prototype, l, function(m) {
        return function() {
          for (var v = this, y = arguments.length, S = new Array(y), _ = 0; _ < y; _++)
            S[_] = arguments[_];
          return Be(this.canvas, n, t, !0) || setTimeout(function() {
            var b = af(S, r, v);
            e(v.canvas, {
              type: Pr["2D"],
              property: l,
              args: b
            });
          }, 0), m.apply(this, S);
        };
      });
      o.push(c);
    } catch {
      var h = Wi(r.CanvasRenderingContext2D.prototype, l, {
        set: function(y) {
          e(this.canvas, {
            type: Pr["2D"],
            property: l,
            args: [
              y
            ],
            setter: !0
          });
        }
      });
      o.push(h);
    }
  }, o = [], s = Object.getOwnPropertyNames(r.CanvasRenderingContext2D.prototype), a = D(s), u; !(u = a()).done; ) i();
  return function() {
    o.forEach(function(l) {
      return l();
    });
  };
}
function Ay(e) {
  return e === "experimental-webgl" ? "webgl" : e;
}
function xu(e, r, n, t) {
  var i = [];
  try {
    var o = Ur(e.HTMLCanvasElement.prototype, "getContext", function(s) {
      return function(a) {
        for (var u = arguments.length, l = new Array(u > 1 ? u - 1 : 0), c = 1; c < u; c++)
          l[c - 1] = arguments[c];
        if (!Be(this, r, n, !0)) {
          var h = Ay(a);
          if ("__context" in this || (this.__context = h), t && [
            "webgl",
            "webgl2"
          ].includes(h))
            if (l[0] && H(l[0]) === "object") {
              var m = l[0];
              m.preserveDrawingBuffer || (m.preserveDrawingBuffer = !0);
            } else
              l.splice(0, 1, {
                preserveDrawingBuffer: !0
              });
        }
        return s.apply(this, [].concat([
          a
        ], l));
      };
    });
    i.push(o);
  } catch {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return function() {
    i.forEach(function(s) {
      return s();
    });
  };
}
function Iu(e, r, n, t, i, o) {
  for (var s = function() {
    var h = c.value;
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      [
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(h)
    )
      return "continue";
    try {
      if (typeof e[h] != "function")
        return "continue";
      var m = Ur(e, h, function(y) {
        return function() {
          for (var S = arguments.length, _ = new Array(S), b = 0; b < S; b++)
            _[b] = arguments[b];
          var C = y.apply(this, _);
          if (sf(C, o, this), "tagName" in this.canvas && !Be(this.canvas, t, i, !0)) {
            var E = af(_, o, this), R = {
              type: r,
              property: h,
              args: E
            };
            n(this.canvas, R);
          }
          return C;
        };
      });
      a.push(m);
    } catch {
      var v = Wi(e, h, {
        set: function(_) {
          n(this.canvas, {
            type: r,
            property: h,
            args: [
              _
            ],
            setter: !0
          });
        }
      });
      a.push(v);
    }
  }, a = [], u = Object.getOwnPropertyNames(e), l = D(u), c; !(c = l()).done; ) s();
  return a;
}
function Ry(e, r, n, t) {
  var i, o = [];
  if ((i = o).push.apply(i, [].concat(Iu(r.WebGLRenderingContext.prototype, Pr.WebGL, e, n, t, r))), typeof r.WebGL2RenderingContext < "u") {
    var s;
    (s = o).push.apply(s, [].concat(Iu(r.WebGL2RenderingContext.prototype, Pr.WebGL2, e, n, t, r)));
  }
  return function() {
    o.forEach(function(a) {
      return a();
    });
  };
}
var cf = "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", Ty = function(e) {
  return Uint8Array.from(atob(e), function(r) {
    return r.charCodeAt(0);
  });
}, Eu = typeof window < "u" && window.Blob && new Blob([
  Ty(cf)
], {
  type: "text/javascript;charset=utf-8"
});
function My(e) {
  var r;
  try {
    if (r = Eu && (window.URL || window.webkitURL).createObjectURL(Eu), !r) throw "";
    var n = new Worker(r, {
      name: e == null ? void 0 : e.name
    });
    return n.addEventListener("error", function() {
      (window.URL || window.webkitURL).revokeObjectURL(r);
    }), n;
  } catch {
    return new Worker("data:text/javascript;base64," + cf, {
      name: e == null ? void 0 : e.name
    });
  } finally {
    r && (window.URL || window.webkitURL).revokeObjectURL(r);
  }
}
var Fy = /* @__PURE__ */ function() {
  function e(n) {
    var t = this;
    F(this, "pendingCanvasMutations", /* @__PURE__ */ new Map()), F(this, "rafStamps", {
      latestId: 0,
      invokeId: null
    }), F(this, "mirror"), F(this, "mutationCb"), F(this, "resetObservers"), F(this, "frozen", !1), F(this, "locked", !1), F(this, "processMutation", function(h, m) {
      var v = t.rafStamps.invokeId && t.rafStamps.latestId !== t.rafStamps.invokeId;
      (v || !t.rafStamps.invokeId) && (t.rafStamps.invokeId = t.rafStamps.latestId), t.pendingCanvasMutations.has(h) || t.pendingCanvasMutations.set(h, []), t.pendingCanvasMutations.get(h).push(m);
    });
    var i = n.sampling, o = i === void 0 ? "all" : i, s = n.win, a = n.blockClass, u = n.blockSelector, l = n.recordCanvas, c = n.dataURLOptions;
    this.mutationCb = n.mutationCb, this.mirror = n.mirror, l && o === "all" && this.initCanvasMutationObserver(s, a, u), l && typeof o == "number" && this.initCanvasFPSObserver(o, s, a, u, {
      dataURLOptions: c
    });
  }
  var r = e.prototype;
  return r.reset = function() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }, r.freeze = function() {
    this.frozen = !0;
  }, r.unfreeze = function() {
    this.frozen = !1;
  }, r.lock = function() {
    this.locked = !0;
  }, r.unlock = function() {
    this.locked = !1;
  }, r.initCanvasFPSObserver = function(t, i, o, s, a) {
    var u = this, l = xu(i, o, s, !0), c = /* @__PURE__ */ new Map(), h = new My();
    h.onmessage = function(b) {
      var C = b.data.id;
      if (c.set(C, !1), "base64" in b.data) {
        var E = b.data, R = E.base64, A = E.type, M = E.width, L = E.height;
        u.mutationCb({
          id: C,
          type: Pr["2D"],
          commands: [
            {
              property: "clearRect",
              // wipe canvas
              args: [
                0,
                0,
                M,
                L
              ]
            },
            {
              property: "drawImage",
              // draws (semi-transparent) image
              args: [
                {
                  rr_type: "ImageBitmap",
                  args: [
                    {
                      rr_type: "Blob",
                      data: [
                        {
                          rr_type: "ArrayBuffer",
                          base64: R
                        }
                      ],
                      type: A
                    }
                  ]
                },
                0,
                0
              ]
            }
          ]
        });
      }
    };
    var m = 1e3 / t, v = 0, y, S = function() {
      var b = [];
      return i.document.querySelectorAll("canvas").forEach(function(C) {
        Be(C, o, s, !0) || b.push(C);
      }), b;
    }, _ = function(b) {
      if (v && b - v < m) {
        y = requestAnimationFrame(_);
        return;
      }
      v = b;
      var C = u;
      S().forEach(/* @__PURE__ */ xs(function(E) {
        var R, A, M, L;
        return nn(this, function(N) {
          switch (N.label) {
            case 0:
              return A = C.mirror.getId(E), c.get(A) ? [
                2
              ] : E.width === 0 || E.height === 0 ? [
                2
              ] : (c.set(A, !0), [
                "webgl",
                "webgl2"
              ].includes(E.__context) && (M = E.getContext(E.__context), ((R = M == null ? void 0 : M.getContextAttributes()) == null ? void 0 : R.preserveDrawingBuffer) === !1 && M.clear(M.COLOR_BUFFER_BIT)), [
                4,
                createImageBitmap(E)
              ]);
            case 1:
              return L = N.sent(), h.postMessage({
                id: A,
                bitmap: L,
                width: E.width,
                height: E.height,
                dataURLOptions: a.dataURLOptions
              }, [
                L
              ]), [
                2
              ];
          }
        });
      })), y = requestAnimationFrame(_);
    };
    y = requestAnimationFrame(_), this.resetObservers = function() {
      l(), cancelAnimationFrame(y);
    };
  }, r.initCanvasMutationObserver = function(t, i, o) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    var s = xu(t, i, o, !1), a = ky(this.processMutation.bind(this), t, i, o), u = Ry(this.processMutation.bind(this), t, i, o);
    this.resetObservers = function() {
      s(), a(), u();
    };
  }, r.startPendingCanvasMutationFlusher = function() {
    var t = this;
    requestAnimationFrame(function() {
      return t.flushPendingCanvasMutations();
    });
  }, r.startRAFTimestamping = function() {
    var t = this, i = function(o) {
      t.rafStamps.latestId = o, requestAnimationFrame(i);
    };
    requestAnimationFrame(i);
  }, r.flushPendingCanvasMutations = function() {
    var t = this;
    this.pendingCanvasMutations.forEach(function(i, o) {
      var s = t.mirror.getId(o);
      t.flushPendingCanvasMutationFor(o, s);
    }), requestAnimationFrame(function() {
      return t.flushPendingCanvasMutations();
    });
  }, r.flushPendingCanvasMutationFor = function(t, i) {
    if (!(this.frozen || this.locked)) {
      var o = this.pendingCanvasMutations.get(t);
      if (!(!o || i === -1)) {
        var s = o.map(function(u) {
          u.type;
          var l = tn(u, [
            "type"
          ]);
          return l;
        }), a = o[0].type;
        this.mutationCb({
          id: i,
          type: a,
          commands: s
        }), this.pendingCanvasMutations.delete(t);
      }
    }
  }, e;
}(), $y = /* @__PURE__ */ function() {
  function e(n) {
    F(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet()), F(this, "mutationCb"), F(this, "adoptedStyleSheetCb"), F(this, "styleMirror", new ty()), this.mutationCb = n.mutationCb, this.adoptedStyleSheetCb = n.adoptedStyleSheetCb;
  }
  var r = e.prototype;
  return r.attachLinkElement = function(t, i) {
    "_cssText" in i.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: i.id,
          attributes: i.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }, r.trackLinkElement = function(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }, r.adoptStyleSheets = function(t, i) {
    var o, s = function() {
      var h = c.value, m = void 0;
      o.styleMirror.has(h) ? m = o.styleMirror.getId(h) : (m = o.styleMirror.add(h), u.push({
        styleId: m,
        rules: Array.from(h.rules || CSSRule, function(v, y) {
          return {
            rule: Sc(v, h.href),
            index: y
          };
        })
      })), a.styleIds.push(m);
    };
    if (t.length !== 0) {
      for (var a = {
        id: i,
        styleIds: []
      }, u = [], l = D(t), c; !(c = l()).done; ) o = this, s();
      u.length > 0 && (a.styles = u), this.adoptedStyleSheetCb(a);
    }
  }, r.reset = function() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }, r.trackStylesheetInLinkElement = function(t) {
  }, e;
}(), Ny = /* @__PURE__ */ function() {
  function e() {
    F(this, "nodeMap", /* @__PURE__ */ new WeakMap()), F(this, "active", !1);
  }
  var r = e.prototype;
  return r.inOtherBuffer = function(t, i) {
    var o = this.nodeMap.get(t);
    return o && Array.from(o).some(function(s) {
      return s !== i;
    });
  }, r.add = function(t, i) {
    var o = this;
    this.active || (this.active = !0, requestAnimationFrame(function() {
      o.nodeMap = /* @__PURE__ */ new WeakMap(), o.active = !1;
    })), this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(i));
  }, r.destroy = function() {
  }, e;
}(), _e, ai, po, xi = !1;
try {
  if (Array.from([
    1
  ], function(e) {
    return e * 2;
  })[0] !== 2) {
    var mo = document.createElement("iframe");
    document.body.appendChild(mo), Array.from = ((Oa = mo.contentWindow) == null ? void 0 : Oa.Array.from) || Array.from, document.body.removeChild(mo);
  }
} catch (e) {
  console.debug("Unable to override Array.from", e);
}
var it = Fp();
function Qt(e) {
  e === void 0 && (e = {});
  var r = e.emit, n = e.checkoutEveryNms, t = e.checkoutEveryNth, i = e.blockClass, o = i === void 0 ? "rr-block" : i, s = e.blockSelector, a = s === void 0 ? null : s, u = e.ignoreClass, l = u === void 0 ? "rr-ignore" : u, c = e.ignoreSelector, h = c === void 0 ? null : c, m = e.maskTextClass, v = m === void 0 ? "rr-mask" : m, y = e.maskTextSelector, S = y === void 0 ? null : y, _ = e.inlineStylesheet, b = _ === void 0 ? !0 : _, C = e.maskAllInputs, E = e.maskInputOptions, R = e.slimDOMOptions, A = e.maskInputFn, M = e.maskTextFn, L = e.hooks, N = e.packFn, B = e.sampling, G = B === void 0 ? {} : B, P = e.dataURLOptions, z = P === void 0 ? {} : P, Z = e.mousemoveWait, Me = e.recordDOM, te = Me === void 0 ? !0 : Me, Pe = e.recordCanvas, Ee = Pe === void 0 ? !1 : Pe, ce = e.recordCrossOriginIframes, xe = ce === void 0 ? !1 : ce, De = e.recordAfter, St = De === void 0 ? e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load" : De, Ze = e.userTriggeredOnInput, Lt = Ze === void 0 ? !1 : Ze, re = e.collectFonts, ye = re === void 0 ? !1 : re, J = e.inlineImages, ut = J === void 0 ? !1 : J, ct = e.plugins, Ct = e.keepIframeSrcFn, Bt = Ct === void 0 ? function() {
    return !1;
  } : Ct, Ke = e.ignoreCSSAttributes, nr = Ke === void 0 ? /* @__PURE__ */ new Set([]) : Ke, ir = e.errorHandler;
  uy(ir);
  var lt = xe ? window.parent === window : !0, ft = !1;
  if (!lt)
    try {
      window.parent.document && (ft = !1);
    } catch {
      ft = !0;
    }
  if (lt && !r)
    throw new Error("emit function is required");
  if (!lt && !ft)
    return function() {
    };
  Z !== void 0 && G.mousemove === void 0 && (G.mousemove = Z), it.reset();
  var Ve = C === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : E !== void 0 ? E : {
    password: !0
  }, tt = R === !0 || R === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: R === "all",
    headMetaDescKeywords: R === "all",
    headTitleMutations: R === "all"
  } : R || {};
  ey();
  var Ut, xt = 0, Ye = function(I) {
    for (var k = D(ct || []), T; !(T = k()).done; ) {
      var U = T.value;
      U.eventProcessor && (I = U.eventProcessor(I));
    }
    return N && // Disable packing events which will be emitted to parent frames.
    !ft && (I = N(I)), I;
  };
  _e = function(I, k) {
    var T, U = I;
    if (U.timestamp = Si(), (T = sr[0]) != null && T.isFrozen() && U.type !== K.FullSnapshot && !(U.type === K.IncrementalSnapshot && U.data.source === q.Mutation) && sr.forEach(function(eh) {
      return eh.unfreeze();
    }), lt)
      r == null || r(Ye(U), k);
    else if (ft) {
      var le = {
        type: "rrweb",
        event: Ye(U),
        origin: window.location.origin,
        isCheckout: k
      };
      window.parent.postMessage(le, "*");
    }
    if (U.type === K.FullSnapshot)
      Ut = U, xt = 0;
    else if (U.type === K.IncrementalSnapshot) {
      if (U.data.source === q.Mutation && U.data.isAttachIframe)
        return;
      xt++;
      var me = t && xt >= t, se = n && U.timestamp - Ut.timestamp > n;
      (me || se) && ai(!0);
    }
  };
  for (var It = function(I) {
    _e({
      type: K.IncrementalSnapshot,
      data: Q({
        source: q.Mutation
      }, I)
    });
  }, Cn = function(I) {
    return _e({
      type: K.IncrementalSnapshot,
      data: Q({
        source: q.Scroll
      }, I)
    });
  }, jr = function(I) {
    return _e({
      type: K.IncrementalSnapshot,
      data: Q({
        source: q.CanvasMutation
      }, I)
    });
  }, mr = function(I) {
    return _e({
      type: K.IncrementalSnapshot,
      data: Q({
        source: q.AdoptedStyleSheet
      }, I)
    });
  }, Oe = new $y({
    mutationCb: It,
    adoptedStyleSheetCb: mr
  }), rt = new Cy({
    mirror: it,
    mutationCb: It,
    stylesheetManager: Oe,
    recordCrossOriginIframes: xe,
    wrappedEmit: _e
  }), Hi = D(ct || []), nt; !(nt = Hi()).done; ) {
    var xn = nt.value;
    xn.getMirror && xn.getMirror({
      nodeMirror: it,
      crossOriginIframeMirror: rt.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: rt.crossOriginIframeStyleMirror
    });
  }
  var g = new Ny();
  po = new Fy({
    recordCanvas: Ee,
    mutationCb: jr,
    win: window,
    blockClass: o,
    blockSelector: a,
    mirror: it,
    sampling: G.canvas,
    dataURLOptions: z
  });
  var f = new xy({
    mutationCb: It,
    scrollCb: Cn,
    bypassOptions: {
      blockClass: o,
      blockSelector: a,
      maskTextClass: v,
      maskTextSelector: S,
      inlineStylesheet: b,
      maskInputOptions: Ve,
      dataURLOptions: z,
      maskTextFn: M,
      maskInputFn: A,
      recordCanvas: Ee,
      inlineImages: ut,
      sampling: G,
      slimDOMOptions: tt,
      iframeManager: rt,
      stylesheetManager: Oe,
      canvasManager: po,
      keepIframeSrcFn: Bt,
      processedNodeManager: g
    },
    mirror: it
  });
  ai = function(I) {
    if (I === void 0 && (I = !1), !!te) {
      _e({
        type: K.Meta,
        data: {
          href: window.location.href,
          width: Yl(),
          height: Vl()
        }
      }, I), Oe.reset(), f.init(), sr.forEach(function(T) {
        return T.lock();
      });
      var k = nd(document, {
        mirror: it,
        blockClass: o,
        blockSelector: a,
        maskTextClass: v,
        maskTextSelector: S,
        inlineStylesheet: b,
        maskAllInputs: Ve,
        maskTextFn: M,
        maskInputFn: A,
        slimDOM: tt,
        dataURLOptions: z,
        recordCanvas: Ee,
        inlineImages: ut,
        onSerialize: function(T) {
          Kl(T, it) && rt.addIframe(T), Jl(T, it) && Oe.trackLinkElement(T), as(T) && f.addShadowRoot(Y.shadowRoot(T), document);
        },
        onIframeLoad: function(T, U) {
          rt.attachIframe(T, U), f.observeAttachShadow(T);
        },
        onStylesheetLoad: function(T, U) {
          Oe.attachLinkElement(T, U);
        },
        keepIframeSrcFn: Bt
      });
      if (!k)
        return console.warn("Failed to snapshot the document");
      _e({
        type: K.FullSnapshot,
        data: {
          node: k,
          initialOffset: Gl(window)
        }
      }, I), sr.forEach(function(T) {
        return T.unlock();
      }), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Oe.adoptStyleSheets(document.adoptedStyleSheets, it.getId(document));
    }
  };
  try {
    var p = [], w = function(I) {
      var k;
      return X(Sy)({
        mutationCb: It,
        mousemoveCb: function(T, U) {
          return _e({
            type: K.IncrementalSnapshot,
            data: {
              source: U,
              positions: T
            }
          });
        },
        mouseInteractionCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.MouseInteraction
            }, T)
          });
        },
        scrollCb: Cn,
        viewportResizeCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.ViewportResize
            }, T)
          });
        },
        inputCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.Input
            }, T)
          });
        },
        mediaInteractionCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.MediaInteraction
            }, T)
          });
        },
        styleSheetRuleCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.StyleSheetRule
            }, T)
          });
        },
        styleDeclarationCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.StyleDeclaration
            }, T)
          });
        },
        canvasMutationCb: jr,
        fontCb: function(T) {
          return _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.Font
            }, T)
          });
        },
        selectionCb: function(T) {
          _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.Selection
            }, T)
          });
        },
        customElementCb: function(T) {
          _e({
            type: K.IncrementalSnapshot,
            data: Q({
              source: q.CustomElement
            }, T)
          });
        },
        blockClass: o,
        ignoreClass: l,
        ignoreSelector: h,
        maskTextClass: v,
        maskTextSelector: S,
        maskInputOptions: Ve,
        inlineStylesheet: b,
        sampling: G,
        recordDOM: te,
        recordCanvas: Ee,
        inlineImages: ut,
        userTriggeredOnInput: Lt,
        collectFonts: ye,
        doc: I,
        maskInputFn: A,
        maskTextFn: M,
        keepIframeSrcFn: Bt,
        blockSelector: a,
        slimDOMOptions: tt,
        dataURLOptions: z,
        mirror: it,
        iframeManager: rt,
        stylesheetManager: Oe,
        shadowDomManager: f,
        processedNodeManager: g,
        canvasManager: po,
        ignoreCSSAttributes: nr,
        plugins: ((k = ct == null ? void 0 : ct.filter(function(T) {
          return T.observer;
        })) == null ? void 0 : k.map(function(T) {
          return {
            observer: T.observer,
            options: T.options,
            callback: function(U) {
              return _e({
                type: K.Plugin,
                data: {
                  plugin: T.name,
                  payload: U
                }
              });
            }
          };
        })) || []
      }, L);
    };
    rt.addLoadListener(function(I) {
      try {
        p.push(w(I.contentDocument));
      } catch (k) {
        console.warn(k);
      }
    });
    var x = function() {
      ai(), p.push(w(document)), xi = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? x() : (p.push(Le("DOMContentLoaded", function() {
      _e({
        type: K.DomContentLoaded,
        data: {}
      }), St === "DOMContentLoaded" && x();
    })), p.push(Le("load", function() {
      _e({
        type: K.Load,
        data: {}
      }), St === "load" && x();
    }, window))), function() {
      p.forEach(function(I) {
        return I();
      }), g.destroy(), xi = !1, cy();
    };
  } catch (I) {
    console.warn(I);
  }
}
Qt.addCustomEvent = function(e, r) {
  if (!xi)
    throw new Error("please add custom event after start recording");
  _e({
    type: K.Custom,
    data: {
      tag: e,
      payload: r
    }
  });
};
Qt.freezePage = function() {
  sr.forEach(function(e) {
    return e.freeze();
  });
};
Qt.takeFullSnapshot = function(e) {
  if (!xi)
    throw new Error("please take full snapshot after start recording");
  ai(e);
};
Qt.mirror = it;
var Ou;
(function(e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
})(Ou || (Ou = {}));
Qt.addCustomEvent;
Qt.freezePage;
Qt.takeFullSnapshot;
var ku = $.setImmediate, Yt, cs, ls, lf = Object.prototype.toString, Py = typeof ku < "u" ? function(r) {
  return ku(r);
} : setTimeout;
try {
  Object.defineProperty({}, "x", {}), Yt = function(r, n, t, i) {
    return Object.defineProperty(r, n, {
      value: t,
      writable: !0,
      configurable: i !== !1
    });
  };
} catch {
  Yt = function(n, t, i) {
    return n[t] = i, n;
  };
}
ls = /* @__PURE__ */ function() {
  var r, n, t;
  function i(o, s) {
    this.fn = o, this.self = s, this.next = void 0;
  }
  return {
    add: function(s, a) {
      t = new i(s, a), n ? n.next = t : r = t, n = t, t = void 0;
    },
    drain: function() {
      var s = r;
      for (r = n = cs = void 0; s; )
        s.fn.call(s.self), s = s.next;
    }
  };
}();
function Ii(e, r) {
  ls.add(e, r), cs || (cs = Py(ls.drain));
}
function ff(e) {
  var r, n = typeof e;
  return e !== null && (n === "object" || n === "function") && (r = e.then), typeof r == "function" ? r : !1;
}
function Ks() {
  for (var e = 0; e < this.chain.length; e++)
    Dy(
      this,
      this.state === 1 ? this.chain[e].success : this.chain[e].failure,
      this.chain[e]
    );
  this.chain.length = 0;
}
function Dy(e, r, n) {
  var t, i;
  try {
    r === !1 ? n.reject(e.msg) : (r === !0 ? t = e.msg : t = r.call(void 0, e.msg), t === n.promise ? n.reject(TypeError("Promise-chain cycle")) : (i = ff(t)) ? i.call(t, n.resolve, n.reject) : n.resolve(t));
  } catch (o) {
    n.reject(o);
  }
}
function hf(e) {
  var r, n = this;
  if (!n.triggered) {
    n.triggered = !0, n.def && (n = n.def);
    try {
      (r = ff(e)) ? Ii(function() {
        var t = new Au(n);
        try {
          r.call(
            e,
            function() {
              hf.apply(t, arguments);
            },
            function() {
              Jr.apply(t, arguments);
            }
          );
        } catch (i) {
          Jr.call(t, i);
        }
      }) : (n.msg = e, n.state = 1, n.chain.length > 0 && Ii(Ks, n));
    } catch (t) {
      Jr.call(new Au(n), t);
    }
  }
}
function Jr(e) {
  var r = this;
  r.triggered || (r.triggered = !0, r.def && (r = r.def), r.msg = e, r.state = 2, r.chain.length > 0 && Ii(Ks, r));
}
function pf(e, r, n, t) {
  for (var i = 0; i < r.length; i++)
    (function(s) {
      e.resolve(r[s]).then(
        function(u) {
          n(s, u);
        },
        t
      );
    })(i);
}
function Au(e) {
  this.def = e, this.triggered = !1;
}
function Ly(e) {
  this.promise = e, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
}
function er(e) {
  if (typeof e != "function")
    throw TypeError("Not a function");
  if (this.__NPO__ !== 0)
    throw TypeError("Not a promise");
  this.__NPO__ = 1;
  var r = new Ly(this);
  this.then = function(t, i) {
    var o = {
      success: typeof t == "function" ? t : !0,
      failure: typeof i == "function" ? i : !1
    };
    return o.promise = new this.constructor(function(a, u) {
      if (typeof a != "function" || typeof u != "function")
        throw TypeError("Not a function");
      o.resolve = a, o.reject = u;
    }), r.chain.push(o), r.state !== 0 && Ii(Ks, r), o.promise;
  }, this.catch = function(t) {
    return this.then(void 0, t);
  };
  try {
    e.call(
      void 0,
      function(t) {
        hf.call(r, t);
      },
      function(t) {
        Jr.call(r, t);
      }
    );
  } catch (n) {
    Jr.call(r, n);
  }
}
var df = Yt(
  {},
  "constructor",
  er,
  /*configurable=*/
  !1
);
er.prototype = df;
Yt(
  df,
  "__NPO__",
  0,
  /*configurable=*/
  !1
);
Yt(er, "resolve", function(r) {
  var n = this;
  return r && typeof r == "object" && r.__NPO__ === 1 ? r : new n(function(i, o) {
    if (typeof i != "function" || typeof o != "function")
      throw TypeError("Not a function");
    i(r);
  });
});
Yt(er, "reject", function(r) {
  return new this(function(t, i) {
    if (typeof t != "function" || typeof i != "function")
      throw TypeError("Not a function");
    i(r);
  });
});
Yt(er, "all", function(r) {
  var n = this;
  return lf.call(r) !== "[object Array]" ? n.reject(TypeError("Not an array")) : r.length === 0 ? n.resolve([]) : new n(function(i, o) {
    if (typeof i != "function" || typeof o != "function")
      throw TypeError("Not a function");
    var s = r.length, a = Array(s), u = 0;
    pf(n, r, function(c, h) {
      a[c] = h, ++u === s && i(a);
    }, o);
  });
});
Yt(er, "race", function(r) {
  var n = this;
  return lf.call(r) !== "[object Array]" ? n.reject(TypeError("Not an array")) : new n(function(i, o) {
    if (typeof i != "function" || typeof o != "function")
      throw TypeError("Not a function");
    pf(n, r, function(a, u) {
      i(u);
    }, o);
  });
});
var oe;
typeof Promise < "u" && Promise.toString().indexOf("[native code]") !== -1 ? oe = Promise : oe = er;
var st = {
  DEBUG: !1,
  LIB_VERSION: "2.67.0"
}, Xr = 24 * 60 * 60 * 1e3, go = 8 * 1e3, Gi = Array.prototype, By = Function.prototype, mf = Object.prototype, qt = Gi.slice, bn = mf.toString, Vi = mf.hasOwnProperty, Ce = $.console, jt = $.navigator, ne = $.document, Kn = $.opera, Ru = $.screen, At = jt.userAgent, vo = By.bind, Tu = Gi.forEach, Mu = Gi.indexOf, Fu = Gi.map, Uy = Array.isArray, fs = {}, d = {
  trim: function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  }
}, ie = {
  /** @type {function(...*)} */
  log: function() {
    if (st.DEBUG && !d.isUndefined(Ce) && Ce)
      try {
        Ce.log.apply(Ce, arguments);
      } catch {
        d.each(arguments, function(r) {
          Ce.log(r);
        });
      }
  },
  /** @type {function(...*)} */
  warn: function() {
    if (st.DEBUG && !d.isUndefined(Ce) && Ce) {
      var e = ["Mixpanel warning:"].concat(d.toArray(arguments));
      try {
        Ce.warn.apply(Ce, e);
      } catch {
        d.each(e, function(n) {
          Ce.warn(n);
        });
      }
    }
  },
  /** @type {function(...*)} */
  error: function() {
    if (st.DEBUG && !d.isUndefined(Ce) && Ce) {
      var e = ["Mixpanel error:"].concat(d.toArray(arguments));
      try {
        Ce.error.apply(Ce, e);
      } catch {
        d.each(e, function(n) {
          Ce.error(n);
        });
      }
    }
  },
  /** @type {function(...*)} */
  critical: function() {
    if (!d.isUndefined(Ce) && Ce) {
      var e = ["Mixpanel error:"].concat(d.toArray(arguments));
      try {
        Ce.error.apply(Ce, e);
      } catch {
        d.each(e, function(n) {
          Ce.error(n);
        });
      }
    }
  }
}, yo = function(e, r) {
  return function() {
    return arguments[0] = "[" + r + "] " + arguments[0], e.apply(ie, arguments);
  };
}, dr = function(e) {
  return {
    log: yo(ie.log, e),
    error: yo(ie.error, e),
    critical: yo(ie.critical, e)
  };
}, Js = function(e) {
  return function() {
    try {
      return e.apply(this, arguments);
    } catch (r) {
      ie.critical("Implementation error. Please turn on debug and contact support@mixpanel.com."), st.DEBUG && ie.critical(r);
    }
  };
}, gf = function(e) {
  var r = e.prototype;
  for (var n in r)
    typeof r[n] == "function" && (r[n] = Js(r[n]));
};
d.bind = function(e, r) {
  var n, t;
  if (vo && e.bind === vo)
    return vo.apply(e, qt.call(arguments, 1));
  if (!d.isFunction(e))
    throw new TypeError();
  return n = qt.call(arguments, 2), t = function() {
    if (!(this instanceof t))
      return e.apply(r, n.concat(qt.call(arguments)));
    var i = {};
    i.prototype = e.prototype;
    var o = new i();
    i.prototype = null;
    var s = e.apply(o, n.concat(qt.call(arguments)));
    return Object(s) === s ? s : o;
  }, t;
};
d.each = function(e, r, n) {
  if (e != null) {
    if (Tu && e.forEach === Tu)
      e.forEach(r, n);
    else if (e.length === +e.length) {
      for (var t = 0, i = e.length; t < i; t++)
        if (t in e && r.call(n, e[t], t, e) === fs)
          return;
    } else
      for (var o in e)
        if (Vi.call(e, o) && r.call(n, e[o], o, e) === fs)
          return;
  }
};
d.extend = function(e) {
  return d.each(qt.call(arguments, 1), function(r) {
    for (var n in r)
      r[n] !== void 0 && (e[n] = r[n]);
  }), e;
};
d.isArray = Uy || function(e) {
  return bn.call(e) === "[object Array]";
};
d.isFunction = function(e) {
  try {
    return /^\s*\bfunction\b/.test(e);
  } catch {
    return !1;
  }
};
d.isArguments = function(e) {
  return !!(e && Vi.call(e, "callee"));
};
d.toArray = function(e) {
  return e ? e.toArray ? e.toArray() : d.isArray(e) || d.isArguments(e) ? qt.call(e) : d.values(e) : [];
};
d.map = function(e, r, n) {
  if (Fu && e.map === Fu)
    return e.map(r, n);
  var t = [];
  return d.each(e, function(i) {
    t.push(r.call(n, i));
  }), t;
};
d.keys = function(e) {
  var r = [];
  return e === null || d.each(e, function(n, t) {
    r[r.length] = t;
  }), r;
};
d.values = function(e) {
  var r = [];
  return e === null || d.each(e, function(n) {
    r[r.length] = n;
  }), r;
};
d.include = function(e, r) {
  var n = !1;
  return e === null ? n : Mu && e.indexOf === Mu ? e.indexOf(r) != -1 : (d.each(e, function(t) {
    if (n || (n = t === r))
      return fs;
  }), n);
};
d.includes = function(e, r) {
  return e.indexOf(r) !== -1;
};
d.inherit = function(e, r) {
  return e.prototype = new r(), e.prototype.constructor = e, e.superclass = r.prototype, e;
};
d.isObject = function(e) {
  return e === Object(e) && !d.isArray(e);
};
d.isEmptyObject = function(e) {
  if (d.isObject(e)) {
    for (var r in e)
      if (Vi.call(e, r))
        return !1;
    return !0;
  }
  return !1;
};
d.isUndefined = function(e) {
  return e === void 0;
};
d.isString = function(e) {
  return bn.call(e) == "[object String]";
};
d.isDate = function(e) {
  return bn.call(e) == "[object Date]";
};
d.isNumber = function(e) {
  return bn.call(e) == "[object Number]";
};
d.isElement = function(e) {
  return !!(e && e.nodeType === 1);
};
d.encodeDates = function(e) {
  return d.each(e, function(r, n) {
    d.isDate(r) ? e[n] = d.formatDate(r) : d.isObject(r) && (e[n] = d.encodeDates(r));
  }), e;
};
d.timestamp = function() {
  return Date.now = Date.now || function() {
    return +/* @__PURE__ */ new Date();
  }, Date.now();
};
d.formatDate = function(e) {
  function r(n) {
    return n < 10 ? "0" + n : n;
  }
  return e.getUTCFullYear() + "-" + r(e.getUTCMonth() + 1) + "-" + r(e.getUTCDate()) + "T" + r(e.getUTCHours()) + ":" + r(e.getUTCMinutes()) + ":" + r(e.getUTCSeconds());
};
d.strip_empty_properties = function(e) {
  var r = {};
  return d.each(e, function(n, t) {
    d.isString(n) && n.length > 0 && (r[t] = n);
  }), r;
};
d.truncate = function(e, r) {
  var n;
  return typeof e == "string" ? n = e.slice(0, r) : d.isArray(e) ? (n = [], d.each(e, function(t) {
    n.push(d.truncate(t, r));
  })) : d.isObject(e) ? (n = {}, d.each(e, function(t, i) {
    n[i] = d.truncate(t, r);
  })) : n = e, n;
};
d.JSONEncode = /* @__PURE__ */ function() {
  return function(e) {
    var r = e, n = function(i) {
      var o = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, s = {
        // table of character substitutions
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      return o.lastIndex = 0, o.test(i) ? '"' + i.replace(o, function(a) {
        var u = s[a];
        return typeof u == "string" ? u : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
      }) + '"' : '"' + i + '"';
    }, t = function(i, o) {
      var s = "", a = "    ", u = 0, l = "", c = "", h = 0, m = s, v = [], y = o[i];
      switch (y && typeof y == "object" && typeof y.toJSON == "function" && (y = y.toJSON(i)), typeof y) {
        case "string":
          return n(y);
        case "number":
          return isFinite(y) ? String(y) : "null";
        case "boolean":
        case "null":
          return String(y);
        case "object":
          if (!y)
            return "null";
          if (s += a, v = [], bn.apply(y) === "[object Array]") {
            for (h = y.length, u = 0; u < h; u += 1)
              v[u] = t(u, y) || "null";
            return c = v.length === 0 ? "[]" : s ? `[
` + s + v.join(`,
` + s) + `
` + m + "]" : "[" + v.join(",") + "]", s = m, c;
          }
          for (l in y)
            Vi.call(y, l) && (c = t(l, y), c && v.push(n(l) + (s ? ": " : ":") + c));
          return c = v.length === 0 ? "{}" : s ? "{" + v.join(",") + m + "}" : "{" + v.join(",") + "}", s = m, c;
      }
    };
    return t("", {
      "": r
    });
  };
}();
d.JSONDecode = function() {
  var e, r, n = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, t, i = function(v) {
    var y = new SyntaxError(v);
    throw y.at = e, y.text = t, y;
  }, o = function(v) {
    return v && v !== r && i("Expected '" + v + "' instead of '" + r + "'"), r = t.charAt(e), e += 1, r;
  }, s = function() {
    var v, y = "";
    for (r === "-" && (y = "-", o("-")); r >= "0" && r <= "9"; )
      y += r, o();
    if (r === ".")
      for (y += "."; o() && r >= "0" && r <= "9"; )
        y += r;
    if (r === "e" || r === "E")
      for (y += r, o(), (r === "-" || r === "+") && (y += r, o()); r >= "0" && r <= "9"; )
        y += r, o();
    if (v = +y, !isFinite(v))
      i("Bad number");
    else
      return v;
  }, a = function() {
    var v, y, S = "", _;
    if (r === '"')
      for (; o(); ) {
        if (r === '"')
          return o(), S;
        if (r === "\\")
          if (o(), r === "u") {
            for (_ = 0, y = 0; y < 4 && (v = parseInt(o(), 16), !!isFinite(v)); y += 1)
              _ = _ * 16 + v;
            S += String.fromCharCode(_);
          } else if (typeof n[r] == "string")
            S += n[r];
          else
            break;
        else
          S += r;
      }
    i("Bad string");
  }, u = function() {
    for (; r && r <= " "; )
      o();
  }, l = function() {
    switch (r) {
      case "t":
        return o("t"), o("r"), o("u"), o("e"), !0;
      case "f":
        return o("f"), o("a"), o("l"), o("s"), o("e"), !1;
      case "n":
        return o("n"), o("u"), o("l"), o("l"), null;
    }
    i('Unexpected "' + r + '"');
  }, c, h = function() {
    var v = [];
    if (r === "[") {
      if (o("["), u(), r === "]")
        return o("]"), v;
      for (; r; ) {
        if (v.push(c()), u(), r === "]")
          return o("]"), v;
        o(","), u();
      }
    }
    i("Bad array");
  }, m = function() {
    var v, y = {};
    if (r === "{") {
      if (o("{"), u(), r === "}")
        return o("}"), y;
      for (; r; ) {
        if (v = a(), u(), o(":"), Object.hasOwnProperty.call(y, v) && i('Duplicate key "' + v + '"'), y[v] = c(), u(), r === "}")
          return o("}"), y;
        o(","), u();
      }
    }
    i("Bad object");
  };
  return c = function() {
    switch (u(), r) {
      case "{":
        return m();
      case "[":
        return h();
      case '"':
        return a();
      case "-":
        return s();
      default:
        return r >= "0" && r <= "9" ? s() : l();
    }
  }, function(v) {
    var y;
    return t = v, e = 0, r = " ", y = c(), u(), r && i("Syntax error"), y;
  };
}();
d.base64Encode = function(e) {
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", n, t, i, o, s, a, u, l, c = 0, h = 0, m = "", v = [];
  if (!e)
    return e;
  e = d.utf8Encode(e);
  do
    n = e.charCodeAt(c++), t = e.charCodeAt(c++), i = e.charCodeAt(c++), l = n << 16 | t << 8 | i, o = l >> 18 & 63, s = l >> 12 & 63, a = l >> 6 & 63, u = l & 63, v[h++] = r.charAt(o) + r.charAt(s) + r.charAt(a) + r.charAt(u);
  while (c < e.length);
  switch (m = v.join(""), e.length % 3) {
    case 1:
      m = m.slice(0, -2) + "==";
      break;
    case 2:
      m = m.slice(0, -1) + "=";
      break;
  }
  return m;
};
d.utf8Encode = function(e) {
  e = (e + "").replace(/\r\n/g, `
`).replace(/\r/g, `
`);
  var r = "", n, t, i = 0, o;
  for (n = t = 0, i = e.length, o = 0; o < i; o++) {
    var s = e.charCodeAt(o), a = null;
    s < 128 ? t++ : s > 127 && s < 2048 ? a = String.fromCharCode(s >> 6 | 192, s & 63 | 128) : a = String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, s & 63 | 128), a !== null && (t > n && (r += e.substring(n, t)), r += a, n = t = o + 1);
  }
  return t > n && (r += e.substring(n, e.length)), r;
};
d.UUID = function() {
  try {
    return $.crypto.randomUUID();
  } catch {
    for (var e = new Array(36), r = 0; r < 36; r++)
      e[r] = Math.floor(Math.random() * 16);
    return e[14] = 4, e[19] = e[19] &= -5, e[19] = e[19] |= 8, e[8] = e[13] = e[18] = e[23] = "-", d.map(e, function(t) {
      return t.toString(16);
    }).join("");
  }
};
var $u = [
  "ahrefsbot",
  "ahrefssiteaudit",
  "amazonbot",
  "baiduspider",
  "bingbot",
  "bingpreview",
  "chrome-lighthouse",
  "facebookexternal",
  "petalbot",
  "pinterest",
  "screaming frog",
  "yahoo! slurp",
  "yandex",
  // a whole bunch of goog-specific crawlers
  // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
  "adsbot-google",
  "apis-google",
  "duplexweb-google",
  "feedfetcher-google",
  "google favicon",
  "google web preview",
  "google-read-aloud",
  "googlebot",
  "googleweblight",
  "mediapartners-google",
  "storebot-google"
];
d.isBlockedUA = function(e) {
  var r;
  for (e = e.toLowerCase(), r = 0; r < $u.length; r++)
    if (e.indexOf($u[r]) !== -1)
      return !0;
  return !1;
};
d.HTTPBuildQuery = function(e, r) {
  var n, t, i = [];
  return d.isUndefined(r) && (r = "&"), d.each(e, function(o, s) {
    n = encodeURIComponent(o.toString()), t = encodeURIComponent(s), i[i.length] = t + "=" + n;
  }), i.join(r);
};
d.getQueryParam = function(e, r) {
  r = r.replace(/[[]/g, "\\[").replace(/[\]]/g, "\\]");
  var n = "[\\?&]" + r + "=([^&#]*)", t = new RegExp(n), i = t.exec(e);
  if (i === null || i && typeof i[1] != "string" && i[1].length)
    return "";
  var o = i[1];
  try {
    o = decodeURIComponent(o);
  } catch {
    ie.error("Skipping decoding for malformed query param: " + o);
  }
  return o.replace(/\+/g, " ");
};
d.cookie = {
  get: function(e) {
    for (var r = e + "=", n = ne.cookie.split(";"), t = 0; t < n.length; t++) {
      for (var i = n[t]; i.charAt(0) == " "; )
        i = i.substring(1, i.length);
      if (i.indexOf(r) === 0)
        return decodeURIComponent(i.substring(r.length, i.length));
    }
    return null;
  },
  parse: function(e) {
    var r;
    try {
      r = d.JSONDecode(d.cookie.get(e)) || {};
    } catch {
    }
    return r;
  },
  set_seconds: function(e, r, n, t, i, o, s) {
    var a = "", u = "", l = "";
    if (s)
      a = "; domain=" + s;
    else if (t) {
      var c = Nu(ne.location.hostname);
      a = c ? "; domain=." + c : "";
    }
    if (n) {
      var h = /* @__PURE__ */ new Date();
      h.setTime(h.getTime() + n * 1e3), u = "; expires=" + h.toGMTString();
    }
    o && (i = !0, l = "; SameSite=None"), i && (l += "; secure"), ne.cookie = e + "=" + encodeURIComponent(r) + u + "; path=/" + a + l;
  },
  set: function(e, r, n, t, i, o, s) {
    var a = "", u = "", l = "";
    if (s)
      a = "; domain=" + s;
    else if (t) {
      var c = Nu(ne.location.hostname);
      a = c ? "; domain=." + c : "";
    }
    if (n) {
      var h = /* @__PURE__ */ new Date();
      h.setTime(h.getTime() + n * 24 * 60 * 60 * 1e3), u = "; expires=" + h.toGMTString();
    }
    o && (i = !0, l = "; SameSite=None"), i && (l += "; secure");
    var m = e + "=" + encodeURIComponent(r) + u + "; path=/" + a + l;
    return ne.cookie = m, m;
  },
  remove: function(e, r, n) {
    d.cookie.set(e, "", -1, r, !1, !1, n);
  }
};
var vf = function(e) {
  var r = !0;
  try {
    var n = "__mplss_" + Xs(8), t = "xyz";
    e.setItem(n, t), e.getItem(n) !== t && (r = !1), e.removeItem(n);
  } catch {
    r = !1;
  }
  return r;
}, _o = null, mn = function(e, r) {
  return _o !== null && !r ? _o : _o = vf(e || $.localStorage);
}, wo = null, zy = function(e, r) {
  return wo !== null && !r ? wo : wo = vf(e || $.sessionStorage);
};
function yf(e, r, n) {
  var t = function(i) {
    ie.error(r + " error: " + i);
  };
  return {
    is_supported: function(i) {
      var o = n(e, i);
      return o || ie.error(r + " unsupported"), o;
    },
    error: t,
    get: function(i) {
      try {
        return e.getItem(i);
      } catch (o) {
        t(o);
      }
      return null;
    },
    parse: function(i) {
      try {
        return d.JSONDecode(e.getItem(i)) || {};
      } catch {
      }
      return null;
    },
    set: function(i, o) {
      try {
        e.setItem(i, o);
      } catch (s) {
        t(s);
      }
    },
    remove: function(i) {
      try {
        e.removeItem(i);
      } catch (o) {
        t(o);
      }
    }
  };
}
d.localStorage = yf($.localStorage, "localStorage", mn);
d.sessionStorage = yf($.sessionStorage, "sessionStorage", zy);
d.register_event = function() {
  var e = function(t, i, o, s, a) {
    if (!t) {
      ie.error("No valid element provided to register_event");
      return;
    }
    if (t.addEventListener && !s)
      t.addEventListener(i, o, !!a);
    else {
      var u = "on" + i, l = t[u];
      t[u] = r(t, o, l);
    }
  };
  function r(t, i, o) {
    var s = function(a) {
      if (a = a || n($.event), !!a) {
        var u = !0, l, c;
        return d.isFunction(o) && (l = o(a)), c = i.call(t, a), (l === !1 || c === !1) && (u = !1), u;
      }
    };
    return s;
  }
  function n(t) {
    return t && (t.preventDefault = n.preventDefault, t.stopPropagation = n.stopPropagation), t;
  }
  return n.preventDefault = function() {
    this.returnValue = !1;
  }, n.stopPropagation = function() {
    this.cancelBubble = !0;
  }, e;
}();
var qy = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
d.dom_query = /* @__PURE__ */ function() {
  function e(i) {
    return i.all ? i.all : i.getElementsByTagName("*");
  }
  var r = /[\t\r\n]/g;
  function n(i, o) {
    var s = " " + o + " ";
    return (" " + i.className + " ").replace(r, " ").indexOf(s) >= 0;
  }
  function t(i) {
    if (!ne.getElementsByTagName)
      return [];
    var o = i.split(" "), s, a, u, l, c, h, m, v, y, S, _ = [ne];
    for (h = 0; h < o.length; h++) {
      if (s = o[h].replace(/^\s+/, "").replace(/\s+$/, ""), s.indexOf("#") > -1) {
        a = s.split("#"), u = a[0];
        var b = a[1], C = ne.getElementById(b);
        if (!C || u && C.nodeName.toLowerCase() != u)
          return [];
        _ = [C];
        continue;
      }
      if (s.indexOf(".") > -1) {
        a = s.split("."), u = a[0];
        var E = a[1];
        for (u || (u = "*"), l = [], c = 0, m = 0; m < _.length; m++)
          for (u == "*" ? y = e(_[m]) : y = _[m].getElementsByTagName(u), v = 0; v < y.length; v++)
            l[c++] = y[v];
        for (_ = [], S = 0, m = 0; m < l.length; m++)
          l[m].className && d.isString(l[m].className) && // some SVG elements have classNames which are not strings
          n(l[m], E) && (_[S++] = l[m]);
        continue;
      }
      var R = s.match(qy);
      if (R) {
        u = R[1];
        var A = R[2], M = R[3], L = R[4];
        for (u || (u = "*"), l = [], c = 0, m = 0; m < _.length; m++)
          for (u == "*" ? y = e(_[m]) : y = _[m].getElementsByTagName(u), v = 0; v < y.length; v++)
            l[c++] = y[v];
        _ = [], S = 0;
        var N;
        switch (M) {
          case "=":
            N = function(B) {
              return B.getAttribute(A) == L;
            };
            break;
          case "~":
            N = function(B) {
              return B.getAttribute(A).match(new RegExp("\\b" + L + "\\b"));
            };
            break;
          case "|":
            N = function(B) {
              return B.getAttribute(A).match(new RegExp("^" + L + "-?"));
            };
            break;
          case "^":
            N = function(B) {
              return B.getAttribute(A).indexOf(L) === 0;
            };
            break;
          case "$":
            N = function(B) {
              return B.getAttribute(A).lastIndexOf(L) == B.getAttribute(A).length - L.length;
            };
            break;
          case "*":
            N = function(B) {
              return B.getAttribute(A).indexOf(L) > -1;
            };
            break;
          default:
            N = function(B) {
              return B.getAttribute(A);
            };
        }
        for (_ = [], S = 0, m = 0; m < l.length; m++)
          N(l[m]) && (_[S++] = l[m]);
        continue;
      }
      for (u = s, l = [], c = 0, m = 0; m < _.length; m++)
        for (y = _[m].getElementsByTagName(u), v = 0; v < y.length; v++)
          l[c++] = y[v];
      _ = l;
    }
    return _;
  }
  return function(i) {
    return d.isElement(i) ? [i] : d.isObject(i) && !d.isUndefined(i.length) ? i : t.call(this, i);
  };
}();
var jy = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "utm_source_platform", "utm_campaign_id", "utm_creative_format", "utm_marketing_tactic"], Wy = ["dclid", "fbclid", "gclid", "ko_click_id", "li_fat_id", "msclkid", "sccid", "ttclid", "twclid", "wbraid"];
d.info = {
  campaignParams: function(e) {
    var r = "", n = {};
    return d.each(jy, function(t) {
      r = d.getQueryParam(ne.URL, t), r.length ? n[t] = r : e !== void 0 && (n[t] = e);
    }), n;
  },
  clickParams: function() {
    var e = "", r = {};
    return d.each(Wy, function(n) {
      e = d.getQueryParam(ne.URL, n), e.length && (r[n] = e);
    }), r;
  },
  marketingParams: function() {
    return d.extend(d.info.campaignParams(), d.info.clickParams());
  },
  searchEngine: function(e) {
    return e.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : e.search("https?://(.*)bing.com") === 0 ? "bing" : e.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : e.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null;
  },
  searchInfo: function(e) {
    var r = d.info.searchEngine(e), n = r != "yahoo" ? "q" : "p", t = {};
    if (r !== null) {
      t.$search_engine = r;
      var i = d.getQueryParam(e, n);
      i.length && (t.mp_keyword = i);
    }
    return t;
  },
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  browser: function(e, r, n) {
    return r = r || "", n || d.includes(e, " OPR/") ? d.includes(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : d.includes(e, "IEMobile") || d.includes(e, "WPDesktop") ? "Internet Explorer Mobile" : d.includes(e, "SamsungBrowser/") ? "Samsung Internet" : d.includes(e, "Edge") || d.includes(e, "Edg/") ? "Microsoft Edge" : d.includes(e, "FBIOS") ? "Facebook Mobile" : d.includes(e, "Whale/") ? "Whale Browser" : d.includes(e, "Chrome") ? "Chrome" : d.includes(e, "CriOS") ? "Chrome iOS" : d.includes(e, "UCWEB") || d.includes(e, "UCBrowser") ? "UC Browser" : d.includes(e, "FxiOS") ? "Firefox iOS" : d.includes(r, "Apple") ? d.includes(e, "Mobile") ? "Mobile Safari" : "Safari" : d.includes(e, "Android") ? "Android Mobile" : d.includes(e, "Konqueror") ? "Konqueror" : d.includes(e, "Firefox") ? "Firefox" : d.includes(e, "MSIE") || d.includes(e, "Trident/") ? "Internet Explorer" : d.includes(e, "Gecko") ? "Mozilla" : "";
  },
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion: function(e, r, n) {
    var t = d.info.browser(e, r, n), i = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/,
      "Whale Browser": /Whale\/(\d+(\.\d+)?)/
    }, o = i[t];
    if (o === void 0)
      return null;
    var s = e.match(o);
    return s ? parseFloat(s[s.length - 2]) : null;
  },
  os: function() {
    var e = At;
    return /Windows/i.test(e) ? /Phone/.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : "Windows" : /(iPhone|iPad|iPod)/.test(e) ? "iOS" : /Android/.test(e) ? "Android" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Mac/i.test(e) ? "Mac OS X" : /Linux/.test(e) ? "Linux" : /CrOS/.test(e) ? "Chrome OS" : "";
  },
  device: function(e) {
    return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) ? "Android" : "";
  },
  referringDomain: function(e) {
    var r = e.split("/");
    return r.length >= 3 ? r[2] : "";
  },
  currentUrl: function() {
    return $.location.href;
  },
  properties: function(e) {
    return typeof e != "object" && (e = {}), d.extend(d.strip_empty_properties({
      $os: d.info.os(),
      $browser: d.info.browser(At, jt.vendor, Kn),
      $referrer: ne.referrer,
      $referring_domain: d.info.referringDomain(ne.referrer),
      $device: d.info.device(At)
    }), {
      $current_url: d.info.currentUrl(),
      $browser_version: d.info.browserVersion(At, jt.vendor, Kn),
      $screen_height: Ru.height,
      $screen_width: Ru.width,
      mp_lib: "web",
      $lib_version: st.LIB_VERSION,
      $insert_id: Xs(),
      time: d.timestamp() / 1e3
      // epoch time in seconds
    }, d.strip_empty_properties(e));
  },
  people_properties: function() {
    return d.extend(d.strip_empty_properties({
      $os: d.info.os(),
      $browser: d.info.browser(At, jt.vendor, Kn)
    }), {
      $browser_version: d.info.browserVersion(At, jt.vendor, Kn)
    });
  },
  mpPageViewProperties: function() {
    return d.strip_empty_properties({
      current_page_title: ne.title,
      current_domain: $.location.hostname,
      current_url_path: $.location.pathname,
      current_url_protocol: $.location.protocol,
      current_url_search: $.location.search
    });
  }
};
var Gy = function(e, r) {
  var n = null, t = [];
  return function(i) {
    var o = this;
    return t.push(i), n || (n = new oe(function(s) {
      setTimeout(function() {
        var a = e.apply(o, [t]);
        n = null, t = [], s(a);
      }, r);
    })), n;
  };
}, Xs = function(e) {
  var r = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  return e ? r.substring(0, e) : r;
}, Vy = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, Yy = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, Nu = function(e) {
  var r = Yy, n = e.split("."), t = n[n.length - 1];
  (t.length > 4 || t === "com" || t === "org") && (r = Vy);
  var i = e.match(r);
  return i ? i[0] : "";
}, Hy = function() {
  var e = $.navigator.onLine;
  return d.isUndefined(e) || e;
}, Gt = function() {
}, Dr = null, Ei = null;
typeof JSON < "u" && (Dr = JSON.stringify, Ei = JSON.parse);
Dr = Dr || d.JSONEncode;
Ei = Ei || d.JSONDecode;
d.info = d.info;
d.info.browser = d.info.browser;
d.info.browserVersion = d.info.browserVersion;
d.info.device = d.info.device;
d.info.properties = d.info.properties;
d.isBlockedUA = d.isBlockedUA;
d.isEmptyObject = d.isEmptyObject;
d.isObject = d.isObject;
d.JSONDecode = d.JSONDecode;
d.JSONEncode = d.JSONEncode;
d.toArray = d.toArray;
d.NPO = er;
var Zy = "mixpanelBrowserDb", _f = "mixpanelRecordingEvents", Qs = "mixpanelRecordingRegistry", Ky = 1, Jy = [_f, Qs], wt = function(e) {
  this.dbPromise = null, this.storeName = e;
};
wt.prototype._openDb = function() {
  return new oe(function(e, r) {
    var n = $.indexedDB.open(Zy, Ky);
    n.onerror = function() {
      r(n.error);
    }, n.onsuccess = function() {
      e(n.result);
    }, n.onupgradeneeded = function(t) {
      var i = t.target.result;
      Jy.forEach(function(o) {
        i.createObjectStore(o);
      });
    };
  });
};
wt.prototype.init = function() {
  return $.indexedDB ? (this.dbPromise || (this.dbPromise = this._openDb()), this.dbPromise.then(function(e) {
    return e instanceof $.IDBDatabase ? oe.resolve() : oe.reject(e);
  })) : oe.reject("indexedDB is not supported in this browser");
};
wt.prototype.makeTransaction = function(e, r) {
  var n = this.storeName, t = function(i) {
    return new oe(function(o, s) {
      var a = i.transaction(n, e);
      a.oncomplete = function() {
        o(a);
      }, a.onabort = a.onerror = function() {
        s(a.error);
      }, r(a.objectStore(n));
    });
  };
  return this.dbPromise.then(t).catch((function(i) {
    return i && i.name === "InvalidStateError" ? (this.dbPromise = this._openDb(), this.dbPromise.then(t)) : oe.reject(i);
  }).bind(this));
};
wt.prototype.setItem = function(e, r) {
  return this.makeTransaction("readwrite", function(n) {
    n.put(r, e);
  });
};
wt.prototype.getItem = function(e) {
  var r;
  return this.makeTransaction("readonly", function(n) {
    r = n.get(e);
  }).then(function() {
    return r.result;
  });
};
wt.prototype.removeItem = function(e) {
  return this.makeTransaction("readwrite", function(r) {
    r.delete(e);
  });
};
wt.prototype.getAll = function() {
  var e;
  return this.makeTransaction("readonly", function(r) {
    e = r.getAll();
  }).then(function() {
    return e.result;
  });
};
var Xy = "__mp_opt_in_out_";
function Qy(e, r) {
  Sf(!0, e, r);
}
function e_(e, r) {
  Sf(!1, e, r);
}
function t_(e, r) {
  return bf(e, r) === "1";
}
function wf(e, r) {
  if (n_(r))
    return ie.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"'), !0;
  var n = bf(e, r) === "0";
  return n && ie.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data."), n;
}
function tr(e) {
  return ra(e, function(r) {
    return this.get_config(r);
  });
}
function rr(e) {
  return ra(e, function(r) {
    return this._get_config(r);
  });
}
function zr(e) {
  return ra(e, function(r) {
    return this._get_config(r);
  });
}
function r_(e, r) {
  r = r || {}, ea(r).remove(
    ta(e, r),
    !!r.crossSubdomainCookie,
    r.cookieDomain
  );
}
function ea(e) {
  return e = e || {}, e.persistenceType === "localStorage" ? d.localStorage : d.cookie;
}
function ta(e, r) {
  return r = r || {}, (r.persistencePrefix || Xy) + e;
}
function bf(e, r) {
  return ea(r).get(ta(e, r));
}
function n_(e) {
  if (e && e.ignoreDnt)
    return !1;
  var r = e && e.window || $, n = r.navigator || {}, t = !1;
  return d.each([
    n.doNotTrack,
    // standard
    n.msDoNotTrack,
    r.doNotTrack
  ], function(i) {
    d.includes([!0, 1, "1", "yes"], i) && (t = !0);
  }), t;
}
function Sf(e, r, n) {
  if (!d.isString(r) || !r.length) {
    ie.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
    return;
  }
  n = n || {}, ea(n).set(
    ta(r, n),
    e ? 1 : 0,
    d.isNumber(n.cookieExpiration) ? n.cookieExpiration : null,
    !!n.crossSubdomainCookie,
    !!n.secureCookie,
    !!n.crossSiteCookie,
    n.cookieDomain
  ), n.track && e && n.track(n.trackEventName || "$opt_in", n.trackProperties, {
    send_immediately: !0
  });
}
function ra(e, r) {
  return function() {
    var n = !1;
    try {
      var t = r.call(this, "token"), i = r.call(this, "ignore_dnt"), o = r.call(this, "opt_out_tracking_persistence_type"), s = r.call(this, "opt_out_tracking_cookie_prefix"), a = r.call(this, "window");
      t && (n = wf(t, {
        ignoreDnt: i,
        persistenceType: o,
        persistencePrefix: s,
        window: a
      }));
    } catch (l) {
      ie.error("Unexpected error when checking tracking opt-out status: " + l);
    }
    if (!n)
      return e.apply(this, arguments);
    var u = arguments[arguments.length - 1];
    typeof u == "function" && u(0);
  };
}
var i_ = dr("lock"), Cf = function(e, r) {
  r = r || {}, this.storageKey = e, this.storage = r.storage || $.localStorage, this.pollIntervalMS = r.pollIntervalMS || 100, this.timeoutMS = r.timeoutMS || 2e3, this.promiseImpl = r.promiseImpl || oe;
};
Cf.prototype.withLock = function(e, r) {
  var n = this.promiseImpl;
  return new n(d.bind(function(t, i) {
    var o = r || (/* @__PURE__ */ new Date()).getTime() + "|" + Math.random(), s = (/* @__PURE__ */ new Date()).getTime(), a = this.storageKey, u = this.pollIntervalMS, l = this.timeoutMS, c = this.storage, h = a + ":X", m = a + ":Y", v = a + ":Z", y = function(E) {
      if ((/* @__PURE__ */ new Date()).getTime() - s > l) {
        i_.error("Timeout waiting for mutex on " + a + "; clearing lock. [" + o + "]"), c.removeItem(v), c.removeItem(m), b();
        return;
      }
      setTimeout(function() {
        try {
          E();
        } catch (R) {
          i(R);
        }
      }, u * (Math.random() + 0.1));
    }, S = function(E, R) {
      E() ? R() : y(function() {
        S(E, R);
      });
    }, _ = function() {
      var E = c.getItem(m);
      return E && E !== o ? !1 : (c.setItem(m, o), c.getItem(m) === o ? !0 : (mn(c, !0) || i(new Error("localStorage support dropped while acquiring lock")), !1));
    }, b = function() {
      c.setItem(h, o), S(_, function() {
        if (c.getItem(h) === o) {
          C();
          return;
        }
        y(function() {
          if (c.getItem(m) !== o) {
            b();
            return;
          }
          S(function() {
            return !c.getItem(v);
          }, C);
        });
      });
    }, C = function() {
      c.setItem(v, "1");
      var E = function() {
        c.removeItem(v), c.getItem(m) === o && c.removeItem(m), c.getItem(h) === o && c.removeItem(h);
      };
      e().then(function(R) {
        E(), t(R);
      }).catch(function(R) {
        E(), i(R);
      });
    };
    try {
      if (mn(c, !0))
        b();
      else
        throw new Error("localStorage support check failed");
    } catch (E) {
      i(E);
    }
  }, this));
};
var Sn = function(e) {
  this.storage = e || $.localStorage;
};
Sn.prototype.init = function() {
  return oe.resolve();
};
Sn.prototype.setItem = function(e, r) {
  return new oe(d.bind(function(n, t) {
    try {
      this.storage.setItem(e, Dr(r));
    } catch (i) {
      t(i);
    }
    n();
  }, this));
};
Sn.prototype.getItem = function(e) {
  return new oe(d.bind(function(r, n) {
    var t;
    try {
      t = Ei(this.storage.getItem(e));
    } catch (i) {
      n(i);
    }
    r(t);
  }, this));
};
Sn.prototype.removeItem = function(e) {
  return new oe(d.bind(function(r, n) {
    try {
      this.storage.removeItem(e);
    } catch (t) {
      n(t);
    }
    r();
  }, this));
};
var Pu = dr("batch"), bt = function(e, r) {
  r = r || {}, this.storageKey = e, this.usePersistence = r.usePersistence, this.usePersistence && (this.queueStorage = r.queueStorage || new Sn(), this.lock = new Cf(e, {
    storage: r.sharedLockStorage || $.localStorage,
    timeoutMS: r.sharedLockTimeoutMS
  })), this.reportError = r.errorReporter || d.bind(Pu.error, Pu), this.pid = r.pid || null, this.memQueue = [], this.initialized = !1, r.enqueueThrottleMs ? this.enqueuePersisted = Gy(d.bind(this._enqueuePersisted, this), r.enqueueThrottleMs) : this.enqueuePersisted = d.bind(function(n) {
    return this._enqueuePersisted([n]);
  }, this);
};
bt.prototype.ensureInit = function() {
  return this.initialized ? oe.resolve() : this.queueStorage.init().then(d.bind(function() {
    this.initialized = !0;
  }, this)).catch(d.bind(function(e) {
    this.reportError("Error initializing queue persistence. Disabling persistence", e), this.initialized = !0, this.usePersistence = !1;
  }, this));
};
bt.prototype.enqueue = function(e, r) {
  var n = {
    id: Xs(),
    flushAfter: (/* @__PURE__ */ new Date()).getTime() + r * 2,
    payload: e
  };
  return this.usePersistence ? this.enqueuePersisted(n) : (this.memQueue.push(n), oe.resolve(!0));
};
bt.prototype._enqueuePersisted = function(e) {
  var r = d.bind(function() {
    return this.ensureInit().then(d.bind(function() {
      return this.readFromStorage();
    }, this)).then(d.bind(function(n) {
      return this.saveToStorage(n.concat(e));
    }, this)).then(d.bind(function(n) {
      return n && (this.memQueue = this.memQueue.concat(e)), n;
    }, this)).catch(d.bind(function(n) {
      return this.reportError("Error enqueueing items", n, e), !1;
    }, this));
  }, this);
  return this.lock.withLock(r, this.pid).catch(d.bind(function(n) {
    return this.reportError("Error acquiring storage lock", n), !1;
  }, this));
};
bt.prototype.fillBatch = function(e) {
  var r = this.memQueue.slice(0, e);
  return this.usePersistence && r.length < e ? this.ensureInit().then(d.bind(function() {
    return this.readFromStorage();
  }, this)).then(d.bind(function(n) {
    if (n.length) {
      var t = {};
      d.each(r, function(s) {
        t[s.id] = !0;
      });
      for (var i = 0; i < n.length; i++) {
        var o = n[i];
        if ((/* @__PURE__ */ new Date()).getTime() > o.flushAfter && !t[o.id] && (o.orphaned = !0, r.push(o), r.length >= e))
          break;
      }
    }
    return r;
  }, this)) : oe.resolve(r);
};
var Du = function(e, r) {
  var n = [];
  return d.each(e, function(t) {
    t.id && !r[t.id] && n.push(t);
  }), n;
};
bt.prototype.removeItemsByID = function(e) {
  var r = {};
  if (d.each(e, function(t) {
    r[t] = !0;
  }), this.memQueue = Du(this.memQueue, r), this.usePersistence) {
    var n = d.bind(function() {
      return this.ensureInit().then(d.bind(function() {
        return this.readFromStorage();
      }, this)).then(d.bind(function(t) {
        return t = Du(t, r), this.saveToStorage(t);
      }, this)).then(d.bind(function() {
        return this.readFromStorage();
      }, this)).then(d.bind(function(t) {
        for (var i = 0; i < t.length; i++) {
          var o = t[i];
          if (o.id && r[o.id])
            throw new Error("Item not removed from storage");
        }
        return !0;
      }, this)).catch(d.bind(function(t) {
        return this.reportError("Error removing items", t, e), !1;
      }, this));
    }, this);
    return this.lock.withLock(n, this.pid).catch(d.bind(function(t) {
      return this.reportError("Error acquiring storage lock", t), mn(this.lock.storage, !0) ? !1 : n().then(d.bind(function(i) {
        return i || this.queueStorage.removeItem(this.storageKey).then(function() {
          return i;
        });
      }, this)).catch(d.bind(function(i) {
        return this.reportError("Error clearing queue", i), !1;
      }, this));
    }, this));
  } else
    return oe.resolve(!0);
};
var Lu = function(e, r) {
  var n = [];
  return d.each(e, function(t) {
    var i = t.id;
    if (i in r) {
      var o = r[i];
      o !== null && (t.payload = o, n.push(t));
    } else
      n.push(t);
  }), n;
};
bt.prototype.updatePayloads = function(e) {
  return this.memQueue = Lu(this.memQueue, e), this.usePersistence ? this.lock.withLock(d.bind(function() {
    return this.ensureInit().then(d.bind(function() {
      return this.readFromStorage();
    }, this)).then(d.bind(function(n) {
      return n = Lu(n, e), this.saveToStorage(n);
    }, this)).catch(d.bind(function(n) {
      return this.reportError("Error updating items", e, n), !1;
    }, this));
  }, this), this.pid).catch(d.bind(function(r) {
    return this.reportError("Error acquiring storage lock", r), !1;
  }, this)) : oe.resolve(!0);
};
bt.prototype.readFromStorage = function() {
  return this.ensureInit().then(d.bind(function() {
    return this.queueStorage.getItem(this.storageKey);
  }, this)).then(d.bind(function(e) {
    return e && (d.isArray(e) || (this.reportError("Invalid storage entry:", e), e = null)), e || [];
  }, this)).catch(d.bind(function(e) {
    return this.reportError("Error retrieving queue", e), [];
  }, this));
};
bt.prototype.saveToStorage = function(e) {
  return this.ensureInit().then(d.bind(function() {
    return this.queueStorage.setItem(this.storageKey, e);
  }, this)).then(function() {
    return !0;
  }).catch(d.bind(function(r) {
    return this.reportError("Error saving queue", r), !1;
  }, this));
};
bt.prototype.clear = function() {
  return this.memQueue = [], this.usePersistence ? this.ensureInit().then(d.bind(function() {
    return this.queueStorage.removeItem(this.storageKey);
  }, this)) : oe.resolve();
};
var o_ = 10 * 60 * 1e3, Qr = dr("batch"), et = function(e, r) {
  this.errorReporter = r.errorReporter, this.queue = new bt(e, {
    errorReporter: d.bind(this.reportError, this),
    queueStorage: r.queueStorage,
    sharedLockStorage: r.sharedLockStorage,
    sharedLockTimeoutMS: r.sharedLockTimeoutMS,
    usePersistence: r.usePersistence,
    enqueueThrottleMs: r.enqueueThrottleMs
  }), this.libConfig = r.libConfig, this.sendRequest = r.sendRequestFunc, this.beforeSendHook = r.beforeSendHook, this.stopAllBatching = r.stopAllBatchingFunc, this.batchSize = this.libConfig.batch_size, this.flushInterval = this.libConfig.batch_flush_interval_ms, this.stopped = !this.libConfig.batch_autostart, this.consecutiveRemovalFailures = 0, this.itemIdsSentSuccessfully = {}, this.flushOnlyOnInterval = r.flushOnlyOnInterval || !1, this._flushPromise = null;
};
et.prototype.enqueue = function(e) {
  return this.queue.enqueue(e, this.flushInterval);
};
et.prototype.start = function() {
  return this.stopped = !1, this.consecutiveRemovalFailures = 0, this.flush();
};
et.prototype.stop = function() {
  this.stopped = !0, this.timeoutID && (clearTimeout(this.timeoutID), this.timeoutID = null);
};
et.prototype.clear = function() {
  return this.queue.clear();
};
et.prototype.resetBatchSize = function() {
  this.batchSize = this.libConfig.batch_size;
};
et.prototype.resetFlush = function() {
  this.scheduleFlush(this.libConfig.batch_flush_interval_ms);
};
et.prototype.scheduleFlush = function(e) {
  this.flushInterval = e, this.stopped || (this.timeoutID = setTimeout(d.bind(function() {
    this.stopped || (this._flushPromise = this.flush());
  }, this), this.flushInterval));
};
et.prototype.sendRequestPromise = function(e, r) {
  return new oe(d.bind(function(n) {
    this.sendRequest(e, r, n);
  }, this));
};
et.prototype.flush = function(e) {
  if (this.requestInProgress)
    return Qr.log("Flush: Request already in progress"), oe.resolve();
  this.requestInProgress = !0, e = e || {};
  var r = this.libConfig.batch_request_timeout_ms, n = (/* @__PURE__ */ new Date()).getTime(), t = this.batchSize;
  return this.queue.fillBatch(t).then(d.bind(function(i) {
    var o = i.length === t, s = [], a = {};
    if (d.each(i, function(h) {
      var m = h.payload;
      if (this.beforeSendHook && !h.orphaned && (m = this.beforeSendHook(m)), m) {
        m.event && m.properties && (m.properties = d.extend(
          {},
          m.properties,
          { mp_sent_by_lib_version: st.LIB_VERSION }
        ));
        var v = !0, y = h.id;
        y ? (this.itemIdsSentSuccessfully[y] || 0) > 5 && (this.reportError("[dupe] item ID sent too many times, not sending", {
          item: h,
          batchSize: i.length,
          timesSent: this.itemIdsSentSuccessfully[y]
        }), v = !1) : this.reportError("[dupe] found item with no ID", { item: h }), v && s.push(m);
      }
      a[h.id] = m;
    }, this), s.length < 1)
      return this.requestInProgress = !1, this.resetFlush(), oe.resolve();
    var u = d.bind(function() {
      return this.queue.removeItemsByID(
        d.map(i, function(h) {
          return h.id;
        })
      ).then(d.bind(function(h) {
        return d.each(i, d.bind(function(m) {
          var v = m.id;
          v ? (this.itemIdsSentSuccessfully[v] = this.itemIdsSentSuccessfully[v] || 0, this.itemIdsSentSuccessfully[v]++, this.itemIdsSentSuccessfully[v] > 5 && this.reportError("[dupe] item ID sent too many times", {
            item: m,
            batchSize: i.length,
            timesSent: this.itemIdsSentSuccessfully[v]
          })) : this.reportError("[dupe] found item with no ID while removing", { item: m });
        }, this)), h ? (this.consecutiveRemovalFailures = 0, this.flushOnlyOnInterval && !o ? (this.resetFlush(), oe.resolve()) : this.flush()) : (++this.consecutiveRemovalFailures > 5 ? (this.reportError("Too many queue failures; disabling batching system."), this.stopAllBatching()) : this.resetFlush(), oe.resolve());
      }, this));
    }, this), l = d.bind(function(h) {
      this.requestInProgress = !1;
      try {
        if (e.unloading)
          return this.queue.updatePayloads(a);
        if (d.isObject(h) && h.error === "timeout" && (/* @__PURE__ */ new Date()).getTime() - n >= r)
          return this.reportError("Network timeout; retrying"), this.flush();
        if (d.isObject(h) && (h.httpStatusCode >= 500 || h.httpStatusCode === 429 || h.httpStatusCode <= 0 && !Hy() || h.error === "timeout")) {
          var m = this.flushInterval * 2;
          return h.retryAfter && (m = parseInt(h.retryAfter, 10) * 1e3 || m), m = Math.min(o_, m), this.reportError("Error; retry in " + m + " ms"), this.scheduleFlush(m), oe.resolve();
        } else if (d.isObject(h) && h.httpStatusCode === 413)
          if (i.length > 1) {
            var v = Math.max(1, Math.floor(t / 2));
            return this.batchSize = Math.min(this.batchSize, v, i.length - 1), this.reportError("413 response; reducing batch size to " + this.batchSize), this.resetFlush(), oe.resolve();
          } else
            return this.reportError("Single-event request too large; dropping", i), this.resetBatchSize(), u();
        else
          return u();
      } catch (y) {
        this.reportError("Error handling API response", y), this.resetFlush();
      }
    }, this), c = {
      method: "POST",
      verbose: !0,
      ignore_json_errors: !0,
      // eslint-disable-line camelcase
      timeout_ms: r
      // eslint-disable-line camelcase
    };
    return e.unloading && (c.transport = "sendBeacon"), Qr.log("MIXPANEL REQUEST:", s), this.sendRequestPromise(s, c).then(l);
  }, this)).catch(d.bind(function(i) {
    this.reportError("Error flushing request queue", i), this.resetFlush();
  }, this));
};
et.prototype.reportError = function(e, r) {
  if (Qr.error.apply(Qr.error, arguments), this.errorReporter)
    try {
      r instanceof Error || (r = new Error(e)), this.errorReporter(e, r);
    } catch (n) {
      Qr.error(n);
    }
};
var na = function(e) {
  var r = Date.now();
  return !e || r > e.maxExpires || r > e.idleExpires;
}, s_ = 250, kr = dr("recorder"), Bu = $.CompressionStream, a_ = {
  batch_size: 1e3,
  batch_flush_interval_ms: 10 * 1e3,
  batch_request_timeout_ms: 90 * 1e3,
  batch_autostart: !0
}, u_ = /* @__PURE__ */ new Set([
  q.MouseMove,
  q.MouseInteraction,
  q.Scroll,
  q.ViewportResize,
  q.Input,
  q.TouchMove,
  q.MediaInteraction,
  q.Drag,
  q.Selection
]);
function c_(e) {
  return e.type === K.IncrementalSnapshot && u_.has(e.data.source);
}
var Ae = function(e) {
  this._mixpanel = e.mixpanelInstance, this._onIdleTimeout = e.onIdleTimeout || Gt, this._onMaxLengthReached = e.onMaxLengthReached || Gt, this._onBatchSent = e.onBatchSent || Gt, this._rrwebRecord = e.rrwebRecord || null, this._stopRecording = null, this.replayId = e.replayId, this.batchStartUrl = e.batchStartUrl || null, this.replayStartUrl = e.replayStartUrl || null, this.idleExpires = e.idleExpires || null, this.maxExpires = e.maxExpires || null, this.replayStartTime = e.replayStartTime || null, this.seqNo = e.seqNo || 0, this.idleTimeoutId = null, this.maxTimeoutId = null, this.recordMaxMs = Xr, this.recordMinMs = 0;
  var r = mn(e.sharedLockStorage, !0);
  this.batcherKey = "__mprec_" + this.getConfig("name") + "_" + this.getConfig("token") + "_" + this.replayId, this.queueStorage = new wt(_f), this.batcher = new et(this.batcherKey, {
    errorReporter: this.reportError.bind(this),
    flushOnlyOnInterval: !0,
    libConfig: a_,
    sendRequestFunc: this.flushEventsWithOptOut.bind(this),
    queueStorage: this.queueStorage,
    sharedLockStorage: e.sharedLockStorage,
    usePersistence: r,
    stopAllBatchingFunc: this.stopRecording.bind(this),
    // increased throttle and shared lock timeout because recording events are very high frequency.
    // this will minimize the amount of lock contention between enqueued events.
    // for session recordings there is a lock for each tab anyway, so there's no risk of deadlock between tabs.
    enqueueThrottleMs: s_,
    sharedLockTimeoutMS: 10 * 1e3
  });
};
Ae.prototype.getUserIdInfo = function() {
  if (this.finalFlushUserIdInfo)
    return this.finalFlushUserIdInfo;
  var e = {
    distinct_id: String(this._mixpanel.get_distinct_id())
  }, r = this._mixpanel.get_property("$device_id");
  r && (e.$device_id = r);
  var n = this._mixpanel.get_property("$user_id");
  return n && (e.$user_id = n), e;
};
Ae.prototype.unloadPersistedData = function() {
  return this.batcher.stop(), this.batcher.flush().then((function() {
    return this.queueStorage.removeItem(this.batcherKey);
  }).bind(this));
};
Ae.prototype.getConfig = function(e) {
  return this._mixpanel.get_config(e);
};
Ae.prototype.get_config = function(e) {
  return this.getConfig(e);
};
Ae.prototype.startRecording = function(e) {
  if (this._rrwebRecord === null) {
    this.reportError("rrweb record function not provided. ");
    return;
  }
  if (this._stopRecording !== null) {
    kr.log("Recording already in progress, skipping startRecording.");
    return;
  }
  this.recordMaxMs = this.getConfig("record_max_ms"), this.recordMaxMs > Xr && (this.recordMaxMs = Xr, kr.critical("record_max_ms cannot be greater than " + Xr + "ms. Capping value.")), this.maxExpires || (this.maxExpires = (/* @__PURE__ */ new Date()).getTime() + this.recordMaxMs), this.recordMinMs = this.getConfig("record_min_ms"), this.recordMinMs > go && (this.recordMinMs = go, kr.critical("record_min_ms cannot be greater than " + go + "ms. Capping value.")), this.replayStartTime || (this.replayStartTime = (/* @__PURE__ */ new Date()).getTime(), this.batchStartUrl = d.info.currentUrl(), this.replayStartUrl = d.info.currentUrl()), e || this.recordMinMs > 0 ? this.batcher.stop() : this.batcher.start();
  var r = (function() {
    clearTimeout(this.idleTimeoutId);
    var i = this.getConfig("record_idle_timeout_ms");
    this.idleTimeoutId = setTimeout(this._onIdleTimeout, i), this.idleExpires = (/* @__PURE__ */ new Date()).getTime() + i;
  }).bind(this);
  r();
  var n = this.getConfig("record_block_selector");
  (n === "" || n === null) && (n = void 0);
  try {
    this._stopRecording = this._rrwebRecord({
      emit: (function(i) {
        if (this.idleExpires && this.idleExpires < i.timestamp) {
          this._onIdleTimeout();
          return;
        }
        c_(i) && (this.batcher.stopped && (/* @__PURE__ */ new Date()).getTime() - this.replayStartTime >= this.recordMinMs && this.batcher.start(), r()), this.__enqueuePromise = this.batcher.enqueue(i);
      }).bind(this),
      blockClass: this.getConfig("record_block_class"),
      blockSelector: n,
      collectFonts: this.getConfig("record_collect_fonts"),
      dataURLOptions: {
        // canvas image options (https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataURL)
        type: "image/webp",
        quality: 0.6
      },
      maskAllInputs: !0,
      maskTextClass: this.getConfig("record_mask_text_class"),
      maskTextSelector: this.getConfig("record_mask_text_selector"),
      recordCanvas: this.getConfig("record_canvas"),
      sampling: {
        canvas: 15
      }
    });
  } catch (i) {
    this.reportError("Unexpected error when starting rrweb recording.", i);
  }
  if (typeof this._stopRecording != "function") {
    this.reportError("rrweb failed to start, skipping this recording."), this._stopRecording = null, this.stopRecording();
    return;
  }
  var t = this.maxExpires - (/* @__PURE__ */ new Date()).getTime();
  this.maxTimeoutId = setTimeout(this._onMaxLengthReached.bind(this), t);
};
Ae.prototype.stopRecording = function(e) {
  if (this.finalFlushUserIdInfo = this.getUserIdInfo(), !this.isRrwebStopped()) {
    try {
      this._stopRecording();
    } catch (n) {
      this.reportError("Error with rrweb stopRecording", n);
    }
    this._stopRecording = null;
  }
  var r;
  return this.batcher.stopped ? r = this.batcher.clear() : e || (r = this.batcher.flush()), this.batcher.stop(), clearTimeout(this.idleTimeoutId), clearTimeout(this.maxTimeoutId), r;
};
Ae.prototype.isRrwebStopped = function() {
  return this._stopRecording === null;
};
Ae.prototype.flushEventsWithOptOut = function(e, r, n) {
  var t = (function(i) {
    i === 0 && (this.stopRecording(), n({ error: "Tracking has been opted out, stopping recording." }));
  }).bind(this);
  this._flushEvents(e, r, n, t);
};
Ae.prototype.serialize = function() {
  var e;
  try {
    e = this._mixpanel.get_tab_id();
  } catch (r) {
    this.reportError("Error getting tab ID for serialization ", r), e = null;
  }
  return {
    replayId: this.replayId,
    seqNo: this.seqNo,
    replayStartTime: this.replayStartTime,
    batchStartUrl: this.batchStartUrl,
    replayStartUrl: this.replayStartUrl,
    idleExpires: this.idleExpires,
    maxExpires: this.maxExpires,
    tabId: e
  };
};
Ae.deserialize = function(e, r) {
  var n = new Ae(d.extend({}, r, {
    replayId: e.replayId,
    batchStartUrl: e.batchStartUrl,
    replayStartUrl: e.replayStartUrl,
    idleExpires: e.idleExpires,
    maxExpires: e.maxExpires,
    replayStartTime: e.replayStartTime,
    seqNo: e.seqNo,
    sharedLockStorage: r.sharedLockStorage
  }));
  return n;
};
Ae.prototype._sendRequest = function(e, r, n, t) {
  var i = (function(s, a) {
    s.status === 200 && this.replayId === e && (this.seqNo++, this.batchStartUrl = d.info.currentUrl()), this._onBatchSent(), t({
      status: 0,
      httpStatusCode: s.status,
      responseBody: a,
      retryAfter: s.headers.get("Retry-After")
    });
  }).bind(this), o = this._mixpanel.get_api_host && this._mixpanel.get_api_host("record") || this.getConfig("api_host");
  $.fetch(o + "/" + this.getConfig("api_routes").record + "?" + new URLSearchParams(r), {
    method: "POST",
    headers: {
      Authorization: "Basic " + btoa(this.getConfig("token") + ":"),
      "Content-Type": "application/octet-stream"
    },
    body: n
  }).then(function(s) {
    s.json().then(function(a) {
      i(s, a);
    }).catch(function(a) {
      t({ error: a });
    });
  }).catch(function(s) {
    t({ error: s, httpStatusCode: 0 });
  });
};
Ae.prototype._flushEvents = tr(function(e, r, n) {
  var t = e.length;
  if (t > 0) {
    for (var i = this.replayId, o = 1 / 0, s = -1 / 0, a = !1, u = 0; u < t; u++)
      o = Math.min(o, e[u].timestamp), s = Math.max(s, e[u].timestamp), e[u].type === K.FullSnapshot && (a = !0);
    if (this.seqNo === 0) {
      if (!a) {
        n({ error: "First batch does not contain a full snapshot. Aborting recording." }), this.stopRecording(!0);
        return;
      }
      this.replayStartTime = o;
    } else this.replayStartTime || (this.reportError("Replay start time not set but seqNo is not 0. Using current batch start time as a fallback."), this.replayStartTime = o);
    var l = s - this.replayStartTime, c = {
      $current_url: this.batchStartUrl,
      $lib_version: st.LIB_VERSION,
      batch_start_time: o / 1e3,
      mp_lib: "web",
      replay_id: i,
      replay_length_ms: l,
      replay_start_time: this.replayStartTime / 1e3,
      replay_start_url: this.replayStartUrl,
      seq: this.seqNo
    }, h = JSON.stringify(e);
    if (Object.assign(c, this.getUserIdInfo()), Bu) {
      var m = new Blob([h], { type: "application/json" }).stream(), v = m.pipeThrough(new Bu("gzip"));
      new Response(v).blob().then((function(y) {
        c.format = "gzip", this._sendRequest(i, c, y, n);
      }).bind(this));
    } else
      c.format = "body", this._sendRequest(i, c, h, n);
  }
});
Ae.prototype.reportError = function(e, r) {
  kr.error.apply(kr.error, arguments);
  try {
    !r && !(e instanceof Error) && (e = new Error(e)), this.getConfig("error_reporter")(e, r);
  } catch (n) {
    kr.error(n);
  }
};
var qr = function(e) {
  this.idb = new wt(Qs), this.errorReporter = e.errorReporter, this.mixpanelInstance = e.mixpanelInstance, this.sharedLockStorage = e.sharedLockStorage;
};
qr.prototype.handleError = function(e) {
  this.errorReporter("IndexedDB error: ", e);
};
qr.prototype.setActiveRecording = function(e) {
  var r = e.tabId;
  return r ? this.idb.init().then((function() {
    return this.idb.setItem(r, e);
  }).bind(this)).catch(this.handleError.bind(this)) : (console.warn("No tab ID is set, cannot persist recording metadata."), oe.resolve());
};
qr.prototype.getActiveRecording = function() {
  return this.idb.init().then((function() {
    return this.idb.getItem(this.mixpanelInstance.get_tab_id());
  }).bind(this)).then((function(e) {
    return na(e) ? null : e;
  }).bind(this)).catch(this.handleError.bind(this));
};
qr.prototype.clearActiveRecording = function() {
  return this.getActiveRecording().then((function(e) {
    if (e)
      return e.maxExpires = 0, this.setActiveRecording(e);
  }).bind(this)).catch(this.handleError.bind(this));
};
qr.prototype.flushInactiveRecordings = function() {
  return this.idb.init().then((function() {
    return this.idb.getAll();
  }).bind(this)).then((function(e) {
    var r = e.filter(function(n) {
      return na(n);
    }).map((function(n) {
      var t = Ae.deserialize(n, {
        mixpanelInstance: this.mixpanelInstance,
        sharedLockStorage: this.sharedLockStorage
      });
      return t.unloadPersistedData().then((function() {
        return this.idb.removeItem(n.tabId);
      }).bind(this)).catch(this.handleError.bind(this));
    }).bind(this));
    return oe.all(r);
  }).bind(this)).catch(this.handleError.bind(this));
};
var en = dr("recorder"), Pt = function(e, r, n) {
  this.mixpanelInstance = e, this.rrwebRecord = r || Qt, this.sharedLockStorage = n, this.recordingRegistry = new qr({
    mixpanelInstance: this.mixpanelInstance,
    errorReporter: en.error,
    sharedLockStorage: n
  }), this._flushInactivePromise = this.recordingRegistry.flushInactiveRecordings(), this.activeRecording = null, this.stopRecordingInProgress = !1;
};
Pt.prototype.startRecording = function(e) {
  if (e = e || {}, this.activeRecording && !this.activeRecording.isRrwebStopped()) {
    en.log("Recording already in progress, skipping startRecording.");
    return;
  }
  var r = (function() {
    en.log("Idle timeout reached, restarting recording."), this.resetRecording();
  }).bind(this), n = (function() {
    en.log("Max recording length reached, stopping recording."), this.resetRecording();
  }).bind(this), t = (function() {
    this.recordingRegistry.setActiveRecording(this.activeRecording.serialize()), this.__flushPromise = this.activeRecording.batcher._flushPromise;
  }).bind(this), i = {
    mixpanelInstance: this.mixpanelInstance,
    onBatchSent: t,
    onIdleTimeout: r,
    onMaxLengthReached: n,
    replayId: d.UUID(),
    rrwebRecord: this.rrwebRecord,
    sharedLockStorage: this.sharedLockStorage
  };
  return e.activeSerializedRecording ? this.activeRecording = Ae.deserialize(e.activeSerializedRecording, i) : this.activeRecording = new Ae(i), this.activeRecording.startRecording(e.shouldStopBatcher), this.recordingRegistry.setActiveRecording(this.activeRecording.serialize());
};
Pt.prototype.stopRecording = function() {
  return this.stopRecordingInProgress = !0, this._stopCurrentRecording(!1, !0).then((function() {
    return this.recordingRegistry.clearActiveRecording();
  }).bind(this)).then((function() {
    this.stopRecordingInProgress = !1;
  }).bind(this));
};
Pt.prototype.pauseRecording = function() {
  return this._stopCurrentRecording(!1);
};
Pt.prototype._stopCurrentRecording = function(e, r) {
  if (this.activeRecording) {
    var n = this.activeRecording.stopRecording(e);
    return r && (this.activeRecording = null), n;
  }
  return oe.resolve();
};
Pt.prototype.resumeRecording = function(e) {
  return this.activeRecording && this.activeRecording.isRrwebStopped() ? (this.activeRecording.startRecording(!1), oe.resolve(null)) : this.recordingRegistry.getActiveRecording().then((function(r) {
    return r && !this.stopRecordingInProgress ? this.startRecording({ activeSerializedRecording: r }) : e ? this.startRecording({ shouldStopBatcher: !1 }) : (en.log("No resumable recording found."), null);
  }).bind(this));
};
Pt.prototype.resetRecording = function() {
  this.stopRecording(), this.startRecording({ shouldStopBatcher: !0 });
};
Pt.prototype.getActiveReplayId = function() {
  return this.activeRecording && !this.activeRecording.isRrwebStopped() ? this.activeRecording.replayId : null;
};
Object.defineProperty(Pt.prototype, "replayId", {
  get: function() {
    return this.getActiveReplayId();
  }
});
$.__mp_recorder = Pt;
var Oi = "change", gn = "click", Uu = "hashchange", _r = "mp_locationchange", zu = "popstate", qu = "scrollend", hs = "submit", l_ = [
  "clientX",
  "clientY",
  "offsetX",
  "offsetY",
  "pageX",
  "pageY",
  "screenX",
  "screenY",
  "x",
  "y"
], ju = ["mp-include"], ps = ["mp-no-track"], Wu = ps.concat(["mp-sensitive"]), f_ = [
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "href",
  "name",
  "role",
  "title",
  "type"
], Ge = dr("autocapture");
function ds(e) {
  for (var r = {}, n = xf(e).split(" "), t = 0; t < n.length; t++) {
    var i = n[t];
    i && (r[i] = !0);
  }
  return r;
}
function xf(e) {
  switch (typeof e.className) {
    case "string":
      return e.className;
    case "object":
      return e.className.baseVal || e.getAttribute("class") || "";
    default:
      return "";
  }
}
function h_(e) {
  if (e.previousElementSibling)
    return e.previousElementSibling;
  do
    e = e.previousSibling;
  while (e && !If(e));
  return e;
}
function Gu(e, r, n, t, i, o) {
  var s = {
    $classes: xf(e).split(" "),
    $tag_name: e.tagName.toLowerCase()
  }, a = e.id;
  a && (s.$id = a), ia(e, r, i, o) && d.each(f_.concat(t), function(h) {
    if (e.hasAttribute(h) && !n[h]) {
      var m = e.getAttribute(h);
      ki(m) && (s["$attr-" + h] = m);
    }
  });
  for (var u = 1, l = 1, c = e; c = h_(c); )
    u++, c.tagName === e.tagName && l++;
  return s.$nth_child = u, s.$nth_of_type = l, s;
}
function p_(e, r) {
  var n = r.allowElementCallback, t = r.allowSelectors || [], i = r.blockAttrs || [], o = r.blockElementCallback, s = r.blockSelectors || [], a = r.captureTextContent || !1, u = r.captureExtraAttrs || [], l = r.capturedForHeatMap || !1, c = {};
  d.each(i, function(A) {
    c[A] = !0;
  });
  var h = null, m = typeof e.target > "u" ? e.srcElement : e.target;
  if (Ef(m) && (m = m.parentNode), g_(m, e) && ms(m, e, n, t) && !bo(m, e, o, s)) {
    for (var v = [m], y = m; y.parentNode && !yt(y, "body"); )
      v.push(y.parentNode), y = y.parentNode;
    var S = [], _, b = !1;
    if (d.each(v, function(A) {
      var M = ia(A, e, n, t);
      !c.href && A.tagName.toLowerCase() === "a" && (_ = A.getAttribute("href"), _ = M && ki(_) && _), bo(A, e, o, s) && (b = !0), S.push(Gu(A, e, c, u, n, t));
    }, this), !b) {
      var C = ne.documentElement;
      if (h = {
        $event_type: e.type,
        $host: $.location.host,
        $pathname: $.location.pathname,
        $elements: S,
        $el_attr__href: _,
        $viewportHeight: Math.max(C.clientHeight, $.innerHeight || 0),
        $viewportWidth: Math.max(C.clientWidth, $.innerWidth || 0),
        $pageHeight: ne.body.offsetHeight || 0,
        $pageWidth: ne.body.offsetWidth || 0
      }, d.each(u, function(A) {
        if (!c[A] && m.hasAttribute(A)) {
          var M = m.getAttribute(A);
          ki(M) && (h["$el_attr__" + A] = M);
        }
      }), a && (E = Vu(m, e, n, t), E && E.length && (h.$el_text = E)), e.type === gn && (d.each(l_, function(A) {
        A in e && (h["$" + A] = e[A]);
      }), l && (h.$captured_for_heatmap = !0), m = d_(e)), a) {
        var E = Vu(m, e, n, t);
        E && E.length && (h.$el_text = E);
      }
      if (m) {
        if (!ms(m, e, n, t) || bo(m, e, o, s))
          return null;
        var R = Gu(m, e, c, u, n, t);
        h.$target = R, h.$el_classes = R.$classes, d.extend(h, d.strip_empty_properties({
          $el_id: R.$id,
          $el_tag_name: R.$tag_name
        }));
      }
    }
  }
  return h;
}
function Vu(e, r, n, t) {
  var i = "";
  return ia(e, r, n, t) && e.childNodes && e.childNodes.length && d.each(e.childNodes, function(o) {
    Ef(o) && o.textContent && (i += d.trim(o.textContent).split(/(\s+)/).filter(ki).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255));
  }), d.trim(i);
}
function d_(e) {
  for (var r = e.target, n = e.composedPath(), t = 0; t < n.length; t++) {
    var i = n[t];
    if (yt(i, "a") || yt(i, "button") || yt(i, "input") || yt(i, "select") || i.getAttribute && i.getAttribute("role") === "button") {
      r = i;
      break;
    }
    if (i === r)
      break;
  }
  return r;
}
function ms(e, r, n, t) {
  if (n)
    try {
      if (!n(e, r))
        return !1;
    } catch (s) {
      return Ge.critical("Error while checking element in allowElementCallback", s), !1;
    }
  if (!t.length)
    return !0;
  for (var i = 0; i < t.length; i++) {
    var o = t[i];
    try {
      if (e.matches(o))
        return !0;
    } catch (s) {
      Ge.critical("Error while checking selector: " + o, s);
    }
  }
  return !1;
}
function bo(e, r, n, t) {
  var i;
  if (n)
    try {
      if (n(e, r))
        return !0;
    } catch (a) {
      return Ge.critical("Error while checking element in blockElementCallback", a), !0;
    }
  if (t && t.length)
    for (i = 0; i < t.length; i++) {
      var o = t[i];
      try {
        if (e.matches(o))
          return !0;
      } catch (a) {
        Ge.critical("Error while checking selector: " + o, a);
      }
    }
  var s = ds(e);
  for (i = 0; i < ps.length; i++)
    if (s[ps[i]])
      return !0;
  return !1;
}
function If(e) {
  return e && e.nodeType === 1;
}
function yt(e, r) {
  return e && e.tagName && e.tagName.toLowerCase() === r.toLowerCase();
}
function Ef(e) {
  return e && e.nodeType === 3;
}
function m_() {
  try {
    var e = ne.createElement("div");
    return !!e.matches;
  } catch {
    return !1;
  }
}
function g_(e, r) {
  if (!e || yt(e, "html") || !If(e))
    return !1;
  var n = e.tagName.toLowerCase();
  switch (n) {
    case "form":
      return r.type === hs;
    case "input":
      return ["button", "submit"].indexOf(e.getAttribute("type")) === -1 ? r.type === Oi : r.type === gn;
    case "select":
    case "textarea":
      return r.type === Oi;
    default:
      return r.type === gn;
  }
}
function ia(e, r, n, t) {
  var i;
  if (!ms(e, r, n, t))
    return !1;
  for (var o = e; o.parentNode && !yt(o, "body"); o = o.parentNode) {
    var s = ds(o);
    for (i = 0; i < Wu.length; i++)
      if (s[Wu[i]])
        return !1;
  }
  var a = ds(e);
  for (i = 0; i < ju.length; i++)
    if (a[ju[i]])
      return !0;
  if (yt(e, "input") || yt(e, "select") || yt(e, "textarea") || e.getAttribute("contenteditable") === "true")
    return !1;
  var u = e.type || "";
  if (typeof u == "string")
    switch (u.toLowerCase()) {
      case "hidden":
        return !1;
      case "password":
        return !1;
    }
  var l = e.name || e.id || "";
  if (typeof l == "string") {
    var c = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
    if (c.test(l.replace(/[^a-zA-Z0-9]/g, "")))
      return !1;
  }
  return !0;
}
function ki(e) {
  if (e === null || d.isUndefined(e))
    return !1;
  if (typeof e == "string") {
    e = d.trim(e);
    var r = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (r.test((e || "").replace(/[- ]/g, "")))
      return !1;
    var n = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (n.test(e))
      return !1;
  }
  return !0;
}
var Of = "autocapture", v_ = "track_pageview", kf = "full-url", y_ = "url-with-path-and-query-string", __ = "url-with-path", w_ = "allow_element_callback", Af = "allow_selectors", Rf = "allow_url_regexes", Tf = "block_attrs", Mf = "block_element_callback", Ff = "block_selectors", $f = "block_url_regexes", Nf = "capture_extra_attrs", Pf = "capture_text_content", Df = "scroll_capture_all", Lf = "scroll_depth_percent_checkpoints", Ai = "click", gs = "input", Bf = "pageview", vs = "scroll", ys = "submit", Re = {};
Re[Af] = [];
Re[Rf] = [];
Re[Tf] = [];
Re[Mf] = null;
Re[Ff] = [];
Re[$f] = [];
Re[Nf] = [];
Re[Pf] = !1;
Re[Df] = !1;
Re[Lf] = [25, 50, 75, 100];
Re[Ai] = !0;
Re[gs] = !0;
Re[Bf] = kf;
Re[vs] = !0;
Re[ys] = !0;
var Ri = {
  $mp_autocapture: !0
}, Uf = "$mp_click", b_ = "$mp_input_change", S_ = "$mp_scroll", C_ = "$mp_submit", He = function(e) {
  this.mp = e;
};
He.prototype.init = function() {
  if (!m_()) {
    Ge.critical("Autocapture unavailable: missing required DOM APIs");
    return;
  }
  this.initPageviewTracking(), this.initClickTracking(), this.initInputTracking(), this.initScrollTracking(), this.initSubmitTracking();
};
He.prototype.getFullConfig = function() {
  var e = this.mp.get_config(Of);
  return e ? d.isObject(e) ? d.extend({}, Re, e) : Re : {};
};
He.prototype.getConfig = function(e) {
  return this.getFullConfig()[e];
};
He.prototype.currentUrlBlocked = function() {
  var e, r = d.info.currentUrl(), n = this.getConfig(Rf) || [];
  if (n.length) {
    var t = !1;
    for (e = 0; e < n.length; e++) {
      var i = n[e];
      try {
        if (r.match(i)) {
          t = !0;
          break;
        }
      } catch (s) {
        return Ge.critical("Error while checking block URL regex: " + i, s), !0;
      }
    }
    if (!t)
      return !0;
  }
  var o = this.getConfig($f) || [];
  if (!o || !o.length)
    return !1;
  for (e = 0; e < o.length; e++)
    try {
      if (r.match(o[e]))
        return !0;
    } catch (s) {
      return Ge.critical("Error while checking block URL regex: " + o[e], s), !0;
    }
  return !1;
};
He.prototype.pageviewTrackingConfig = function() {
  return this.mp.get_config(Of) ? this.getConfig(Bf) : this.mp.get_config(v_);
};
He.prototype.trackDomEvent = function(e, r) {
  if (!this.currentUrlBlocked()) {
    var n = p_(e, {
      allowElementCallback: this.getConfig(w_),
      allowSelectors: this.getConfig(Af),
      blockAttrs: this.getConfig(Tf),
      blockElementCallback: this.getConfig(Mf),
      blockSelectors: this.getConfig(Ff),
      captureExtraAttrs: this.getConfig(Nf),
      captureTextContent: this.getConfig(Pf),
      capturedForHeatMap: r === Uf && !this.getConfig(Ai) && this.mp.is_recording_heatmap_data()
    });
    n && (d.extend(n, Ri), this.mp.track(r, n));
  }
};
He.prototype.initClickTracking = function() {
  $.removeEventListener(gn, this.listenerClick), !(!this.getConfig(Ai) && !this.mp.get_config("record_heatmap_data")) && (Ge.log("Initializing click tracking"), this.listenerClick = $.addEventListener(gn, (function(e) {
    !this.getConfig(Ai) && !this.mp.is_recording_heatmap_data() || this.trackDomEvent(e, Uf);
  }).bind(this)));
};
He.prototype.initInputTracking = function() {
  $.removeEventListener(Oi, this.listenerChange), this.getConfig(gs) && (Ge.log("Initializing input tracking"), this.listenerChange = $.addEventListener(Oi, (function(e) {
    this.getConfig(gs) && this.trackDomEvent(e, b_);
  }).bind(this)));
};
He.prototype.initPageviewTracking = function() {
  if ($.removeEventListener(zu, this.listenerPopstate), $.removeEventListener(Uu, this.listenerHashchange), $.removeEventListener(_r, this.listenerLocationchange), !!this.pageviewTrackingConfig()) {
    Ge.log("Initializing pageview tracking");
    var e = "", r = !1;
    this.currentUrlBlocked() || (r = this.mp.track_pageview(Ri)), r && (e = d.info.currentUrl()), this.listenerPopstate = $.addEventListener(zu, function() {
      $.dispatchEvent(new Event(_r));
    }), this.listenerHashchange = $.addEventListener(Uu, function() {
      $.dispatchEvent(new Event(_r));
    });
    var n = $.history.pushState;
    typeof n == "function" && ($.history.pushState = function(i, o, s) {
      n.call($.history, i, o, s), $.dispatchEvent(new Event(_r));
    });
    var t = $.history.replaceState;
    typeof t == "function" && ($.history.replaceState = function(i, o, s) {
      t.call($.history, i, o, s), $.dispatchEvent(new Event(_r));
    }), this.listenerLocationchange = $.addEventListener(_r, Js((function() {
      if (!this.currentUrlBlocked()) {
        var i = d.info.currentUrl(), o = !1, s = i.split("#")[0].split("?")[0] !== e.split("#")[0].split("?")[0], a = this.pageviewTrackingConfig();
        if (a === kf ? o = i !== e : a === y_ ? o = i.split("#")[0] !== e.split("#")[0] : a === __ && (o = s), o) {
          var u = this.mp.track_pageview(Ri);
          u && (e = i), s && (this.lastScrollCheckpoint = 0, Ge.log("Path change: re-initializing scroll depth checkpoints"));
        }
      }
    }).bind(this)));
  }
};
He.prototype.initScrollTracking = function() {
  $.removeEventListener(qu, this.listenerScroll), this.getConfig(vs) && (Ge.log("Initializing scroll tracking"), this.lastScrollCheckpoint = 0, this.listenerScroll = $.addEventListener(qu, Js((function() {
    if (this.getConfig(vs) && !this.currentUrlBlocked()) {
      var e = this.getConfig(Df), r = (this.getConfig(Lf) || []).slice().sort(function(u, l) {
        return u - l;
      }), n = $.scrollY, t = d.extend({ $scroll_top: n }, Ri);
      try {
        var i = ne.body.scrollHeight, o = Math.round(n / (i - $.innerHeight) * 100);
        if (t.$scroll_height = i, t.$scroll_percentage = o, o > this.lastScrollCheckpoint)
          for (var s = 0; s < r.length; s++) {
            var a = r[s];
            o >= a && this.lastScrollCheckpoint < a && (t.$scroll_checkpoint = a, this.lastScrollCheckpoint = a, e = !0);
          }
      } catch (u) {
        Ge.critical("Error while calculating scroll percentage", u);
      }
      e && this.mp.track(S_, t);
    }
  }).bind(this))));
};
He.prototype.initSubmitTracking = function() {
  $.removeEventListener(hs, this.listenerSubmit), this.getConfig(ys) && (Ge.log("Initializing submit tracking"), this.listenerSubmit = $.addEventListener(hs, (function(e) {
    this.getConfig(ys) && this.trackDomEvent(e, C_);
  }).bind(this)));
};
gf(He);
var x_ = $.fetch, je = dr("flags"), zf = "flags", qf = "context", _s = {};
_s[qf] = {};
var ee = function(e) {
  this.getFullApiRoute = e.getFullApiRoute, this.getMpConfig = e.getConfigFunc, this.getMpProperty = e.getPropertyFunc, this.track = e.trackingFunc;
};
ee.prototype.init = function() {
  if (!I_()) {
    je.critical("Feature Flags unavailable: missing minimum required APIs");
    return;
  }
  this.flags = null, this.fetchFlags(), this.trackedFeatures = /* @__PURE__ */ new Set();
};
ee.prototype.getFullConfig = function() {
  var e = this.getMpConfig(zf);
  return e ? d.isObject(e) ? d.extend({}, _s, e) : _s : {};
};
ee.prototype.getConfig = function(e) {
  return this.getFullConfig()[e];
};
ee.prototype.isSystemEnabled = function() {
  return !!this.getMpConfig(zf);
};
ee.prototype.areFlagsReady = function() {
  return this.isSystemEnabled() || je.error("Feature Flags not enabled"), !!this.flags;
};
ee.prototype.fetchFlags = function() {
  if (this.isSystemEnabled()) {
    var e = this.getMpProperty("distinct_id"), r = this.getMpProperty("$device_id");
    je.log("Fetching flags for distinct ID: " + e);
    var n = {
      context: d.extend({ distinct_id: e, device_id: r }, this.getConfig(qf))
    };
    this._fetchInProgressStartTime = Date.now(), this.fetchPromise = $.fetch(this.getFullApiRoute(), {
      method: "POST",
      headers: {
        Authorization: "Basic " + btoa(this.getMpConfig("token") + ":"),
        "Content-Type": "application/octet-stream"
      },
      body: JSON.stringify(n)
    }).then((function(t) {
      return this.markFetchComplete(), t.json().then((function(i) {
        var o = i.flags;
        if (!o)
          throw new Error("No flags in API response");
        var s = /* @__PURE__ */ new Map();
        d.each(o, function(a, u) {
          s.set(u, {
            key: a.variant_key,
            value: a.variant_value
          });
        }), this.flags = s;
      }).bind(this)).catch((function(i) {
        this.markFetchComplete(), je.error(i);
      }).bind(this));
    }).bind(this)).catch((function(t) {
      this.markFetchComplete(), je.error(t);
    }).bind(this));
  }
};
ee.prototype.markFetchComplete = function() {
  if (!this._fetchInProgressStartTime) {
    je.error("Fetch in progress started time not set, cannot mark fetch complete");
    return;
  }
  this._fetchStartTime = this._fetchInProgressStartTime, this._fetchCompleteTime = Date.now(), this._fetchLatency = this._fetchCompleteTime - this._fetchStartTime, this._fetchInProgressStartTime = null;
};
ee.prototype.getVariant = function(e, r) {
  return this.fetchPromise ? this.fetchPromise.then((function() {
    return this.getVariantSync(e, r);
  }).bind(this)).catch(function(n) {
    return je.error(n), r;
  }) : new Promise(function(n) {
    je.critical("Feature Flags not initialized"), n(r);
  });
};
ee.prototype.getVariantSync = function(e, r) {
  if (!this.areFlagsReady())
    return je.log("Flags not loaded yet"), r;
  var n = this.flags.get(e);
  return n ? (this.trackFeatureCheck(e, n), n) : (je.log('No flag found: "' + e + '"'), r);
};
ee.prototype.getVariantValue = function(e, r) {
  return this.getVariant(e, { value: r }).then(function(n) {
    return n.value;
  }).catch(function(n) {
    return je.error(n), r;
  });
};
ee.prototype.getFeatureData = function(e, r) {
  return je.critical("mixpanel.flags.get_feature_data() is deprecated and will be removed in a future release. Use mixpanel.flags.get_variant_value() instead."), this.getVariantValue(e, r);
};
ee.prototype.getVariantValueSync = function(e, r) {
  return this.getVariantSync(e, { value: r }).value;
};
ee.prototype.isEnabled = function(e, r) {
  return this.getVariantValue(e).then((function() {
    return this.isEnabledSync(e, r);
  }).bind(this)).catch(function(n) {
    return je.error(n), r;
  });
};
ee.prototype.isEnabledSync = function(e, r) {
  r = r || !1;
  var n = this.getVariantValueSync(e, r);
  return n !== !0 && n !== !1 && (je.error('Feature flag "' + e + '" value: ' + n + " is not a boolean; returning fallback value: " + r), n = r), n;
};
ee.prototype.trackFeatureCheck = function(e, r) {
  this.trackedFeatures.has(e) || (this.trackedFeatures.add(e), this.track("$experiment_started", {
    "Experiment name": e,
    "Variant name": r.key,
    $experiment_type: "feature_flag",
    "Variant fetch start time": new Date(this._fetchStartTime).toISOString(),
    "Variant fetch complete time": new Date(this._fetchCompleteTime).toISOString(),
    "Variant fetch latency (ms)": this._fetchLatency
  }));
};
function I_() {
  return !!x_ && typeof Promise < "u" && typeof Map < "u" && typeof Set < "u";
}
gf(ee);
ee.prototype.are_flags_ready = ee.prototype.areFlagsReady;
ee.prototype.get_variant = ee.prototype.getVariant;
ee.prototype.get_variant_sync = ee.prototype.getVariantSync;
ee.prototype.get_variant_value = ee.prototype.getVariantValue;
ee.prototype.get_variant_value_sync = ee.prototype.getVariantValueSync;
ee.prototype.is_enabled = ee.prototype.isEnabled;
ee.prototype.is_enabled_sync = ee.prototype.isEnabledSync;
ee.prototype.get_feature_data = ee.prototype.getFeatureData;
var Dt = function() {
};
Dt.prototype.create_properties = function() {
};
Dt.prototype.event_handler = function() {
};
Dt.prototype.after_track_handler = function() {
};
Dt.prototype.init = function(e) {
  return this.mp = e, this;
};
Dt.prototype.track = function(e, r, n, t) {
  var i = this, o = d.dom_query(e);
  if (o.length === 0) {
    ie.error("The DOM query (" + e + ") returned 0 elements");
    return;
  }
  return d.each(o, function(s) {
    d.register_event(s, this.override_event, function(a) {
      var u = {}, l = i.create_properties(n, this), c = i.mp.get_config("track_links_timeout");
      i.event_handler(a, this, u), window.setTimeout(i.track_callback(t, l, u, !0), c), i.mp.track(r, l, i.track_callback(t, l, u));
    });
  }, this), !0;
};
Dt.prototype.track_callback = function(e, r, n, t) {
  t = t || !1;
  var i = this;
  return function() {
    n.callback_fired || (n.callback_fired = !0, !(e && e(t, r) === !1) && i.after_track_handler(r, n, t));
  };
};
Dt.prototype.create_properties = function(e, r) {
  var n;
  return typeof e == "function" ? n = e(r) : n = d.extend({}, e), n;
};
var Lr = function() {
  this.override_event = "click";
};
d.inherit(Lr, Dt);
Lr.prototype.create_properties = function(e, r) {
  var n = Lr.superclass.create_properties.apply(this, arguments);
  return r.href && (n.url = r.href), n;
};
Lr.prototype.event_handler = function(e, r, n) {
  n.new_tab = e.which === 2 || e.metaKey || e.ctrlKey || r.target === "_blank", n.href = r.href, n.new_tab || e.preventDefault();
};
Lr.prototype.after_track_handler = function(e, r) {
  r.new_tab || setTimeout(function() {
    window.location = r.href;
  }, 0);
};
var Yi = function() {
  this.override_event = "submit";
};
d.inherit(Yi, Dt);
Yi.prototype.event_handler = function(e, r, n) {
  n.element = r, e.preventDefault();
};
Yi.prototype.after_track_handler = function(e, r) {
  setTimeout(function() {
    r.element.submit();
  }, 0);
};
var Ht = "$set", Br = "$set_once", ot = "$unset", cr = "$add", _t = "$append", lr = "$union", Mt = "$remove", E_ = "$delete", jf = {
  set_action: function(e, r) {
    var n = {}, t = {};
    return d.isObject(e) ? d.each(e, function(i, o) {
      this._is_reserved_property(o) || (t[o] = i);
    }, this) : t[e] = r, n[Ht] = t, n;
  },
  unset_action: function(e) {
    var r = {}, n = [];
    return d.isArray(e) || (e = [e]), d.each(e, function(t) {
      this._is_reserved_property(t) || n.push(t);
    }, this), r[ot] = n, r;
  },
  set_once_action: function(e, r) {
    var n = {}, t = {};
    return d.isObject(e) ? d.each(e, function(i, o) {
      this._is_reserved_property(o) || (t[o] = i);
    }, this) : t[e] = r, n[Br] = t, n;
  },
  union_action: function(e, r) {
    var n = {}, t = {};
    return d.isObject(e) ? d.each(e, function(i, o) {
      this._is_reserved_property(o) || (t[o] = d.isArray(i) ? i : [i]);
    }, this) : t[e] = d.isArray(r) ? r : [r], n[lr] = t, n;
  },
  append_action: function(e, r) {
    var n = {}, t = {};
    return d.isObject(e) ? d.each(e, function(i, o) {
      this._is_reserved_property(o) || (t[o] = i);
    }, this) : t[e] = r, n[_t] = t, n;
  },
  remove_action: function(e, r) {
    var n = {}, t = {};
    return d.isObject(e) ? d.each(e, function(i, o) {
      this._is_reserved_property(o) || (t[o] = i);
    }, this) : t[e] = r, n[Mt] = t, n;
  },
  delete_action: function() {
    var e = {};
    return e[E_] = "", e;
  }
}, de = function() {
};
d.extend(de.prototype, jf);
de.prototype._init = function(e, r, n) {
  this._mixpanel = e, this._group_key = r, this._group_id = n;
};
de.prototype.set = zr(function(e, r, n) {
  var t = this.set_action(e, r);
  return d.isObject(e) && (n = r), this._send_request(t, n);
});
de.prototype.set_once = zr(function(e, r, n) {
  var t = this.set_once_action(e, r);
  return d.isObject(e) && (n = r), this._send_request(t, n);
});
de.prototype.unset = zr(function(e, r) {
  var n = this.unset_action(e);
  return this._send_request(n, r);
});
de.prototype.union = zr(function(e, r, n) {
  d.isObject(e) && (n = r);
  var t = this.union_action(e, r);
  return this._send_request(t, n);
});
de.prototype.delete = zr(function(e) {
  var r = this.delete_action();
  return this._send_request(r, e);
});
de.prototype.remove = zr(function(e, r, n) {
  var t = this.remove_action(e, r);
  return this._send_request(t, n);
});
de.prototype._send_request = function(e, r) {
  e.$group_key = this._group_key, e.$group_id = this._group_id, e.$token = this._get_config("token");
  var n = d.encodeDates(e);
  return this._mixpanel._track_or_batch({
    type: "groups",
    data: n,
    endpoint: this._mixpanel.get_api_host("groups") + "/" + this._get_config("api_routes").groups,
    batcher: this._mixpanel.request_batchers.groups
  }, r);
};
de.prototype._is_reserved_property = function(e) {
  return e === "$group_key" || e === "$group_id";
};
de.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
de.prototype.toString = function() {
  return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
de.prototype.remove = de.prototype.remove;
de.prototype.set = de.prototype.set;
de.prototype.set_once = de.prototype.set_once;
de.prototype.union = de.prototype.union;
de.prototype.unset = de.prototype.unset;
de.prototype.toString = de.prototype.toString;
var j = function() {
};
d.extend(j.prototype, jf);
j.prototype._init = function(e) {
  this._mixpanel = e;
};
j.prototype.set = rr(function(e, r, n) {
  var t = this.set_action(e, r);
  return d.isObject(e) && (n = r), this._get_config("save_referrer") && this._mixpanel.persistence.update_referrer_info(document.referrer), t[Ht] = d.extend(
    {},
    d.info.people_properties(),
    t[Ht]
  ), this._send_request(t, n);
});
j.prototype.set_once = rr(function(e, r, n) {
  var t = this.set_once_action(e, r);
  return d.isObject(e) && (n = r), this._send_request(t, n);
});
j.prototype.unset = rr(function(e, r) {
  var n = this.unset_action(e);
  return this._send_request(n, r);
});
j.prototype.increment = rr(function(e, r, n) {
  var t = {}, i = {};
  return d.isObject(e) ? (d.each(e, function(o, s) {
    if (!this._is_reserved_property(s))
      if (isNaN(parseFloat(o))) {
        ie.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
        return;
      } else
        i[s] = o;
  }, this), n = r) : (d.isUndefined(r) && (r = 1), i[e] = r), t[cr] = i, this._send_request(t, n);
});
j.prototype.append = rr(function(e, r, n) {
  d.isObject(e) && (n = r);
  var t = this.append_action(e, r);
  return this._send_request(t, n);
});
j.prototype.remove = rr(function(e, r, n) {
  d.isObject(e) && (n = r);
  var t = this.remove_action(e, r);
  return this._send_request(t, n);
});
j.prototype.union = rr(function(e, r, n) {
  d.isObject(e) && (n = r);
  var t = this.union_action(e, r);
  return this._send_request(t, n);
});
j.prototype.track_charge = rr(function() {
  ie.error("mixpanel.people.track_charge() is deprecated and no longer has any effect.");
});
j.prototype.clear_charges = function(e) {
  return this.set("$transactions", [], e);
};
j.prototype.delete_user = function() {
  if (!this._identify_called()) {
    ie.error("mixpanel.people.delete_user() requires you to call identify() first");
    return;
  }
  var e = { $delete: this._mixpanel.get_distinct_id() };
  return this._send_request(e);
};
j.prototype.toString = function() {
  return this._mixpanel.toString() + ".people";
};
j.prototype._send_request = function(e, r) {
  e.$token = this._get_config("token"), e.$distinct_id = this._mixpanel.get_distinct_id();
  var n = this._mixpanel.get_property("$device_id"), t = this._mixpanel.get_property("$user_id"), i = this._mixpanel.get_property("$had_persisted_distinct_id");
  n && (e.$device_id = n), t && (e.$user_id = t), i && (e.$had_persisted_distinct_id = i);
  var o = d.encodeDates(e);
  return this._identify_called() ? this._mixpanel._track_or_batch({
    type: "people",
    data: o,
    endpoint: this._mixpanel.get_api_host("people") + "/" + this._get_config("api_routes").engage,
    batcher: this._mixpanel.request_batchers.people
  }, r) : (this._enqueue(e), d.isUndefined(r) || (this._get_config("verbose") ? r({ status: -1, error: null }) : r(-1)), d.truncate(o, 255));
};
j.prototype._get_config = function(e) {
  return this._mixpanel.get_config(e);
};
j.prototype._identify_called = function() {
  return this._mixpanel._flags.identify_called === !0;
};
j.prototype._enqueue = function(e) {
  Ht in e ? this._mixpanel.persistence._add_to_people_queue(Ht, e) : Br in e ? this._mixpanel.persistence._add_to_people_queue(Br, e) : ot in e ? this._mixpanel.persistence._add_to_people_queue(ot, e) : cr in e ? this._mixpanel.persistence._add_to_people_queue(cr, e) : _t in e ? this._mixpanel.persistence._add_to_people_queue(_t, e) : Mt in e ? this._mixpanel.persistence._add_to_people_queue(Mt, e) : lr in e ? this._mixpanel.persistence._add_to_people_queue(lr, e) : ie.error("Invalid call to _enqueue():", e);
};
j.prototype._flush_one_queue = function(e, r, n, t) {
  var i = this, o = d.extend({}, this._mixpanel.persistence.load_queue(e)), s = o;
  !d.isUndefined(o) && d.isObject(o) && !d.isEmptyObject(o) && (i._mixpanel.persistence._pop_from_people_queue(e, o), i._mixpanel.persistence.save(), t && (s = t(o)), r.call(i, s, function(a, u) {
    a === 0 && i._mixpanel.persistence._add_to_people_queue(e, o), d.isUndefined(n) || n(a, u);
  }));
};
j.prototype._flush = function(e, r, n, t, i, o, s) {
  var a = this;
  this._flush_one_queue(Ht, this.set, e), this._flush_one_queue(Br, this.set_once, t), this._flush_one_queue(ot, this.unset, o, function(_) {
    return d.keys(_);
  }), this._flush_one_queue(cr, this.increment, r), this._flush_one_queue(lr, this.union, i);
  var u = this._mixpanel.persistence.load_queue(_t);
  if (!d.isUndefined(u) && d.isArray(u) && u.length)
    for (var l, c = function(_, b) {
      _ === 0 && a._mixpanel.persistence._add_to_people_queue(_t, l), d.isUndefined(n) || n(_, b);
    }, h = u.length - 1; h >= 0; h--)
      u = this._mixpanel.persistence.load_queue(_t), l = u.pop(), a._mixpanel.persistence.save(), d.isEmptyObject(l) || a.append(l, c);
  var m = this._mixpanel.persistence.load_queue(Mt);
  if (!d.isUndefined(m) && d.isArray(m) && m.length)
    for (var v, y = function(_, b) {
      _ === 0 && a._mixpanel.persistence._add_to_people_queue(Mt, v), d.isUndefined(s) || s(_, b);
    }, S = m.length - 1; S >= 0; S--)
      m = this._mixpanel.persistence.load_queue(Mt), v = m.pop(), a._mixpanel.persistence.save(), d.isEmptyObject(v) || a.remove(v, y);
};
j.prototype._is_reserved_property = function(e) {
  return e === "$distinct_id" || e === "$token" || e === "$device_id" || e === "$user_id" || e === "$had_persisted_distinct_id";
};
j.prototype.set = j.prototype.set;
j.prototype.set_once = j.prototype.set_once;
j.prototype.unset = j.prototype.unset;
j.prototype.increment = j.prototype.increment;
j.prototype.append = j.prototype.append;
j.prototype.remove = j.prototype.remove;
j.prototype.union = j.prototype.union;
j.prototype.track_charge = j.prototype.track_charge;
j.prototype.clear_charges = j.prototype.clear_charges;
j.prototype.delete_user = j.prototype.delete_user;
j.prototype.toString = j.prototype.toString;
var oa = "__mps", sa = "__mpso", aa = "__mpus", ua = "__mpa", ca = "__mpap", la = "__mpr", fa = "__mpu", Wf = "$people_distinct_id", Ti = "__alias", vn = "__timers", O_ = [
  oa,
  sa,
  aa,
  ua,
  ca,
  la,
  fa,
  Wf,
  Ti,
  vn
], V = function(e) {
  this.props = {}, this.campaign_params_saved = !1, e.persistence_name ? this.name = "mp_" + e.persistence_name : this.name = "mp_" + e.token + "_mixpanel";
  var r = e.persistence;
  r !== "cookie" && r !== "localStorage" && (ie.critical("Unknown persistence type " + r + "; falling back to cookie"), r = e.persistence = "cookie"), r === "localStorage" && d.localStorage.is_supported() ? this.storage = d.localStorage : this.storage = d.cookie, this.load(), this.update_config(e), this.upgrade(), this.save();
};
V.prototype.properties = function() {
  var e = {};
  return this.load(), d.each(this.props, function(r, n) {
    d.include(O_, n) || (e[n] = r);
  }), e;
};
V.prototype.load = function() {
  if (!this.disabled) {
    var e = this.storage.parse(this.name);
    e && (this.props = d.extend({}, e));
  }
};
V.prototype.upgrade = function() {
  var e, r;
  this.storage === d.localStorage ? (e = d.cookie.parse(this.name), d.cookie.remove(this.name), d.cookie.remove(this.name, !0), e && this.register_once(e)) : this.storage === d.cookie && (r = d.localStorage.parse(this.name), d.localStorage.remove(this.name), r && this.register_once(r));
};
V.prototype.save = function() {
  this.disabled || this.storage.set(
    this.name,
    Dr(this.props),
    this.expire_days,
    this.cross_subdomain,
    this.secure,
    this.cross_site,
    this.cookie_domain
  );
};
V.prototype.load_prop = function(e) {
  return this.load(), this.props[e];
};
V.prototype.remove = function() {
  this.storage.remove(this.name, !1, this.cookie_domain), this.storage.remove(this.name, !0, this.cookie_domain);
};
V.prototype.clear = function() {
  this.remove(), this.props = {};
};
V.prototype.register_once = function(e, r, n) {
  return d.isObject(e) ? (typeof r > "u" && (r = "None"), this.expire_days = typeof n > "u" ? this.default_expiry : n, this.load(), d.each(e, function(t, i) {
    (!this.props.hasOwnProperty(i) || this.props[i] === r) && (this.props[i] = t);
  }, this), this.save(), !0) : !1;
};
V.prototype.register = function(e, r) {
  return d.isObject(e) ? (this.expire_days = typeof r > "u" ? this.default_expiry : r, this.load(), d.extend(this.props, e), this.save(), !0) : !1;
};
V.prototype.unregister = function(e) {
  this.load(), e in this.props && (delete this.props[e], this.save());
};
V.prototype.update_search_keyword = function(e) {
  this.register(d.info.searchInfo(e));
};
V.prototype.update_referrer_info = function(e) {
  this.register_once({
    $initial_referrer: e || "$direct",
    $initial_referring_domain: d.info.referringDomain(e) || "$direct"
  }, "");
};
V.prototype.get_referrer_info = function() {
  return d.strip_empty_properties({
    $initial_referrer: this.props.$initial_referrer,
    $initial_referring_domain: this.props.$initial_referring_domain
  });
};
V.prototype.update_config = function(e) {
  this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cookie_domain(e.cookie_domain), this.set_cross_site(e.cross_site_cookie), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
};
V.prototype.set_disabled = function(e) {
  this.disabled = e, this.disabled ? this.remove() : this.save();
};
V.prototype.set_cookie_domain = function(e) {
  e !== this.cookie_domain && (this.remove(), this.cookie_domain = e, this.save());
};
V.prototype.set_cross_site = function(e) {
  e !== this.cross_site && (this.cross_site = e, this.remove(), this.save());
};
V.prototype.set_cross_subdomain = function(e) {
  e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
};
V.prototype.get_cross_subdomain = function() {
  return this.cross_subdomain;
};
V.prototype.set_secure = function(e) {
  e !== this.secure && (this.secure = !!e, this.remove(), this.save());
};
V.prototype._add_to_people_queue = function(e, r) {
  var n = this._get_queue_key(e), t = r[e], i = this._get_or_create_queue(Ht), o = this._get_or_create_queue(Br), s = this._get_or_create_queue(ot), a = this._get_or_create_queue(cr), u = this._get_or_create_queue(lr), l = this._get_or_create_queue(Mt, []), c = this._get_or_create_queue(_t, []);
  n === oa ? (d.extend(i, t), this._pop_from_people_queue(cr, t), this._pop_from_people_queue(lr, t), this._pop_from_people_queue(ot, t)) : n === sa ? (d.each(t, function(h, m) {
    m in o || (o[m] = h);
  }), this._pop_from_people_queue(ot, t)) : n === aa ? d.each(t, function(h) {
    d.each([i, o, a, u], function(m) {
      h in m && delete m[h];
    }), d.each(c, function(m) {
      h in m && delete m[h];
    }), s[h] = !0;
  }) : n === ua ? (d.each(t, function(h, m) {
    m in i ? i[m] += h : (m in a || (a[m] = 0), a[m] += h);
  }, this), this._pop_from_people_queue(ot, t)) : n === fa ? (d.each(t, function(h, m) {
    d.isArray(h) && (m in u || (u[m] = []), d.each(h, function(v) {
      d.include(u[m], v) || u[m].push(v);
    }));
  }), this._pop_from_people_queue(ot, t)) : n === la ? (l.push(t), this._pop_from_people_queue(_t, t)) : n === ca && (c.push(t), this._pop_from_people_queue(ot, t)), ie.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):"), ie.log(r), this.save();
};
V.prototype._pop_from_people_queue = function(e, r) {
  var n = this.props[this._get_queue_key(e)];
  d.isUndefined(n) || d.each(r, function(t, i) {
    e === _t || e === Mt ? d.each(n, function(o) {
      o[i] === t && delete o[i];
    }) : delete n[i];
  }, this);
};
V.prototype.load_queue = function(e) {
  return this.load_prop(this._get_queue_key(e));
};
V.prototype._get_queue_key = function(e) {
  if (e === Ht)
    return oa;
  if (e === Br)
    return sa;
  if (e === ot)
    return aa;
  if (e === cr)
    return ua;
  if (e === _t)
    return ca;
  if (e === Mt)
    return la;
  if (e === lr)
    return fa;
  ie.error("Invalid queue:", e);
};
V.prototype._get_or_create_queue = function(e, r) {
  var n = this._get_queue_key(e);
  return r = d.isUndefined(r) ? {} : r, this.props[n] || (this.props[n] = r);
};
V.prototype.set_event_timer = function(e, r) {
  var n = this.load_prop(vn) || {};
  n[e] = r, this.props[vn] = n, this.save();
};
V.prototype.remove_event_timer = function(e) {
  var r = this.load_prop(vn) || {}, n = r[e];
  return d.isUndefined(n) || (delete this.props[vn][e], this.save()), n;
};
var ha, Gf = function(e, r) {
  throw new Error(e + " not available in this build.");
}, Fe, Vf = 0, k_ = 1, A_ = function(e) {
  return e;
}, Qe = "mixpanel", Yf = "base64", R_ = "json", pa = "$device:", Ar = $.XMLHttpRequest && "withCredentials" in new XMLHttpRequest(), Hf = !Ar && At.indexOf("MSIE") === -1 && At.indexOf("Mozilla") === -1, Mi = null;
jt.sendBeacon && (Mi = function() {
  return jt.sendBeacon.apply(jt, arguments);
});
var Zf = {
  track: "track/",
  engage: "engage/",
  groups: "groups/",
  record: "record/",
  flags: "flags/"
}, Yu = {
  api_host: "https://api-js.mixpanel.com",
  api_hosts: {},
  api_routes: Zf,
  api_extra_query_params: {},
  api_method: "POST",
  api_transport: "XHR",
  api_payload_format: Yf,
  app_host: "https://mixpanel.com",
  autocapture: !1,
  cdn: "https://cdn.mxpnl.com",
  cross_site_cookie: !1,
  cross_subdomain_cookie: !0,
  error_reporter: Gt,
  flags: !1,
  persistence: "cookie",
  persistence_name: "",
  cookie_domain: "",
  cookie_name: "",
  loaded: Gt,
  mp_loader: null,
  track_marketing: !0,
  track_pageview: !1,
  skip_first_touch_marketing: !1,
  store_google: !0,
  stop_utm_persistence: !1,
  save_referrer: !0,
  test: !1,
  verbose: !1,
  img: !1,
  debug: !1,
  track_links_timeout: 300,
  cookie_expiration: 365,
  upgrade: !1,
  disable_persistence: !1,
  disable_cookie: !1,
  secure_cookie: !1,
  ip: !0,
  opt_out_tracking_by_default: !1,
  opt_out_persistence_by_default: !1,
  opt_out_tracking_persistence_type: "localStorage",
  opt_out_tracking_cookie_prefix: null,
  property_blacklist: [],
  xhr_headers: {},
  // { header: value, header2: value }
  ignore_dnt: !1,
  batch_requests: !0,
  batch_size: 50,
  batch_flush_interval_ms: 5e3,
  batch_request_timeout_ms: 9e4,
  batch_autostart: !0,
  hooks: {},
  record_block_class: new RegExp("^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$"),
  record_block_selector: "img, video",
  record_canvas: !1,
  record_collect_fonts: !1,
  record_heatmap_data: !1,
  record_idle_timeout_ms: 30 * 60 * 1e3,
  // 30 minutes
  record_mask_text_class: new RegExp("^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$"),
  record_mask_text_selector: "*",
  record_max_ms: Xr,
  record_min_ms: 0,
  record_sessions_percent: 0,
  recorder_src: "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
}, Kf = !1, O = function() {
}, ws = function(e, r, n) {
  var t, i = n === Qe ? Fe : Fe[n];
  if (i && ha === Vf)
    t = i;
  else {
    if (i && !d.isArray(i)) {
      ie.error("You have already initialized " + n);
      return;
    }
    t = new O();
  }
  if (t._cached_groups = {}, t._init(e, r, n), t.people = new j(), t.people._init(t), !t.get_config("skip_first_touch_marketing")) {
    var o = d.info.campaignParams(null), s = {}, a = !1;
    d.each(o, function(u, l) {
      s["initial_" + l] = u, u && (a = !0);
    }), a && t.people.set_once(s);
  }
  return st.DEBUG = st.DEBUG || t.get_config("debug"), !d.isUndefined(i) && d.isArray(i) && (t._execute_array.call(t.people, i.people), t._execute_array(i)), t;
};
O.prototype.init = function(e, r, n) {
  if (d.isUndefined(n)) {
    this.report_error("You must name your new library: init(token, config, name)");
    return;
  }
  if (n === Qe) {
    this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
    return;
  }
  var t = ws(e, r, n);
  return Fe[n] = t, t._loaded(), t;
};
O.prototype._init = function(e, r, n) {
  r = r || {}, this.__loaded = !0, this.config = {};
  var t = {};
  if (!("api_payload_format" in r)) {
    var i = r.api_host || Yu.api_host;
    i.match(/\.mixpanel\.com/) && (t.api_payload_format = R_);
  }
  if (this.set_config(d.extend({}, Yu, t, r, {
    name: n,
    token: e,
    callback_fn: (n === Qe ? n : Qe + "." + n) + "._jsc"
  })), this._jsc = Gt, this.__dom_loaded_queue = [], this.__request_queue = [], this.__disabled_events = [], this._flags = {
    disable_all_events: !1,
    identify_called: !1
  }, this.request_batchers = {}, this._batch_requests = this.get_config("batch_requests"), this._batch_requests) {
    if (!d.localStorage.is_supported(!0) || !Ar)
      this._batch_requests = !1, ie.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support"), d.each(this.get_batcher_configs(), function(a) {
        ie.log("Clearing batch queue " + a.queue_key), d.localStorage.remove(a.queue_key);
      });
    else if (this.init_batchers(), Mi && $.addEventListener) {
      var o = d.bind(function() {
        this.request_batchers.events.stopped || this.request_batchers.events.flush({ unloading: !0 });
      }, this);
      $.addEventListener("pagehide", function(a) {
        a.persisted && o();
      }), $.addEventListener("visibilitychange", function() {
        ne.visibilityState === "hidden" && o();
      });
    }
  }
  this.persistence = this.cookie = new V(this.config), this.unpersisted_superprops = {}, this._gdpr_init();
  var s = d.UUID();
  this.get_distinct_id() || this.register_once({
    distinct_id: pa + s,
    $device_id: s
  }, ""), this.flags = new ee({
    getFullApiRoute: d.bind(function() {
      return this.get_api_host("flags") + "/" + this.get_config("api_routes").flags;
    }, this),
    getConfigFunc: d.bind(this.get_config, this),
    getPropertyFunc: d.bind(this.get_property, this),
    trackingFunc: d.bind(this.track, this)
  }), this.flags.init(), this.flags = this.flags, this.autocapture = new He(this), this.autocapture.init(), this._init_tab_id(), this._check_and_start_session_recording();
};
O.prototype._init_tab_id = function() {
  if (d.sessionStorage.is_supported())
    try {
      var e = this.get_config("name") + "_" + this.get_config("token"), r = "mp_tab_id_" + e, n = "mp_gen_new_tab_id_" + e;
      (d.sessionStorage.get(n) || !d.sessionStorage.get(r)) && d.sessionStorage.set(r, "$tab-" + d.UUID()), d.sessionStorage.set(n, "1"), this.tab_id = d.sessionStorage.get(r), $.addEventListener("beforeunload", function() {
        d.sessionStorage.remove(n);
      });
    } catch (t) {
      this.report_error("Error initializing tab id", t);
    }
  else
    this.report_error("Session storage is not supported, cannot keep track of unique tab ID.");
};
O.prototype.get_tab_id = function() {
  return this.tab_id || null;
};
O.prototype._should_load_recorder = function() {
  var e = new wt(Qs), r = this.get_tab_id();
  return e.init().then(function() {
    return e.getAll();
  }).then(function(n) {
    for (var t = 0; t < n.length; t++)
      if (na(n[t]) || n[t].tabId === r)
        return !0;
    return !1;
  }).catch(d.bind(function(n) {
    this.report_error("Error checking recording registry", n);
  }, this));
};
O.prototype._check_and_start_session_recording = tr(function(e) {
  if (!$.MutationObserver) {
    ie.critical("Browser does not support MutationObserver; skipping session recording");
    return;
  }
  var r = d.bind(function(t) {
    var i = d.bind(function() {
      this._recorder = this._recorder || new $.__mp_recorder(this), this._recorder.resumeRecording(t);
    }, this);
    d.isUndefined($.__mp_recorder) ? Gf(this.get_config("recorder_src"), i) : i();
  }, this), n = this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent");
  e || n ? r(!0) : this._should_load_recorder().then(function(t) {
    t && r(!1);
  });
});
O.prototype.start_session_recording = function() {
  this._check_and_start_session_recording(!0);
};
O.prototype.stop_session_recording = function() {
  return this._recorder ? this._recorder.stopRecording() : Promise.resolve();
};
O.prototype.pause_session_recording = function() {
  return this._recorder ? this._recorder.pauseRecording() : Promise.resolve();
};
O.prototype.resume_session_recording = function() {
  return this._recorder ? this._recorder.resumeRecording() : Promise.resolve();
};
O.prototype.is_recording_heatmap_data = function() {
  return this._get_session_replay_id() && this.get_config("record_heatmap_data");
};
O.prototype.get_session_recording_properties = function() {
  var e = {}, r = this._get_session_replay_id();
  return r && (e.$mp_replay_id = r), e;
};
O.prototype.get_session_replay_url = function() {
  var e = null, r = this._get_session_replay_id();
  if (r) {
    var n = d.HTTPBuildQuery({
      replay_id: r,
      distinct_id: this.get_distinct_id(),
      token: this.get_config("token")
    });
    e = "https://mixpanel.com/projects/replay-redirect?" + n;
  }
  return e;
};
O.prototype._get_session_replay_id = function() {
  var e = null;
  return this._recorder && (e = this._recorder.replayId), e || null;
};
O.prototype.__get_recorder = function() {
  return this._recorder;
};
O.prototype._loaded = function() {
  if (this.get_config("loaded")(this), this._set_default_superprops(), this.people.set_once(this.persistence.get_referrer_info()), this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
    var e = d.info.campaignParams(null);
    d.each(e, (function(r, n) {
      this.unregister(n);
    }).bind(this));
  }
};
O.prototype._set_default_superprops = function() {
  this.persistence.update_search_keyword(ne.referrer), this.get_config("store_google") && !this.get_config("stop_utm_persistence") && this.register(d.info.campaignParams()), this.get_config("save_referrer") && this.persistence.update_referrer_info(ne.referrer);
};
O.prototype._dom_loaded = function() {
  d.each(this.__dom_loaded_queue, function(e) {
    this._track_dom.apply(this, e);
  }, this), this.has_opted_out_tracking() || d.each(this.__request_queue, function(e) {
    this._send_request.apply(this, e);
  }, this), delete this.__dom_loaded_queue, delete this.__request_queue;
};
O.prototype._track_dom = function(e, r) {
  if (this.get_config("img"))
    return this.report_error("You can't use DOM tracking functions with img = true."), !1;
  if (!Kf)
    return this.__dom_loaded_queue.push([e, r]), !1;
  var n = new e().init(this);
  return n.track.apply(n, r);
};
O.prototype._prepare_callback = function(e, r) {
  if (d.isUndefined(e))
    return null;
  if (Ar) {
    var n = function(s) {
      e(s, r);
    };
    return n;
  } else {
    var t = this._jsc, i = "" + Math.floor(Math.random() * 1e8), o = this.get_config("callback_fn") + "[" + i + "]";
    return t[i] = function(s) {
      delete t[i], e(s, r);
    }, o;
  }
};
O.prototype._send_request = function(e, r, n, t) {
  var i = !0;
  if (Hf)
    return this.__request_queue.push(arguments), i;
  var o = {
    method: this.get_config("api_method"),
    transport: this.get_config("api_transport"),
    verbose: this.get_config("verbose")
  }, s = null;
  !t && (d.isFunction(n) || typeof n == "string") && (t = n, n = null), n = d.extend(o, n || {}), Ar || (n.method = "GET");
  var a = n.method === "POST", u = Mi && a && n.transport.toLowerCase() === "sendbeacon", l = n.verbose;
  r.verbose && (l = !0), this.get_config("test") && (r.test = 1), l && (r.verbose = 1), this.get_config("img") && (r.img = 1), Ar || (t ? r.callback = t : (l || this.get_config("test")) && (r.callback = "(function(){})")), r.ip = this.get_config("ip") ? 1 : 0, r._ = (/* @__PURE__ */ new Date()).getTime().toString(), a && (s = "data=" + encodeURIComponent(r.data), delete r.data), d.extend(r, this.get_config("api_extra_query_params")), e += "?" + d.HTTPBuildQuery(r);
  var c = this;
  if ("img" in r) {
    var h = ne.createElement("img");
    h.src = e, ne.body.appendChild(h);
  } else if (u) {
    try {
      i = Mi(e, s);
    } catch (b) {
      c.report_error(b), i = !1;
    }
    try {
      t && t(i ? 1 : 0);
    } catch (b) {
      c.report_error(b);
    }
  } else if (Ar)
    try {
      var m = new XMLHttpRequest();
      m.open(n.method, e, !0);
      var v = this.get_config("xhr_headers");
      if (a && (v["Content-Type"] = "application/x-www-form-urlencoded"), d.each(v, function(b, C) {
        m.setRequestHeader(C, b);
      }), n.timeout_ms && typeof m.timeout < "u") {
        m.timeout = n.timeout_ms;
        var y = (/* @__PURE__ */ new Date()).getTime();
      }
      m.withCredentials = !0, m.onreadystatechange = function() {
        if (m.readyState === 4)
          if (m.status === 200) {
            if (t)
              if (l) {
                var b;
                try {
                  b = d.JSONDecode(m.responseText);
                } catch (R) {
                  if (c.report_error(R), n.ignore_json_errors)
                    b = m.responseText;
                  else
                    return;
                }
                t(b);
              } else
                t(Number(m.responseText));
          } else {
            var C;
            if (m.timeout && !m.status && (/* @__PURE__ */ new Date()).getTime() - y >= m.timeout ? C = "timeout" : C = "Bad HTTP status: " + m.status + " " + m.statusText, c.report_error(C), t)
              if (l) {
                var E = m.responseHeaders || {};
                t({ status: 0, httpStatusCode: m.status, error: C, retryAfter: E["Retry-After"] });
              } else
                t(0);
          }
      }, m.send(s);
    } catch (b) {
      c.report_error(b), i = !1;
    }
  else {
    var S = ne.createElement("script");
    S.type = "text/javascript", S.async = !0, S.defer = !0, S.src = e;
    var _ = ne.getElementsByTagName("script")[0];
    _.parentNode.insertBefore(S, _);
  }
  return i;
};
O.prototype._execute_array = function(e) {
  var r, n = [], t = [], i = [];
  d.each(e, function(s) {
    s && (r = s[0], d.isArray(r) ? i.push(s) : typeof s == "function" ? s.call(this) : d.isArray(s) && r === "alias" ? n.push(s) : d.isArray(s) && r.indexOf("track") !== -1 && typeof this[r] == "function" ? i.push(s) : t.push(s));
  }, this);
  var o = function(s, a) {
    d.each(s, function(u) {
      if (d.isArray(u[0])) {
        var l = a;
        d.each(u, function(c) {
          l = l[c[0]].apply(l, c.slice(1));
        });
      } else
        this[u[0]].apply(this, u.slice(1));
    }, a);
  };
  o(n, this), o(t, this), o(i, this);
};
O.prototype.are_batchers_initialized = function() {
  return !!this.request_batchers.events;
};
O.prototype.get_batcher_configs = function() {
  var e = "__mpq_" + this.get_config("token");
  return this._batcher_configs = this._batcher_configs || {
    events: { type: "events", api_name: "track", queue_key: e + "_ev" },
    people: { type: "people", api_name: "engage", queue_key: e + "_pp" },
    groups: { type: "groups", api_name: "groups", queue_key: e + "_gr" }
  }, this._batcher_configs;
};
O.prototype.init_batchers = function() {
  if (!this.are_batchers_initialized()) {
    var e = d.bind(function(n) {
      return new et(
        n.queue_key,
        {
          libConfig: this.config,
          errorReporter: this.get_config("error_reporter"),
          sendRequestFunc: d.bind(function(t, i, o) {
            var s = this.get_config("api_routes");
            this._send_request(
              this.get_api_host(n.api_name) + "/" + s[n.api_name],
              this._encode_data_for_request(t),
              i,
              this._prepare_callback(o, t)
            );
          }, this),
          beforeSendHook: d.bind(function(t) {
            return this._run_hook("before_send_" + n.type, t);
          }, this),
          stopAllBatchingFunc: d.bind(this.stop_batch_senders, this),
          usePersistence: !0
        }
      );
    }, this), r = this.get_batcher_configs();
    this.request_batchers = {
      events: e(r.events),
      people: e(r.people),
      groups: e(r.groups)
    };
  }
  this.get_config("batch_autostart") && this.start_batch_senders();
};
O.prototype.start_batch_senders = function() {
  this._batchers_were_started = !0, this.are_batchers_initialized() && (this._batch_requests = !0, d.each(this.request_batchers, function(e) {
    e.start();
  }));
};
O.prototype.stop_batch_senders = function() {
  this._batch_requests = !1, d.each(this.request_batchers, function(e) {
    e.stop(), e.clear();
  });
};
O.prototype.push = function(e) {
  this._execute_array([e]);
};
O.prototype.disable = function(e) {
  typeof e > "u" ? this._flags.disable_all_events = !0 : this.__disabled_events = this.__disabled_events.concat(e);
};
O.prototype._encode_data_for_request = function(e) {
  var r = Dr(e);
  return this.get_config("api_payload_format") === Yf && (r = d.base64Encode(r)), { data: r };
};
O.prototype._track_or_batch = function(e, r) {
  var n = d.truncate(e.data, 255), t = e.endpoint, i = e.batcher, o = e.should_send_immediately, s = e.send_request_options || {};
  r = r || Gt;
  var a = !0, u = d.bind(function() {
    return s.skip_hooks || (n = this._run_hook("before_send_" + e.type, n)), n ? (ie.log("MIXPANEL REQUEST:"), ie.log(n), this._send_request(
      t,
      this._encode_data_for_request(n),
      s,
      this._prepare_callback(r, n)
    )) : null;
  }, this);
  return this._batch_requests && !o ? i.enqueue(n).then(function(l) {
    l ? r(1, n) : u();
  }) : a = u(), a && n;
};
O.prototype.track = tr(function(e, r, n, t) {
  !t && typeof n == "function" && (t = n, n = null), n = n || {};
  var i = n.transport;
  i && (n.transport = i);
  var o = n.send_immediately;
  if (typeof t != "function" && (t = Gt), d.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.track");
    return;
  }
  if (this._event_is_disabled(e)) {
    t(0);
    return;
  }
  r = d.extend({}, r), r.token = this.get_config("token");
  var s = this.persistence.remove_event_timer(e);
  if (!d.isUndefined(s)) {
    var a = (/* @__PURE__ */ new Date()).getTime() - s;
    r.$duration = parseFloat((a / 1e3).toFixed(3));
  }
  this._set_default_superprops();
  var u = this.get_config("track_marketing") ? d.info.marketingParams() : {};
  r = d.extend(
    {},
    d.info.properties({ mp_loader: this.get_config("mp_loader") }),
    u,
    this.persistence.properties(),
    this.unpersisted_superprops,
    this.get_session_recording_properties(),
    r
  );
  var l = this.get_config("property_blacklist");
  d.isArray(l) ? d.each(l, function(m) {
    delete r[m];
  }) : this.report_error("Invalid value for property_blacklist config: " + l);
  var c = {
    event: e,
    properties: r
  }, h = this._track_or_batch({
    type: "events",
    data: c,
    endpoint: this.get_api_host("events") + "/" + this.get_config("api_routes").track,
    batcher: this.request_batchers.events,
    should_send_immediately: o,
    send_request_options: n
  }, t);
  return h;
});
O.prototype.set_group = tr(function(e, r, n) {
  d.isArray(r) || (r = [r]);
  var t = {};
  return t[e] = r, this.register(t), this.people.set(e, r, n);
});
O.prototype.add_group = tr(function(e, r, n) {
  var t = this.get_property(e), i = {};
  return t === void 0 ? (i[e] = [r], this.register(i)) : t.indexOf(r) === -1 && (t.push(r), i[e] = t, this.register(i)), this.people.union(e, r, n);
});
O.prototype.remove_group = tr(function(e, r, n) {
  var t = this.get_property(e);
  if (t !== void 0) {
    var i = t.indexOf(r);
    i > -1 && (t.splice(i, 1), this.register({ group_key: t })), t.length === 0 && this.unregister(e);
  }
  return this.people.remove(e, r, n);
});
O.prototype.track_with_groups = tr(function(e, r, n, t) {
  var i = d.extend({}, r || {});
  return d.each(n, function(o, s) {
    o != null && (i[s] = o);
  }), this.track(e, i, t);
});
O.prototype._create_map_key = function(e, r) {
  return e + "_" + JSON.stringify(r);
};
O.prototype._remove_group_from_cache = function(e, r) {
  delete this._cached_groups[this._create_map_key(e, r)];
};
O.prototype.get_group = function(e, r) {
  var n = this._create_map_key(e, r), t = this._cached_groups[n];
  return (t === void 0 || t._group_key !== e || t._group_id !== r) && (t = new de(), t._init(this, e, r), this._cached_groups[n] = t), t;
};
O.prototype.track_pageview = tr(function(e, r) {
  typeof e != "object" && (e = {}), r = r || {};
  var n = r.event_name || "$mp_web_page_view", t = d.extend(
    d.info.mpPageViewProperties(),
    d.info.campaignParams(),
    d.info.clickParams()
  ), i = d.extend(
    {},
    t,
    e
  );
  return this.track(n, i);
});
O.prototype.track_links = function() {
  return this._track_dom.call(this, Lr, arguments);
};
O.prototype.track_forms = function() {
  return this._track_dom.call(this, Yi, arguments);
};
O.prototype.time_event = function(e) {
  if (d.isUndefined(e)) {
    this.report_error("No event name provided to mixpanel.time_event");
    return;
  }
  this._event_is_disabled(e) || this.persistence.set_event_timer(e, (/* @__PURE__ */ new Date()).getTime());
};
var T_ = {
  persistent: !0
}, da = function(e) {
  var r;
  return d.isObject(e) ? r = e : d.isUndefined(e) ? r = {} : r = { days: e }, d.extend({}, T_, r);
};
O.prototype.register = function(e, r) {
  var n = da(r);
  n.persistent ? this.persistence.register(e, n.days) : d.extend(this.unpersisted_superprops, e);
};
O.prototype.register_once = function(e, r, n) {
  var t = da(n);
  t.persistent ? this.persistence.register_once(e, r, t.days) : (typeof r > "u" && (r = "None"), d.each(e, function(i, o) {
    (!this.unpersisted_superprops.hasOwnProperty(o) || this.unpersisted_superprops[o] === r) && (this.unpersisted_superprops[o] = i);
  }, this));
};
O.prototype.unregister = function(e, r) {
  r = da(r), r.persistent ? this.persistence.unregister(e) : delete this.unpersisted_superprops[e];
};
O.prototype._register_single = function(e, r) {
  var n = {};
  n[e] = r, this.register(n);
};
O.prototype.identify = function(e, r, n, t, i, o, s, a) {
  var u = this.get_distinct_id();
  if (e && u !== e) {
    if (typeof e == "string" && e.indexOf(pa) === 0)
      return this.report_error("distinct_id cannot have $device: prefix"), -1;
    this.register({ $user_id: e });
  }
  if (!this.get_property("$device_id")) {
    var l = u;
    this.register_once({
      $had_persisted_distinct_id: !0,
      $device_id: l
    }, "");
  }
  e !== u && e !== this.get_property(Ti) && (this.unregister(Ti), this.register({ distinct_id: e })), this._flags.identify_called = !0, this.people._flush(r, n, t, i, o, s, a), e !== u && this.track("$identify", {
    distinct_id: e,
    $anon_distinct_id: u
  }, { skip_hooks: !0 }), e !== u && this.flags.fetchFlags();
};
O.prototype.reset = function() {
  this.stop_session_recording(), this.persistence.clear(), this._flags.identify_called = !1;
  var e = d.UUID();
  this.register_once({
    distinct_id: pa + e,
    $device_id: e
  }, ""), this._check_and_start_session_recording();
};
O.prototype.get_distinct_id = function() {
  return this.get_property("distinct_id");
};
O.prototype.alias = function(e, r) {
  if (e === this.get_property(Wf))
    return this.report_error("Attempting to create alias for existing People user - aborting."), -2;
  var n = this;
  return d.isUndefined(r) && (r = this.get_distinct_id()), e !== r ? (this._register_single(Ti, e), this.track("$create_alias", {
    alias: e,
    distinct_id: r
  }, {
    skip_hooks: !0
  }, function() {
    n.identify(e);
  })) : (this.report_error("alias matches current distinct_id - skipping api call."), this.identify(e), -1);
};
O.prototype.name_tag = function(e) {
  this._register_single("mp_name_tag", e);
};
O.prototype.set_config = function(e) {
  if (d.isObject(e)) {
    d.extend(this.config, e);
    var r = e.batch_size;
    r && d.each(this.request_batchers, function(n) {
      n.resetBatchSize();
    }), this.get_config("persistence_name") || (this.config.persistence_name = this.config.cookie_name), this.get_config("disable_persistence") || (this.config.disable_persistence = this.config.disable_cookie), this.persistence && this.persistence.update_config(this.config), st.DEBUG = st.DEBUG || this.get_config("debug"), ("autocapture" in e || "record_heatmap_data" in e) && this.autocapture && this.autocapture.init();
  }
};
O.prototype.get_config = function(e) {
  return this.config[e];
};
O.prototype._run_hook = function(e) {
  var r = (this.config.hooks[e] || A_).apply(this, qt.call(arguments, 1));
  return typeof r > "u" && (this.report_error(e + " hook did not return a value"), r = null), r;
};
O.prototype.get_property = function(e) {
  return this.persistence.load_prop([e]);
};
O.prototype.get_api_host = function(e) {
  return this.get_config("api_hosts")[e] || this.get_config("api_host");
};
O.prototype.toString = function() {
  var e = this.get_config("name");
  return e !== Qe && (e = Qe + "." + e), e;
};
O.prototype._event_is_disabled = function(e) {
  return d.isBlockedUA(At) || this._flags.disable_all_events || d.include(this.__disabled_events, e);
};
O.prototype._gdpr_init = function() {
  var e = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
  e && d.localStorage.is_supported() && (!this.has_opted_in_tracking() && this.has_opted_in_tracking({ persistence_type: "cookie" }) && this.opt_in_tracking({ enable_persistence: !1 }), !this.has_opted_out_tracking() && this.has_opted_out_tracking({ persistence_type: "cookie" }) && this.opt_out_tracking({ clear_persistence: !1 }), this.clear_opt_in_out_tracking({
    persistence_type: "cookie",
    enable_persistence: !1
  })), this.has_opted_out_tracking() ? this._gdpr_update_persistence({ clear_persistence: !0 }) : !this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || d.cookie.get("mp_optout")) && (d.cookie.remove("mp_optout"), this.opt_out_tracking({
    clear_persistence: this.get_config("opt_out_persistence_by_default")
  }));
};
O.prototype._gdpr_update_persistence = function(e) {
  var r;
  if (e && e.clear_persistence)
    r = !0;
  else if (e && e.enable_persistence)
    r = !1;
  else
    return;
  !this.get_config("disable_persistence") && this.persistence.disabled !== r && this.persistence.set_disabled(r), r ? (this.stop_batch_senders(), this.stop_session_recording()) : this._batchers_were_started && this.start_batch_senders();
};
O.prototype._gdpr_call_func = function(e, r) {
  return r = d.extend({
    track: d.bind(this.track, this),
    persistence_type: this.get_config("opt_out_tracking_persistence_type"),
    cookie_prefix: this.get_config("opt_out_tracking_cookie_prefix"),
    cookie_expiration: this.get_config("cookie_expiration"),
    cross_site_cookie: this.get_config("cross_site_cookie"),
    cross_subdomain_cookie: this.get_config("cross_subdomain_cookie"),
    cookie_domain: this.get_config("cookie_domain"),
    secure_cookie: this.get_config("secure_cookie"),
    ignore_dnt: this.get_config("ignore_dnt")
  }, r), d.localStorage.is_supported() || (r.persistence_type = "cookie"), e(this.get_config("token"), {
    track: r.track,
    trackEventName: r.track_event_name,
    trackProperties: r.track_properties,
    persistenceType: r.persistence_type,
    persistencePrefix: r.cookie_prefix,
    cookieDomain: r.cookie_domain,
    cookieExpiration: r.cookie_expiration,
    crossSiteCookie: r.cross_site_cookie,
    crossSubdomainCookie: r.cross_subdomain_cookie,
    secureCookie: r.secure_cookie,
    ignoreDnt: r.ignore_dnt
  });
};
O.prototype.opt_in_tracking = function(e) {
  e = d.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(Qy, e), this._gdpr_update_persistence(e);
};
O.prototype.opt_out_tracking = function(e) {
  e = d.extend({
    clear_persistence: !0,
    delete_user: !0
  }, e), e.delete_user && this.people && this.people._identify_called() && (this.people.delete_user(), this.people.clear_charges()), this._gdpr_call_func(e_, e), this._gdpr_update_persistence(e);
};
O.prototype.has_opted_in_tracking = function(e) {
  return this._gdpr_call_func(t_, e);
};
O.prototype.has_opted_out_tracking = function(e) {
  return this._gdpr_call_func(wf, e);
};
O.prototype.clear_opt_in_out_tracking = function(e) {
  e = d.extend({
    enable_persistence: !0
  }, e), this._gdpr_call_func(r_, e), this._gdpr_update_persistence(e);
};
O.prototype.report_error = function(e, r) {
  ie.error.apply(ie.error, arguments);
  try {
    !r && !(e instanceof Error) && (e = new Error(e)), this.get_config("error_reporter")(e, r);
  } catch (n) {
    ie.error(n);
  }
};
O.prototype.init = O.prototype.init;
O.prototype.reset = O.prototype.reset;
O.prototype.disable = O.prototype.disable;
O.prototype.time_event = O.prototype.time_event;
O.prototype.track = O.prototype.track;
O.prototype.track_links = O.prototype.track_links;
O.prototype.track_forms = O.prototype.track_forms;
O.prototype.track_pageview = O.prototype.track_pageview;
O.prototype.register = O.prototype.register;
O.prototype.register_once = O.prototype.register_once;
O.prototype.unregister = O.prototype.unregister;
O.prototype.identify = O.prototype.identify;
O.prototype.alias = O.prototype.alias;
O.prototype.name_tag = O.prototype.name_tag;
O.prototype.set_config = O.prototype.set_config;
O.prototype.get_config = O.prototype.get_config;
O.prototype.get_api_host = O.prototype.get_api_host;
O.prototype.get_property = O.prototype.get_property;
O.prototype.get_distinct_id = O.prototype.get_distinct_id;
O.prototype.toString = O.prototype.toString;
O.prototype.opt_out_tracking = O.prototype.opt_out_tracking;
O.prototype.opt_in_tracking = O.prototype.opt_in_tracking;
O.prototype.has_opted_out_tracking = O.prototype.has_opted_out_tracking;
O.prototype.has_opted_in_tracking = O.prototype.has_opted_in_tracking;
O.prototype.clear_opt_in_out_tracking = O.prototype.clear_opt_in_out_tracking;
O.prototype.get_group = O.prototype.get_group;
O.prototype.set_group = O.prototype.set_group;
O.prototype.add_group = O.prototype.add_group;
O.prototype.remove_group = O.prototype.remove_group;
O.prototype.track_with_groups = O.prototype.track_with_groups;
O.prototype.start_batch_senders = O.prototype.start_batch_senders;
O.prototype.stop_batch_senders = O.prototype.stop_batch_senders;
O.prototype.start_session_recording = O.prototype.start_session_recording;
O.prototype.stop_session_recording = O.prototype.stop_session_recording;
O.prototype.pause_session_recording = O.prototype.pause_session_recording;
O.prototype.resume_session_recording = O.prototype.resume_session_recording;
O.prototype.get_session_recording_properties = O.prototype.get_session_recording_properties;
O.prototype.get_session_replay_url = O.prototype.get_session_replay_url;
O.prototype.get_tab_id = O.prototype.get_tab_id;
O.prototype.DEFAULT_API_ROUTES = Zf;
O.prototype.__get_recorder = O.prototype.__get_recorder;
V.prototype.properties = V.prototype.properties;
V.prototype.update_search_keyword = V.prototype.update_search_keyword;
V.prototype.update_referrer_info = V.prototype.update_referrer_info;
V.prototype.get_cross_subdomain = V.prototype.get_cross_subdomain;
V.prototype.clear = V.prototype.clear;
var Er = {}, M_ = function() {
  d.each(Er, function(e, r) {
    r !== Qe && (Fe[r] = e);
  }), Fe._ = d;
}, F_ = function() {
  Fe.init = function(e, r, n) {
    if (n)
      return Fe[n] || (Fe[n] = Er[n] = ws(e, r, n), Fe[n]._loaded()), Fe[n];
    var t = Fe;
    Er[Qe] ? t = Er[Qe] : e && (t = ws(e, r, Qe), t._loaded(), Er[Qe] = t), Fe = t, ha === k_ && ($[Qe] = Fe), M_();
  };
}, $_ = function() {
  function e() {
    e.done || (e.done = !0, Kf = !0, Hf = !1, d.each(Er, function(t) {
      t._dom_loaded();
    }));
  }
  function r() {
    try {
      ne.documentElement.doScroll("left");
    } catch {
      setTimeout(r, 1);
      return;
    }
    e();
  }
  if (ne.addEventListener)
    ne.readyState === "complete" ? e() : ne.addEventListener("DOMContentLoaded", e, !1);
  else if (ne.attachEvent) {
    ne.attachEvent("onreadystatechange", e);
    var n = !1;
    try {
      n = $.frameElement === null;
    } catch {
    }
    ne.documentElement.doScroll && n && r();
  }
  d.register_event($, "load", e, !0);
};
function N_(e) {
  return Gf = e, ha = Vf, Fe = new O(), F_(), Fe.init(), $_(), Fe;
}
function P_(e, r) {
  r();
}
var Jf = N_(P_);
const ke = [];
for (let e = 0; e < 256; ++e)
  ke.push((e + 256).toString(16).slice(1));
function D_(e, r = 0) {
  return (ke[e[r + 0]] + ke[e[r + 1]] + ke[e[r + 2]] + ke[e[r + 3]] + "-" + ke[e[r + 4]] + ke[e[r + 5]] + "-" + ke[e[r + 6]] + ke[e[r + 7]] + "-" + ke[e[r + 8]] + ke[e[r + 9]] + "-" + ke[e[r + 10]] + ke[e[r + 11]] + ke[e[r + 12]] + ke[e[r + 13]] + ke[e[r + 14]] + ke[e[r + 15]]).toLowerCase();
}
let So;
const L_ = new Uint8Array(16);
function B_() {
  if (!So) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    So = crypto.getRandomValues.bind(crypto);
  }
  return So(L_);
}
const U_ = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hu = { randomUUID: U_ };
function z_(e, r, n) {
  var i;
  if (Hu.randomUUID && !e)
    return Hu.randomUUID();
  e = e || {};
  const t = e.random ?? ((i = e.rng) == null ? void 0 : i.call(e)) ?? B_();
  if (t.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, D_(t);
}
function Xf() {
  return z_();
}
function q_() {
  let e;
  try {
    e = `$device:${Xf()}`;
  } catch {
    e = `$device:default-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  }
  return e;
}
function j_() {
  let e = localStorage.getItem("localLogicDevice");
  return e || (e = q_(), localStorage.setItem("localLogicDevice", e)), e;
}
function Zu() {
  const e = (/* @__PURE__ */ new Date()).toISOString();
  let r;
  try {
    r = `$session:${Xf()}`;
  } catch {
    r = `$session:default-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  }
  return {
    sessionId: r,
    startTime: e,
    endTime: e
  };
}
function W_() {
  const e = /* @__PURE__ */ new Date(), r = localStorage.getItem("localLogicSession");
  let n;
  return r ? (n = JSON.parse(r), n.endTime && e.getTime() - new Date(n.endTime).getTime() >= 30 * 60 * 1e3 ? n = Zu() : n.endTime = e.toISOString()) : n = Zu(), localStorage.setItem("localLogicSession", JSON.stringify(n)), n.sessionId;
}
const Qf = nh.createContext({}), Z_ = () => ih(Qf);
function K_(e) {
  try {
    Jf.init(e, {
      track_pageview: !1,
      persistence: "localStorage"
    });
  } catch {
  }
}
const J_ = ({
  children: e,
  trackingPipelineSettings: r,
  analyticsSettings: n,
  attributes: t = {},
  meta: i,
  flags: o
}) => {
  var c, h;
  const s = Zh((r == null ? void 0 : r.apiKey) ?? ""), [a] = oh({
    ll_product_name: i.productName,
    ll_product_version: i.productVersion,
    ll_client_id: i.clientId,
    ll_locale: t.locale,
    ll_location_lat: (c = t.location) == null ? void 0 : c.lat,
    ll_location_lng: (h = t.location) == null ? void 0 : h.lng
  }), u = ({ eventType: m, eventAttributes: v }) => {
    const y = {
      product_version: i.productVersion || "not_defined",
      product_name: i.productName || "",
      client_id: i.clientId,
      device_id: j_(),
      session_id: W_()
    }, S = {
      event_type: m,
      event_version: "1.0.0",
      meta: y,
      attributes: {
        event_attributes: v,
        ...t
      }
    };
    if (o != null && o.isDebugMode) {
      console.info("Tracking event:", S);
      return;
    }
    s.postEvent(S);
  }, l = ({ eventName: m, eventAttributes: v = {} }) => {
    if (!(typeof n > "u" || n.tracker !== "mixpanel") && (n.printDebugMode && console.info("Mixpanel Debug:", {
      event: m,
      projectToken: n.key,
      properties: {
        ...v,
        ...a
      }
    }), !n.isDebugMode))
      try {
        Jf.track(m, {
          ...v,
          ...a
        });
      } catch {
      }
  };
  return /* @__PURE__ */ rh(Qf.Provider, { value: { postEvent: u, trackAnalyticsEvent: l }, children: e });
}, X_ = (e) => e instanceof lc, Q_ = (e) => e instanceof cc, e0 = (e) => e instanceof ui;
export {
  Zh as LocalLogicTracking,
  fc as Methods,
  J_ as TrackingProvider,
  jh as eventVersion,
  K_ as initializeAnalytics,
  e0 as isRequestError,
  Q_ as isUnknownError,
  X_ as isValidationError,
  Z_ as useTracking
};
